// do not manually modify this auto-generated file!!

export const allLocales = [
  {
    lang: 'ar',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      dataTable: {
        noSearchResultsFound: 'No search results found.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      dataTable: {
        noSearchResultsFound: 'No search results found.',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      welcome: 'स्वागत है',
    },
  },
  {
    lang: 'ru',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      welcome: 'Добро пожаловать',
    },
  },
  {
    lang: 'zh',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      welcome: '欢迎',
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'إلغاء',
      save: 'حفظ',
      loading: 'جاري التحميل...',
      delete: 'حذف المنظمة',
      submit: 'إرسال',
      search: 'بحث',
      genericError: 'Something went wrong. Try again',
      navMenu: {
        users: 'المستخدمين',
        teams: 'الفرق',
        projects: 'المشاريع',
        orgs: 'المنظمات',
        logs: 'السجلات',
        userPreferences: 'تفضيلات المستخدم',
        logout: 'تسجيل الخروج',
        orgPrefix: 'لـ',
        superAdmin: 'المشرف العام',
      },
      products: {
        analytics: 'التحليلات',
        manager: 'المدير',
        agentAssist: 'مركز الاتصال',
        youDontHaveAccess: 'ليس لديك صلاحية الوصول إلى هذه الأداة',
        proStudio: 'ستوديو برو',
        analyticsDescription: 'إفتح الرؤى وتحسين العمليات.',
        managerDescription: 'تنظيم فريقك والمشاريع بكفاءة.',
        agentAssistDescription: 'منصة التواصل العميلي الذكية.',
        proStudioDescription: 'إنشاء عمليات ذكية باستخدام الذكاء الاصطناعي.',
        selectToolToView: 'حدد أداة لعرض {{projectName}}',
      },
      homepage: {
        header: {
          tools: 'أدوات',
        },
        projects: {
          createProject: 'إنشاء مشروع',
          yourProjects: 'مشاريعك',
          project: 'مشروع',
          tools: 'أدوات',
          lastUpdated: 'آخر تحديث',
          toGetStartedCreateProject: 'للبدء، أنشئ مشروعك الأول.',
          nothingToShowHere: 'لا يوجد شيء لعرضه هنا...',
          YouDontHaveAccessToTheToolsInThisProject:
            'ليس لديك حق الوصول إلى الأدوات في هذا المشروع. يرجى الاتصال بمسؤول.',
          YouDontHaveAccessToThisTool: 'ليس لديك حق الوصول إلى هذه الأداة.',
          manageProject: 'إدارة المشروع',
        },
        contacts: {
          needHelp: 'بحاجة الى مساعدة؟',
          yourBrowserDoesNotSupportVideoTag:
            'المتصفح الخاص بك لا يدعم علامة الفيديو.',
          startChat: 'ابدأ الدردشة',
          learnMore: 'تعلم المزيد',
          visitOurSite: 'قم بزيارة موقعنا',
          seeOurBlog: 'انظر الى مدونتنا',
          blog: 'مدونة',
          haveQuestions: 'هل لديك أسئلة؟',
          helpCenter: 'مركز المساعدة',
        },
        noToolAccessMessage:
          'ليس لديك حق الوصول إلى أي مشاريع {{appName}} في هذه المنظمة. تم إعادة توجيهك إلى الرئيسية.',
      },
      firstName: 'الاسم الأول',
      lastName: 'الاسم الأخير',
      emailAddress: 'البريد الإلكتروني',
      permissionAndAccessTable: {
        teamEmptyState: 'لم يتم العثور على أي فرق.',
        addProject: 'إضافة مشروع',
        orgTitle: 'منظمة',
        projectTitle: 'مشروع',
        roleTitle: 'دور',
        toolTitle: 'أداة',
        orgParent: 'الوالد: {{name}}',
        roles: {
          viewOnly: 'للعرض فقط',
        },
        projectsEmptyState:
          'لا يوجد لدى هذه المنظمة أي مشاريع. أنشئ واحدًا للبدء.',
        projectsEmptyStateForViewUser:
          'لا توجد مشاريع لهذه المنظمة. تواصل مع أحد المشرفين للبدء.',
        noProjectsAssigned: 'لم يتم تعيين أي مشاريع',
        addTeam: 'إضافة فريق',
        noPermissionsAssigned: 'لا يوجد وصول - تعيين دور',
        managerRoleTooltip:
          'يؤدي تعيين دور المدير لهذه المنظمة إلى تعيينه لجميع المنظمات الفرعية الحالية والمستقبلية.',
        teamRoleTooltip:
          'يرث المستخدمون في الفريق جميع الأدوار الخاصة بهذا الفريق.',
        projectRemoveDisabledTooltip:
          'لا يمكنك حذف هذا المشروع لأن دورًا واحدًا على الأقل موروث من خلال فريق. قم بتحديث أدوار الفريق لهذا المشروع أو قم بإلغاء تعيين المستخدم من الفريق لتمكين الحذف.',
      },
      errorBoundary: {
        pageNotFound: '_Page not found.',
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'logs',
    translations: {
      title: 'السجلات',
      table: {
        column1: 'الإجراء',
        column2: 'المستخدم',
        column3: 'الوقت',
      },
      empty: 'لا توجد بيانات',
      showing: 'عرض',
      of: 'من',
      page: 'الصفحة',
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'organizations',
    translations: {
      childOrgsList: {
        childOrgs: 'المنظمات الفرعية ({{count}})',
        createOrg: 'إنشاء منظمة فرعية',
        editOrg: 'تحرير المنظمة',
        viewOrg: 'عرض المنظمة',
        created: 'تم الإنشاء {{date}}',
        table: {
          name: 'الاسم',
          users: 'المستخدمين',
          teams: 'الفرق',
          projects: 'المشاريع',
          childOrgs: 'المنظمات الفرعية',
          updated: 'آخر تحديث',
        },
        createToGetStarted: 'أنشئ منظمة للبدء.',
        loadError: {
          title: "_We couldn't load the child organizations",
          body: '_Something went wrong while loading this list.',
          retry: '_Try again',
          retrying: '_Retrying…',
          recovered: '_Child organizations loaded',
        },
      },
      orgDetails: {
        title: 'تفاصيل المنظمة',
      },
      createOrg: {
        title: 'إنشاء منظمة فرعية',
        cancel: 'إلغاء',
        create: 'إنشاء منظمة فرعية',
        creating: 'إنشاء منظمة للأطفال...',
        name: 'الاسم*',
        loginMethods: 'طرق الدخول',
        authProvider: 'مقدم المصادقة*',
        icon: 'الأيقونة',
        accountManager: 'مدير الحساب',
        clientId: 'معرف العميل',
        clientIdSaml: 'عنوان URL لتسجيل الدخول مرة واحدة',
        clientSecret: 'سر العميل',
        clientSecretSaml: 'شهادة X.509',
        issuerURL: 'معرف URI الخاص بالجهة المصدرة',
        issuerURLSaml: 'معرف كيان مزود الخدمة',
        issuerURLHelpText: 'المعرف الفريد لمزود الخدمة (SP) الخاص بك.',
        usernameAttribute: 'اسم السمة اسم المستخدم',
        emailAttribute: 'اسم سمة البريد الإلكتروني',
        redirectURL: 'رابط التحويل',
        entityIssuer: 'معرف كيان مزود الهوية (الجهة المصدرة)',
        entityIssuerHelpText:
          'المعرف الفريد لموفر هوية المستخدم (IdP). هذا الحقل اختياري، ويُرجى ملؤه فقط إذا طلبه موفر هويتك.',
        redirectURLHelpText:
          'استخدم هذا الرابط وأضفه إلى قائمة الروابط المسموحة بها في إعدادات التطبيق الخاص بك في مقدم المصادقة. يتطلب هذا أن يتم توجيه المستخدمين بنجاح إلى المنظمة بعد تسجيل الدخول.',
        placeholders: {
          name: 'الاسم',
          authProvider: 'اختر مقدم المصادقة',
          accountManager: 'اختر مدير الحساب',
          dragPicture: 'اسحب صورة هنا',
          selectFile: 'حدد ملفًا',
          emailDomain: '@domain.com',
        },
        nameIDPolicyFormat: 'تنسيق سياسة معرف الاسم',
        fieldIsRequired: '{{field}} مطلوب.',
        nameIDPolicyFormatHelpText:
          'صيغة مُعرِّف اسم المستخدم. هذا الحقل اختياري، ويُرجى ملؤه فقط إذا طلبه مُزوِّد هويتك.',
      },
      editOrg: {
        cancel: 'إلغاء',
        back: 'خلف',
        save: 'حفظ',
        saving: 'توفير...',
        delete: 'حذف المنظمة',
        deleteModal: {
          cancel: 'إلغاء',
          removeOrg: 'حذف المنظمة',
          areYouSure: 'هل أنت متأكد؟',
          description:
            'حذف هذه المنظمة سيؤدي إلى حذف {{usersCount}} من المستخدمين و{{projectsCount}} من المشاريع. لا يمكن التراجع عن ذلك.',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'حسابي',
      general: {
        details: 'التفاصيل',
        name: 'الاسم*',
        email_address: 'عنوان البريد الإلكتروني*',
        job_title: 'المسمى الوظيفي',
        profile_picture: 'الصورة الشخصية',
        cookie_policy: 'سياسة ملفات تعريف الارتباط',
        other_policies: 'السياسات الأخرى',
        reset_password: 'إعادة تعيين كلمة المرور',
        reset_password_help:
          'Googleلإعادة تعيين كلمة المرور، قم بزيارة حسابك على',
        language_timezone: 'اللغة والمنطقة الزمنية',
        default_language: 'اللغة الافتراضية',
        default_timezone: 'المنطقة الزمنية',
        add_job_title: 'أضف المسمى الوظيفي',
        add_name: 'أضف الاسم',
        add_surname: 'أضف اللقب',
        add_email_address: 'أضف عنوان البريد الإلكتروني',
        cookie_policy_label_prefix: 'الموافقة على',
        cookie_policy_label_suffix: 'لمساعدتنا في تحسين تجربتك',
        privacy_policy: 'سياسة الخصوصية',
        terms_conditions: 'الشروط والأحكام',
        dsar_form: 'نموذج DSAR',
        upload_profile_picture_on_google:
          'Googleللاستبدال أو الإزالة، قم بزيارة حسابك على',
        upload_a_file_here: 'ارفع ملفًا هنا',
        select_a_language: 'اختر لغة',
        select_a_time_zone: 'اختر منطقة زمنية',
        language_select_hint: 'لا ينطبق على مركز الاتصال والتحليلات',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'projects',
    translations: {
      projectsList: {
        projects: 'المشاريع',
        createProject: 'إنشاء مشروع',
        table: {
          name: 'الاسم',
          users: 'المستخدمين',
          tools: 'الأدوات',
          updated: 'آخر تحديث',
        },
      },
      sidebar: {
        backToProjects: 'الرجوعالى المشاريع',
        general: 'عام',
        environments: 'البيئات',
        environmentName: '{{environmentName}}',
        projectDetails: 'تفاصيل المشروع',
        appletDetails: 'تفاصيل التطبيق',
      },
      environments: {
        development: 'التطوير',
        testing: 'الاختبار',
        production: 'الإنتاج',
        staging: 'التدريج',
      },
      projectDetails: {
        deleteModal: {
          areYouSure: 'هل أنت متأكد؟',
          youWillLose: 'ستفقد نهائيًا:',
          accessToProjectTools: 'الوصول إلى أدوات المشروع',
          dataInsideProjectTools: 'البيانات داخل أدوات المشروع',
          rolesAssignedForProjectTools: 'الأدوار المعينة لأدوات المشروع',
          removeProject: 'حذف المشروع',
          cancel: 'إلغاء',
          removingProject: 'جارٍ حذف المشروع...',
        },
        createAppletModal: {
          step1: {
            title: 'إنشاء تطبيق',
            subTitle:
              'تطبيق Pypestream هو بيئة التشغيل لوظائف منصة Pypestream على موقع معين. يستدعي كود App Loader منصة Pypestream ويسترجع وينفذ أي تعليمات برمجية إضافية على الصفحة بناءً على شروط معينة. يتضمن ذلك كود تتبع التحليلات وكود الدردشة وعناصر من محرك الأتمتة.',
            name: 'اسم التطبيق',
            description: 'الوصف (اختياري)',
            required: 'هذا الحقل مطلوب',
          },
          step2: {
            title: 'اختر قالب التطبيق للبدء',
            subTitle:
              'تساعدك قوالب التطبيقات على بناء التطبيقات مع إعدادات أقل',
            required: 'يرجى اختيار تطبيق واحد',
            applets: {
              analytics: 'تحليلات',
              pype: 'Pype',
              custom: 'مخصص',
            },
          },
          step3: {
            title: 'نجاح!',
            subTitle: 'تم إنشاء التطبيق الجديد...',
            button: 'تم',
          },
          nextStep: 'التالي',
          backStep: 'رجوع',
        },
        deleteAppletModal: {
          areYouSure: 'هل أنت متأكد؟',
          youWillLose: 'ستفقد نهائيًا:',
          accessToApplet: 'الوصول إلى التطبيق',
          removeApplet: 'حذف التطبيق',
          cancel: 'إلغاء',
        },
        updateAppletInstanceStatusModal: {
          title: 'هل أنت متأكد؟',
          description: 'وصف تبديل الحالة',
          confirmButton: 'تحديث التطبيق',
          cancelButton: 'إلغاء',
        },
        deleteToolModal: {
          title: 'هل تريد حذف نسخة {{tool}} هذه؟',
          subTitle:
            'يؤدي حذف نسخة {{tool}} هذه إلى حذف جميع البيانات المرتبطة بها. ولا يؤثر هذا على نسخ {{tool}} في المشاريع الأخرى.',
          deleteConfirmationHint: 'للتحقق، اكتب "{{tool}}" أدناه',
          deleteButton: 'يمسح',
        },
        environmentURLModal: {
          title: 'تعيين عناوين URL لـ {{environmentName}}',
          subTitle:
            'تنظم المشاريع العمل حول ممتلكات رقمية مثل المواقع الإلكترونية. يجب ربط كل شيء في المشروع بنطاق ويمكن تغيير الإعدادات في إعدادات المشروع.',
          addURLButton: 'إضافة عنوان URL لـ {{environmentName}}',
        },
        cancel: 'إلغاء',
        save: 'حفظ التغييرات',
        saving: 'توفير...',
        delete: 'حذف المشروع',
        created: 'تم الإنشاء {{date}}',
        unsavedChanges: 'هناك تغييرات لم يتم حفظها',
        generalTab: {
          title: 'عام',
          details: {
            detailsCaption: 'التفاصيل',
            name: 'الاسم',
            description: 'الوصف',
            projectIcon: 'أيقونة المشروع',
            placeholders: {
              addName: 'أضف الاسم',
              addDescription: 'أضف الوصف',
              dragPhoto: 'قم بسحب الصورة إلى هنا',
              selectFile: 'حدد ملفًا',
            },
          },
          tools: {
            toolsCaption: 'الأدوات',
            configureToolsYouNeed: 'قم بإعداد الأدوات التي تحتاجها لمشروعك',
            selectOneOrMoreProducts: 'يرجى اختيار أداة أو أكثر',
            editTools: 'أدوات التحرير',
          },
          languageAndTimezone: {
            languageCaption: 'الإعدادات اللغوية',
            defaultLanguage: 'اللغة الافتراضية',
            defaultTimezone: 'المنطقة الزمنية',
            placeholders: {
              selectLanguage: 'اختر اللغة',
              selectTimezone: 'اختر المنطقة الزمنية',
            },
            helpText: {
              locale: 'ينطبق فقط على مركز الاتصال',
              timezone: 'ينطبق فقط على للتحليلات',
            },
          },
        },
        environmentsTab: {
          title: 'نظرة عامة على النشر',
          appletsSection: {
            title: 'تطبيقات الويب',
            addButton: 'إضافة تطبيق',
            description:
              'تطبيق Pypestream هو بيئة التشغيل لوظائف منصة Pypestream على موقع معين.',
            status: 'سحابة',
            trigger: {
              title: 'مشغل',
              label: 'لم يتم تعيين مشغل',
            },
            actions: {
              title: 'إجراءات',
              label: 'لم يتم تعيين إجراءات',
            },
          },
          platformSection: {
            title: 'تكامل المنصة',
            addButton: 'إضافة تكاملات',
          },
          summarySection: {
            developmentUrls: 'عناوين URL الخاصة بـ {{environmentName}}',
            appInterfaces: 'واجهات التطبيقات',
            variables: 'المتغيرات',
          },
          caption: 'البيئات',
          environmentName: '{{environmentName}}',
          description:
            'تنظم المشاريع العمل حول ممتلكات عبر الإنترنت مثل الموقع الإلكتروني. يجب ربط كل شيء في المشروع بنطاق، وبشكل اختياري، نطاقاته الفرعية.',
          addEnvironmentUrl: 'إضافة عنوان URL لـ {{environmentName}}',
          gqlPlaygroundsButton: 'ملعب GQL للتطبيقات',
        },
      },
      createProject: {
        step1: {
          title: 'إنشاء مشروع',
          name: 'اسم المشروع',
          description: 'الوصف (اختياري)',
          icon: 'أيقونة المشروع (اختياري)',
        },
        step2: {
          title: 'عناوين URL للبيئات',
          field1: 'الإنتاج',
          field1Button: 'إضافة عنوان URL للإنتاج',
          field2: 'التدريج',
          field2Button: 'إضافة عنوان URL للتدريج',
          field3: 'التطوير',
          field3Button: 'إضافة عنوان URL للتطوير',
          errors: {
            default: 'يجب أن يكون هذا الحقل عنوان URL صالحًا.',
            invalidDomain: 'النطاق الأعلى غير صالح',
            invalidURL: 'عنوان URL غير صالح',
            intersection:
              'عنوان URL هذا ({{intersection}}) مستخدم في مشروع آخر',
          },
        },
        step3: {
          title: 'اختر الأدوات للدمج',
          required: 'يرجى اختيار أداة واحدة أو أكثر',
        },
        step4: {
          title: 'التعريب',
        },
        step5: {
          title: 'نجاح!',
          subTitle: 'تم إنشاء المشروع الجديد...',
          button: 'تم',
        },
        required: 'هذا الحقل مطلوب',
        nextStep: 'التالي',
        backStep: 'السابق',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'super-admin',
    translations: {
      title: 'المشرف العام',
      permission: 'ليس لديك إذن لعرض هذه الصفحة',
      section1: {
        title: 'هذا الزر لالتقاط لقطة من قاعدة البيانات',
        button: 'التقاط لقطة',
      },
      section2: {
        title: 'رابط إلى صفحة إعدادات التحليلات',
        button: 'التحليلات',
      },
      section3: {
        title: 'رابط إلى صفحة المشرف العام لمركز الاتصال',
        button: 'مركز الاتصال',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'teams',
    translations: {
      teamsList: {
        teams: 'الفرق',
        createTeam: 'إنشاء فريق',
        table: {
          name: 'الاسم',
          users: 'المستخدمين',
          updated: 'آخر تحديث',
        },
        createToGetStarted: 'أنشئ فريقًا للبدء.',
      },
      teamDetails: {
        createTeam: 'إنشاء فريق',
        deleteTeam: 'حذف الفريق',
        teamInfo: {
          name: 'اسم',
          description: 'وصف',
          contactCenterAccess:
            'يؤدي منح فريق حق الوصول إلى نسخة مركز الاتصال إلى إنشاء فريق مرتبط بها. لا يمكن إدارة الفرق إلا هنا، وليس في مركز الاتصال.',
        },
        teamUsers: {
          teamMembers: 'أعضاء الفريق',
          teamMembersSubTitle: 'يرث أعضاء الفريق جميع الأدوار المخصصة للفريق.',
          teamMembersOtherOrgs: 'أعضاء الفريق في المنظمات الأخرى',
          teamMembersOtherOrgsSubTitle:
            'لا يمكن إدارة أعضاء الفريق في منظمات أخرى من هذه الشاشة. لإزالتهم من هذا الفريق، انتقل إلى إعدادات المستخدم الخاصة بهم.',
          user: 'مستخدم',
          lastActive: 'آخر نشاط',
          addUsers: 'إضافة المستخدمين',
          noUsers: 'لا يوجد مستخدمين في هذه المنظمة',
          noUsersInTeam: 'لا يوجد مستخدمين في هذا الفريق.',
        },
        deleteTeamModal: {
          mainTitle: 'حذف الفريق {{teamName}}؟',
          subTitle: 'سيؤدي حذف {{teamName}} إلى:',
          line1: 'إزالة الأدوار الموروثة من جميع المستخدمين في هذا الفريق',
          line2: 'حذف أي فرق مرتبطة في حالات مركز الاتصال المرتبطة',
          cancel: 'يلغي',
          delete: 'يمسح',
          deleting: 'جاري الحذف...',
        },
        snackbar: {
          createTeamText: 'عندما تكون مستعدًا، قم بإنشاء الفريق',
          updateTeamText: 'هناك تغييرات غير محفوظة',
          cancel: 'يلغي',
          create: 'إنشاء فريق',
          creating: 'إنشاء فريق...',
          update: 'حفظ التغييرات',
          updating: 'حفظ التغييرات...',
        },
        permissionAndAccessTitle: 'الأدوار',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'users',
    translations: {
      usersList: {
        users: 'المستخدمين',
        createUser: 'إنشاء مستخدم',
        bulkInviteUsers: 'دعوة جماعية',
        bulkInviting: 'دعوة...',
        table: {
          name: 'الاسم',
          email: 'البريد الإلكتروني',
          lastActive: 'آخر نشاط',
          invited: 'تم الدعوة',
        },
        createToGetStarted: 'أنشئ مستخدمًا للبدء.',
      },
      userDetails: {
        title: 'تفاصيل المستخدم',
        permissionAndAccessTitle: 'الأدوار',
        deleteUserConfirmationModal: {
          description:
            'سيتم إزالة جميع صلاحياتهم. لا يمكن التراجع عن هذا الإجراء.',
          title: 'حذف {{userName}}؟',
        },
        agentConversationLimit: 'حد محادثة الوكيل',
        agentConversationLimitTooltip:
          'الحد الأقصى لعدد المحادثات التي يمكن تعيينها لوكيل في وقت واحد.',
        smartOrgMenu: 'القائمة التنظيمية الذكية',
        smartOrgMenuTooltip:
          'يعرض فقط المنظمات التي يمكنك الوصول إلى أداة واحدة على الأقل منها أو التي تكون فيها عضوًا في فريق. تبقى المنظمات الرئيسية مرئية إذا كانت تحتوي على منظمات فرعية مرئية. تبقى منظمتك الرئيسية مرئية.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'Cancel',
      save: 'Save Changes',
      loading: 'Loading...',
      delete: 'Delete',
      submit: 'Submit',
      search: 'Search',
      genericError: 'Something went wrong. Try again',
      navMenu: {
        users: 'Users',
        teams: 'Teams',
        projects: 'Projects',
        orgs: 'Orgs',
        logs: 'Logs',
        userPreferences: 'My Account',
        logout: 'Logout',
        orgPrefix: 'for',
        superAdmin: 'Super Admin',
      },
      products: {
        analytics: 'Analytics',
        manager: 'Manager',
        agentAssist: 'Contact Center',
        youDontHaveAccess: 'You don’t have access to this tool',
        proStudio: 'Pro Studio',
        analyticsDescription: 'Unlock insights and optimize workflows.',
        managerDescription: 'Organize your team and projects efficiently.',
        agentAssistDescription: 'AI powered customer engagement platform.',
        proStudioDescription: 'Build AI powered workflows.',
        selectToolToView: 'Select a tool to view {{projectName}}',
      },
      homepage: {
        header: {
          tools: 'Tools',
        },
        projects: {
          createProject: 'Create Project',
          yourProjects: 'Your Projects',
          project: 'Project',
          tools: 'Tools',
          lastUpdated: 'Last updated',
          toGetStartedCreateProject:
            'To get started, create your first project.',
          nothingToShowHere: 'Nothing to show here...',
          YouDontHaveAccessToTheToolsInThisProject:
            'You do not have access to the tools in this project. Contact an admin.',
          YouDontHaveAccessToThisTool: 'You do not have access to this tool.',
          manageProject: 'Manage Project',
        },
        contacts: {
          needHelp: 'Need Help?',
          yourBrowserDoesNotSupportVideoTag:
            'Your browser does not support the video tag.',
          startChat: 'Start Chat',
          learnMore: 'Learn More...',
          visitOurSite: 'Visit our site',
          seeOurBlog: 'See our blog',
          blog: 'Blog',
          haveQuestions: 'Have questions?',
          helpCenter: 'Help Center',
        },
        noToolAccessMessage:
          "You don't have access to any {{appName}} projects in this Organization. You've been brought to Home.",
      },
      firstName: 'First Name',
      lastName: 'Last Name',
      emailAddress: 'Email Address',
      permissionAndAccessTable: {
        teamEmptyState: 'No teams found.',
        addProject: 'Add Project',
        orgTitle: 'Org',
        projectTitle: 'Project',
        roleTitle: 'Role',
        toolTitle: 'Tool',
        orgParent: 'Parent: {{name}}',
        roles: {
          viewOnly: 'View Only',
        },
        projectsEmptyState:
          'This Org has no Projects. Create one to get started.',
        projectsEmptyStateForViewUser:
          'This Org has no Projects. Contact an admin to get started.',
        noProjectsAssigned: 'No projects assigned',
        addTeam: 'Add Team',
        noPermissionsAssigned: 'No access — assign a role',
        managerRoleTooltip:
          'Assigning a Manager role for this Org assigns it for all current and future Child Orgs.',
        teamRoleTooltip: 'Users on a Team inherit all roles of that Team.',
        projectRemoveDisabledTooltip:
          'You cannot remove this project because at least one role is inherited through a team. Update the team’s roles for this project or unassign the user from the team to enable removal.',
      },
      errorBoundary: {
        pageNotFound: 'Page not found.',
        reloadPage: 'Reload Page',
        goHome: 'Go Home',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'logs',
    translations: {
      title: 'Logs',
      table: {
        column1: 'Action',
        column2: 'User',
        column3: 'When',
      },
      empty: 'No data',
      showing: 'Showing',
      of: 'of',
      page: 'page',
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'organizations',
    translations: {
      childOrgsList: {
        childOrgs: 'Child Orgs ({{count}})',
        createOrg: 'Create Child Org',
        editOrg: 'Edit Org',
        viewOrg: 'View Org',
        created: 'Created {{date}}',
        table: {
          name: 'Name',
          users: 'Users',
          teams: 'Teams',
          projects: 'Projects',
          childOrgs: 'Child Orgs',
          updated: 'Last updated',
        },
        createToGetStarted: 'Create an org to get started.',
        loadError: {
          title: "We couldn't load the child organizations",
          body: 'Something went wrong while loading this list.',
          retry: 'Try again',
          retrying: 'Retrying…',
          recovered: 'Child organizations loaded',
        },
      },
      orgDetails: {
        title: 'Org Details',
      },
      createOrg: {
        title: 'Create Child Org',
        cancel: 'Cancel',
        create: 'Create Org',
        creating: 'Creating Org...',
        name: 'Name*',
        loginMethods: 'Login Methods',
        icon: 'Icon',
        accountManager: 'Account Manager',
        clientId: 'Client ID',
        clientIdSaml: 'Single Sign-On URL',
        clientSecret: 'Client Secret',
        clientSecretSaml: 'X.509 Certificate',
        issuerURL: 'Issuer URI',
        issuerURLSaml: 'Service Provider Entity ID',
        issuerURLHelpText:
          'The unique identifier for your Service Provider (SP).',
        usernameAttribute: 'Username Attribute Name',
        emailAttribute: 'Email Attribute Name',
        redirectURL: 'Redirect URI',
        entityIssuer: 'Identity Provider Entity ID (Issuer)',
        entityIssuerHelpText:
          "The unique identifier for the user's Identity Provider (IdP). This field is optional and should only be filled in if your identity provider requires it.",
        redirectURLHelpText:
          'Copy this URI and add it to the list of allowed redirect URIs in your OpenID Connect provider’s application settings. This is required for users to be successfully redirected back after logging in.',
        placeholders: {
          name: 'Name',
          loginMethod: 'Select login method',
          accountManager: 'Select account manager',
          dragPicture: 'Drag a photo here',
          selectFile: 'Select a file',
          emailDomain: '@domain.com',
        },
        nameIDPolicyFormat: 'Name ID Policy Format',
        fieldIsRequired: '{{field}} is required.',
        nameIDPolicyFormatHelpText:
          'The format of the user’s NameID. This field is optional and should only be filled in if your identity provider requires it.',
      },
      editOrg: {
        cancel: 'Cancel',
        back: 'Back',
        save: 'Save Changes',
        saving: 'Saving...',
        delete: 'Delete Org',
        deleteModal: {
          cancel: 'Cancel',
          removeOrg: 'Delete Org',
          areYouSure: 'Are you sure?',
          description:
            'Deleting this Org will delete all users, Projects, and Child Orgs associated with it, including their users and projects. This cannot be undone.',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'My Account',
      general: {
        details: 'Details',
        name: 'Name*',
        email_address: 'Email address*',
        job_title: 'Job Title',
        profile_picture: 'Profile Picture',
        cookie_policy: 'Cookie Policy',
        other_policies: 'Other Policies',
        reset_password: 'Reset Password',
        reset_password_help:
          'To reset your password, visit your Google account',
        language_timezone: 'Language & Timezone',
        default_language: 'Default language',
        default_timezone: 'Timezone',
        add_job_title: 'Add Job Title',
        add_name: 'Add Name',
        add_surname: 'Add Surname',
        add_email_address: 'Add Email address',
        cookie_policy_label_prefix: 'Opt in to the',
        cookie_policy_label_suffix: 'to help us improve your experience',
        privacy_policy: 'Privacy Policy',
        terms_conditions: 'Terms & Conditions',
        dsar_form: 'DSAR Form',
        upload_profile_picture_on_google:
          'To replace or remove, visit your Google account',
        upload_a_file_here: 'Upload a file here',
        select_a_language: 'Select a language',
        select_a_time_zone: 'Select a time zone',
        language_select_hint: 'Does not apply to Contact Center and Analytics',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'projects',
    translations: {
      projectsList: {
        projects: 'Projects',
        createProject: 'Create Project',
        table: {
          name: 'Name',
          users: 'Users',
          tools: 'Tools',
          updated: 'Last updated',
        },
      },
      sidebar: {
        backToProjects: 'All Projects',
        general: 'General',
        environments: 'Environments',
        environmentName: '{{environmentName}}',
        projectDetails: 'Project Details',
        appletDetails: 'Applet Details',
      },
      environments: {
        development: 'Development',
        testing: 'Testing',
        production: 'Production',
        staging: 'Staging',
      },
      projectDetails: {
        deleteModal: {
          areYouSure: 'Are you sure?',
          youWillLose: "You'll permanently lose:",
          accessToProjectTools: "access to this Project's tool instances",
          dataInsideProjectTools:
            "all data inside this Project's tool instances",
          rolesAssignedForProjectTools:
            "all roles assigned for this Project's tool instances",
          removeProject: 'Delete Project',
          cancel: 'Cancel',
          removingProject: 'Deleting Project...',
        },
        createAppletModal: {
          step1: {
            title: 'Create an Applet',
            subTitle:
              'The Pypestream Applet is the runtime environment for Pypestream platform functionality on a given website. The App Loader code snippet calls the Pypestream platform and retrieves and executes any additional code needed on the page assuming certain conditions are met. This includes Analytics tracking code, chat widget code, and Elements from the automation engine.',
            name: 'Applet Name',
            description: 'Description (optional)',
            required: 'This is a required field',
          },
          step2: {
            title: 'Select applet template to start with',
            subTitle:
              'Applets templates help you to build applets with less configurations',
            required: 'Please select one applet',
            applets: {
              analytics: 'Analytics',
              pype: 'Pype',
              custom: 'Custom',
            },
          },
          step3: {
            title: 'Success!',
            subTitle: 'New applet has been created...',
            button: 'Done',
          },
          nextStep: 'Next',
          backStep: 'Back',
        },
        deleteAppletModal: {
          areYouSure: 'Are you sure?',
          youWillLose: "You'll permanently lose:",
          accessToApplet: 'access to this Applet instance',
          removeApplet: 'Delete Applet',
          cancel: 'Cancel',
        },
        updateAppletInstanceStatusModal: {
          title: 'Are you sure?',
          description: 'Toggle status description',
          confirmButton: 'Update Applet',
          cancelButton: 'Cancel',
        },
        deleteToolModal: {
          title: 'Delete this {{tool}} instance?',
          subTitle:
            'Deleting this {{tool}} instance deletes all associated data. This does not affect {{tool}} instances in other Projects.',
          deleteConfirmationHint: 'To verify, type "{{tool}}" below',
          deleteButton: 'Delete',
        },
        environmentURLModal: {
          title: 'Set {{environmentName}} URLs',
          subTitle:
            'Projects organize work around an online property like a website. Everything in the project must be tied to a domain and, optionally, its subdomains. You can make changes in project settings.',
          addURLButton: 'Add {{environmentName}} URL',
        },
        cancel: 'Cancel',
        save: 'Save Changes',
        saving: 'Saving...',
        delete: 'Delete Project',
        created: 'Created {{date}}',
        unsavedChanges: 'There are unsaved changes',
        generalTab: {
          title: 'General',
          details: {
            detailsCaption: 'Details',
            name: 'Name*',
            description: 'Description',
            projectIcon: 'Project Icon',
            placeholders: {
              addName: 'Add Name',
              addDescription: 'Add description',
              dragPhoto: 'Drag a photo here',
              selectFile: 'Select a file',
            },
          },
          tools: {
            toolsCaption: 'Tools',
            configureToolsYouNeed:
              'Configure the tools you need for your project',
            selectOneOrMoreProducts: 'Please select one or more tools',
            editTools: 'Edit Tools',
          },
          languageAndTimezone: {
            languageCaption: 'Localization',
            defaultLanguage: 'Default language',
            defaultTimezone: 'Timezone',
            placeholders: {
              selectLanguage: 'Select language',
              selectTimezone: 'Select timezone',
            },
            helpText: {
              locale: 'Applies only to Contact Center',
              timezone: 'Applies only to Analytics',
            },
          },
        },
        environmentsTab: {
          title: 'Deployment Overview',
          appletsSection: {
            title: 'Web Applets',
            addButton: 'Add Applet',
            description:
              'The Pypestream Applet is the runtime environment for Pypestream platform functionality on a given website.',
            status: 'Cloud',
            trigger: {
              title: 'Trigger',
              label: "You haven't set a triggers",
            },
            actions: {
              title: 'Actions',
              label: "You haven't set an actions",
            },
          },
          platformSection: {
            title: 'Platform Integrations',
            addButton: 'Add Integrations',
          },
          summarySection: {
            developmentUrls: '{{environmentName}} URLs',
            appInterfaces: 'App Interfaces',
            variables: 'Variables',
          },
          caption: 'Environments',
          environmentName: '{{environmentName}}',
          description:
            'Projects organize work around an online property like a website. Everything in the project must be tied to a domain and, optionally, its subdomains.',
          addEnvironmentUrl: 'Add {{environmentName}} URL',
          gqlPlaygroundsButton: 'GQL playground for Applets',
        },
      },
      createProject: {
        step1: {
          title: 'Create a project',
          name: 'Project name',
          description: 'Description (optional)',
          icon: 'Project Icon (optional)',
        },
        step2: {
          title: 'Environments URLs',
          field1: 'Production',
          field1Button: 'Add Production URL',
          field2: 'Staging',
          field2Button: 'Add Staging URL',
          field3: 'Development',
          field3Button: 'Add Development URL',
          errors: {
            default: 'This field should be a valid url.',
            invalidDomain: 'The top level domain is invalid',
            invalidURL: 'The URL is invalid',
            intersection:
              'This URL ({{intersection}}) is used in another project',
          },
        },
        step3: {
          title: 'Select tooling to integrate',
          required: 'Please select one or more tools',
        },
        step4: {
          title: 'Localization',
        },
        step5: {
          title: 'Success!',
          subTitle: 'New project has been created...',
          button: 'Done',
        },
        required: 'This is a required field',
        nextStep: 'Next',
        backStep: 'Back',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'super-admin',
    translations: {
      title: 'Super Admin',
      permission: 'You don&apos;t have permission to see this page',
      section1: {
        title: 'This button is for making a snapshot of DB',
        button: 'Make Snapshot',
      },
      section2: {
        title: 'Link to Analytics Settings Page',
        button: 'Analytics',
      },
      section3: {
        title: 'Link to Contact Center Super Admin Page',
        button: 'Contact Center',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'teams',
    translations: {
      teamsList: {
        teams: 'Teams',
        createTeam: 'Create Team',
        table: {
          name: 'Name',
          users: 'Users',
          updated: 'Last updated',
        },
        createToGetStarted: 'Create a team to get started.',
      },
      teamDetails: {
        createTeam: 'Create Team',
        deleteTeam: 'Delete Team',
        teamInfo: {
          name: 'Name',
          description: 'Description',
          contactCenterAccess:
            'Giving a Team access to a Contact Center instance creates a linked Team in that instance. Teams can only be managed here, not in Contact Center.',
        },
        teamUsers: {
          teamMembers: 'Team Members',
          teamMembersSubTitle:
            'Team members inherit all roles assigned to the Team.',
          teamMembersOtherOrgs: 'Team Members in Other Orgs',
          teamMembersOtherOrgsSubTitle:
            'Team members in other Orgs cannot be managed from this screen. To remove them from this Team, go to their user settings.',
          user: 'User',
          lastActive: 'Last Active',
          addUsers: 'Add Users',
          noUsers: 'There are no users in this Org',
          noUsersInTeam: 'There are no users in this team.',
        },
        deleteTeamModal: {
          mainTitle: 'Delete team {{teamName}}?',
          subTitle: 'Deleting {{teamName}} will:',
          line1: 'Remove inherited roles from all users in this team',
          line2:
            'Delete any linked teams in associated Contact Center instances',
          cancel: 'Cancel',
          delete: 'Delete',
          deleting: 'Deleting...',
        },
        snackbar: {
          createTeamText: 'When you are ready, create the team',
          updateTeamText: 'There are unsaved changes',
          cancel: 'Cancel',
          create: 'Create Team',
          creating: 'Creating Team...',
          update: 'Save Changes',
          updating: 'Saving Changes...',
        },
        permissionAndAccessTitle: 'Roles',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'users',
    translations: {
      usersList: {
        users: 'Users',
        inviteUser: 'Invite User',
        importUsers: 'Import Users',
        importing: 'Importing...',
        createUser: 'Create User',
        bulkInviteUsers: 'Bulk Invite',
        bulkInviting: 'Inviting...',
        table: {
          name: 'Name',
          email: 'Email',
          lastActive: 'Last Active',
          invited: 'Invited',
        },
        createToGetStarted: 'Create a user to get started.',
      },
      userDetails: {
        title: 'User Details',
        permissionAndAccessTitle: 'Roles',
        deleteUserConfirmationModal: {
          description:
            'This will remove all of their access. This cannot be undone.',
          title: 'Delete {{userName}}?',
        },
        agentConversationLimit: 'Agent Conversation Limit',
        agentConversationLimitTooltip:
          'Maximum number of conversations that an agent can be assigned at one time.',
        smartOrgMenu: 'Smart Org Menu',
        smartOrgMenuTooltip:
          'Shows only Orgs where you have access to at least one Tool or are a member of a Team. Parent Orgs stay visible if they contain visible child Orgs. Your top Org stays visible.',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'lorem',
      save: 'lorem',
      genericError: 'Something went wrong. Try again',
      errorBoundary: {
        pageNotFound: '_Page not found.',
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'lorem',
      general: {
        details: 'lorem',
        name: 'lorem',
        email_address: 'lorem',
        job_title: 'lorem',
        profile_picture: 'lorem',
        cookie_policy: 'lorem',
        other_policies: 'lorem',
        reset_password: 'lorem',
        reset_password_help: 'lorem',
        language_timezone: 'lorem',
        default_language: 'lorem',
        default_timezone: 'lorem',
        add_job_title: 'lorem',
        add_name: 'lorem',
        add_surname: 'lorem',
        add_email_address: 'lorem',
        cookie_policy_label_prefix: 'lorem',
        cookie_policy_label_suffix: 'lorem',
        privacy_policy: 'lorem',
        terms_conditions: 'lorem',
        dsar_form: 'lorem',
        upload_profile_picture_on_google: 'lorem',
        upload_a_file_here: 'lorem',
        select_a_language: 'lorem',
        select_a_time_zone: 'lorem',
        applies_only_to_manager: 'lorem',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'lorem',
      save: 'lorem',
      genericError: 'Something went wrong. Try again',
      errorBoundary: {
        pageNotFound: '_Page not found.',
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'lorem',
      general: {
        details: 'lorem',
        name: 'lorem',
        email_address: 'lorem',
        job_title: 'lorem',
        profile_picture: 'lorem',
        cookie_policy: 'lorem',
        other_policies: 'lorem',
        reset_password: 'lorem',
        reset_password_help: 'lorem',
        language_timezone: 'lorem',
        default_language: 'lorem',
        default_timezone: 'lorem',
        add_job_title: 'lorem',
        add_name: 'lorem',
        add_surname: 'lorem',
        add_email_address: 'lorem',
        cookie_policy_label_prefix: 'lorem',
        cookie_policy_label_suffix: 'lorem',
        privacy_policy: 'lorem',
        terms_conditions: 'lorem',
        dsar_form: 'lorem',
        upload_profile_picture_on_google: 'lorem',
        upload_a_file_here: 'lorem',
        select_a_language: 'lorem',
        select_a_time_zone: 'lorem',
        applies_only_to_manager: 'lorem',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'lorem',
      save: 'lorem',
      genericError: 'Something went wrong. Try again',
      errorBoundary: {
        pageNotFound: '_Page not found.',
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'lorem',
      general: {
        details: 'lorem',
        name: 'lorem',
        email_address: 'lorem',
        job_title: 'lorem',
        profile_picture: 'lorem',
        cookie_policy: 'lorem',
        other_policies: 'lorem',
        reset_password: 'lorem',
        reset_password_help: 'lorem',
        language_timezone: 'lorem',
        default_language: 'lorem',
        default_timezone: 'lorem',
        add_job_title: 'lorem',
        add_name: 'lorem',
        add_surname: 'lorem',
        add_email_address: 'lorem',
        cookie_policy_label_prefix: 'lorem',
        cookie_policy_label_suffix: 'lorem',
        privacy_policy: 'lorem',
        terms_conditions: 'lorem',
        dsar_form: 'lorem',
        upload_profile_picture_on_google: 'lorem',
        upload_a_file_here: 'lorem',
        select_a_language: 'lorem',
        select_a_time_zone: 'lorem',
        applies_only_to_manager: 'lorem',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'لـ',
      },
      mega: {
        sidebar: {
          title: 'المشاريع',
          empty: 'لا توجد مشاريع متاحة',
          goHome: 'الرئيسية',
          home: 'الرئيسية',
          error: 'لقد حدث خطأ ما. يرجى إعادة تحميل الصفحة.',
        },
        content: {
          title: 'الاختصارات',
          empty: {
            part1: 'اختر',
            part2: 'مشروعًا',
            part3: 'من القائمة للبدء',
          },
          help: {
            part1: 'تحتاج إلى مساعدة في شيء؟ تواصل مع أخصائي',
            part2: 'هنا',
          },
        },
      },
      userDropdown: {
        superAdmin: 'المشرف العام',
        userAccount: 'حسابي',
        logout: 'تسجيل الخروج',
      },
      error: {
        generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.',
        retry: 'إعادة المحاولة',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          goHome: 'Go Home',
          home: 'Home',
          error: 'Somethings went wrong. Please reload page.',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        superAdmin: 'Super Admin',
        userAccount: 'My Account',
        logout: 'Logout',
      },
      error: {
        generic: 'Something went wrong. Please try again later.',
        retry: 'Retry',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          home: 'होम',
          goHome: 'होम पर जाएं',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        logout: 'Logout',
      },
      error: {
        generic: 'कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें।',
        retry: 'पुनः प्रयास',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          home: 'Главная',
          goHome: 'Вернуться домой',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        logout: 'Logout',
      },
      error: {
        generic: 'Что-то пошло не так. Пожалуйста, повторите попытку позже.',
        retry: 'Повторить',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          home: '首页',
          goHome: '返回首页',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        logout: 'Logout',
      },
      error: {
        generic: '出了点问题，请稍后再试。',
        retry: '重试',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      title: 'إنهاء إعداد ملفك الشخصي',
      subTitle: 'باقي بضع أسئلة فقط لك...',
      firstName: 'الاسم الأول',
      lastName: 'الاسم الأخير',
      picture: 'الصورة الشخصية',
      upload_profile_picture_on_google:
        'لتغيير الصورة أو إزالتها، قم بزيارة حسابك على Google',
      upload_a_file_here: 'ارفع ملفًا هنا',
      selectFile: 'حدد ملفًا',
      changePicture: 'تغيير الصورة الشخصية',
      jobTitle: 'المسمى الوظيفي',
      terms_conditions_prefix: 'الموافقة على',
      terms_conditions: 'الشروط والأحكام',
      and: 'و',
      privacy_policy: 'سياسة الخصوصية',
      cookie_policy_label_prefix: 'الموافقة على',
      cookie_policy: 'سياسة ملفات تعريف الارتباط',
      cookie_policy_label_suffix: 'لمساعدتنا في تحسين تجربتك',
      button: 'حفظ التغييرات',
      loading: 'جاري التحميل...',
      error: {
        generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.',
        retry: 'إعادة المحاولة',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      title: 'Finish up your profile',
      subTitle: 'Just a couple more questions for you...',
      firstName: 'First Name',
      lastName: 'Last Name',
      picture: 'Profile Picture',
      upload_profile_picture_on_google:
        'To replace or remove, visit your Google account',
      upload_a_file_here: 'Upload a file here',
      selectFile: 'Select a file',
      changePicture: 'Change profile picture',
      jobTitle: 'Job Title',
      terms_conditions_prefix: 'Agree to',
      terms_conditions: 'Terms and Conditions',
      and: 'and',
      privacy_policy: 'Privacy Policy',
      cookie_policy_label_prefix: 'Opt in to the',
      cookie_policy: 'Cookie Policy',
      cookie_policy_label_suffix: 'to help us improve your experience',
      button: 'Save Changes',
      loading: 'Loading...',
      error: {
        generic: 'Something went wrong. Please try again later.',
        retry: 'Retry',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      welcome: 'स्वागत है',
      error: {
        generic: 'कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें।',
        retry: 'पुनः प्रयास',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      welcome: 'Добро пожаловать',
      error: {
        generic: 'Что-то пошло не так. Пожалуйста, повторите попытку позже.',
        retry: 'Повторить',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      welcome: '欢迎',
      error: {
        generic: '出了点问题，请稍后再试。',
        retry: '重试',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      workflowsTableStatus: {
        loading: '_Loading workflows',
        loaded: '_Workflows loaded',
      },
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
      unsavedChangesModal: {
        title: '_You have unsaved changes',
        body: '_If you leave now, your changes will be lost.',
        leave: '_Leave without saving',
        saveAndLeave: '_Save and leave',
        saving: '_Saving...',
        saveError: '_Your changes could not be saved. Please try again.',
      },
      errorBoundary: {
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
        more: '_More',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solutions:',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
          duplicate_node_numbers:
            '_This solution has duplicate node numbers. Node numbers must be unique — fix the highlighted cells and try publishing again.',
          missing_node_numbers:
            '_This solution has rows without a node number. Every node needs one — fix the highlighted cells and try publishing again.',
          validation_incomplete:
            '_The last validation run did not finish, so this solution has not been checked. Validation has been restarted — wait for it to complete, then try publishing again.',
          invalid_node_numbers:
            '_This solution has cells that do not hold a usable node number. Enter a whole number other than 0 in each — fix the highlighted cells and try publishing again.',
        },
      },
      validation_popover: {
        auto_validation_toggle_label: '_Automatic validation',
        empty_state:
          '_There are no errors, your solution is ready to be published.',
        incomplete_state:
          '_Validation did not finish, so these results may be out of date. Publishing stays disabled until a validation run completes.',
        tab: {
          agent_validator: '_Agent Validator {{count}}',
          bot_compiler: '_Bot Compiler {{count}}',
          errors: '_Errors {{count}}',
          download_diagnostics: '_Download Agent Compiler Data',
        },
        error_row: {
          hidden_row_hint:
            '_This row is hidden — clear the search or expand its group to open it.',
          unknown_error: '_Unknown validation error',
        },
        trigger: {
          label_clean: '_Solution validation: no errors',
          label_incomplete: '_Solution validation: did not finish',
          label_with_errors_zero: '_Solution validation: {{count}} errors',
          label_with_errors_one: '_Solution validation: {{count}} error',
          label_with_errors_two: '_Solution validation: {{count}} errors',
          label_with_errors_few: '_Solution validation: {{count}} errors',
          label_with_errors_many: '_Solution validation: {{count}} errors',
          label_with_errors_other: '_Solution validation: {{count}} errors',
        },
      },
      publish_button: {
        tooltip: {
          publishing_in_progress: '_Publishing is in progress.',
          fix_errors: '_Fix any errors to enable publishing.',
          validate_then_fix:
            '_Click Validate to check your changes, then fix any errors to enable publishing.',
          waiting_for_backend:
            "_We're still setting things up. Publishing will be available soon.",
        },
      },
      validate_button: {
        tooltip: {
          no_changes: '_There are no changes to validate.',
          check_solution: '_Check your solution for errors.',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
      modality_floating: '_Floating (Launcher + Tray)',
      modality_fullpage: '_Full Page',
      modality_preview_label: '_Preview modality (read-only)',
      modality_preview_readonly: '_Change the modality in Shell settings',
      preview_title: '_Preview',
      preview_stage_label: '_Pype widget preview',
      open_real_preview_title: '_Open Real Preview',
      open_real_preview_tooltip:
        "_Boots this channel in the environment's Pype Next preview harness — a real conversation, not the mock on the Pype Theme tab.",
      open_real_preview_copy_tooltip: '_Copy App ID',
      open_real_preview_copied: '_App ID has been copied to your clipboard.',
      open_real_preview_open_tooltip: '_Open the preview harness in a new tab',
      embed_code_title: '_Embed code',
      embed_code_description: '_Paste this on your site to run this channel.',
      embed_code_copy_tooltip: '_Copy embed code',
      embed_code_copied: '_Embed code has been copied to your clipboard.',
      embed_code_docs_link: '_Full integration docs',
      raw_css_description:
        'Appended last, after theme tokens and part overrides.',
      raw_css_example_all_label: 'Every text message:',
      raw_css_example_one_label: 'Only messages tagged with a custom class:',
      raw_css_example_note:
        'The custom class must be configured on the node from the solution design side.',
      raw_css_edit_button: 'Edit Style Sheet',
      raw_css_editor_title: 'Custom CSS',
      raw_css_set: 'Custom CSS set',
      raw_css_empty: 'No custom CSS',
      preview_zoom: '_shown at {{percent}}% scale to fit your window',
      preview_zoom_clipped: '_shown at {{percent}}% — window too short to fit',
      shell_size_range: '_{{wMin}}–{{wMax}} × {{hMin}}–{{hMax}} px',
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
      group_color: {
        tooltip: '_Group color',
      },
      behaviors_cell: {
        open: '_Open behaviors selection',
        open_with_values: '_Open behaviors selection: {{values}}',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: 'Actions',
      subtitle: {
        part1:
          'Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: 'the documentation',
      },
      section1: {
        title: 'Configuration',
        label: 'File Name',
        action: 'Upload Config',
      },
      section2: {
        title: 'Functions',
        label: 'File Name',
        action: 'Upload Scripts',
      },
      deleteFilePopover: {
        title: 'Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: 'Save',
          progress: 'Saving',
        },
        cancel: 'Cancel',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: 'Create Channel',
        update: 'Update Channel',
      },
      form: {
        titles: {
          'channel-details': 'Channel Details',
          'branding-options': 'Branding Options',
          'sizing-options': 'Sizing Options',
          'agent-support-platform': 'Agent Support Platform',
          preview: 'Preview',
        },
        labels: {
          'channel-name': 'Channel Name',
          environment: 'Environment',
          'launcher-name': 'Launcher Name',
          logo: 'Logo',
          'brand-moment-url': 'Brand Moment URL',
          'brand-color': 'Brand Color',
          'solution-bubble-color': 'Solution Bubble Color',
          'solution-text-color': 'Solution Text Color',
          'user-bubble-color': 'User Bubble Color',
          'user-text-color': 'User Text Color',
          'button-color': 'Button Color',
          'button-text-color': 'Button Text Color',
          width: 'Width',
          height: 'Height',
          'account-id': 'Account Id',
          'inbox-id': 'Inbox Id',
          or: 'or',
        },
        placeholders: {
          'channel-name': 'Channel Name',
          environment: 'Select Environment',
          'launcher-name': 'Engage with us',
          logo: 'Logo URL',
          'brand-moment-url': 'Brand Moment URL',
          'brand-color': 'Brand Color',
          'solution-bubble-color': 'Solution Bubble Color',
          'solution-text-color': 'Solution Text Color',
          'user-bubble-color': 'User Bubble Color',
          'user-text-color': 'User Text Color',
          'button-color': 'Button Color',
          'button-text-color': 'Button Text Color',
          width: 'Width',
          height: 'Height',
          pixels: 'Pixels',
        },
        'validation-messages': {
          integration:
            'This field is required when other agent support fields are filled',
          env: 'Environment is required',
          name: 'Channel name is required',
          projectId: 'Project ID is required',
          customerId: 'Customer ID is required',
          botId: 'Bot ID is required',
          'brand-moment-upload':
            'Could not resolve the uploaded Brand Moment URL',
        },
        errors: {
          'save-failed': 'Your changes could not be saved. Please try again.',
          'save-timeout': 'Your changes could not be saved. Please try again.',
        },
        'help-texts': {
          env: 'Cannot be changed after channel is created.',
          preview:
            'The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: 'Cancel',
          save: 'Save',
          reset: 'Reset',
          edit: 'Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: 'Channels',
      subtitle:
        'Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      addchannel: 'Add Channel',
      table: {
        column1: 'Name',
        column2: 'Environment',
        column3: 'Last edited',
      },
      deleteChannelModal: {
        title: 'Are you sure?',
        description:
          'Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: 'Cancel',
        delete: 'Delete Channel',
      },
      toasts: {
        appIdCopied: 'App ID has been copied to your clipboard.',
        embedCodeCopied: 'Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: 'Pro Studio',
      loading: 'Loading',
      workflowsTableStatus: {
        loading: 'Loading workflows',
        loaded: 'Workflows loaded',
      },
      orgPrefix: 'for',
      versionPrefix: 'from',
      userNamePrefix: 'by',
      environments: {
        sandbox: 'Sandbox',
        live: 'Live',
      },
      versions: {
        draft: 'Draft',
        sandbox: 'Sandbox',
        live: 'Live',
      },
      deleteFilePopover: {
        cancel: 'Cancel',
        delete: 'Delete',
      },
      deleteTaskModal: {
        title: 'Delete Task?',
        description:
          'Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: 'Cancel',
        delete: 'Delete',
      },
      unsavedChangesModal: {
        title: 'You have unsaved changes',
        body: 'If you leave now, your changes will be lost.',
        leave: 'Leave without saving',
        saveAndLeave: 'Save and leave',
        saving: 'Saving...',
        saveError: 'Your changes could not be saved. Please try again.',
      },
      errorBoundary: {
        reloadPage: 'Reload Page',
        goHome: 'Go Home',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: 'Media and Files',
      description: {
        part1:
          "In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: 'Designing Agents',
      },
      filepond: {
        previewLabel: 'Drag a file here',
      },
      deleteFilePopover: {
        title: 'Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: 'Solutions',
      create: 'Create Solution',
      table: {
        column1: 'Solution Title',
        column2: 'Last Updated',
      },
      modal: {
        title: 'Create Solution',
        form: {
          name: {
            placeholder: 'Solution Title',
            validation: {
              uniqueness: 'Uniqueness',
              length: 'Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: 'Create',
          creating: 'Creating...',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'keyboard-shortcuts',
    translations: {
      title: 'Keyboard Shortcuts',
      platform: {
        mac: 'Mac',
        windows: 'Windows',
      },
      sections: {
        help: 'Help',
        navigation: 'Navigation',
        selection: 'Selection',
        editing: 'Editing',
        clipboard: 'Clipboard',
        undoRedo: 'Undo/redo',
        expandedCellEditor: 'Expanded cell view — JSON editor',
      },
      rows: {
        openPanel: 'Open this shortcuts panel',
        moveCells: 'Move between cells',
        jumpColumn: 'Jump to next data block, up/down column',
        jumpRow: 'Jump to next data block, across row',
        toggleCell: 'Toggle focused cell (edit/check box)',
        deselect: 'Deselect, clear clipboard highlight',
        filterNode: 'Filter Node',
        selectAll: 'Select all rows',
        selectRow: 'Select focused row',
        extendSelection: 'Extend selection',
        enterEdit: 'Enter edit mode / commit and move down',
        commitNext: 'Commit cell and move to next',
        expandedCellView: 'Toggle expanded cell view',
        panelCommit: 'Commit the cell and move down',
        panelNewLine: 'Insert a line break inside the value',
        panelIndent: 'Indent / outdent inside the value',
        panelTabFocus: 'Release Tab so it moves focus again',
        clearCell: "Clear focused cell's value",
        copy: 'Copy',
        cut: 'Cut',
        paste: 'Paste',
        autoRenumber: 'Auto-renumber pasted nodes',
        undo: 'Undo',
        redo: 'Redo',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: 'Versions',
        channels: 'Channels',
        actions: 'Actions',
        workflows: 'Workflows',
        publish: 'Publish',
        files: 'Files',
        solutions: 'Solutions',
        project_settings: 'Project Settings',
        default_messages: 'Default Messages',
        more: 'More',
      },
      project_settings: {
        placeholder: 'Coming soon.',
        live_agent_platforms: 'Live Agent Platforms',
        reporting_api_credentials: 'Reporting API Credentials',
        data_privacy: 'Data Privacy',
        advanced_settings: 'Advanced Settings',
      },
      settings: {
        title: 'Solution Type',
        radio_group: {
          radio1: 'Main',
          radio2: 'Survey',
          radio3: 'Unknown',
        },
        button: 'Delete',
      },
      delete_solution_modal: {
        title: 'Delete this solution?',
        subtitle: {
          part1: 'Deleting',
          part2:
            'deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: 'To verify, type',
          part2: 'below',
        },
        buttons: {
          decline: 'Cancel',
          accept: 'Delete',
        },
      },
      publish_modal: {
        title: {
          part1: 'Publish',
          solution_type: 'Survey',
        },
        active_coworkers: {
          banner_message:
            'Other people are working on this solution. Review any changes before publishing. Publishing now may discard their in-progress edits.',
        },
        button: {
          static: 'Publish',
          loading: 'Publishing',
          publish_anyway: 'Publish anyway',
        },
        form: {
          part1: {
            title: 'Select an environment:',
          },
          part2: {
            title: 'For the following solutions:',
            select: {
              placeholder: 'Select solution',
              loading_placeholder: 'Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "The solution has been published, you've been switched to edit mode.",
          publish_failed:
            'There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            'Failed to save pending changes. Please try publishing again.',
          duplicate_node_numbers:
            'This solution has duplicate node numbers. Node numbers must be unique — fix the highlighted cells and try publishing again.',
          missing_node_numbers:
            'This solution has rows without a node number. Every node needs one — fix the highlighted cells and try publishing again.',
          validation_incomplete:
            'The last validation run did not finish, so this solution has not been checked. Validation has been restarted — wait for it to complete, then try publishing again.',
          invalid_node_numbers:
            'This solution has cells that do not hold a usable node number. Enter a whole number other than 0 in each — fix the highlighted cells and try publishing again.',
        },
      },
      validation_popover: {
        auto_validation_toggle_label: 'Automatic validation',
        empty_state:
          'There are no errors, your solution is ready to be published.',
        incomplete_state:
          'Validation did not finish, so these results may be out of date. Publishing stays disabled until a validation run completes.',
        tab: {
          agent_validator: 'Agent Validator {{count}}',
          bot_compiler: 'Bot Compiler {{count}}',
          errors: 'Errors {{count}}',
          download_diagnostics: 'Download Agent Compiler Data',
        },
        error_row: {
          hidden_row_hint:
            'This row is hidden — clear the search or expand its group to open it.',
          unknown_error: 'Unknown validation error',
        },
        trigger: {
          label_clean: 'Solution validation: no errors',
          label_incomplete: 'Solution validation: did not finish',
          label_with_errors_one: 'Solution validation: {{count}} error',
          label_with_errors_other: 'Solution validation: {{count}} errors',
        },
      },
      publish_button: {
        tooltip: {
          publishing_in_progress: 'Publishing is in progress.',
          fix_errors: 'Fix any errors to enable publishing.',
          validate_then_fix:
            'Click Validate to check your changes, then fix any errors to enable publishing.',
          waiting_for_backend:
            "We're still setting things up. Publishing will be available soon.",
        },
      },
      validate_button: {
        tooltip: {
          no_changes: 'There are no changes to validate.',
          check_solution: 'Check your solution for errors.',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'performance',
    translations: {
      title: 'Performance metrics',
      subtitle: 'type="{{type}}" · {{filtered}} of {{total}} rows',
      filters: {
        from: 'From',
        to: 'To',
        scenario: 'Scenario',
        metric: 'Metric',
        all: 'All',
      },
      scenarios: {
        'cold-render': 'Cold render',
        scroll: 'Scroll',
        'single-drag': 'Single drag',
        'search-typing': 'Search typing',
        'idle-snapshot': 'Idle snapshot',
      },
      metrics: {
        jsHeapUsedSize: 'JS heap used',
        scriptingMs: 'Scripting CPU',
        meanFps: 'Mean FPS',
        domRows: 'DOM rows',
        wallMs: 'Wall time',
      },
      table: {
        created: 'Created',
        scenario: 'Scenario',
        rows: 'Rows',
        commit: 'Commit',
        branch: 'Branch',
        pr: 'PR',
        heap: 'Heap',
        scripting: 'Scripting (ms)',
        fps: 'FPS',
        domRows: 'DOM rows',
        details: 'Details',
      },
      chart: {
        caption: '{{metric}} over time, one line per dataset size',
        noData: 'No data for scenario "{{scenario}}".',
      },
      errors: {
        loadFailed: 'Failed to load metrics: {{message}}',
      },
      empty: {
        title: 'No perf metrics found.',
        hint: 'Run the bench in CI (label “with-performance-test”) or upload locally via scripts/upload-perf-metrics.mjs.',
      },
      detail: {
        title: '{{scenario}} · {{size}} rows',
        labels: {
          id: 'id',
          createdAt: 'createdAt',
          commit: 'commit',
          branch: 'branch',
          pr: 'PR',
          runId: 'runId',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      saving: 'Saving...',
      save_changes: 'Save Changes',
      cancel: 'Cancel',
      unsaved_changes: 'There are unsaved changes',
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
      raw_css_description:
        'Appended last, after theme tokens and part overrides.',
      raw_css_example_all_label: 'Every text message:',
      raw_css_example_one_label: 'Only messages tagged with a custom class:',
      raw_css_example_note:
        'The custom class must be configured on the node from the solution design side.',
      raw_css_edit_button: 'Edit Style Sheet',
      raw_css_editor_title: 'Custom CSS',
      raw_css_set: 'Custom CSS set',
      raw_css_empty: 'No custom CSS',
      shell_section_title: 'Shell',
      modality_label: 'Modality',
      shell_size_label: 'Frame size (optional)',
      shell_size_range: '{{wMin}}–{{wMax}} × {{hMin}}–{{hMax}} px',
      branding_section_title: 'Branding',
      display_name_label: 'Display name',
      customer_logo_url_label: 'Customer logo URL',
      brand_moment_url_label: 'Brand moment URL',
      launcher_name_label: 'Launcher name',
      design_config_json_label: 'WidgetAppConfig JSON',
      design_config_json_description:
        'Backend contract — the exact JSON sent to the engagement API on save.',
      modality_floating: 'Floating (Launcher + Tray)',
      modality_fullpage: 'Full Page',
      modality_preview_label: 'Preview modality (read-only)',
      modality_preview_readonly: 'Change the modality in Shell settings',
      preview_title: 'Preview',
      preview_stage_label: 'Pype widget preview',
      open_real_preview_title: 'Open Real Preview',
      open_real_preview_tooltip:
        "Boots this channel in the environment's Pype Next preview harness — a real conversation, not the mock on the Pype Theme tab.",
      open_real_preview_copy_tooltip: 'Copy App ID',
      open_real_preview_copied: 'App ID has been copied to your clipboard.',
      open_real_preview_open_tooltip: 'Open the preview harness in a new tab',
      embed_code_title: 'Embed code',
      embed_code_description: 'Paste this on your site to run this channel.',
      embed_code_copy_tooltip: 'Copy embed code',
      embed_code_copied: 'Embed code has been copied to your clipboard.',
      embed_code_docs_link: 'Full integration docs',
      preview_zoom: 'shown at {{percent}}% scale to fit your window',
      preview_zoom_clipped: 'shown at {{percent}}% — window too short to fit',
      launcher_style_label: 'Launcher',
      connecting_label: 'While connecting',
      welcome_label: 'Welcome',
      welcome_message_placeholder: 'Welcome message (optional)',
      welcome_persistent_label: 'Keep it in the conversation',
      welcome_persistent_note:
        'Off, the welcome disappears once the conversation connects. On, it stays as the first message.',
      show_thinking_bubble_label: 'Show thinking bubble',
      show_inline_loader_label: 'Show connecting placeholder',
      disable_slide_animation_label: 'Disable reveal animation',
      ignored_fills_container:
        'Floating only — a full-page widget fills its container.',
      ignored_no_launcher:
        'Floating only — a full-page widget has no launcher.',
      ignored_owns_the_page:
        'Floating only — a full-page widget owns the page.',
      language_label: 'Language',
      language_unset: 'Default (English)',
      language_host_note:
        'An embed that sets a language overrides this — the page it sits on knows better than the design does.',
      launcher_enabled_label:
        'With launcher (uncheck = headless / bring-your-own)',
      use_iframe_label: 'useIframe (isolate in an iframe)',
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: 'Copy DuploCloud ID',
        message: 'DuploCloud ID copied to clipboard',
      },
      cards: {
        title: 'Environments',
        button: 'Edit Workflows',
        empty:
          'To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: 'Last edited',
        no_published_label:
          'Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: 'Published Versions',
        column1: 'Version',
        column2: 'Environment',
        column3: 'Last published',
        buttons: {
          load_as_draft: 'Load as draft',
          republish: 'Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: 'Load',
          part2: 'as draft',
        },
        radio_group: {
          radio1: 'Restore all files',
          radio2: 'Restore without Actions',
        },
        button: 'Confirm',
      },
      republish_modal: {
        title: 'Republish',
        subtitle: 'Select environment:',
        button: {
          static: 'Republish',
          loading: 'Republishing...',
        },
        radio_group: {
          radio1: 'Republish all files',
          radio2: 'Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: 'Replace all nodes in this solution?',
        subtitle: 'Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: 'Replace Nodes',
          uploading: 'Uploading...',
          cancel: 'Cancel',
        },
      },
      group_color: {
        tooltip: 'Group color',
      },
      behaviors_cell: {
        open: 'Open behaviors selection',
        open_with_values: 'Open behaviors selection: {{values}}',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      workflowsTableStatus: {
        loading: '_Loading workflows',
        loaded: '_Workflows loaded',
      },
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
      unsavedChangesModal: {
        title: '_You have unsaved changes',
        body: '_If you leave now, your changes will be lost.',
        leave: '_Leave without saving',
        saveAndLeave: '_Save and leave',
        saving: '_Saving...',
        saveError: '_Your changes could not be saved. Please try again.',
      },
      errorBoundary: {
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
        more: '_More',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solutions:',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
          duplicate_node_numbers:
            '_This solution has duplicate node numbers. Node numbers must be unique — fix the highlighted cells and try publishing again.',
          missing_node_numbers:
            '_This solution has rows without a node number. Every node needs one — fix the highlighted cells and try publishing again.',
          validation_incomplete:
            '_The last validation run did not finish, so this solution has not been checked. Validation has been restarted — wait for it to complete, then try publishing again.',
          invalid_node_numbers:
            '_This solution has cells that do not hold a usable node number. Enter a whole number other than 0 in each — fix the highlighted cells and try publishing again.',
        },
      },
      validation_popover: {
        auto_validation_toggle_label: '_Automatic validation',
        empty_state:
          '_There are no errors, your solution is ready to be published.',
        incomplete_state:
          '_Validation did not finish, so these results may be out of date. Publishing stays disabled until a validation run completes.',
        tab: {
          agent_validator: '_Agent Validator {{count}}',
          bot_compiler: '_Bot Compiler {{count}}',
          errors: '_Errors {{count}}',
          download_diagnostics: '_Download Agent Compiler Data',
        },
        error_row: {
          hidden_row_hint:
            '_This row is hidden — clear the search or expand its group to open it.',
          unknown_error: '_Unknown validation error',
        },
        trigger: {
          label_clean: '_Solution validation: no errors',
          label_incomplete: '_Solution validation: did not finish',
          label_with_errors_one: '_Solution validation: {{count}} error',
          label_with_errors_other: '_Solution validation: {{count}} errors',
        },
      },
      publish_button: {
        tooltip: {
          publishing_in_progress: '_Publishing is in progress.',
          fix_errors: '_Fix any errors to enable publishing.',
          validate_then_fix:
            '_Click Validate to check your changes, then fix any errors to enable publishing.',
          waiting_for_backend:
            "_We're still setting things up. Publishing will be available soon.",
        },
      },
      validate_button: {
        tooltip: {
          no_changes: '_There are no changes to validate.',
          check_solution: '_Check your solution for errors.',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
      modality_floating: '_Floating (Launcher + Tray)',
      modality_fullpage: '_Full Page',
      modality_preview_label: '_Preview modality (read-only)',
      modality_preview_readonly: '_Change the modality in Shell settings',
      preview_title: '_Preview',
      preview_stage_label: '_Pype widget preview',
      open_real_preview_title: '_Open Real Preview',
      open_real_preview_tooltip:
        "_Boots this channel in the environment's Pype Next preview harness — a real conversation, not the mock on the Pype Theme tab.",
      open_real_preview_copy_tooltip: '_Copy App ID',
      open_real_preview_copied: '_App ID has been copied to your clipboard.',
      open_real_preview_open_tooltip: '_Open the preview harness in a new tab',
      embed_code_title: '_Embed code',
      embed_code_description: '_Paste this on your site to run this channel.',
      embed_code_copy_tooltip: '_Copy embed code',
      embed_code_copied: '_Embed code has been copied to your clipboard.',
      embed_code_docs_link: '_Full integration docs',
      raw_css_description:
        'Appended last, after theme tokens and part overrides.',
      raw_css_example_all_label: 'Every text message:',
      raw_css_example_one_label: 'Only messages tagged with a custom class:',
      raw_css_example_note:
        'The custom class must be configured on the node from the solution design side.',
      raw_css_edit_button: 'Edit Style Sheet',
      raw_css_editor_title: 'Custom CSS',
      raw_css_set: 'Custom CSS set',
      raw_css_empty: 'No custom CSS',
      preview_zoom: '_shown at {{percent}}% scale to fit your window',
      preview_zoom_clipped: '_shown at {{percent}}% — window too short to fit',
      shell_size_range: '_{{wMin}}–{{wMax}} × {{hMin}}–{{hMax}} px',
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
      group_color: {
        tooltip: '_Group color',
      },
      behaviors_cell: {
        open: '_Open behaviors selection',
        open_with_values: '_Open behaviors selection: {{values}}',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      workflowsTableStatus: {
        loading: '_Loading workflows',
        loaded: '_Workflows loaded',
      },
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
      unsavedChangesModal: {
        title: '_You have unsaved changes',
        body: '_If you leave now, your changes will be lost.',
        leave: '_Leave without saving',
        saveAndLeave: '_Save and leave',
        saving: '_Saving...',
        saveError: '_Your changes could not be saved. Please try again.',
      },
      errorBoundary: {
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
        more: '_More',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solutions:',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
          duplicate_node_numbers:
            '_This solution has duplicate node numbers. Node numbers must be unique — fix the highlighted cells and try publishing again.',
          missing_node_numbers:
            '_This solution has rows without a node number. Every node needs one — fix the highlighted cells and try publishing again.',
          validation_incomplete:
            '_The last validation run did not finish, so this solution has not been checked. Validation has been restarted — wait for it to complete, then try publishing again.',
          invalid_node_numbers:
            '_This solution has cells that do not hold a usable node number. Enter a whole number other than 0 in each — fix the highlighted cells and try publishing again.',
        },
      },
      validation_popover: {
        auto_validation_toggle_label: '_Automatic validation',
        empty_state:
          '_There are no errors, your solution is ready to be published.',
        incomplete_state:
          '_Validation did not finish, so these results may be out of date. Publishing stays disabled until a validation run completes.',
        tab: {
          agent_validator: '_Agent Validator {{count}}',
          bot_compiler: '_Bot Compiler {{count}}',
          errors: '_Errors {{count}}',
          download_diagnostics: '_Download Agent Compiler Data',
        },
        error_row: {
          hidden_row_hint:
            '_This row is hidden — clear the search or expand its group to open it.',
          unknown_error: '_Unknown validation error',
        },
        trigger: {
          label_clean: '_Solution validation: no errors',
          label_incomplete: '_Solution validation: did not finish',
          label_with_errors_one: '_Solution validation: {{count}} error',
          label_with_errors_few: '_Solution validation: {{count}} errors',
          label_with_errors_many: '_Solution validation: {{count}} errors',
          label_with_errors_other: '_Solution validation: {{count}} errors',
        },
      },
      publish_button: {
        tooltip: {
          publishing_in_progress: '_Publishing is in progress.',
          fix_errors: '_Fix any errors to enable publishing.',
          validate_then_fix:
            '_Click Validate to check your changes, then fix any errors to enable publishing.',
          waiting_for_backend:
            "_We're still setting things up. Publishing will be available soon.",
        },
      },
      validate_button: {
        tooltip: {
          no_changes: '_There are no changes to validate.',
          check_solution: '_Check your solution for errors.',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
      modality_floating: '_Floating (Launcher + Tray)',
      modality_fullpage: '_Full Page',
      modality_preview_label: '_Preview modality (read-only)',
      modality_preview_readonly: '_Change the modality in Shell settings',
      preview_title: '_Preview',
      preview_stage_label: '_Pype widget preview',
      open_real_preview_title: '_Open Real Preview',
      open_real_preview_tooltip:
        "_Boots this channel in the environment's Pype Next preview harness — a real conversation, not the mock on the Pype Theme tab.",
      open_real_preview_copy_tooltip: '_Copy App ID',
      open_real_preview_copied: '_App ID has been copied to your clipboard.',
      open_real_preview_open_tooltip: '_Open the preview harness in a new tab',
      embed_code_title: '_Embed code',
      embed_code_description: '_Paste this on your site to run this channel.',
      embed_code_copy_tooltip: '_Copy embed code',
      embed_code_copied: '_Embed code has been copied to your clipboard.',
      embed_code_docs_link: '_Full integration docs',
      raw_css_description:
        'Appended last, after theme tokens and part overrides.',
      raw_css_example_all_label: 'Every text message:',
      raw_css_example_one_label: 'Only messages tagged with a custom class:',
      raw_css_example_note:
        'The custom class must be configured on the node from the solution design side.',
      raw_css_edit_button: 'Edit Style Sheet',
      raw_css_editor_title: 'Custom CSS',
      raw_css_set: 'Custom CSS set',
      raw_css_empty: 'No custom CSS',
      preview_zoom: '_shown at {{percent}}% scale to fit your window',
      preview_zoom_clipped: '_shown at {{percent}}% — window too short to fit',
      shell_size_range: '_{{wMin}}–{{wMax}} × {{hMin}}–{{hMax}} px',
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
      group_color: {
        tooltip: '_Group color',
      },
      behaviors_cell: {
        open: '_Open behaviors selection',
        open_with_values: '_Open behaviors selection: {{values}}',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      workflowsTableStatus: {
        loading: '_Loading workflows',
        loaded: '_Workflows loaded',
      },
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
      unsavedChangesModal: {
        title: '_You have unsaved changes',
        body: '_If you leave now, your changes will be lost.',
        leave: '_Leave without saving',
        saveAndLeave: '_Save and leave',
        saving: '_Saving...',
        saveError: '_Your changes could not be saved. Please try again.',
      },
      errorBoundary: {
        reloadPage: '_Reload Page',
        goHome: '_Go Home',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
        more: '_More',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solutions:',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
          duplicate_node_numbers:
            '_This solution has duplicate node numbers. Node numbers must be unique — fix the highlighted cells and try publishing again.',
          missing_node_numbers:
            '_This solution has rows without a node number. Every node needs one — fix the highlighted cells and try publishing again.',
          validation_incomplete:
            '_The last validation run did not finish, so this solution has not been checked. Validation has been restarted — wait for it to complete, then try publishing again.',
          invalid_node_numbers:
            '_This solution has cells that do not hold a usable node number. Enter a whole number other than 0 in each — fix the highlighted cells and try publishing again.',
        },
      },
      validation_popover: {
        auto_validation_toggle_label: '_Automatic validation',
        empty_state:
          '_There are no errors, your solution is ready to be published.',
        incomplete_state:
          '_Validation did not finish, so these results may be out of date. Publishing stays disabled until a validation run completes.',
        tab: {
          agent_validator: '_Agent Validator {{count}}',
          bot_compiler: '_Bot Compiler {{count}}',
          errors: '_Errors {{count}}',
          download_diagnostics: '_Download Agent Compiler Data',
        },
        error_row: {
          hidden_row_hint:
            '_This row is hidden — clear the search or expand its group to open it.',
          unknown_error: '_Unknown validation error',
        },
        trigger: {
          label_clean: '_Solution validation: no errors',
          label_incomplete: '_Solution validation: did not finish',
          label_with_errors_other: '_Solution validation: {{count}} errors',
        },
      },
      publish_button: {
        tooltip: {
          publishing_in_progress: '_Publishing is in progress.',
          fix_errors: '_Fix any errors to enable publishing.',
          validate_then_fix:
            '_Click Validate to check your changes, then fix any errors to enable publishing.',
          waiting_for_backend:
            "_We're still setting things up. Publishing will be available soon.",
        },
      },
      validate_button: {
        tooltip: {
          no_changes: '_There are no changes to validate.',
          check_solution: '_Check your solution for errors.',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
      modality_floating: '_Floating (Launcher + Tray)',
      modality_fullpage: '_Full Page',
      modality_preview_label: '_Preview modality (read-only)',
      modality_preview_readonly: '_Change the modality in Shell settings',
      preview_title: '_Preview',
      preview_stage_label: '_Pype widget preview',
      open_real_preview_title: '_Open Real Preview',
      open_real_preview_tooltip:
        "_Boots this channel in the environment's Pype Next preview harness — a real conversation, not the mock on the Pype Theme tab.",
      open_real_preview_copy_tooltip: '_Copy App ID',
      open_real_preview_copied: '_App ID has been copied to your clipboard.',
      open_real_preview_open_tooltip: '_Open the preview harness in a new tab',
      embed_code_title: '_Embed code',
      embed_code_description: '_Paste this on your site to run this channel.',
      embed_code_copy_tooltip: '_Copy embed code',
      embed_code_copied: '_Embed code has been copied to your clipboard.',
      embed_code_docs_link: '_Full integration docs',
      raw_css_description:
        'Appended last, after theme tokens and part overrides.',
      raw_css_example_all_label: 'Every text message:',
      raw_css_example_one_label: 'Only messages tagged with a custom class:',
      raw_css_example_note:
        'The custom class must be configured on the node from the solution design side.',
      raw_css_edit_button: 'Edit Style Sheet',
      raw_css_editor_title: 'Custom CSS',
      raw_css_set: 'Custom CSS set',
      raw_css_empty: 'No custom CSS',
      preview_zoom: '_shown at {{percent}}% scale to fit your window',
      preview_zoom_clipped: '_shown at {{percent}}% — window too short to fit',
      shell_size_range: '_{{wMin}}–{{wMax}} × {{hMin}}–{{hMax}} px',
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
      group_color: {
        tooltip: '_Group color',
      },
      behaviors_cell: {
        open: '_Open behaviors selection',
        open_with_values: '_Open behaviors selection: {{values}}',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'لقد انتهت هذه المحادثة.',
      agentConnected: 'تم توصيلك بأحد الوكلاء بنجاح.',
      downloadTranscript: 'تنزيل النص',
      startNewConversation: 'بدء محادثة جديدة',
      returnToConversation: 'العودة إلى المحادثة',
      connecting: 'جارٍ الاتصال...',
      retry: 'إعادة المحاولة',
      reconnecting: 'جارٍ إعادة الاتصال...',
      connectionLost: 'تم فقدان الاتصال بالإنترنت',
      reconnectDescription:
        'تم فقدان الاتصال بالإنترنت. انقر على "إعادة الاتصال" للمحاولة مرة أخرى.',
      typeMessage: 'اكتب رسالة',
      inputSelect: 'اختر خيارًا',
      inputSelectOrType: 'اختر خيارًا أو اكتب رسالة',
      secureInput: 'اكتب رسالة آمنة',
      secureValueHidden: 'قيمة آمنة مخفية',
      redactedValue: 'معلومات شخصية محجوبة',
      startChat: 'بدء المحادثة',
      settings: 'الإعدادات',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      close: 'إغلاق',
      next: 'التالي',
      brandingTagline: 'عزّز أعمالك بوكلاء ذكاء اصطناعي أذكياء',
      poweredBy: 'مدعوم بواسطة',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'المساعد يفكّر',
      youSaid: 'لقد قلت',
      botSays: 'يقول المساعد',
      agentSays: 'يقول {{name}}',
      joinMeeting: 'الانضمام إلى الاجتماع',
      meetingInProgress: 'الاجتماع جارٍ — انقر لإعادة الانضمام',
      meetingExpired: 'رابط الاجتماع (منتهي الصلاحية)',
      embeddedContent: 'محتوى مضمّن',
      openInNewTab: 'فتح في علامة تبويب جديدة',
      skipToMain: 'تخطّي إلى المحتوى الرئيسي',
      customerLogoAlt: 'شعار {{customerName}}',
      selectDate: 'اختر التاريخ',
      selectTime: 'اختر الوقت',
      browseOptions: 'تصفّح الخيارات',
      carouselRoleDescription: 'عرض دوّار',
      carouselSlideLabel: 'الشريحة {{current}} من {{total}}',
      carouselPrevious: 'العنصر السابق',
      carouselNext: 'العنصر التالي',
      carouselGoToItem: 'الانتقال إلى العنصر {{index}}',
      collapse: 'طيّ',
      expand: 'توسيع',
      messageHistory: 'سجل الرسائل',
      reduce: 'تصغير',
      today: 'اليوم',
      at: 'في',
      a11yOptionsCount_zero: 'لا توجد خيارات.',
      a11yOptionsCount_one: 'يوجد خيار واحد.',
      a11yOptionsCount_two: 'يوجد خياران.',
      a11yOptionsCount_few: 'يوجد {{count}} خيارات.',
      a11yOptionsCount_many: 'يوجد {{count}} خيارًا.',
      a11yOptionsCount_other: 'يوجد {{count}} خيار.',
      listpickerSelectAll: 'تحديد الكل',
      listpickerSelectOption: 'اختر خيارًا',
      listpickerSearchAriaLabel: 'البحث عن خيارات التصفية',
      listpickerSearchPlaceholder: 'بحث…',
      listpickerNoResults: 'لا توجد خيارات مطابقة.',
      listpickerResults_zero: 'لا نتائج',
      listpickerResults_one: 'نتيجة واحدة',
      listpickerResults_two: 'نتيجتان',
      listpickerResults_few: '{{count}} نتائج',
      listpickerResults_many: '{{count}} نتيجة',
      listpickerResults_other: '{{count}} نتيجة',
      listpickerCondensed_zero: 'لم يتم التحديد',
      listpickerCondensed_one: 'تم تحديد واحد',
      listpickerCondensed_two: 'تم تحديد اثنين',
      listpickerCondensed_few: 'تم تحديد {{count}}',
      listpickerCondensed_many: 'تم تحديد {{count}}',
      listpickerCondensed_other: 'تم تحديد {{count}}',
      scrollToLatest: 'التمرير إلى أحدث رسالة',
      scrollToUnread_zero: 'لا رسائل جديدة، انتقل إلى الأحدث',
      scrollToUnread_one: 'رسالة جديدة واحدة، انتقل إلى الأحدث',
      scrollToUnread_two: 'رسالتان جديدتان، انتقل إلى الأحدث',
      scrollToUnread_few: '{{count}} رسائل جديدة، انتقل إلى الأحدث',
      scrollToUnread_many: '{{count}} رسالة جديدة، انتقل إلى الأحدث',
      scrollToUnread_other: '{{count}} رسالة جديدة، انتقل إلى الأحدث',
      showPassword: 'إظهار المحتوى الآمن',
      hidePassword: 'إخفاء المحتوى الآمن',
      clear: 'مسح',
      send: 'إرسال',
      yesterday: 'أمس',
      chatEndedActions: 'إجراءات بعد انتهاء المحادثة',
      openConversationDialog: 'فتح نافذة المحادثة مع {{title}}',
      agentTyping: 'الوكيل يكتب',
      agentAway: 'وكلاؤنا غير متاحين حاليًا.',
      agentBusy: 'وكلاؤنا مشغولون حاليًا. يُرجى الانتظار...',
      waitingForAgent: 'جارٍ توصيلك بأحد الوكلاء...',
      waitingForAgentWithSkill: 'جارٍ توصيلك بوكيل {{skill}}...',
      talkingWithAgent: 'محادثة مع {{name}}',
      home: 'الرئيسية',
      back: 'رجوع',
      menu: 'القائمة',
      minimize: 'تصغير',
      endConversation: 'إنهاء المحادثة',
      engageWithUs: 'تواصل معنا',
      noMessagesYet: 'لا توجد رسائل بعد',
      tryAgain: 'حاول مرة أخرى',
      gettingLocation: '... الحصول على الموقع الحالي',
      locationSharedMessage: 'هنا موقعي',
      selectFile: 'اختر ملفًا',
      upload: 'رفع',
      uploadComplete: 'اكتمل الرفع',
      uploadFailed: 'فشل التحميل',
      fileTooLarge:
        'هذا الملف كبير جدًا بحيث لا يمكن تحميله. الرجاء تحديد ملف أقل من {{maxSize}}.',
      dragOrClick: 'اسحب ملفًا أو انقر للاختيار',
      document: 'مستند',
      audioContent: 'محتوى صوتي',
      videoContent: 'محتوى فيديو',
      videoUnsupported: 'لا يمكن تشغيل هذا الفيديو في متصفحك.',
      unsupportedContent: 'محتوى غير مدعوم',
      unavailable: {
        error: {
          title: 'حدث خطأ ما',
          body: 'تعذّر تحميل المحادثة. يُرجى المحاولة مرة أخرى.',
          retry: 'حاول مرة أخرى',
        },
        maintenance: {
          title: 'المحادثة غير متاحة مؤقتًا',
          body: 'نجري صيانة مجدولة. يُرجى المعاودة قريبًا.',
        },
      },
      image: 'صورة',
      agentSharedImage: ' :تمت مشاركة صورة بواسطة {{name}}',
      assistantSharedImage: ' : شارك {{name}} صورة',
      starRating: 'تقييم بالنجوم',
      starRatingOrder: '{{current}} من {{total}} نجوم',
      submit: 'إرسال',
      closeConversationDialog: 'إنهاء المحادثة',
      waitingForAgentDescription: 'يرجى الانتظار بينما نقوم بتوصيلك بوكيل',
      agentTransferred: '.لقد تم نقلك إلى وكيل آخر',
      uploadingFile: 'أنت تقوم بتحميل : {{fileName}}',
      uploadedFile: 'لقد قمت بالتحميل {{fileName}}',
      attachedFile: 'مُرفَق : {{fileName}}',
      fileTypeNotPermitted: 'عذرًا، هذا النوع من الملفات غير مسموح به.',
      relaunch: 'إعادة التشغيل',
      screenReaderHintChrome:
        'للحصول على أفضل تجربة لقارئ الشاشة في Google Chrome، نقترح استخدام JAWS.',
      screenReaderHintFirefox:
        'للحصول على أفضل تجربة لقارئ الشاشة في Firefox، نقترح استخدام NVDA.',
      agentInitiatedCall: 'قام {{name}} ببدء مكالمة',
      clickToJoin: 'انقر للانضمام',
      callSessionInProgress: 'جلسة المكالمة الخاصة بك قيد التقدم',
      primaryNavigation: 'التنقل',
      agentTypingNamed: 'يكتب {{name}}',
      agentSaysUnnamed: 'الوكيل يقول',
      botIsThinkingNamed: '{{name}} يفكّر',
      talkingWithAgentUnnamed: 'محادثة مع وكيل',
      download: 'تنزيل',
      downloading: 'جارٍ التنزيل',
      downloadComplete: 'اكتمل التنزيل',
      downloadFailed: 'فشل التنزيل',
      attachFile: 'إرفاق ملف',
      removeAttachment: 'إزالة المرفق',
      uploadFailedConnection: 'فشل التحميل. تحقق من اتصالك.',
      fileTooLargeToUpload:
        'هذا الملف كبير جدًا بحيث لا يمكن تحميله. الرجاء تحديد ملف أقل من {{maxSize}}.',
      problemUploadingFile: 'حدثت مشكلة أثناء تحميل ملفك.',
      attachmentRemoved: 'تمت إزالة المرفق.',
      tomorrow: 'غداً',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'القائمة الرئيسية',
      goBack: 'العودة',
      expandInSameWindow: 'التوسيع في نفس النافذة',
      collapseDialog: 'طي مربع الحوار',
      closeDialog: 'إغلاق مربع الحوار',
    },
  },
  {
    lang: 'bg',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Този разговор приключи.',
      agentConnected: 'Успешно сте свързани с агент.',
      downloadTranscript: 'Изтегляне на разговора',
      startNewConversation: 'Започни нов разговор',
      returnToConversation: 'Обратно към разговора',
      connecting: 'Свързване...',
      retry: 'Опитай отново',
      reconnecting: 'Повторно свързване...',
      connectionLost: 'Връзката с интернет е загубена',
      reconnectDescription:
        'Връзката с интернет е загубена. Щракнете върху „Повторно свързване“, за да опитате отново.',
      typeMessage: 'Въведете съобщение',
      inputSelect: 'Изберете опция',
      inputSelectOrType: 'Изберете опция или въведете съобщение',
      secureInput: 'Въведете защитено съобщение',
      secureValueHidden: 'Скрита защитена стойност',
      redactedValue: 'Скрита лична информация',
      startChat: 'Започни чат',
      settings: 'Настройки',
      cancel: 'Отказ',
      confirm: 'Потвърди',
      close: 'Затвори',
      next: 'Напред',
      brandingTagline: 'Развийте бизнеса си с интелигентни AI агенти',
      poweredBy: 'Задвижвано от',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Асистентът мисли',
      youSaid: 'Вие казахте',
      botSays: 'Асистентът казва',
      agentSays: '{{name}} казва',
      joinMeeting: 'Присъедини се към срещата',
      meetingInProgress:
        'Срещата е в ход — щракнете, за да се присъедините отново',
      meetingExpired: 'Връзка към среща (изтекла)',
      embeddedContent: 'Вградено съдържание',
      openInNewTab: 'Отвори в нов раздел',
      skipToMain: 'Прескочи към основното съдържание',
      customerLogoAlt: 'Лого на {{customerName}}',
      selectDate: 'Изберете дата',
      selectTime: 'Изберете час',
      browseOptions: 'Прегледай опциите',
      carouselRoleDescription: 'Въртележка',
      carouselSlideLabel: 'Слайд {{current}} от {{total}}',
      carouselPrevious: 'Предишен елемент',
      carouselNext: 'Следващ елемент',
      carouselGoToItem: 'Към елемент {{index}}',
      collapse: 'Свий',
      expand: 'Разгъни',
      messageHistory: 'История на съобщенията',
      reduce: 'Намали',
      today: 'Днес',
      at: 'в',
      a11yOptionsCount_one: 'Има 1 опция.',
      a11yOptionsCount_other: 'Има {{count}} опции.',
      listpickerSelectAll: 'Избери всички',
      listpickerSelectOption: 'Изберете опция',
      listpickerSearchAriaLabel: 'Търсене на опции за филтриране',
      listpickerSearchPlaceholder: 'Търсене…',
      listpickerNoResults: 'Няма съвпадащи опции.',
      listpickerResults_one: '1 резултат',
      listpickerResults_other: '{{count}} резултата',
      listpickerCondensed_one: '1 избрана',
      listpickerCondensed_other: '{{count}} избрани',
      scrollToLatest: 'Към най-новото съобщение',
      scrollToUnread_one: '1 ново съобщение, към най-новото',
      scrollToUnread_other: '{{count}} нови съобщения, към най-новото',
      showPassword: 'Покажи защитеното съдържание',
      hidePassword: 'Скрий защитеното съдържание',
      clear: 'Изчисти',
      send: 'Изпрати',
      yesterday: 'Вчера',
      chatEndedActions: 'Действия след края на чата',
      openConversationDialog: 'Отвори прозореца за разговор с {{title}}',
      agentTyping: 'Агентът пише',
      agentAway: 'Нашите агенти в момента не са налични.',
      agentBusy: 'Нашите агенти в момента са заети. Моля, изчакайте...',
      waitingForAgent: 'Свързваме ви с агент...',
      waitingForAgentWithSkill: 'Свързваме ви с агент за {{skill}}...',
      talkingWithAgent: 'Разговор с {{name}}',
      home: 'Начало',
      back: 'Назад',
      menu: 'Меню',
      minimize: 'Намали',
      endConversation: 'Край на разговора',
      engageWithUs: 'Свържете се с нас',
      noMessagesYet: 'Все още няма съобщения',
      tryAgain: 'Опитай отново',
      gettingLocation: 'Получаване на текущото местоположение...',
      locationSharedMessage: 'Ето моето местоположение.',
      selectFile: 'Изберете файл',
      upload: 'Качи',
      uploadComplete: 'Качването завърши',
      uploadFailed: 'Качването е неуспешно',
      fileTooLarge:
        'Този файл е твърде голям за качване. Моля, изберете файл по-малък от {{maxSize}}.',
      dragOrClick: 'Плъзнете файл или щракнете, за да изберете',
      document: 'Документ',
      audioContent: 'Аудио съдържание',
      videoContent: 'Видео съдържание',
      videoUnsupported:
        'Това видео не може да се възпроизведе във вашия браузър.',
      unsupportedContent: 'Неподдържано съдържание',
      unavailable: {
        error: {
          title: 'Нещо се обърка',
          body: 'Не успяхме да заредим чата. Опитайте отново.',
          retry: 'Опитай отново',
        },
        maintenance: {
          title: 'Чатът е временно недостъпен',
          body: 'Извършваме планирана поддръжка. Върнете се скоро.',
        },
      },
      image: 'Изображение',
      agentSharedImage: '{{name}} сподели изображение: ',
      assistantSharedImage: '{{name}} сподели изображение: ',
      starRating: 'Оценка със звезди',
      starRatingOrder: '{{current}} от {{total}} звезди',
      submit: 'Изпращане',
      closeConversationDialog: 'Затваряне на разговора',
      waitingForAgentDescription: 'Моля, изчакайте, докато ви свържем с агент',
      agentTransferred: 'Вие сте прехвърлени към друг агент.',
      uploadingFile: 'Качвате: {{fileName}}',
      uploadedFile: 'Качихте {{fileName}}',
      attachedFile: 'Прикачен: {{fileName}}',
      fileTypeNotPermitted: 'Съжаляваме, този тип файл не е разрешен.',
      relaunch: 'Рестартирайте',
      screenReaderHintChrome:
        'За най-добро изживяване с екранен четец в Google Chrome препоръчваме да използвате JAWS.',
      screenReaderHintFirefox:
        'За най-добро изживяване с екранен четец във Firefox препоръчваме да използвате NVDA.',
      agentInitiatedCall: '{{name}} започна разговор',
      clickToJoin: 'Щракнете за да се присъедините',
      callSessionInProgress: 'Вашата сесия на разговор е в ход',
      primaryNavigation: 'Навигация',
      agentTypingNamed: '{{name}} пише',
      agentSaysUnnamed: 'Агентът казва',
      botIsThinkingNamed: '{{name}} мисли',
      talkingWithAgentUnnamed: 'Разговор с агент',
      download: 'Изтегляне',
      downloading: 'Изтегля се',
      downloadComplete: 'Изтеглянето завърши',
      downloadFailed: 'Изтеглянето е неуспешно',
      attachFile: 'Прикачване на файл',
      removeAttachment: 'Премахване на прикачения файл',
      uploadFailedConnection: 'Качването е неуспешно. Проверете връзката си.',
      fileTooLargeToUpload:
        'Този файл е твърде голям за качване. Моля, изберете файл по-малък от {{maxSize}}.',
      problemUploadingFile: 'Възникна проблем при качването на вашия файл.',
      attachmentRemoved: 'Прикаченият файл е премахнат.',
      tomorrow: 'утре',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Начално меню',
      goBack: 'Назад',
      expandInSameWindow: 'Разгъване в същия прозорец',
      collapseDialog: 'Свиване на диалога',
      closeDialog: 'Затваряне на диалога',
    },
  },
  {
    lang: 'bn',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'এই কথোপকথনটি শেষ হয়েছে।',
      agentConnected: 'আপনি সফলভাবে একজন এজেন্টের সাথে সংযুক্ত হয়েছেন।',
      downloadTranscript: 'ট্রান্সক্রিপ্ট ডাউনলোড করুন',
      startNewConversation: 'নতুন কথোপকথন শুরু করুন',
      returnToConversation: 'কথোপকথনে ফিরে যান',
      connecting: 'সংযোগ করা হচ্ছে...',
      retry: 'আবার চেষ্টা করুন',
      reconnecting: 'পুনরায় সংযোগ করা হচ্ছে...',
      connectionLost: 'ইন্টারনেট সংযোগ বিচ্ছিন্ন হয়েছে',
      reconnectDescription:
        "ইন্টারনেট সংযোগ বিচ্ছিন্ন হয়েছে। আবার চেষ্টা করতে 'পুনরায় সংযোগ করুন' এ ক্লিক করুন।",
      typeMessage: 'বার্তা টাইপ করুন',
      inputSelect: 'একটি বিকল্প নির্বাচন করুন',
      inputSelectOrType: 'একটি বিকল্প নির্বাচন করুন বা বার্তা টাইপ করুন',
      secureInput: 'নিরাপদ বার্তা টাইপ করুন',
      secureValueHidden: 'লুকানো নিরাপদ মান',
      redactedValue: 'লুকানো ব্যক্তিগত তথ্য',
      startChat: 'চ্যাট শুরু করুন',
      settings: 'সেটিংস',
      cancel: 'বাতিল করুন',
      confirm: 'নিশ্চিত করুন',
      close: 'বন্ধ করুন',
      next: 'পরবর্তী',
      brandingTagline:
        'বুদ্ধিমান AI এজেন্ট দিয়ে আপনার ব্যবসাকে শক্তিশালী করুন',
      poweredBy: 'চালিত',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'সহকারী ভাবছে',
      youSaid: 'আপনি বলেছেন',
      botSays: 'সহকারী বলে',
      agentSays: '{{name}} বলেন',
      joinMeeting: 'মিটিংয়ে যোগ দিন',
      meetingInProgress: 'মিটিং চলছে — পুনরায় যোগ দিতে ক্লিক করুন',
      meetingExpired: 'মিটিং লিঙ্ক (মেয়াদোত্তীর্ণ)',
      embeddedContent: 'এমবেড করা বিষয়বস্তু',
      openInNewTab: 'নতুন ট্যাবে খুলুন',
      skipToMain: 'মূল বিষয়বস্তুতে যান',
      customerLogoAlt: '{{customerName}} লোগো',
      selectDate: 'তারিখ নির্বাচন করুন',
      selectTime: 'সময় নির্বাচন করুন',
      browseOptions: 'বিকল্পগুলি দেখুন',
      carouselRoleDescription: 'ক্যারোজেল',
      carouselSlideLabel: 'স্লাইড {{current}} / {{total}}',
      carouselPrevious: 'পূর্ববর্তী আইটেম',
      carouselNext: 'পরবর্তী আইটেম',
      carouselGoToItem: 'আইটেম {{index}} এ যান',
      collapse: 'সংকুচিত করুন',
      expand: 'প্রসারিত করুন',
      messageHistory: 'বার্তার ইতিহাস',
      reduce: 'ছোট করুন',
      today: 'আজ',
      at: '',
      a11yOptionsCount_one: '1টি বিকল্প রয়েছে।',
      a11yOptionsCount_other: '{{count}}টি বিকল্প রয়েছে।',
      listpickerSelectAll: 'সব নির্বাচন করুন',
      listpickerSelectOption: 'একটি বিকল্প নির্বাচন করুন',
      listpickerSearchAriaLabel: 'ফিল্টার বিকল্প অনুসন্ধান করুন',
      listpickerSearchPlaceholder: 'অনুসন্ধান…',
      listpickerNoResults: 'কোনো মিল থাকা বিকল্প নেই।',
      listpickerResults_one: '1টি ফলাফল',
      listpickerResults_other: '{{count}}টি ফলাফল',
      listpickerCondensed_one: '1টি নির্বাচিত',
      listpickerCondensed_other: '{{count}}টি নির্বাচিত',
      scrollToLatest: 'সর্বশেষ বার্তায় স্ক্রোল করুন',
      scrollToUnread_one: '1টি নতুন বার্তা, সর্বশেষে যান',
      scrollToUnread_other: '{{count}}টি নতুন বার্তা, সর্বশেষে যান',
      showPassword: 'নিরাপদ বিষয়বস্তু দেখান',
      hidePassword: 'নিরাপদ বিষয়বস্তু লুকান',
      clear: 'সাফ করুন',
      send: 'পাঠান',
      yesterday: 'গতকাল',
      chatEndedActions: 'চ্যাট শেষ হওয়ার পরের কাজ',
      openConversationDialog: '{{title}} এর সাথে কথোপকথন ডায়ালগ খুলুন',
      agentTyping: 'এজেন্ট টাইপ করছেন',
      agentAway: 'আমাদের এজেন্টরা এই মুহূর্তে উপলব্ধ নয়।',
      agentBusy:
        'আমাদের এজেন্টরা এই মুহূর্তে ব্যস্ত। অনুগ্রহ করে অপেক্ষা করুন...',
      waitingForAgent: 'আপনাকে একজন এজেন্টের সাথে সংযুক্ত করা হচ্ছে...',
      waitingForAgentWithSkill:
        'আপনাকে একজন {{skill}} এজেন্টের সাথে সংযুক্ত করা হচ্ছে...',
      talkingWithAgent: '{{name}} এর সাথে কথা বলছেন',
      home: 'হোম',
      back: 'পিছনে',
      menu: 'মেনু',
      minimize: 'ছোট করুন',
      endConversation: 'কথোপকথন শেষ করুন',
      engageWithUs: 'আমাদের সাথে যোগাযোগ করুন',
      noMessagesYet: 'এখনও কোনো বার্তা নেই',
      tryAgain: 'আবার চেষ্টা করুন',
      gettingLocation: 'বর্তমান অবস্থান পাওয়া যাচ্ছে...',
      locationSharedMessage: 'এখানে আমার অবস্থান',
      selectFile: 'একটি ফাইল নির্বাচন করুন',
      upload: 'আপলোড করুন',
      uploadComplete: 'আপলোড সম্পূর্ণ',
      uploadFailed: 'আপলোড ব্যর্থ হয়েছে',
      fileTooLarge:
        'এই ফাইলটি আপলোড করার জন্য খুব বড়। অনুগ্রহ করে {{maxSize}} এর কম আকারের একটি ফাইল নির্বাচন করুন।',
      dragOrClick: 'একটি ফাইল টেনে আনুন বা নির্বাচন করতে ক্লিক করুন',
      document: 'নথি',
      audioContent: 'অডিও বিষয়বস্তু',
      videoContent: 'ভিডিও বিষয়বস্তু',
      videoUnsupported: 'এই ভিডিওটি আপনার ব্রাউজারে চালানো যাচ্ছে না।',
      unsupportedContent: 'অসমর্থিত বিষয়বস্তু',
      unavailable: {
        error: {
          title: 'কিছু ভুল হয়েছে',
          body: 'আমরা চ্যাট লোড করতে পারিনি। অনুগ্রহ করে আবার চেষ্টা করুন।',
          retry: 'আবার চেষ্টা করুন',
        },
        maintenance: {
          title: 'চ্যাট সাময়িকভাবে অনুপলব্ধ',
          body: 'আমরা নির্ধারিত রক্ষণাবেক্ষণ করছি। অনুগ্রহ করে শীঘ্রই ফিরে আসুন।',
        },
      },
      image: 'ছবি',
      agentSharedImage: '{{name}} একটি ছবি শেয়ার করেছেন: ',
      assistantSharedImage: '{{name}} একটি ছবি শেয়ার করেছেন: ',
      starRating: 'তারকা রেটিং',
      starRatingOrder: '{{total}} তারকার মধ্যে {{current}}',
      submit: 'জমা দিন',
      closeConversationDialog: 'কথোপকথন বন্ধ করুন',
      waitingForAgentDescription:
        'অনুগ্রহ করে অপেক্ষা করুন যখন আমরা আপনাকে একজন এজেন্টের সাথে সংযুক্ত করছি',
      agentTransferred: 'আপনাকে অন্য এজেন্টে স্থানান্তর করা হয়েছে।',
      uploadingFile: 'আপনি আপলোড করছেন: {{fileName}}',
      uploadedFile: 'আপনি {{fileName}} আপলোড করেছেন',
      attachedFile: 'সংযুক্ত: {{fileName}}',
      fileTypeNotPermitted: 'দুঃখিত, এই ধরনের ফাইল অনুমোদিত নয়।',
      relaunch: 'পুনরায় চালু করুন',
      screenReaderHintChrome:
        "'Google Chrome''-এ সর্বোত্তম স্ক্রিনরিডার অভিজ্ঞতার জন্য, আমরা JAWS ব্যবহার করার পরামর্শ দিই।",
      screenReaderHintFirefox:
        'Firefox-এ সর্বোত্তম স্ক্রিনরিডার অভিজ্ঞতার জন্য, আমরা NVDA ব্যবহার করার পরামর্শ দিই।',
      agentInitiatedCall: '{{name}} একটি কল শুরু করেছেন',
      clickToJoin: 'যোগ দিতে ক্লিক করুন',
      callSessionInProgress: 'আপনার কল সেশন চলছে',
      primaryNavigation: 'নেভিগেশন',
      agentTypingNamed: '{{name}} টাইপ করছে',
      agentSaysUnnamed: 'এজেন্ট বলছেন',
      botIsThinkingNamed: '{{name}} ভাবছে',
      talkingWithAgentUnnamed: 'একজন এজেন্টের সাথে কথা বলছেন',
      download: 'ডাউনলোড',
      downloading: 'ডাউনলোড হচ্ছে',
      downloadComplete: 'ডাউনলোড সম্পূর্ণ',
      downloadFailed: 'ডাউনলোড ব্যর্থ হয়েছে',
      attachFile: 'ফাইল সংযুক্ত করুন',
      removeAttachment: 'সংযুক্তি সরান',
      uploadFailedConnection: 'আপলোড ব্যর্থ। আপনার সংযোগ পরীক্ষা করুন।',
      fileTooLargeToUpload:
        'এই ফাইলটি আপলোড করার জন্য খুব বড়। অনুগ্রহ করে {{maxSize}} এর কম আকারের একটি ফাইল নির্বাচন করুন।',
      problemUploadingFile: 'আপনার ফাইল আপলোড করার সময় একটি সমস্যা হয়েছে।',
      attachmentRemoved: 'সংযুক্তি সরানো হয়েছে।',
      tomorrow: 'কাল',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'হোম মেনু',
      goBack: 'ফিরে যান',
      expandInSameWindow: 'একই উইন্ডোতে প্রসারিত করুন',
      collapseDialog: 'ডায়ালগ সঙ্কুচিত করুন',
      closeDialog: 'ডায়ালগ বন্ধ করুন',
    },
  },
  {
    lang: 'cs',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Tato konverzace byla ukončena.',
      agentConnected: 'Byli jste úspěšně spojeni s operátorem.',
      downloadTranscript: 'Stáhnout přepis',
      startNewConversation: 'Zahájit novou konverzaci',
      returnToConversation: 'Zpět ke konverzaci',
      connecting: 'Připojování...',
      retry: 'Zkusit znovu',
      reconnecting: 'Opětovné připojování...',
      connectionLost: 'Připojení k internetu bylo ztraceno',
      reconnectDescription:
        'Připojení k internetu bylo ztraceno. Kliknutím na Znovu připojit to zkuste znovu.',
      typeMessage: 'Napište zprávu',
      inputSelect: 'Vyberte možnost',
      inputSelectOrType: 'Vyberte možnost nebo napište zprávu',
      secureInput: 'Napište zabezpečenou zprávu',
      secureValueHidden: 'Skrytá zabezpečená hodnota',
      redactedValue: 'Skryté osobní údaje',
      startChat: 'Zahájit chat',
      settings: 'Nastavení',
      cancel: 'Zrušit',
      confirm: 'Potvrdit',
      close: 'Zavřít',
      next: 'Další',
      brandingTagline: 'Posilte své podnikání s inteligentními agenty AI',
      poweredBy: 'Poháněno technologií',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistent přemýšlí',
      youSaid: 'Řekli jste',
      botSays: 'Asistent říká',
      agentSays: '{{name}} říká',
      joinMeeting: 'Připojit se ke schůzce',
      meetingInProgress: 'Schůzka probíhá — kliknutím se znovu připojíte',
      meetingExpired: 'Odkaz na schůzku (vypršel)',
      embeddedContent: 'Vložený obsah',
      openInNewTab: 'Otevřít na nové kartě',
      skipToMain: 'Přeskočit na hlavní obsah',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Vyberte datum',
      selectTime: 'Vyberte čas',
      browseOptions: 'Procházet možnosti',
      carouselRoleDescription: 'Karusel',
      carouselSlideLabel: 'Snímek {{current}} z {{total}}',
      carouselPrevious: 'Předchozí položka',
      carouselNext: 'Další položka',
      carouselGoToItem: 'Přejít na položku {{index}}',
      collapse: 'Sbalit',
      expand: 'Rozbalit',
      messageHistory: 'Historie zpráv',
      reduce: 'Zmenšit',
      today: 'Dnes',
      at: 'v',
      a11yOptionsCount_one: 'Je 1 možnost.',
      a11yOptionsCount_few: 'Jsou {{count}} možnosti.',
      a11yOptionsCount_many: 'Je {{count}} možnosti.',
      a11yOptionsCount_other: 'Je {{count}} možností.',
      listpickerSelectAll: 'Vybrat vše',
      listpickerSelectOption: 'Vyberte možnost',
      listpickerSearchAriaLabel: 'Hledat možnosti filtru',
      listpickerSearchPlaceholder: 'Hledat…',
      listpickerNoResults: 'Žádné odpovídající možnosti.',
      listpickerResults_one: '1 výsledek',
      listpickerResults_few: '{{count}} výsledky',
      listpickerResults_many: '{{count}} výsledku',
      listpickerResults_other: '{{count}} výsledků',
      listpickerCondensed_one: 'Vybráno 1',
      listpickerCondensed_few: 'Vybráno {{count}}',
      listpickerCondensed_many: 'Vybráno {{count}}',
      listpickerCondensed_other: 'Vybráno {{count}}',
      scrollToLatest: 'Přejít na nejnovější zprávu',
      scrollToUnread_one: '1 nová zpráva, přejít na nejnovější',
      scrollToUnread_few: '{{count}} nové zprávy, přejít na nejnovější',
      scrollToUnread_many: '{{count}} nové zprávy, přejít na nejnovější',
      scrollToUnread_other: '{{count}} nových zpráv, přejít na nejnovější',
      showPassword: 'Zobrazit zabezpečený obsah',
      hidePassword: 'Skrýt zabezpečený obsah',
      clear: 'Vymazat',
      send: 'Odeslat',
      yesterday: 'Včera',
      chatEndedActions: 'Akce po ukončení chatu',
      openConversationDialog: 'Otevřít okno konverzace s {{title}}',
      agentTyping: 'Operátor píše',
      agentAway: 'Naši operátoři jsou momentálně nedostupní.',
      agentBusy:
        'Naši operátoři jsou momentálně zaneprázdněni. Vyčkejte prosím...',
      waitingForAgent: 'Spojujeme vás s operátorem...',
      waitingForAgentWithSkill: 'Spojujeme vás s operátorem pro {{skill}}...',
      talkingWithAgent: 'Hovoříte s {{name}}',
      home: 'Domů',
      back: 'Zpět',
      menu: 'Nabídka',
      minimize: 'Minimalizovat',
      endConversation: 'Ukončit konverzaci',
      engageWithUs: 'Kontaktujte nás',
      noMessagesYet: 'Zatím žádné zprávy',
      tryAgain: 'Zkusit znovu',
      gettingLocation: 'Načítání aktuální polohy...',
      locationSharedMessage: 'Zde je moje poloha.',
      selectFile: 'Vyberte soubor',
      upload: 'Nahrát',
      uploadComplete: 'Nahrávání dokončeno',
      uploadFailed: 'Nahrávání se nezdařilo',
      fileTooLarge:
        'Tento soubor je příliš velký pro nahrání. Vyberte prosím soubor menší než {{maxSize}}.',
      dragOrClick: 'Přetáhněte soubor nebo klikněte pro výběr',
      document: 'Dokument',
      audioContent: 'Zvukový obsah',
      videoContent: 'Videoobsah',
      videoUnsupported: 'Toto video nelze ve vašem prohlížeči přehrát.',
      unsupportedContent: 'Nepodporovaný obsah',
      unavailable: {
        error: {
          title: 'Něco se pokazilo',
          body: 'Chat se nepodařilo načíst. Zkuste to znovu.',
          retry: 'Zkusit znovu',
        },
        maintenance: {
          title: 'Chat je dočasně nedostupný',
          body: 'Provádíme plánovanou údržbu. Vraťte se prosím brzy.',
        },
      },
      image: 'Obrázek',
      agentSharedImage: '{{name}} sdílel(a) obrázek:',
      assistantSharedImage: '{{name}} sdílel(a) obrázek:',
      starRating: 'Hodnocení hvězdami',
      starRatingOrder: '{{current}} z {{total}} hvězd',
      submit: 'Odeslat',
      closeConversationDialog: 'Ukončit konverzaci',
      waitingForAgentDescription: 'Prosím vyčkejte, připojujeme vás k agentovi',
      agentTransferred: 'Byli jste převedeni k jinému agentovi.',
      uploadingFile: 'Nahráváte: {{fileName}}',
      uploadedFile: 'Nahráli jste {{fileName}}',
      attachedFile: 'Příloha: {{fileName}}',
      fileTypeNotPermitted: 'Omlouváme se, tento typ souboru není povolen.',
      relaunch: 'Znovu spustit',
      screenReaderHintChrome:
        'Pro nejlepší zážitek se čtečkou obrazovky v Google Chrome doporučujeme používat JAWS.',
      screenReaderHintFirefox:
        'Pro nejlepší zážitek se čtečkou obrazovky ve Firefoxu doporučujeme používat NVDA.',
      agentInitiatedCall: '{{name}} zahájil(a) hovor',
      clickToJoin: 'Klikněte pro připojení',
      callSessionInProgress: 'Vaše relace hovoru probíhá',
      primaryNavigation: 'Navigace',
      agentTypingNamed: '{{name}} píše',
      agentSaysUnnamed: 'Agent říká',
      botIsThinkingNamed: '{{name}} přemýšlí',
      talkingWithAgentUnnamed: 'Hovoříte s agentem',
      download: 'Stáhnout',
      downloading: 'Stahování',
      downloadComplete: 'Stahování dokončeno',
      downloadFailed: 'Stahování se nezdařilo',
      attachFile: 'Přiložit soubor',
      removeAttachment: 'Odebrat přílohu',
      uploadFailedConnection: 'Nahrání selhalo. Zkontrolujte připojení.',
      fileTooLargeToUpload:
        'Tento soubor je příliš velký pro nahrání. Vyberte prosím soubor menší než {{maxSize}}.',
      problemUploadingFile: 'Při nahrávání vašeho souboru došlo k problému.',
      attachmentRemoved: 'Příloha odebrána.',
      tomorrow: 'Zítra',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Hlavní nabídka',
      goBack: 'Zpět',
      expandInSameWindow: 'Rozbalit ve stejném okně',
      collapseDialog: 'Sbalit dialog',
      closeDialog: 'Zavřít dialog',
    },
  },
  {
    lang: 'da',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Denne samtale er afsluttet.',
      agentConnected: 'Du er blevet forbundet til en medarbejder.',
      downloadTranscript: 'Download udskrift',
      startNewConversation: 'Start ny samtale',
      returnToConversation: 'Tilbage til samtalen',
      connecting: 'Opretter forbindelse...',
      retry: 'Prøv igen',
      reconnecting: 'Opretter forbindelse igen...',
      connectionLost: 'Internetforbindelsen er mistet',
      reconnectDescription:
        'Internetforbindelsen er mistet. Klik på Opret forbindelse igen for at prøve igen.',
      typeMessage: 'Skriv en besked',
      inputSelect: 'Vælg en mulighed',
      inputSelectOrType: 'Vælg en mulighed, eller skriv en besked',
      secureInput: 'Skriv en sikker besked',
      secureValueHidden: 'Skjult sikker værdi',
      redactedValue: 'Skjulte personoplysninger',
      startChat: 'Start chat',
      settings: 'Indstillinger',
      cancel: 'Annuller',
      confirm: 'Bekræft',
      close: 'Luk',
      next: 'Næste',
      brandingTagline: 'Styrk din virksomhed med intelligente AI-agenter',
      poweredBy: 'Leveret af',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Assistenten tænker',
      youSaid: 'Du sagde',
      botSays: 'Assistenten siger',
      agentSays: '{{name}} siger',
      joinMeeting: 'Deltag i møde',
      meetingInProgress: 'Møde i gang — klik for at deltage igen',
      meetingExpired: 'Mødelink (udløbet)',
      embeddedContent: 'Indlejret indhold',
      openInNewTab: 'Åbn i ny fane',
      skipToMain: 'Gå til hovedindhold',
      customerLogoAlt: '{{customerName}}-logo',
      selectDate: 'Vælg dato',
      selectTime: 'Vælg tidspunkt',
      browseOptions: 'Gennemse muligheder',
      carouselRoleDescription: 'Karrusel',
      carouselSlideLabel: 'Slide {{current}} af {{total}}',
      carouselPrevious: 'Forrige element',
      carouselNext: 'Næste element',
      carouselGoToItem: 'Gå til element {{index}}',
      collapse: 'Skjul',
      expand: 'Udvid',
      messageHistory: 'Beskedhistorik',
      reduce: 'Formindsk',
      today: 'I dag',
      at: 'kl.',
      a11yOptionsCount_one: 'Der er 1 mulighed.',
      a11yOptionsCount_other: 'Der er {{count}} muligheder.',
      listpickerSelectAll: 'Vælg alle',
      listpickerSelectOption: 'Vælg en mulighed',
      listpickerSearchAriaLabel: 'Søg efter filtermuligheder',
      listpickerSearchPlaceholder: 'Søg…',
      listpickerNoResults: 'Ingen matchende muligheder.',
      listpickerResults_one: '1 resultat',
      listpickerResults_other: '{{count}} resultater',
      listpickerCondensed_one: '1 valgt',
      listpickerCondensed_other: '{{count}} valgt',
      scrollToLatest: 'Rul til den seneste besked',
      scrollToUnread_one: '1 ny besked, gå til seneste',
      scrollToUnread_other: '{{count}} nye beskeder, gå til seneste',
      showPassword: 'Vis sikkert indhold',
      hidePassword: 'Skjul sikkert indhold',
      clear: 'Ryd',
      send: 'Send',
      yesterday: 'I går',
      chatEndedActions: 'Handlinger efter afsluttet chat',
      openConversationDialog: 'Åbn samtalevindue med {{title}}',
      agentTyping: 'Medarbejderen skriver',
      agentAway: 'Vores medarbejdere er ikke tilgængelige i øjeblikket.',
      agentBusy: 'Vores medarbejdere er optaget i øjeblikket. Vent venligst...',
      waitingForAgent: 'Du bliver forbundet til en medarbejder...',
      waitingForAgentWithSkill:
        'Du bliver forbundet til en medarbejder til {{skill}}...',
      talkingWithAgent: 'Taler med {{name}}',
      home: 'Hjem',
      back: 'Tilbage',
      menu: 'Menu',
      minimize: 'Minimer',
      endConversation: 'Afslut samtale',
      engageWithUs: 'Kontakt os',
      noMessagesYet: 'Ingen beskeder endnu',
      tryAgain: 'Prøv igen',
      gettingLocation: 'Henter den aktuelle placering...',
      locationSharedMessage: 'Her er min placering',
      selectFile: 'Vælg en fil',
      upload: 'Upload',
      uploadComplete: 'Upload fuldført',
      uploadFailed: 'Upload mislykkedes',
      fileTooLarge:
        'Denne fil er for stor til at uploade. Vælg venligst en fil på mindre end {{maxSize}}.',
      dragOrClick: 'Træk en fil, eller klik for at vælge',
      document: 'Dokument',
      audioContent: 'Lydindhold',
      videoContent: 'Videoindhold',
      videoUnsupported: 'Denne video kan ikke afspilles i din browser.',
      unsupportedContent: 'Indhold, der ikke understøttes',
      unavailable: {
        error: {
          title: 'Noget gik galt',
          body: 'Vi kunne ikke indlæse chatten. Prøv igen.',
          retry: 'Prøv igen',
        },
        maintenance: {
          title: 'Chatten er midlertidigt utilgængelig',
          body: 'Vi udfører planlagt vedligeholdelse. Kom snart tilbage.',
        },
      },
      image: 'Billede',
      agentSharedImage: '{{name}} delte et billede: ',
      assistantSharedImage: '{{name}} delte et billede: ',
      starRating: 'Stjernebedømmelse',
      starRatingOrder: '{{current}} ud af {{total}} stjerner',
      submit: 'Indsend',
      closeConversationDialog: 'Afslut samtale',
      waitingForAgentDescription:
        'Vent venligst mens vi forbinder dig til en agent',
      agentTransferred: 'Du er blevet overført til en anden agent.',
      uploadingFile: 'Du uploader: {{fileName}}',
      uploadedFile: 'Du uploadede {{fileName}}',
      attachedFile: 'Vedhæftet: {{fileName}}',
      fileTypeNotPermitted: 'Beklager, denne filtype er ikke tilladt.',
      relaunch: 'Genstart',
      screenReaderHintChrome:
        'For den bedste skærmlæseroplevelse i Google Chrome anbefaler vi at bruge JAWS.',
      screenReaderHintFirefox:
        'For den bedste skærmlæseroplevelse i Firefox anbefaler vi at bruge NVDA.',
      agentInitiatedCall: '{{name}} har indledt et opkald',
      clickToJoin: 'Klik for at deltage',
      callSessionInProgress: 'Din opkaldsession er i gang',
      primaryNavigation: 'Navigation',
      agentTypingNamed: '{{name}} skriver',
      agentSaysUnnamed: 'Agenten siger',
      botIsThinkingNamed: '{{name}} tænker',
      talkingWithAgentUnnamed: 'Taler med en agent',
      download: 'Download',
      downloading: 'Downloader',
      downloadComplete: 'Download fuldført',
      downloadFailed: 'Download mislykkedes',
      attachFile: 'Vedhæft fil',
      removeAttachment: 'Fjern vedhæftet fil',
      uploadFailedConnection: 'Upload mislykkedes. Tjek din forbindelse.',
      fileTooLargeToUpload:
        'Denne fil er for stor til at uploade. Vælg venligst en fil på mindre end {{maxSize}}.',
      problemUploadingFile: 'Der opstod et problem med at uploade din fil.',
      attachmentRemoved: 'Vedhæftet fil fjernet.',
      tomorrow: 'I morgen',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Startmenu',
      goBack: 'Gå tilbage',
      expandInSameWindow: 'Udvid i samme vindue',
      collapseDialog: 'Skjul dialog',
      closeDialog: 'Luk dialog',
    },
  },
  {
    lang: 'de',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Diese Unterhaltung ist beendet.',
      agentConnected: 'Sie wurden erfolgreich mit einem Mitarbeiter verbunden.',
      downloadTranscript: 'Transkript herunterladen',
      startNewConversation: 'Neue Unterhaltung starten',
      returnToConversation: 'Zurück zur Unterhaltung',
      connecting: 'Verbindung wird hergestellt...',
      retry: 'Wiederholen',
      reconnecting: 'Verbindung wird wiederhergestellt...',
      connectionLost: 'Die Internetverbindung wurde unterbrochen',
      reconnectDescription:
        'Die Internetverbindung wurde unterbrochen. Klicken Sie auf „Erneut verbinden“, um es erneut zu versuchen.',
      typeMessage: 'Nachricht eingeben',
      inputSelect: 'Option auswählen',
      inputSelectOrType: 'Option auswählen oder Nachricht eingeben',
      secureInput: 'Sichere Nachricht eingeben',
      secureValueHidden: 'Verborgener sicherer Wert',
      redactedValue: 'Verborgene personenbezogene Daten',
      startChat: 'Chat starten',
      settings: 'Einstellungen',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      close: 'Schließen',
      next: 'Weiter',
      brandingTagline:
        'Bringen Sie Ihr Unternehmen mit intelligenten KI-Agenten voran',
      poweredBy: 'Bereitgestellt von',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Der Assistent denkt nach',
      youSaid: 'Sie sagten',
      botSays: 'Der Assistent sagt',
      agentSays: '{{name}} sagt',
      joinMeeting: 'Meeting beitreten',
      meetingInProgress: 'Meeting läuft — zum Wiederbeitreten klicken',
      meetingExpired: 'Meeting-Link (abgelaufen)',
      embeddedContent: 'Eingebetteter Inhalt',
      openInNewTab: 'In neuem Tab öffnen',
      skipToMain: 'Zum Hauptinhalt springen',
      customerLogoAlt: '{{customerName}}-Logo',
      selectDate: 'Datum auswählen',
      selectTime: 'Uhrzeit auswählen',
      browseOptions: 'Optionen durchsuchen',
      carouselRoleDescription: 'Karussell',
      carouselSlideLabel: 'Folie {{current}} von {{total}}',
      carouselPrevious: 'Vorheriges Element',
      carouselNext: 'Nächstes Element',
      carouselGoToItem: 'Zu Element {{index}} gehen',
      collapse: 'Einklappen',
      expand: 'Ausklappen',
      messageHistory: 'Nachrichtenverlauf',
      reduce: 'Verkleinern',
      today: 'Heute',
      at: 'um',
      a11yOptionsCount_one: 'Es gibt 1 Option.',
      a11yOptionsCount_other: 'Es gibt {{count}} Optionen.',
      listpickerSelectAll: 'Alle auswählen',
      listpickerSelectOption: 'Wählen Sie eine Option',
      listpickerSearchAriaLabel: 'Nach Filteroptionen suchen',
      listpickerSearchPlaceholder: 'Suchen…',
      listpickerNoResults: 'Keine passenden Optionen.',
      listpickerResults_one: '1 Ergebnis',
      listpickerResults_other: '{{count}} Ergebnisse',
      listpickerCondensed_one: '1 ausgewählt',
      listpickerCondensed_other: '{{count}} ausgewählt',
      scrollToLatest: 'Zur neuesten Nachricht scrollen',
      scrollToUnread_one: '1 neue Nachricht, zur neuesten scrollen',
      scrollToUnread_other: '{{count}} neue Nachrichten, zur neuesten scrollen',
      showPassword: 'Sicheren Inhalt anzeigen',
      hidePassword: 'Sicheren Inhalt ausblenden',
      clear: 'Löschen',
      send: 'Senden',
      yesterday: 'Gestern',
      chatEndedActions: 'Aktionen nach Chat-Ende',
      openConversationDialog: 'Konversationsdialog mit {{title}} öffnen',
      agentTyping: 'Der Mitarbeiter schreibt',
      agentAway: 'Unsere Mitarbeiter sind derzeit nicht verfügbar.',
      agentBusy:
        'Unsere Mitarbeiter sind derzeit beschäftigt. Bitte haben Sie einen Moment Geduld...',
      waitingForAgent: 'Sie werden mit einem Mitarbeiter verbunden...',
      waitingForAgentWithSkill:
        'Sie werden mit einem {{skill}}-Mitarbeiter verbunden...',
      talkingWithAgent: 'Gespräch mit {{name}}',
      home: 'Startseite',
      back: 'Zurück',
      menu: 'Menü',
      minimize: 'Minimieren',
      endConversation: 'Gespräch beenden',
      engageWithUs: 'Kontaktieren Sie uns',
      noMessagesYet: 'Noch keine Nachrichten',
      tryAgain: 'Erneut versuchen',
      gettingLocation: 'Aktuellen Standort abrufen...',
      locationSharedMessage: 'Hier ist mein Standort',
      selectFile: 'Datei auswählen',
      upload: 'Hochladen',
      uploadComplete: 'Hochladen abgeschlossen',
      uploadFailed: 'Upload fehlgeschlagen',
      fileTooLarge:
        'Diese Datei ist zu groß zum Hochladen. Bitte wählen Sie eine Datei mit weniger als {{maxSize}} aus.',
      dragOrClick: 'Datei hierher ziehen oder zum Auswählen klicken',
      document: 'Dokument',
      audioContent: 'Audioinhalt',
      videoContent: 'Videoinhalt',
      videoUnsupported:
        'Dieses Video kann in Ihrem Browser nicht abgespielt werden.',
      unsupportedContent: 'Nicht unterstützter Inhalt',
      unavailable: {
        error: {
          title: 'Etwas ist schiefgelaufen',
          body: 'Der Chat konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
          retry: 'Erneut versuchen',
        },
        maintenance: {
          title: 'Chat vorübergehend nicht verfügbar',
          body: 'Wir führen planmäßige Wartungsarbeiten durch. Bitte schauen Sie bald wieder vorbei.',
        },
      },
      image: 'Bild',
      agentSharedImage: '{{name}} hat ein Bild geteilt: ',
      assistantSharedImage: '{{name}} hat ein Bild geteilt: ',
      starRating: 'Sternebewertung',
      starRatingOrder: '{{current}} von {{total}} Sternen',
      submit: 'Absenden',
      closeConversationDialog: 'Gespräch beenden',
      waitingForAgentDescription:
        'Bitte warten Sie, während wir Sie mit einem Agenten verbinden',
      agentTransferred: 'Sie wurden zu einem anderen Agenten transferiert.',
      uploadingFile: 'Sie laden hoch: {{fileName}}',
      uploadedFile: 'Sie haben {{fileName}} hochgeladen',
      attachedFile: 'Angehängt: {{fileName}}',
      fileTypeNotPermitted:
        'Entschuldigung, dieser Dateityp ist nicht erlaubt.',
      relaunch: 'Neu starten',
      screenReaderHintChrome:
        'Für die beste Bildschirmleseerfahrung in Google Chrome empfehlen wir die Verwendung von JAWS.',
      screenReaderHintFirefox:
        'Für die beste Bildschirmleseerfahrung in Firefox empfehlen wir die Verwendung von NVDA.',
      agentInitiatedCall: '{{name}} hat einen Anruf initiiert',
      clickToJoin: 'Klicken Sie zum Beitreten',
      callSessionInProgress: 'Ihre Anrufsitzung läuft',
      primaryNavigation: 'Navigation',
      agentTypingNamed: '{{name}} tippt',
      agentSaysUnnamed: 'Der Agent sagt',
      botIsThinkingNamed: '{{name}} denkt nach',
      talkingWithAgentUnnamed: 'Gespräch mit einem Agenten',
      download: 'Herunterladen',
      downloading: 'Wird heruntergeladen',
      downloadComplete: 'Download abgeschlossen',
      downloadFailed: 'Download fehlgeschlagen',
      attachFile: 'Datei anhängen',
      removeAttachment: 'Anhang entfernen',
      uploadFailedConnection:
        'Upload fehlgeschlagen. Prüfen Sie Ihre Verbindung.',
      fileTooLargeToUpload:
        'Diese Datei ist zu groß zum Hochladen. Bitte wählen Sie eine Datei mit weniger als {{maxSize}} aus.',
      problemUploadingFile: 'Es gab ein Problem beim Hochladen Ihrer Datei.',
      attachmentRemoved: 'Anhang entfernt.',
      tomorrow: 'Morgen',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Startmenü',
      goBack: 'Zurück',
      expandInSameWindow: 'Im selben Fenster erweitern',
      collapseDialog: 'Dialog einklappen',
      closeDialog: 'Dialog schließen',
    },
  },
  {
    lang: 'el',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Αυτή η συνομιλία έχει λήξει.',
      agentConnected: 'Συνδεθήκατε με έναν εκπρόσωπο.',
      downloadTranscript: 'Λήψη απομαγνητοφώνησης',
      startNewConversation: 'Έναρξη νέας συνομιλίας',
      returnToConversation: 'Επιστροφή στη συνομιλία',
      connecting: 'Σύνδεση...',
      retry: 'Επανάληψη',
      reconnecting: 'Επανασύνδεση...',
      connectionLost: 'Η σύνδεση στο διαδίκτυο χάθηκε',
      reconnectDescription:
        'Η σύνδεση στο διαδίκτυο χάθηκε. Κάντε κλικ στην Επανασύνδεση για νέα προσπάθεια.',
      typeMessage: 'Πληκτρολογήστε μήνυμα',
      inputSelect: 'Επιλέξτε μια επιλογή',
      inputSelectOrType: 'Επιλέξτε μια επιλογή ή πληκτρολογήστε μήνυμα',
      secureInput: 'Πληκτρολογήστε ασφαλές μήνυμα',
      secureValueHidden: 'Κρυφή ασφαλής τιμή',
      redactedValue: 'Κρυφά προσωπικά δεδομένα',
      startChat: 'Έναρξη συνομιλίας',
      settings: 'Ρυθμίσεις',
      cancel: 'Ακύρωση',
      confirm: 'Επιβεβαίωση',
      close: 'Κλείσιμο',
      next: 'Επόμενο',
      brandingTagline: 'Ενισχύστε την επιχείρησή σας με έξυπνους πράκτορες AI',
      poweredBy: 'Με την υποστήριξη',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Ο βοηθός σκέφτεται',
      youSaid: 'Είπατε',
      botSays: 'Ο βοηθός λέει',
      agentSays: 'Ο/Η {{name}} λέει',
      joinMeeting: 'Συμμετοχή στη σύσκεψη',
      meetingInProgress:
        'Η σύσκεψη είναι σε εξέλιξη — κάντε κλικ για επανασύνδεση',
      meetingExpired: 'Σύνδεσμος σύσκεψης (έληξε)',
      embeddedContent: 'Ενσωματωμένο περιεχόμενο',
      openInNewTab: 'Άνοιγμα σε νέα καρτέλα',
      skipToMain: 'Μετάβαση στο κύριο περιεχόμενο',
      customerLogoAlt: 'Λογότυπο {{customerName}}',
      selectDate: 'Επιλέξτε ημερομηνία',
      selectTime: 'Επιλέξτε ώρα',
      browseOptions: 'Περιήγηση επιλογών',
      carouselRoleDescription: 'Καρουζέλ',
      carouselSlideLabel: 'Διαφάνεια {{current}} από {{total}}',
      carouselPrevious: 'Προηγούμενο στοιχείο',
      carouselNext: 'Επόμενο στοιχείο',
      carouselGoToItem: 'Μετάβαση στο στοιχείο {{index}}',
      collapse: 'Σύμπτυξη',
      expand: 'Ανάπτυξη',
      messageHistory: 'Ιστορικό μηνυμάτων',
      reduce: 'Σμίκρυνση',
      today: 'Σήμερα',
      at: 'στις',
      a11yOptionsCount_one: 'Υπάρχει 1 επιλογή.',
      a11yOptionsCount_other: 'Υπάρχουν {{count}} επιλογές.',
      listpickerSelectAll: 'Επιλογή όλων',
      listpickerSelectOption: 'Επιλέξτε μια επιλογή',
      listpickerSearchAriaLabel: 'Αναζήτηση επιλογών φίλτρου',
      listpickerSearchPlaceholder: 'Αναζήτηση…',
      listpickerNoResults: 'Δεν υπάρχουν αντίστοιχες επιλογές.',
      listpickerResults_one: '1 αποτέλεσμα',
      listpickerResults_other: '{{count}} αποτελέσματα',
      listpickerCondensed_one: '1 επιλεγμένο',
      listpickerCondensed_other: '{{count}} επιλεγμένα',
      scrollToLatest: 'Μετάβαση στο πιο πρόσφατο μήνυμα',
      scrollToUnread_one: '1 νέο μήνυμα, μετάβαση στο πιο πρόσφατο',
      scrollToUnread_other: '{{count}} νέα μηνύματα, μετάβαση στο πιο πρόσφατο',
      showPassword: 'Εμφάνιση ασφαλούς περιεχομένου',
      hidePassword: 'Απόκρυψη ασφαλούς περιεχομένου',
      clear: 'Εκκαθάριση',
      send: 'Αποστολή',
      yesterday: 'Χθες',
      chatEndedActions: 'Ενέργειες μετά τη λήξη της συνομιλίας',
      openConversationDialog: 'Άνοιγμα παραθύρου συνομιλίας με {{title}}',
      agentTyping: 'Ο εκπρόσωπος πληκτρολογεί',
      agentAway: 'Οι εκπρόσωποί μας δεν είναι διαθέσιμοι αυτήν τη στιγμή.',
      agentBusy:
        'Οι εκπρόσωποί μας είναι απασχολημένοι αυτήν τη στιγμή. Περιμένετε...',
      waitingForAgent: 'Σας συνδέουμε με έναν εκπρόσωπο...',
      waitingForAgentWithSkill:
        'Σας συνδέουμε με έναν εκπρόσωπο για {{skill}}...',
      talkingWithAgent: 'Συνομιλία με {{name}}',
      home: 'Αρχική',
      back: 'Πίσω',
      menu: 'Μενού',
      minimize: 'Ελαχιστοποίηση',
      endConversation: 'Τερματισμός Συνομιλίας',
      engageWithUs: 'Επικοινωνήστε μαζί μας',
      noMessagesYet: 'Δεν υπάρχουν ακόμη μηνύματα',
      tryAgain: 'Δοκιμάστε ξανά',
      gettingLocation: 'Λήψη τρέχουσας τοποθεσίας...',
      locationSharedMessage: 'Εδώ είναι η τοποθεσία μου.',
      selectFile: 'Επιλέξτε αρχείο',
      upload: 'Μεταφόρτωση',
      uploadComplete: 'Η μεταφόρτωση ολοκληρώθηκε',
      uploadFailed: 'Η μεταφόρτωση απέτυχε',
      fileTooLarge:
        'Αυτό το αρχείο είναι πολύ μεγάλο για μεταφόρτωση. Παρακαλώ επιλέξτε ένα αρχείο μικρότερο από {{maxSize}}.',
      dragOrClick: 'Σύρετε ένα αρχείο ή κάντε κλικ για επιλογή',
      document: 'Έγγραφο',
      audioContent: 'Περιεχόμενο ήχου',
      videoContent: 'Περιεχόμενο βίντεο',
      videoUnsupported:
        'Αυτό το βίντεο δεν μπορεί να αναπαραχθεί στο πρόγραμμα περιήγησής σας.',
      unsupportedContent: 'Μη υποστηριζόμενο περιεχόμενο',
      unavailable: {
        error: {
          title: 'Κάτι πήγε στραβά',
          body: 'Δεν ήταν δυνατή η φόρτωση της συνομιλίας. Δοκιμάστε ξανά.',
          retry: 'Δοκιμάστε ξανά',
        },
        maintenance: {
          title: 'Η συνομιλία δεν είναι προσωρινά διαθέσιμη',
          body: 'Πραγματοποιούμε προγραμματισμένη συντήρηση. Επιστρέψτε σύντομα.',
        },
      },
      image: 'Εικόνα',
      agentSharedImage: 'Ο/Η {{name}} μοιράστηκε μια εικόνα: ',
      assistantSharedImage: 'Ο/Η {{name}} μοιράστηκε μια εικόνα: ',
      starRating: 'Αξιολόγηση με αστέρια',
      starRatingOrder: '{{current}} από {{total}} αστέρια',
      submit: 'Υποβολή',
      closeConversationDialog: 'Κλείσιμο συνομιλίας',
      waitingForAgentDescription:
        'Παρακαλώ περιμένετε ενώ σας συνδέουμε με έναν εκπρόσωπο',
      agentTransferred: 'Έχετε μεταφερθεί σε άλλον εκπρόσωπο.',
      uploadingFile: 'Ανεβάζετε: {{fileName}}',
      uploadedFile: 'Ανεβάσατε {{fileName}}',
      attachedFile: 'Επισυνάφθηκε: {{fileName}}',
      fileTypeNotPermitted: 'Συγγνώμη, αυτός ο τύπος αρχείου δεν επιτρέπεται.',
      relaunch: 'Επανεκκίνηση',
      screenReaderHintChrome:
        'Για την καλύτερη εμπειρία αναγνώστη οθόνης στο Google Chrome, προτείνουμε τη χρήση του JAWS.',
      screenReaderHintFirefox:
        'Για την καλύτερη εμπειρία αναγνώστη οθόνης στο Firefox, προτείνουμε τη χρήση του NVDA.',
      agentInitiatedCall: 'Ο/Η {{name}} ξεκίνησε μια κλήση',
      clickToJoin: 'Κάντε κλικ για να συμμετάσχετε',
      callSessionInProgress: 'Η κλήση σας είναι σε εξέλιξη',
      primaryNavigation: 'Πλοήγηση',
      agentTypingNamed: 'Ο/Η {{name}} πληκτρολογεί',
      agentSaysUnnamed: 'Ο πράκτορας λέει',
      botIsThinkingNamed: 'Ο/Η {{name}} σκέφτεται',
      talkingWithAgentUnnamed: 'Συνομιλία με πράκτορα',
      download: 'Λήψη',
      downloading: 'Γίνεται λήψη',
      downloadComplete: 'Η λήψη ολοκληρώθηκε',
      downloadFailed: 'Η λήψη απέτυχε',
      attachFile: 'Επισύναψη αρχείου',
      removeAttachment: 'Κατάργηση συνημμένου',
      uploadFailedConnection: 'Η μεταφόρτωση απέτυχε. Ελέγξτε τη σύνδεσή σας.',
      fileTooLargeToUpload:
        'Αυτό το αρχείο είναι πολύ μεγάλο για μεταφόρτωση. Παρακαλώ επιλέξτε ένα αρχείο μικρότερο από {{maxSize}}.',
      problemUploadingFile:
        'Υπήρξε πρόβλημα κατά τη μεταφόρτωση του αρχείου σας.',
      attachmentRemoved: 'Το συνημμένο καταργήθηκε.',
      tomorrow: 'Αύριο',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Αρχικό μενού',
      goBack: 'Πίσω',
      expandInSameWindow: 'Επέκταση στο ίδιο παράθυρο',
      collapseDialog: 'Σύμπτυξη Διαλόγου',
      closeDialog: 'Κλείσιμο Διαλόγου',
    },
  },
  {
    lang: 'en',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'This conversation has ended.',
      agentConnected: 'You have been successfully connected to an agent.',
      downloadTranscript: 'Download Transcript',
      startNewConversation: 'Start New Conversation',
      returnToConversation: 'Return to Conversation',
      connecting: 'Connecting...',
      retry: 'Retry',
      reconnecting: 'Reconnecting...',
      connectionLost: 'Internet connection has been lost',
      reconnectDescription:
        'Internet connection has been lost. Click Reconnect to retry.',
      typeMessage: 'Type message',
      inputSelect: 'Select option',
      inputSelectOrType: 'Select option or type message',
      secureInput: 'Type secure message',
      secureValueHidden: 'Hidden secure value',
      redactedValue: 'Redacted personal information',
      startChat: 'Start chat',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      next: 'Next',
      brandingTagline: 'Supercharge your Business with Intelligent AI Agents',
      poweredBy: 'Powered by',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Bot is thinking',
      botIsThinkingNamed: '{{name}} is thinking',
      youSaid: 'You said',
      botSays: 'Bot says',
      agentSaysUnnamed: 'Agent says',
      agentSays: '{{name}} says',
      joinMeeting: 'Join Meeting',
      meetingInProgress: 'Meeting in progress — click to rejoin',
      meetingExpired: 'Meeting link (expired)',
      embeddedContent: 'Embedded content',
      openInNewTab: 'Open in new tab',
      skipToMain: 'Skip to main content',
      customerLogoAlt: '{{customerName}} Logo',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      browseOptions: 'Browse Options',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} of {{total}}',
      carouselPrevious: 'Previous item',
      carouselNext: 'Next item',
      carouselGoToItem: 'Go to item {{index}}',
      collapse: 'Collapse',
      expand: 'Expand',
      messageHistory: 'Message history',
      reduce: 'Reduce',
      today: 'Today',
      at: 'at',
      a11yOptionsCount_one: 'There is 1 option.',
      a11yOptionsCount_other: 'There are {{count}} options.',
      listpickerSelectAll: 'Select all',
      listpickerSelectOption: 'Select an option',
      listpickerSearchAriaLabel: 'Search for filter options',
      listpickerSearchPlaceholder: 'Search…',
      listpickerNoResults: 'No options match.',
      listpickerResults_one: '1 result',
      listpickerResults_other: '{{count}} results',
      listpickerCondensed_one: '1 selected',
      listpickerCondensed_other: '{{count}} selected',
      scrollToLatest: 'Scroll to latest message',
      scrollToUnread_one: '1 new message, scroll to latest',
      scrollToUnread_other: '{{count}} new messages, scroll to latest',
      showPassword: 'Show secure content',
      hidePassword: 'Hide secure content',
      clear: 'Clear',
      send: 'Send',
      yesterday: 'Yesterday',
      chatEndedActions: 'Chat ended actions',
      openConversationDialog: 'Open conversation dialog with {{title}}',
      agentTyping: 'Agent is typing',
      agentTypingNamed: '{{name}} is typing',
      agentAway: 'Our agents are currently unavailable.',
      agentBusy: 'Our agents are currently busy. Please hold on...',
      waitingForAgent: 'Connecting you to an agent...',
      waitingForAgentWithSkill: 'Connecting you to a {{skill}} agent...',
      talkingWithAgent: 'Talking with {{name}}',
      talkingWithAgentUnnamed: 'Talking with an agent',
      home: 'Home',
      back: 'Back',
      menu: 'Menu',
      primaryNavigation: 'Navigation',
      minimize: 'Minimize',
      endConversation: 'End Conversation',
      engageWithUs: 'Engage with us',
      noMessagesYet: 'No messages yet',
      tryAgain: 'Try again',
      gettingLocation: 'Getting current location...',
      locationSharedMessage: 'Here is my location.',
      selectFile: 'Select a file',
      upload: 'Upload',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge:
        'This file is too large to upload. Please select a file less than {{maxSize}}.',
      dragOrClick: 'Drag a file or click to choose',
      document: 'Document',
      audioContent: 'Audio content',
      videoContent: 'Video content',
      videoUnsupported: "This video can't be played in your browser.",
      unsupportedContent: 'Unsupported content',
      unavailable: {
        error: {
          title: 'Something went wrong',
          body: "We couldn't load the chat. Please try again.",
          retry: 'Try again',
        },
        maintenance: {
          title: 'Chat is temporarily unavailable',
          body: 'We are doing scheduled maintenance. Please check back soon.',
        },
      },
      image: 'Image',
      agentSharedImage: '{{name}} shared an image: ',
      assistantSharedImage: '{{name}} shared an image: ',
      starRating: 'Star rating',
      starRatingOrder: '{{current}} out of {{total}} stars',
      submit: 'Submit',
      closeConversationDialog: 'Close conversation',
      waitingForAgentDescription:
        'Please wait while we connect you to an agent',
      agentTransferred: 'You have been transferred to another agent.',
      uploadingFile: 'You are uploading: {{fileName}}',
      uploadedFile: 'You uploaded {{fileName}}',
      attachedFile: 'Attached: {{fileName}}',
      fileTypeNotPermitted: 'Sorry, this file type is not permitted.',
      relaunch: 'Relaunch',
      screenReaderHintChrome:
        'For the best screenreader experience in Google Chrome, we suggest using JAWS.',
      screenReaderHintFirefox:
        'For the best screenreader experience in Firefox, we suggest using NVDA.',
      agentInitiatedCall: '{{name}} has initiated a call',
      clickToJoin: 'Click to join',
      callSessionInProgress: 'Your call session is in progress',
      download: 'Download',
      downloading: 'Downloading',
      downloadComplete: 'Download complete',
      downloadFailed: 'Download failed',
      attachFile: 'Attach file',
      removeAttachment: 'Remove attachment',
      uploadFailedConnection: 'Upload failed. Check your connection.',
      fileTooLargeToUpload:
        'This file is too large to upload. Please select a file less than {{maxSize}}.',
      problemUploadingFile: 'There was a problem uploading your file.',
      attachmentRemoved: 'Attachment removed.',
      tomorrow: 'Tomorrow',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Home menu',
      goBack: 'Go back',
      expandInSameWindow: 'Expand in same window',
      collapseDialog: 'Collapse Dialog',
      closeDialog: 'Close Dialog',
    },
  },
  {
    lang: 'en-AU',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'This conversation has ended.',
      agentConnected: 'You have been successfully connected to an agent.',
      downloadTranscript: 'Download Transcript',
      startNewConversation: 'Start New Conversation',
      returnToConversation: 'Return to Conversation',
      connecting: 'Connecting...',
      retry: 'Retry',
      reconnecting: 'Reconnecting...',
      connectionLost: 'Internet connection has been lost',
      reconnectDescription:
        'Internet connection has been lost. Click Reconnect to retry.',
      typeMessage: 'Type message',
      inputSelect: 'Select option',
      inputSelectOrType: 'Select option or type message',
      secureInput: 'Type secure message',
      secureValueHidden: 'Hidden secure value',
      redactedValue: 'Redacted personal information',
      startChat: 'Start chat',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      next: 'Next',
      brandingTagline: 'Supercharge your Business with Intelligent AI Agents',
      poweredBy: 'Powered by',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Assistant is thinking',
      youSaid: 'You said',
      botSays: 'Assistant says',
      agentSays: '{{name}} says',
      joinMeeting: 'Join Meeting',
      meetingInProgress: 'Meeting in progress — click to rejoin',
      meetingExpired: 'Meeting link (expired)',
      embeddedContent: 'Embedded content',
      openInNewTab: 'Open in new tab',
      skipToMain: 'Skip to main content',
      customerLogoAlt: '{{customerName}} Logo',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      browseOptions: 'Browse Options',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} of {{total}}',
      carouselPrevious: 'Previous item',
      carouselNext: 'Next item',
      carouselGoToItem: 'Go to item {{index}}',
      collapse: 'Collapse',
      expand: 'Expand',
      messageHistory: 'Message history',
      reduce: 'Reduce',
      today: 'Today',
      at: 'at',
      a11yOptionsCount_one: 'There is 1 option.',
      a11yOptionsCount_other: 'There are {{count}} options.',
      listpickerSelectAll: 'Select all',
      listpickerSelectOption: 'Select an option',
      listpickerSearchAriaLabel: 'Search for filter options',
      listpickerSearchPlaceholder: 'Search…',
      listpickerNoResults: 'No options match.',
      listpickerResults_one: '1 result',
      listpickerResults_other: '{{count}} results',
      listpickerCondensed_one: '1 selected',
      listpickerCondensed_other: '{{count}} selected',
      scrollToLatest: 'Scroll to latest message',
      scrollToUnread_one: '1 new message, scroll to latest',
      scrollToUnread_other: '{{count}} new messages, scroll to latest',
      showPassword: 'Show secure content',
      hidePassword: 'Hide secure content',
      clear: 'Clear',
      send: 'Send',
      yesterday: 'Yesterday',
      chatEndedActions: 'Chat ended actions',
      openConversationDialog: 'Open conversation dialog with {{title}}',
      agentTyping: 'Agent is typing',
      agentAway: 'Our agents are currently unavailable.',
      agentBusy: 'Our agents are currently busy. Please hold on...',
      waitingForAgent: 'Connecting you to an agent...',
      waitingForAgentWithSkill: 'Connecting you to a {{skill}} agent...',
      talkingWithAgent: 'Talking with {{name}}',
      home: 'Home',
      back: 'Back',
      menu: 'Menu',
      minimize: 'Minimize',
      endConversation: 'End Conversation',
      engageWithUs: 'Engage with us',
      noMessagesYet: 'No messages yet',
      tryAgain: 'Try again',
      gettingLocation: 'Getting current location...',
      locationSharedMessage: 'Here is my location.',
      selectFile: 'Select a file',
      upload: 'Upload',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge:
        'This file is too large to upload. Please select a file less than {{maxSize}}.',
      dragOrClick: 'Drag a file or click to choose',
      document: 'Document',
      audioContent: 'Audio content',
      videoContent: 'Video content',
      videoUnsupported: "This video can't be played in your browser.",
      unsupportedContent: 'Unsupported content',
      unavailable: {
        error: {
          title: 'Something went wrong',
          body: "We couldn't load the chat. Please try again.",
          retry: 'Try again',
        },
        maintenance: {
          title: 'Chat is temporarily unavailable',
          body: 'We are doing scheduled maintenance. Please check back soon.',
        },
      },
      image: 'Image',
      agentSharedImage: '{{name}} shared an image: ',
      assistantSharedImage: '{{name}} shared an image: ',
      starRating: 'Star rating',
      starRatingOrder: '{{current}} out of {{total}} stars',
      submit: 'Submit',
      closeConversationDialog: 'Close conversation',
      waitingForAgentDescription:
        'Please wait while we connect you to an agent',
      agentTransferred: 'You have been transferred to another agent.',
      uploadingFile: 'You are uploading: {{fileName}}',
      uploadedFile: 'You uploaded {{fileName}}',
      attachedFile: 'Attached: {{fileName}}',
      fileTypeNotPermitted: 'Sorry, this file type is not permitted.',
      relaunch: 'Relaunch',
      screenReaderHintChrome:
        'For the best screenreader experience in Google Chrome, we suggest using JAWS.',
      screenReaderHintFirefox:
        'For the best screenreader experience in Firefox, we suggest using NVDA.',
      agentInitiatedCall: '{{name}} has initiated a call',
      clickToJoin: 'Click to join',
      callSessionInProgress: 'Your call session is in progress',
      primaryNavigation: 'Navigation',
      agentTypingNamed: '{{name}} is typing',
      agentSaysUnnamed: 'Agent says',
      botIsThinkingNamed: '{{name}} is thinking',
      talkingWithAgentUnnamed: 'Talking with an agent',
      download: 'Download',
      downloading: 'Downloading',
      downloadComplete: 'Download complete',
      downloadFailed: 'Download failed',
      attachFile: 'Attach file',
      removeAttachment: 'Remove attachment',
      uploadFailedConnection: 'Upload failed. Check your connection.',
      fileTooLargeToUpload:
        'This file is too large to upload. Please select a file less than {{maxSize}}.',
      problemUploadingFile: 'There was a problem uploading your file.',
      attachmentRemoved: 'Attachment removed.',
      tomorrow: 'Tomorrow',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Home menu',
      goBack: 'Go back',
      expandInSameWindow: 'Expand in same window',
      collapseDialog: 'Collapse Dialogue',
      closeDialog: 'Close Dialogue',
    },
  },
  {
    lang: 'en-GB',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'This conversation has ended.',
      agentConnected: 'You have been successfully connected to an agent.',
      downloadTranscript: 'Download Transcript',
      startNewConversation: 'Start New Conversation',
      returnToConversation: 'Return to Conversation',
      connecting: 'Connecting...',
      retry: 'Retry',
      reconnecting: 'Reconnecting...',
      connectionLost: 'Internet connection has been lost',
      reconnectDescription:
        'Internet connection has been lost. Click Reconnect to retry.',
      typeMessage: 'Type message',
      inputSelect: 'Select option',
      inputSelectOrType: 'Select option or type message',
      secureInput: 'Type secure message',
      secureValueHidden: 'Hidden secure value',
      redactedValue: 'Redacted personal information',
      startChat: 'Start chat',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      next: 'Next',
      brandingTagline: 'Supercharge your Business with Intelligent AI Agents',
      poweredBy: 'Powered by',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Assistant is thinking',
      youSaid: 'You said',
      botSays: 'Assistant says',
      agentSays: '{{name}} says',
      joinMeeting: 'Join Meeting',
      meetingInProgress: 'Meeting in progress — click to rejoin',
      meetingExpired: 'Meeting link (expired)',
      embeddedContent: 'Embedded content',
      openInNewTab: 'Open in new tab',
      skipToMain: 'Skip to main content',
      customerLogoAlt: '{{customerName}} Logo',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      browseOptions: 'Browse Options',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} of {{total}}',
      carouselPrevious: 'Previous item',
      carouselNext: 'Next item',
      carouselGoToItem: 'Go to item {{index}}',
      collapse: 'Collapse',
      expand: 'Expand',
      messageHistory: 'Message history',
      reduce: 'Reduce',
      today: 'Today',
      at: 'at',
      a11yOptionsCount_one: 'There is 1 option.',
      a11yOptionsCount_other: 'There are {{count}} options.',
      listpickerSelectAll: 'Select all',
      listpickerSelectOption: 'Select an option',
      listpickerSearchAriaLabel: 'Search for filter options',
      listpickerSearchPlaceholder: 'Search…',
      listpickerNoResults: 'No options match.',
      listpickerResults_one: '1 result',
      listpickerResults_other: '{{count}} results',
      listpickerCondensed_one: '1 selected',
      listpickerCondensed_other: '{{count}} selected',
      scrollToLatest: 'Scroll to latest message',
      scrollToUnread_one: '1 new message, scroll to latest',
      scrollToUnread_other: '{{count}} new messages, scroll to latest',
      showPassword: 'Show secure content',
      hidePassword: 'Hide secure content',
      clear: 'Clear',
      send: 'Send',
      yesterday: 'Yesterday',
      chatEndedActions: 'Chat ended actions',
      openConversationDialog: 'Open conversation dialog with {{title}}',
      agentTyping: 'Agent is typing',
      agentAway: 'Our agents are currently unavailable.',
      agentBusy: 'Our agents are currently busy. Please hold on...',
      waitingForAgent: 'Connecting you to an agent...',
      waitingForAgentWithSkill: 'Connecting you to a {{skill}} agent...',
      talkingWithAgent: 'Talking with {{name}}',
      home: 'Home',
      back: 'Back',
      menu: 'Menu',
      minimize: 'Minimize',
      endConversation: 'End Conversation',
      engageWithUs: 'Engage with us',
      noMessagesYet: 'No messages yet',
      tryAgain: 'Try again',
      gettingLocation: 'Getting current location...',
      locationSharedMessage: 'Here is my location.',
      selectFile: 'Select a file',
      upload: 'Upload',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge:
        'This file is too large to upload. Please select a file less than {{maxSize}}.',
      dragOrClick: 'Drag a file or click to choose',
      document: 'Document',
      audioContent: 'Audio content',
      videoContent: 'Video content',
      videoUnsupported: "This video can't be played in your browser.",
      unsupportedContent: 'Unsupported content',
      unavailable: {
        error: {
          title: 'Something went wrong',
          body: "We couldn't load the chat. Please try again.",
          retry: 'Try again',
        },
        maintenance: {
          title: 'Chat is temporarily unavailable',
          body: 'We are doing scheduled maintenance. Please check back soon.',
        },
      },
      image: 'Image',
      agentSharedImage: '{{name}} shared an image: ',
      assistantSharedImage: '{{name}} shared an image: ',
      starRating: 'Star rating',
      starRatingOrder: '{{current}} out of {{total}} stars',
      submit: 'Submit',
      closeConversationDialog: 'Close conversation',
      waitingForAgentDescription:
        'Please wait while we connect you to an agent',
      agentTransferred: 'You have been transferred to another agent.',
      uploadingFile: 'You are uploading: {{fileName}}',
      uploadedFile: 'You uploaded {{fileName}}',
      attachedFile: 'Attached: {{fileName}}',
      fileTypeNotPermitted: 'Sorry, this file type is not permitted.',
      relaunch: 'Relaunch',
      screenReaderHintChrome:
        'For the best screenreader experience in Google Chrome, we suggest using JAWS.',
      screenReaderHintFirefox:
        'For the best screenreader experience in Firefox, we suggest using NVDA.',
      agentInitiatedCall: '{{name}} has initiated a call',
      clickToJoin: 'Click to join',
      callSessionInProgress: 'Your call session is in progress',
      primaryNavigation: 'Navigation',
      agentTypingNamed: '{{name}} is typing',
      agentSaysUnnamed: 'Agent says',
      botIsThinkingNamed: '{{name}} is thinking',
      talkingWithAgentUnnamed: 'Talking with an agent',
      download: 'Download',
      downloading: 'Downloading',
      downloadComplete: 'Download complete',
      downloadFailed: 'Download failed',
      attachFile: 'Attach file',
      removeAttachment: 'Remove attachment',
      uploadFailedConnection: 'Upload failed. Check your connection.',
      fileTooLargeToUpload:
        'This file is too large to upload. Please select a file less than {{maxSize}}.',
      problemUploadingFile: 'There was a problem uploading your file.',
      attachmentRemoved: 'Attachment removed.',
      tomorrow: 'Tomorrow',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Home menu',
      goBack: 'Go back',
      expandInSameWindow: 'Expand in same window',
      collapseDialog: 'Collapse Dialogue',
      closeDialog: 'Close Dialogue',
    },
  },
  {
    lang: 'es',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Esta conversación ha finalizado.',
      agentConnected: 'Te has conectado correctamente con un agente.',
      downloadTranscript: 'Descargar la transcripción',
      startNewConversation: 'Iniciar una nueva conversación',
      returnToConversation: 'Volver a la conversación',
      connecting: 'Conectando...',
      retry: 'Reintentar',
      reconnecting: 'Reconectando...',
      connectionLost: 'Se ha perdido la conexión a internet',
      reconnectDescription:
        'Se ha perdido la conexión a internet. Haz clic en Reconectar para reintentar.',
      typeMessage: 'Escribe un mensaje',
      inputSelect: 'Selecciona una opción',
      inputSelectOrType: 'Selecciona una opción o escribe un mensaje',
      secureInput: 'Escribe un mensaje seguro',
      secureValueHidden: 'Valor seguro oculto',
      redactedValue: 'Información personal oculta',
      startChat: 'Iniciar chat',
      settings: 'Configuración',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      close: 'Cerrar',
      next: 'Siguiente',
      brandingTagline: 'Impulsa tu negocio con agentes de IA inteligentes',
      poweredBy: 'Con la tecnología de',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'El asistente está pensando',
      youSaid: 'Dijiste',
      botSays: 'El asistente dice',
      agentSays: '{{name}} dice',
      joinMeeting: 'Unirse a la reunión',
      meetingInProgress: 'Reunión en curso — haz clic para volver a unirte',
      meetingExpired: 'Enlace de la reunión (caducado)',
      embeddedContent: 'Contenido incrustado',
      openInNewTab: 'Abrir en una pestaña nueva',
      skipToMain: 'Saltar al contenido principal',
      customerLogoAlt: 'Logotipo de {{customerName}}',
      selectDate: 'Seleccionar fecha',
      selectTime: 'Seleccionar hora',
      browseOptions: 'Explorar opciones',
      carouselRoleDescription: 'Carrusel',
      carouselSlideLabel: 'Diapositiva {{current}} de {{total}}',
      carouselPrevious: 'Elemento anterior',
      carouselNext: 'Elemento siguiente',
      carouselGoToItem: 'Ir al elemento {{index}}',
      collapse: 'Contraer',
      expand: 'Expandir',
      messageHistory: 'Historial de mensajes',
      reduce: 'Reducir',
      today: 'Hoy',
      at: 'a las',
      a11yOptionsCount_one: 'Hay 1 opción.',
      a11yOptionsCount_many: 'Hay {{count}} opciones.',
      a11yOptionsCount_other: 'Hay {{count}} opciones.',
      listpickerSelectAll: 'Seleccionar todo',
      listpickerSelectOption: 'Selecciona una opción',
      listpickerSearchAriaLabel: 'Buscar opciones de filtro',
      listpickerSearchPlaceholder: 'Buscar…',
      listpickerNoResults: 'No hay opciones que coincidan.',
      listpickerResults_one: '1 resultado',
      listpickerResults_many: '{{count}} resultados',
      listpickerResults_other: '{{count}} resultados',
      listpickerCondensed_one: '1 seleccionado',
      listpickerCondensed_many: '{{count}} seleccionados',
      listpickerCondensed_other: '{{count}} seleccionados',
      scrollToLatest: 'Desplazarse al último mensaje',
      scrollToUnread_one: '1 mensaje nuevo, ir al último',
      scrollToUnread_many: '{{count}} mensajes nuevos, ir al último',
      scrollToUnread_other: '{{count}} mensajes nuevos, ir al último',
      showPassword: 'Mostrar contenido seguro',
      hidePassword: 'Ocultar contenido seguro',
      clear: 'Borrar',
      send: 'Enviar',
      yesterday: 'Ayer',
      chatEndedActions: 'Acciones al finalizar el chat',
      openConversationDialog: 'Abrir el diálogo de conversación con {{title}}',
      agentTyping: 'El agente está escribiendo',
      agentAway: 'Nuestros agentes no están disponibles en este momento.',
      agentBusy:
        'Nuestros agentes están ocupados en este momento. Por favor, espera...',
      waitingForAgent: 'Conectándote con un agente...',
      waitingForAgentWithSkill: 'Conectándote con un agente de {{skill}}...',
      talkingWithAgent: 'Hablando con {{name}}',
      home: 'Inicio',
      back: 'Atrás',
      menu: 'Menú',
      minimize: 'Minimizar',
      endConversation: 'Finalizar conversación',
      engageWithUs: 'Contáctanos',
      noMessagesYet: 'Aún no hay mensajes',
      tryAgain: 'Inténtalo de nuevo',
      gettingLocation: 'Consiguiendo ubicación actual...',
      locationSharedMessage: 'Aquí está mi ubicación',
      selectFile: 'Seleccionar un archivo',
      upload: 'Subir',
      uploadComplete: 'Subida completa',
      uploadFailed: 'Error al cargar',
      fileTooLarge:
        'Este archivo es demasiado grande para cargarlo. Seleccione un archivo de menos de {{maxSize}}.',
      dragOrClick: 'Arrastra un archivo o haz clic para elegir',
      document: 'Documento',
      audioContent: 'Contenido de audio',
      videoContent: 'Contenido de video',
      videoUnsupported: 'Este vídeo no se puede reproducir en tu navegador.',
      unsupportedContent: 'Contenido no compatible',
      unavailable: {
        error: {
          title: 'Algo salió mal',
          body: 'No pudimos cargar el chat. Por favor, inténtalo de nuevo.',
          retry: 'Inténtalo de nuevo',
        },
        maintenance: {
          title: 'El chat no está disponible temporalmente',
          body: 'Estamos realizando un mantenimiento programado. Vuelve pronto.',
        },
      },
      image: 'Imagen',
      agentSharedImage: '{{name}} Compartió una imagen: ',
      assistantSharedImage: '{{name}} Compartió una imagen: ',
      starRating: 'Calificación por estrellas',
      starRatingOrder: '{{current}} de {{total}} estrellas',
      submit: 'Enviar',
      closeConversationDialog: 'Cerrar conversación',
      waitingForAgentDescription:
        'Por favor espere mientras le conectamos con un agente',
      agentTransferred: 'Ha sido transferido a otro agente.',
      uploadingFile: 'Estás cargando: {{fileName}}',
      uploadedFile: 'tu cargaste {{fileName}}',
      attachedFile: 'Adjunto: {{fileName}}',
      fileTypeNotPermitted:
        'Lo sentimos, este tipo de archivo no está permitido.',
      relaunch: 'Reiniciar',
      screenReaderHintChrome:
        'Para obtener la mejor experiencia con el lector de pantalla en Google Chrome, sugerimos utilizar JAWS.',
      screenReaderHintFirefox:
        'Para obtener la mejor experiencia con el lector de pantalla en Firefox, sugerimos utilizar NVDA.',
      agentInitiatedCall: '{{name}} ha iniciado una llamada',
      clickToJoin: 'Haga clic para unirse',
      callSessionInProgress: 'Su sesión de llamada está en curso',
      primaryNavigation: 'Navegación',
      agentTypingNamed: '{{name}} está escribiendo',
      agentSaysUnnamed: 'El agente dice',
      botIsThinkingNamed: '{{name}} está pensando',
      talkingWithAgentUnnamed: 'Hablando con un agente',
      download: 'Descargar',
      downloading: 'Descargando',
      downloadComplete: 'Descarga completa',
      downloadFailed: 'Error en la descarga',
      attachFile: 'Adjuntar archivo',
      removeAttachment: 'Quitar archivo adjunto',
      uploadFailedConnection: 'Error al subir. Comprueba tu conexión.',
      fileTooLargeToUpload:
        'Este archivo es demasiado grande para cargarlo. Seleccione un archivo de menos de {{maxSize}}.',
      problemUploadingFile: 'Hubo un problema al cargar tu archivo.',
      attachmentRemoved: 'Archivo adjunto eliminado.',
      tomorrow: 'Mañana',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menú principal',
      goBack: 'Volver',
      expandInSameWindow: 'Expandir en la misma ventana',
      collapseDialog: 'Contraer cuadro de diálogo',
      closeDialog: 'Cerrar diálogo',
    },
  },
  {
    lang: 'et',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'See vestlus on lõppenud.',
      agentConnected: 'Teid on edukalt ühendatud agendiga.',
      downloadTranscript: 'Laadi vestlus alla',
      startNewConversation: 'Alusta uut vestlust',
      returnToConversation: 'Tagasi vestluse juurde',
      connecting: 'Ühendamine...',
      retry: 'Proovi uuesti',
      reconnecting: 'Uuesti ühendamine...',
      connectionLost: 'Internetiühendus on katkenud',
      reconnectDescription:
        'Internetiühendus on katkenud. Klõpsake „Ühenda uuesti“, et uuesti proovida.',
      typeMessage: 'Kirjuta sõnum',
      inputSelect: 'Vali valik',
      inputSelectOrType: 'Vali valik või kirjuta sõnum',
      secureInput: 'Kirjuta turvaline sõnum',
      secureValueHidden: 'Peidetud turvaline väärtus',
      redactedValue: 'Peidetud isikuandmed',
      startChat: 'Alusta vestlust',
      settings: 'Seaded',
      cancel: 'Tühista',
      confirm: 'Kinnita',
      close: 'Sulge',
      next: 'Edasi',
      brandingTagline:
        'Kiirenda oma äri intelligentsete tehisintellekti agentidega',
      poweredBy: 'Teenusepakkuja',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Assistent mõtleb',
      youSaid: 'Sa ütlesid',
      botSays: 'Assistent ütleb',
      agentSays: '{{name}} ütleb',
      joinMeeting: 'Liitu koosolekuga',
      meetingInProgress: 'Koosolek käib — klõpsake uuesti liitumiseks',
      meetingExpired: 'Koosoleku link (aegunud)',
      embeddedContent: 'Manustatud sisu',
      openInNewTab: 'Ava uuel vahekaardil',
      skipToMain: 'Liigu põhisisu juurde',
      customerLogoAlt: '{{customerName}} logo',
      selectDate: 'Vali kuupäev',
      selectTime: 'Vali kellaaeg',
      browseOptions: 'Sirvi valikuid',
      carouselRoleDescription: 'Karussell',
      carouselSlideLabel: 'Slaid {{current}} / {{total}}',
      carouselPrevious: 'Eelmine üksus',
      carouselNext: 'Järgmine üksus',
      carouselGoToItem: 'Mine üksusele {{index}}',
      collapse: 'Ahenda',
      expand: 'Laienda',
      messageHistory: 'Sõnumite ajalugu',
      reduce: 'Vähenda',
      today: 'Täna',
      at: 'kell',
      a11yOptionsCount_one: 'On 1 valik.',
      a11yOptionsCount_other: 'On {{count}} valikut.',
      listpickerSelectAll: 'Vali kõik',
      listpickerSelectOption: 'Vali valik',
      listpickerSearchAriaLabel: 'Otsi filtrivalikuid',
      listpickerSearchPlaceholder: 'Otsi…',
      listpickerNoResults: 'Sobivaid valikuid pole.',
      listpickerResults_one: '1 tulemus',
      listpickerResults_other: '{{count}} tulemust',
      listpickerCondensed_one: '1 valitud',
      listpickerCondensed_other: '{{count}} valitud',
      scrollToLatest: 'Keri uusima sõnumini',
      scrollToUnread_one: '1 uus sõnum, liigu uusimale',
      scrollToUnread_other: '{{count}} uut sõnumit, liigu uusimale',
      showPassword: 'Näita turvalist sisu',
      hidePassword: 'Peida turvaline sisu',
      clear: 'Tühjenda',
      send: 'Saada',
      yesterday: 'Eile',
      chatEndedActions: 'Toimingud pärast vestluse lõppu',
      openConversationDialog: 'Ava vestlusaken: {{title}}',
      agentTyping: 'Agent kirjutab',
      agentAway: 'Meie agendid pole hetkel saadaval.',
      agentBusy: 'Meie agendid on hetkel hõivatud. Palun oodake...',
      waitingForAgent: 'Ühendame teid agendiga...',
      waitingForAgentWithSkill: 'Ühendame teid {{skill}} agendiga...',
      talkingWithAgent: 'Vestlus kasutajaga {{name}}',
      home: 'Avaleht',
      back: 'Tagasi',
      menu: 'Menüü',
      minimize: 'Minimeeri',
      endConversation: 'Lõpeta vestlus',
      engageWithUs: 'Võtke meiega ühendust',
      noMessagesYet: 'Sõnumeid veel pole',
      tryAgain: 'Proovi uuesti',
      gettingLocation: 'Praeguse asukoha hankimine...',
      locationSharedMessage: 'Siin on minu asukoht.',
      selectFile: 'Vali fail',
      upload: 'Laadi üles',
      uploadComplete: 'Üleslaadimine lõpetatud',
      uploadFailed: 'Üleslaadimine ebaõnnestus',
      fileTooLarge:
        'See fail on üleslaadimiseks liiga suur. Palun valige fail, mis on väiksem kui {{maxSize}}.',
      dragOrClick: 'Lohista fail või klõpsa valimiseks',
      document: 'Dokument',
      audioContent: 'Helisisu',
      videoContent: 'Videosisu',
      videoUnsupported: 'Seda videot ei saa teie brauseris esitada.',
      unsupportedContent: 'Toetamata sisu',
      unavailable: {
        error: {
          title: 'Midagi läks valesti',
          body: 'Vestlust ei õnnestunud laadida. Proovige uuesti.',
          retry: 'Proovi uuesti',
        },
        maintenance: {
          title: 'Vestlus on ajutiselt kättesaamatu',
          body: 'Teostame plaanilist hooldust. Tulge varsti tagasi.',
        },
      },
      image: 'Pilt',
      agentSharedImage: '{{name}} jagas pildi: ',
      assistantSharedImage: '{{name}} jagas pildi: ',
      starRating: 'Tärnihinnang',
      starRatingOrder: '{{current}} {{total}}-st tähest',
      submit: 'Saada',
      closeConversationDialog: 'Sulge vestlus',
      waitingForAgentDescription: 'Palun oodake, kuni ühendame teid agendiga',
      agentTransferred: 'Teid on üle viidud teise agendi juurde.',
      uploadingFile: 'Laadite üles: {{fileName}}',
      uploadedFile: 'Laadisite üles {{fileName}}',
      attachedFile: 'Lisatud: {{fileName}}',
      fileTypeNotPermitted: 'Vabandust, see failitüüp ei ole lubatud.',
      relaunch: 'Taaskäivitage',
      screenReaderHintChrome:
        "Parima ekraanilugeri kogemuse saamiseks Google Chrome'is soovitame kasutada JAWS-i.",
      screenReaderHintFirefox:
        'Parima ekraanilugeri kogemuse saamiseks Firefoxis soovitame kasutada NVDA-d.',
      agentInitiatedCall: '{{name}} on alustanud kõnet',
      clickToJoin: 'Liitumiseks klõpsake',
      callSessionInProgress: 'Teie kõneseanss on pooleli',
      primaryNavigation: 'Navigeerimine',
      agentTypingNamed: '{{name}} kirjutab',
      agentSaysUnnamed: 'Agent ütleb',
      botIsThinkingNamed: '{{name}} mõtleb',
      talkingWithAgentUnnamed: 'Vestlus agendiga',
      download: 'Laadi alla',
      downloading: 'Allalaadimine',
      downloadComplete: 'Allalaadimine lõpetatud',
      downloadFailed: 'Allalaadimine ebaõnnestus',
      attachFile: 'Lisa fail',
      removeAttachment: 'Eemalda manus',
      uploadFailedConnection:
        'Üleslaadimine ebaõnnestus. Kontrollige ühendust.',
      fileTooLargeToUpload:
        'See fail on üleslaadimiseks liiga suur. Palun valige fail, mis on väiksem kui {{maxSize}}.',
      problemUploadingFile: 'Teie faili üleslaadimisel tekkis probleem.',
      attachmentRemoved: 'Manus eemaldatud.',
      tomorrow: 'Homme',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Avamenüü',
      goBack: 'Tagasi',
      expandInSameWindow: 'Laienda samas aknas',
      collapseDialog: 'Ahenda dialoog',
      closeDialog: 'Sulge dialoog',
    },
  },
  {
    lang: 'fi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Tämä keskustelu on päättynyt.',
      agentConnected: 'Sinut on yhdistetty asiakaspalvelijaan.',
      downloadTranscript: 'Lataa keskustelu',
      startNewConversation: 'Aloita uusi keskustelu',
      returnToConversation: 'Takaisin keskusteluun',
      connecting: 'Yhdistetään...',
      retry: 'Yritä uudelleen',
      reconnecting: 'Yhdistetään uudelleen...',
      connectionLost: 'Internetyhteys on katkennut',
      reconnectDescription:
        'Internetyhteys on katkennut. Napsauta Yhdistä uudelleen yrittääksesi uudelleen.',
      typeMessage: 'Kirjoita viesti',
      inputSelect: 'Valitse vaihtoehto',
      inputSelectOrType: 'Valitse vaihtoehto tai kirjoita viesti',
      secureInput: 'Kirjoita suojattu viesti',
      secureValueHidden: 'Piilotettu suojattu arvo',
      redactedValue: 'Piilotetut henkilötiedot',
      startChat: 'Aloita keskustelu',
      settings: 'Asetukset',
      cancel: 'Peruuta',
      confirm: 'Vahvista',
      close: 'Sulje',
      next: 'Seuraava',
      brandingTagline: 'Tehosta liiketoimintaasi älykkäillä tekoälyagenteilla',
      poweredBy: 'Palvelun tarjoaa',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Avustaja miettii',
      youSaid: 'Sanoit',
      botSays: 'Avustaja sanoo',
      agentSays: '{{name}} sanoo',
      joinMeeting: 'Liity kokoukseen',
      meetingInProgress: 'Kokous käynnissä — napsauta liittyäksesi uudelleen',
      meetingExpired: 'Kokouslinkki (vanhentunut)',
      embeddedContent: 'Upotettu sisältö',
      openInNewTab: 'Avaa uudessa välilehdessä',
      skipToMain: 'Siirry pääsisältöön',
      customerLogoAlt: '{{customerName}}-logo',
      selectDate: 'Valitse päivämäärä',
      selectTime: 'Valitse aika',
      browseOptions: 'Selaa vaihtoehtoja',
      carouselRoleDescription: 'Karuselli',
      carouselSlideLabel: 'Dia {{current}} / {{total}}',
      carouselPrevious: 'Edellinen kohde',
      carouselNext: 'Seuraava kohde',
      carouselGoToItem: 'Siirry kohteeseen {{index}}',
      collapse: 'Tiivistä',
      expand: 'Laajenna',
      messageHistory: 'Viestihistoria',
      reduce: 'Pienennä',
      today: 'Tänään',
      at: 'klo',
      a11yOptionsCount_one: '1 vaihtoehto.',
      a11yOptionsCount_other: '{{count}} vaihtoehtoa.',
      listpickerSelectAll: 'Valitse kaikki',
      listpickerSelectOption: 'Valitse vaihtoehto',
      listpickerSearchAriaLabel: 'Hae suodatinvaihtoehtoja',
      listpickerSearchPlaceholder: 'Hae…',
      listpickerNoResults: 'Ei vastaavia vaihtoehtoja.',
      listpickerResults_one: '1 tulos',
      listpickerResults_other: '{{count}} tulosta',
      listpickerCondensed_one: '1 valittu',
      listpickerCondensed_other: '{{count}} valittu',
      scrollToLatest: 'Vieritä uusimpaan viestiin',
      scrollToUnread_one: '1 uusi viesti, siirry uusimpaan',
      scrollToUnread_other: '{{count}} uutta viestiä, siirry uusimpaan',
      showPassword: 'Näytä suojattu sisältö',
      hidePassword: 'Piilota suojattu sisältö',
      clear: 'Tyhjennä',
      send: 'Lähetä',
      yesterday: 'Eilen',
      chatEndedActions: 'Toiminnot keskustelun päätyttyä',
      openConversationDialog: 'Avaa keskusteluikkuna: {{title}}',
      agentTyping: 'Asiakaspalvelija kirjoittaa',
      agentAway: 'Asiakaspalvelijamme eivät ole tällä hetkellä käytettävissä.',
      agentBusy:
        'Asiakaspalvelijamme ovat tällä hetkellä varattuja. Odota hetki...',
      waitingForAgent: 'Yhdistämme sinut asiakaspalvelijaan...',
      waitingForAgentWithSkill:
        'Yhdistämme sinut {{skill}}-asiakaspalvelijaan...',
      talkingWithAgent: 'Keskustelet henkilön {{name}} kanssa',
      home: 'Etusivu',
      back: 'Takaisin',
      menu: 'Valikko',
      minimize: 'Pienennä',
      endConversation: 'Lopeta keskustelu',
      engageWithUs: 'Ota yhteyttä',
      noMessagesYet: 'Ei vielä viestejä',
      tryAgain: 'Yritä uudelleen',
      gettingLocation: 'Haetaan nykyistä sijaintia...',
      locationSharedMessage: 'Tässä on sijaintini',
      selectFile: 'Valitse tiedosto',
      upload: 'Lataa',
      uploadComplete: 'Lataus valmis',
      uploadFailed: 'Lataus epäonnistui',
      fileTooLarge:
        'Tämä tiedosto on liian suuri ladattavaksi. Valitse tiedosto, joka on alle {{maxSize}}.',
      dragOrClick: 'Vedä tiedosto tai valitse napsauttamalla',
      document: 'Asiakirja',
      audioContent: 'Äänisisältö',
      videoContent: 'Videosisältö',
      videoUnsupported: 'Tätä videota ei voi toistaa selaimessasi.',
      unsupportedContent: 'Ei tuettu sisältö',
      unavailable: {
        error: {
          title: 'Jokin meni pieleen',
          body: 'Keskustelua ei voitu ladata. Yritä uudelleen.',
          retry: 'Yritä uudelleen',
        },
        maintenance: {
          title: 'Keskustelu ei ole tilapäisesti käytettävissä',
          body: 'Suoritamme ajoitettua huoltoa. Palaa pian takaisin.',
        },
      },
      image: 'Kuva',
      agentSharedImage: '{{name}} jakoi kuvan: ',
      assistantSharedImage: '{{name}} jakoi kuvan: ',
      starRating: 'Tähtiarviointi',
      starRatingOrder: '{{current}} / {{total}} tähteä',
      submit: 'Lähetä',
      closeConversationDialog: 'Sulje keskustelu',
      waitingForAgentDescription: 'Odota, kun yhdistämme sinut agenttiin',
      agentTransferred: 'Sinut on siirretty toiselle edustajalle.',
      uploadingFile: 'Olet lataamassa: {{fileName}}',
      uploadedFile: 'Latasit {{fileName}}',
      attachedFile: 'Liitetty: {{fileName}}',
      fileTypeNotPermitted: 'Pahoittelut, tämä tiedostotyyppi ei ole sallittu.',
      relaunch: 'Käynnistä uudelleen',
      screenReaderHintChrome:
        'Parhaan ruudunlukijakokemuksen saamiseksi Google Chrome -selaimessa suosittelemme JAWS:in käyttöä.',
      screenReaderHintFirefox:
        'Parhaan ruudunlukijakokemuksen saamiseksi Firefox-selaimessa suosittelemme NVDA:n käyttöä.',
      agentInitiatedCall: '{{name}} on aloittanut puhelun',
      clickToJoin: 'Napsauta liittyäksesi',
      callSessionInProgress: 'Puheluistuntosi on käynnissä',
      primaryNavigation: 'Navigointi',
      agentTypingNamed: '{{name}} kirjoittaa',
      agentSaysUnnamed: 'Asiakaspalvelija sanoo',
      botIsThinkingNamed: '{{name}} miettii',
      talkingWithAgentUnnamed: 'Keskustelu asiakaspalvelijan kanssa',
      download: 'Lataa',
      downloading: 'Ladataan',
      downloadComplete: 'Lataus valmis',
      downloadFailed: 'Lataus epäonnistui',
      attachFile: 'Liitä tiedosto',
      removeAttachment: 'Poista liite',
      uploadFailedConnection: 'Lataus epäonnistui. Tarkista yhteytesi.',
      fileTooLargeToUpload:
        'Tämä tiedosto on liian suuri ladattavaksi. Valitse tiedosto, joka on alle {{maxSize}}.',
      problemUploadingFile: 'Tiedostosi lataamisessa ilmeni ongelma.',
      attachmentRemoved: 'Liite poistettu.',
      tomorrow: 'Huomenna',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Kotivalikko',
      goBack: 'Palaa takaisin',
      expandInSameWindow: 'Laajenna samassa ikkunassa',
      collapseDialog: 'Pienennä valintaikkuna',
      closeDialog: 'Sulje valintaikkuna',
    },
  },
  {
    lang: 'fr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Cette conversation est terminée.',
      agentConnected: 'Vous avez été mis en relation avec un agent.',
      downloadTranscript: 'Télécharger la transcription',
      startNewConversation: 'Démarrer une nouvelle conversation',
      returnToConversation: 'Revenir à la conversation',
      connecting: 'Connexion...',
      retry: 'Réessayer',
      reconnecting: 'Reconnexion...',
      connectionLost: 'La connexion internet a été perdue',
      reconnectDescription:
        'La connexion internet a été perdue. Cliquez sur Se reconnecter pour réessayer.',
      typeMessage: 'Saisissez un message',
      inputSelect: 'Sélectionnez une option',
      inputSelectOrType: 'Sélectionnez une option ou saisissez un message',
      secureInput: 'Saisissez un message sécurisé',
      secureValueHidden: 'Valeur sécurisée masquée',
      redactedValue: 'Informations personnelles masquées',
      startChat: 'Démarrer la discussion',
      settings: 'Paramètres',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      close: 'Fermer',
      next: 'Suivant',
      brandingTagline:
        'Boostez votre entreprise avec des agents IA intelligents',
      poweredBy: 'Propulsé par',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: "L'assistant réfléchit",
      youSaid: 'Vous avez dit',
      botSays: "L'assistant dit",
      agentSays: '{{name}} dit',
      joinMeeting: 'Rejoindre la réunion',
      meetingInProgress: 'Réunion en cours — cliquez pour rejoindre',
      meetingExpired: 'Lien de réunion (expiré)',
      embeddedContent: 'Contenu intégré',
      openInNewTab: 'Ouvrir dans un nouvel onglet',
      skipToMain: 'Passer au contenu principal',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Sélectionner une date',
      selectTime: "Sélectionner l'heure",
      browseOptions: 'Parcourir les options',
      carouselRoleDescription: 'Carrousel',
      carouselSlideLabel: 'Diapositive {{current}} sur {{total}}',
      carouselPrevious: 'Élément précédent',
      carouselNext: 'Élément suivant',
      carouselGoToItem: "Aller à l'élément {{index}}",
      collapse: 'Réduire',
      expand: 'Développer',
      messageHistory: 'Historique des messages',
      reduce: 'Réduire',
      today: "Aujourd'hui",
      at: 'à',
      a11yOptionsCount_one: 'Il y a 1 option.',
      a11yOptionsCount_many: 'Il y a {{count}} options.',
      a11yOptionsCount_other: 'Il y a {{count}} options.',
      listpickerSelectAll: 'Tout sélectionner',
      listpickerSelectOption: 'Sélectionnez une option',
      listpickerSearchAriaLabel: 'Rechercher des options de filtre',
      listpickerSearchPlaceholder: 'Rechercher…',
      listpickerNoResults: 'Aucune option correspondante.',
      listpickerResults_one: '1 résultat',
      listpickerResults_many: '{{count}} résultats',
      listpickerResults_other: '{{count}} résultats',
      listpickerCondensed_one: '1 sélectionné',
      listpickerCondensed_many: '{{count}} sélectionnés',
      listpickerCondensed_other: '{{count}} sélectionnés',
      scrollToLatest: 'Aller au dernier message',
      scrollToUnread_one: '1 nouveau message, aller au dernier',
      scrollToUnread_many: '{{count}} nouveaux messages, aller au dernier',
      scrollToUnread_other: '{{count}} nouveaux messages, aller au dernier',
      showPassword: 'Afficher le contenu sécurisé',
      hidePassword: 'Masquer le contenu sécurisé',
      clear: 'Effacer',
      send: 'Envoyer',
      yesterday: 'Hier',
      chatEndedActions: 'Actions de fin de discussion',
      openConversationDialog:
        'Ouvrir la boîte de dialogue de conversation avec {{title}}',
      agentTyping: "L'agent est en train d'écrire",
      agentAway: 'Nos agents ne sont pas disponibles pour le moment.',
      agentBusy: 'Nos agents sont actuellement occupés. Veuillez patienter...',
      waitingForAgent: 'Mise en relation avec un agent...',
      waitingForAgentWithSkill: 'Mise en relation avec un agent {{skill}}...',
      talkingWithAgent: 'Discussion avec {{name}}',
      home: 'Accueil',
      back: 'Retour',
      menu: 'Menu',
      minimize: 'Réduire',
      endConversation: 'Terminer la conversation',
      engageWithUs: 'Contactez-nous',
      noMessagesYet: "Aucun message pour l'instant",
      tryAgain: 'Réessayer',
      gettingLocation: 'Recherche de votre position…',
      locationSharedMessage: 'Voici ma position',
      selectFile: 'Sélectionner un fichier',
      upload: 'Téléverser',
      uploadComplete: 'Téléversement terminé',
      uploadFailed: 'Échec du téléchargement',
      fileTooLarge:
        'Ce fichier est trop volumineux pour être téléchargé. Veuillez sélectionner un fichier de moins de {{maxSize}}.',
      dragOrClick: 'Glissez un fichier ou cliquez pour choisir',
      document: 'Document',
      audioContent: 'Contenu audio',
      videoContent: 'Contenu vidéo',
      videoUnsupported:
        'Cette vidéo ne peut pas être lue dans votre navigateur.',
      unsupportedContent: 'Contenu non pris en charge',
      unavailable: {
        error: {
          title: "Une erreur s'est produite",
          body: "Nous n'avons pas pu charger la discussion. Veuillez réessayer.",
          retry: 'Réessayer',
        },
        maintenance: {
          title: 'La discussion est temporairement indisponible',
          body: 'Nous effectuons une maintenance planifiée. Revenez bientôt.',
        },
      },
      image: 'Image',
      agentSharedImage: '{{name}} a partagé une image :',
      assistantSharedImage: '{{name}} a partagé une image :',
      starRating: 'Évaluation par étoiles',
      starRatingOrder: '{{current}} sur {{total}} étoiles',
      submit: 'Envoyer',
      closeConversationDialog: 'Fermer la conversation',
      waitingForAgentDescription:
        'Veuillez patienter pendant que nous vous connectons à un agent',
      agentTransferred: 'Vous avez été transféré à un autre conseiller.',
      uploadingFile: 'Vous êtes en train de télécharger: {{fileName}}',
      uploadedFile: 'Vous avez téléchargé {{fileName}}',
      attachedFile: 'Pièce jointe: {{fileName}}',
      fileTypeNotPermitted: "Désolé, ce type de fichier n'est pas autorisé.",
      relaunch: 'Relancer',
      screenReaderHintChrome:
        "Pour la meilleure expérience de lecteur d'écran dans Google Chrome, nous suggérons d'utiliser JAWS.",
      screenReaderHintFirefox:
        "Pour la meilleure expérience de lecteur d'écran dans Firefox, nous suggérons d'utiliser NVDA.",
      agentInitiatedCall: '{{name}} a initié un appel',
      clickToJoin: 'Cliquez pour rejoindre',
      callSessionInProgress: "Votre session d'appel est en cours",
      primaryNavigation: 'Navigation',
      agentTypingNamed: "{{name}} est en train d'écrire",
      agentSaysUnnamed: "L'agent dit",
      botIsThinkingNamed: '{{name}} réfléchit',
      talkingWithAgentUnnamed: 'Discussion avec un agent',
      download: 'Télécharger',
      downloading: 'Téléchargement en cours',
      downloadComplete: 'Téléchargement terminé',
      downloadFailed: 'Échec du téléchargement',
      attachFile: 'Joindre un fichier',
      removeAttachment: 'Supprimer la pièce jointe',
      uploadFailedConnection: 'Échec de l’envoi. Vérifiez votre connexion.',
      fileTooLargeToUpload:
        'Ce fichier est trop volumineux pour être téléchargé. Veuillez sélectionner un fichier de moins de {{maxSize}}.',
      problemUploadingFile:
        'Il y a eu un problème lors du téléchargement de votre fichier.',
      attachmentRemoved: 'Pièce jointe supprimée.',
      tomorrow: 'Demain',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: "Menu d'accueil",
      goBack: 'Retour',
      expandInSameWindow: 'Agrandir dans la même fenêtre',
      collapseDialog: 'Réduire la boîte de dialogue',
      closeDialog: 'Fermer la boîte de dialogue',
    },
  },
  {
    lang: 'he',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'השיחה הזו הסתיימה.',
      agentConnected: 'חוברת בהצלחה לנציג.',
      downloadTranscript: 'הורדת תמליל',
      startNewConversation: 'התחלת שיחה חדשה',
      returnToConversation: 'חזרה לשיחה',
      connecting: 'מתחבר...',
      retry: 'נסה שוב',
      reconnecting: 'מתחבר מחדש...',
      connectionLost: 'החיבור לאינטרנט אבד',
      reconnectDescription:
        "החיבור לאינטרנט אבד. לחץ על 'התחבר מחדש' כדי לנסות שוב.",
      typeMessage: 'הקלד הודעה',
      inputSelect: 'בחר אפשרות',
      inputSelectOrType: 'בחר אפשרות או הקלד הודעה',
      secureInput: 'הקלד הודעה מאובטחת',
      secureValueHidden: 'ערך מאובטח מוסתר',
      redactedValue: 'מידע אישי מוסתר',
      startChat: "התחל צ'אט",
      settings: 'הגדרות',
      cancel: 'ביטול',
      confirm: 'אישור',
      close: 'סגור',
      next: 'הבא',
      brandingTagline: 'האיצו את העסק שלכם עם סוכני AI חכמים',
      poweredBy: 'מופעל על ידי',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'העוזר חושב',
      youSaid: 'אמרת',
      botSays: 'העוזר אומר',
      agentSays: '{{name}} אומר',
      joinMeeting: 'הצטרף לפגישה',
      meetingInProgress: 'פגישה מתקיימת — לחץ כדי להצטרף מחדש',
      meetingExpired: 'קישור לפגישה (פג תוקף)',
      embeddedContent: 'תוכן מוטמע',
      openInNewTab: 'פתח בכרטיסייה חדשה',
      skipToMain: 'דלג לתוכן הראשי',
      customerLogoAlt: 'הלוגו של {{customerName}}',
      selectDate: 'בחר תאריך',
      selectTime: 'בחר שעה',
      browseOptions: 'עיין באפשרויות',
      carouselRoleDescription: 'קרוסלה',
      carouselSlideLabel: 'שקופית {{current}} מתוך {{total}}',
      carouselPrevious: 'הפריט הקודם',
      carouselNext: 'הפריט הבא',
      carouselGoToItem: 'עבור לפריט {{index}}',
      collapse: 'כווץ',
      expand: 'הרחב',
      messageHistory: 'היסטוריית הודעות',
      reduce: 'הקטן',
      today: 'היום',
      at: 'בשעה',
      a11yOptionsCount_one: 'יש אפשרות אחת.',
      a11yOptionsCount_two: 'יש {{count}} אפשרויות.',
      a11yOptionsCount_other: 'יש {{count}} אפשרויות.',
      listpickerSelectAll: 'בחר הכול',
      listpickerSelectOption: 'בחר אפשרות',
      listpickerSearchAriaLabel: 'חפש אפשרויות סינון',
      listpickerSearchPlaceholder: 'חיפוש…',
      listpickerNoResults: 'אין אפשרויות תואמות.',
      listpickerResults_one: 'תוצאה אחת',
      listpickerResults_two: '{{count}} תוצאות',
      listpickerResults_other: '{{count}} תוצאות',
      listpickerCondensed_one: 'נבחרה אחת',
      listpickerCondensed_two: '{{count}} נבחרו',
      listpickerCondensed_other: '{{count}} נבחרו',
      scrollToLatest: 'גלול להודעה האחרונה',
      scrollToUnread_one: 'הודעה חדשה אחת, גלול לאחרונה',
      scrollToUnread_two: '{{count}} הודעות חדשות, גלול לאחרונה',
      scrollToUnread_other: '{{count}} הודעות חדשות, גלול לאחרונה',
      showPassword: 'הצג תוכן מאובטח',
      hidePassword: 'הסתר תוכן מאובטח',
      clear: 'נקה',
      send: 'שלח',
      yesterday: 'אתמול',
      chatEndedActions: "פעולות לאחר סיום הצ'אט",
      openConversationDialog: 'פתח את חלון השיחה עם {{title}}',
      agentTyping: 'הנציג מקליד',
      agentAway: 'הנציגים שלנו אינם זמינים כרגע.',
      agentBusy: 'הנציגים שלנו עסוקים כרגע. נא להמתין...',
      waitingForAgent: 'מחברים אותך לנציג...',
      waitingForAgentWithSkill: 'מחברים אותך לנציג בנושא {{skill}}...',
      talkingWithAgent: 'בשיחה עם {{name}}',
      home: 'בית',
      back: 'חזרה',
      menu: 'תפריט',
      minimize: 'מזער',
      endConversation: 'סיים שיחה',
      engageWithUs: 'צור איתנו קשר',
      noMessagesYet: 'אין הודעות עדיין',
      tryAgain: 'נסה שוב',
      gettingLocation: 'מאתר את המיקום הנוכחי...',
      locationSharedMessage: 'הנה המיקום שלי.',
      selectFile: 'בחר קובץ',
      upload: 'העלה',
      uploadComplete: 'ההעלאה הושלמה',
      uploadFailed: 'ההעלאה נכשלה',
      fileTooLarge: 'הקובץ גדול מדי להעלאה. אנא בחר קובץ הקטן מ-{{maxSize}}.',
      dragOrClick: 'גרור קובץ או לחץ כדי לבחור',
      document: 'מסמך',
      audioContent: 'תוכן שמע',
      videoContent: 'תוכן וידאו',
      videoUnsupported: 'לא ניתן להפעיל את הסרטון הזה בדפדפן שלך.',
      unsupportedContent: 'תוכן שאינו נתמך',
      unavailable: {
        error: {
          title: 'משהו השתבש',
          body: "לא הצלחנו לטעון את הצ'אט. נסה שוב.",
          retry: 'נסה שוב',
        },
        maintenance: {
          title: "הצ'אט אינו זמין באופן זמני",
          body: 'אנו מבצעים תחזוקה מתוכננת. חזור בקרוב.',
        },
      },
      image: 'תמונה',
      agentSharedImage: '{{name}} שיתף תמונה: ',
      assistantSharedImage: '{{name}} שיתף תמונה: ',
      starRating: 'דירוג כוכבים',
      starRatingOrder: 'כוכב {{current}} מתוך {{total}}',
      submit: 'שליחה',
      closeConversationDialog: 'סגור שיחה',
      waitingForAgentDescription: 'אנא המתן בזמן שאנו מחברים אותך לנציג',
      agentTransferred: 'הועברת לנציג אחר.',
      uploadingFile: 'אתה מעלה: {{fileName}}',
      uploadedFile: 'העלית {{fileName}}',
      attachedFile: 'מצורף: {{fileName}}',
      fileTypeNotPermitted: 'מצטערים, סוג קובץ זה אינו מורשה.',
      relaunch: 'הפעל מחדש',
      screenReaderHintChrome:
        'לחוויה הטובה ביותר עם קורא מסך בגוגל כרום, אנו ממליצים להשתמש ב-JAWS.',
      screenReaderHintFirefox:
        'לחוויה הטובה ביותר עם קורא מסך בפיירפוקס, אנו ממליצים להשתמש ב-NVDA.',
      agentInitiatedCall: '{{name}} יזם שיחה',
      clickToJoin: 'לחץ להצטרפות',
      callSessionInProgress: 'השיחה שלך מתקיימת',
      primaryNavigation: 'ניווט',
      agentTypingNamed: '{{name}} מקליד',
      agentSaysUnnamed: 'הנציג אומר',
      botIsThinkingNamed: '{{name}} חושב',
      talkingWithAgentUnnamed: 'שיחה עם נציג',
      download: 'הורדה',
      downloading: 'מוריד',
      downloadComplete: 'ההורדה הושלמה',
      downloadFailed: 'ההורדה נכשלה',
      attachFile: 'צירוף קובץ',
      removeAttachment: 'הסרת הקובץ המצורף',
      uploadFailedConnection: 'ההעלאה נכשלה. בדוק את החיבור שלך.',
      fileTooLargeToUpload:
        'הקובץ גדול מדי להעלאה. אנא בחר קובץ הקטן מ-{{maxSize}}.',
      problemUploadingFile: 'הייתה בעיה בהעלאת הקובץ שלך.',
      attachmentRemoved: 'הקובץ המצורף הוסר.',
      tomorrow: 'מחר',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'תפריט ראשי',
      goBack: 'חזור',
      expandInSameWindow: 'הרחב באותו חלון',
      collapseDialog: 'כווץ חלון',
      closeDialog: 'סגור חלון',
    },
  },
  {
    lang: 'hr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ovaj razgovor je završen.',
      agentConnected: 'Uspješno ste povezani s agentom.',
      downloadTranscript: 'Preuzmi transkript',
      startNewConversation: 'Započni novi razgovor',
      returnToConversation: 'Natrag na razgovor',
      connecting: 'Povezivanje...',
      retry: 'Pokušaj ponovno',
      reconnecting: 'Ponovno povezivanje...',
      connectionLost: 'Internetska veza je izgubljena',
      reconnectDescription:
        'Internetska veza je izgubljena. Kliknite Ponovno poveži za novi pokušaj.',
      typeMessage: 'Upišite poruku',
      inputSelect: 'Odaberite opciju',
      inputSelectOrType: 'Odaberite opciju ili upišite poruku',
      secureInput: 'Upišite sigurnu poruku',
      secureValueHidden: 'Skrivena sigurna vrijednost',
      redactedValue: 'Skriveni osobni podaci',
      startChat: 'Započni chat',
      settings: 'Postavke',
      cancel: 'Odustani',
      confirm: 'Potvrdi',
      close: 'Zatvori',
      next: 'Dalje',
      brandingTagline: 'Osnažite svoje poslovanje s inteligentnim AI agentima',
      poweredBy: 'Pokreće',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistent razmišlja',
      youSaid: 'Rekli ste',
      botSays: 'Asistent kaže',
      agentSays: '{{name}} kaže',
      joinMeeting: 'Pridruži se sastanku',
      meetingInProgress:
        'Sastanak je u tijeku — kliknite za ponovno pridruživanje',
      meetingExpired: 'Poveznica na sastanak (istekla)',
      embeddedContent: 'Ugrađeni sadržaj',
      openInNewTab: 'Otvori u novoj kartici',
      skipToMain: 'Preskoči na glavni sadržaj',
      customerLogoAlt: 'Logotip {{customerName}}',
      selectDate: 'Odaberite datum',
      selectTime: 'Odaberite vrijeme',
      browseOptions: 'Pregledaj opcije',
      carouselRoleDescription: 'Vrtuljak',
      carouselSlideLabel: 'Slajd {{current}} od {{total}}',
      carouselPrevious: 'Prethodna stavka',
      carouselNext: 'Sljedeća stavka',
      carouselGoToItem: 'Idi na stavku {{index}}',
      collapse: 'Sažmi',
      expand: 'Proširi',
      messageHistory: 'Povijest poruka',
      reduce: 'Smanji',
      today: 'Danas',
      at: 'u',
      a11yOptionsCount_one: 'Postoji 1 opcija.',
      a11yOptionsCount_few: 'Postoje {{count}} opcije.',
      a11yOptionsCount_other: 'Postoji {{count}} opcija.',
      listpickerSelectAll: 'Odaberi sve',
      listpickerSelectOption: 'Odaberite opciju',
      listpickerSearchAriaLabel: 'Pretraži opcije filtra',
      listpickerSearchPlaceholder: 'Pretraži…',
      listpickerNoResults: 'Nema podudarnih opcija.',
      listpickerResults_one: '1 rezultat',
      listpickerResults_few: '{{count}} rezultata',
      listpickerResults_other: '{{count}} rezultata',
      listpickerCondensed_one: '1 odabrano',
      listpickerCondensed_few: '{{count}} odabrano',
      listpickerCondensed_other: '{{count}} odabrano',
      scrollToLatest: 'Pomakni na najnoviju poruku',
      scrollToUnread_one: '1 nova poruka, na najnoviju',
      scrollToUnread_few: '{{count}} nove poruke, na najnoviju',
      scrollToUnread_other: '{{count}} novih poruka, na najnoviju',
      showPassword: 'Prikaži siguran sadržaj',
      hidePassword: 'Sakrij siguran sadržaj',
      clear: 'Očisti',
      send: 'Pošalji',
      yesterday: 'Jučer',
      chatEndedActions: 'Radnje nakon završetka chata',
      openConversationDialog: 'Otvori prozor razgovora s {{title}}',
      agentTyping: 'Agent tipka',
      agentAway: 'Naši agenti trenutačno nisu dostupni.',
      agentBusy: 'Naši agenti trenutačno su zauzeti. Pričekajte...',
      waitingForAgent: 'Povezujemo vas s agentom...',
      waitingForAgentWithSkill: 'Povezujemo vas s agentom za {{skill}}...',
      talkingWithAgent: 'Razgovor s {{name}}',
      home: 'Početna',
      back: 'Natrag',
      menu: 'Izbornik',
      minimize: 'Minimiziraj',
      endConversation: 'Završi razgovor',
      engageWithUs: 'Kontaktirajte nas',
      noMessagesYet: 'Još nema poruka',
      tryAgain: 'Pokušaj ponovno',
      gettingLocation: 'Dohvaćanje trenutne lokacije...',
      locationSharedMessage: 'Ovdje je moja lokacija.',
      selectFile: 'Odaberite datoteku',
      upload: 'Prenesi',
      uploadComplete: 'Prijenos dovršen',
      uploadFailed: 'Učitavanje nije uspjelo',
      fileTooLarge:
        'Ova datoteka je prevelika za učitavanje. Molimo odaberite datoteku manju od {{maxSize}}.',
      dragOrClick: 'Povucite datoteku ili kliknite za odabir',
      document: 'Dokument',
      audioContent: 'Audiosadržaj',
      videoContent: 'Videosadržaj',
      videoUnsupported:
        'Ovaj se videozapis ne može reproducirati u vašem pregledniku.',
      unsupportedContent: 'Nepodržani sadržaj',
      unavailable: {
        error: {
          title: 'Nešto je pošlo po zlu',
          body: 'Nismo mogli učitati chat. Pokušajte ponovno.',
          retry: 'Pokušaj ponovno',
        },
        maintenance: {
          title: 'Chat je privremeno nedostupan',
          body: 'Provodimo planirano održavanje. Vratite se uskoro.',
        },
      },
      image: 'Slika',
      agentSharedImage: '{{name}} je podijelio sliku:',
      assistantSharedImage: '{{name}} je podijelio sliku:',
      starRating: 'Ocjena zvjezdicama',
      starRatingOrder: '{{current}} od {{total}} zvjezdica',
      submit: 'Pošalji',
      closeConversationDialog: 'Zatvori razgovor',
      waitingForAgentDescription:
        'Molimo pričekajte dok vas povezujemo s agentom',
      agentTransferred: 'Prebačeni ste na drugog agenta.',
      uploadingFile: 'Učitavate: {{fileName}}',
      uploadedFile: 'Učitali ste {{fileName}}',
      attachedFile: 'Priloženo: {{fileName}}',
      fileTypeNotPermitted: 'Žao nam je, ova vrsta datoteke nije dopuštena.',
      relaunch: 'Ponovno pokrenite',
      screenReaderHintChrome:
        'Za najbolje iskustvo čitača zaslona u Google Chromeu predlažemo korištenje JAWS-a.',
      screenReaderHintFirefox:
        'Za najbolje iskustvo čitača zaslona u Firefoxu predlažemo korištenje NVDA.',
      agentInitiatedCall: '{{name}} je započeo poziv',
      clickToJoin: 'Kliknite za pridruživanje',
      callSessionInProgress: 'Vaša sesija poziva je u tijeku',
      primaryNavigation: 'Navigacija',
      agentTypingNamed: '{{name}} tipka',
      agentSaysUnnamed: 'Agent kaže',
      botIsThinkingNamed: '{{name}} razmišlja',
      talkingWithAgentUnnamed: 'Razgovor s agentom',
      download: 'Preuzmi',
      downloading: 'Preuzimanje',
      downloadComplete: 'Preuzimanje dovršeno',
      downloadFailed: 'Preuzimanje nije uspjelo',
      attachFile: 'Priloži datoteku',
      removeAttachment: 'Ukloni privitak',
      uploadFailedConnection: 'Prijenos nije uspio. Provjerite vezu.',
      fileTooLargeToUpload:
        'Ova datoteka je prevelika za učitavanje. Molimo odaberite datoteku manju od {{maxSize}}.',
      problemUploadingFile:
        'Došlo je do problema prilikom učitavanja vaše datoteke.',
      attachmentRemoved: 'Privitak uklonjen.',
      tomorrow: 'Sutra',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Početni izbornik',
      goBack: 'Natrag',
      expandInSameWindow: 'Proširi u istom prozoru',
      collapseDialog: 'Sažmi dijalog',
      closeDialog: 'Zatvori dijalog',
    },
  },
  {
    lang: 'ht',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Konvèsasyon sa a fini.',
      agentConnected: 'Ou konekte avèk yon ajan avèk siksè.',
      downloadTranscript: 'Telechaje transkripsyon an',
      startNewConversation: 'Kòmanse yon nouvo konvèsasyon',
      returnToConversation: 'Retounen nan konvèsasyon an',
      connecting: 'Koneksyon...',
      retry: 'Eseye ankò',
      reconnecting: 'Rekoneksyon...',
      connectionLost: 'Koneksyon entènèt la pèdi',
      reconnectDescription:
        'Koneksyon entènèt la pèdi. Klike sou Rekonekte pou eseye ankò.',
      typeMessage: 'Tape yon mesaj',
      inputSelect: 'Chwazi yon opsyon',
      inputSelectOrType: 'Chwazi yon opsyon oswa tape yon mesaj',
      secureInput: 'Tape yon mesaj sekirize',
      secureValueHidden: 'Valè sekirize kache',
      redactedValue: 'Enfòmasyon pèsonèl kache',
      startChat: 'Kòmanse chat la',
      settings: 'Paramèt',
      cancel: 'Anile',
      confirm: 'Konfime',
      close: 'Fèmen',
      next: 'Pwochen',
      brandingTagline: 'Ranfòse biznis ou avèk ajan AI entèlijan',
      poweredBy: 'Alimante pa',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistan an ap reflechi',
      youSaid: 'Ou di',
      botSays: 'Asistan an di',
      agentSays: '{{name}} di',
      joinMeeting: 'Rantre nan reyinyon an',
      meetingInProgress: 'Reyinyon an ap fèt — klike pou rantre ankò',
      meetingExpired: 'Lyen reyinyon (ekspire)',
      embeddedContent: 'Kontni entegre',
      openInNewTab: 'Louvri nan yon nouvo onglè',
      skipToMain: 'Ale nan kontni prensipal la',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Chwazi dat',
      selectTime: 'Chwazi lè',
      browseOptions: 'Gade opsyon yo',
      carouselRoleDescription: 'Kawousèl',
      carouselSlideLabel: 'Slid {{current}} sou {{total}}',
      carouselPrevious: 'Atik anvan',
      carouselNext: 'Atik apre',
      carouselGoToItem: 'Ale nan atik {{index}}',
      collapse: 'Ranje',
      expand: 'Elaji',
      messageHistory: 'Istwa mesaj yo',
      reduce: 'Redwi',
      today: 'Jodi a',
      at: 'a',
      a11yOptionsCount_one: 'Gen 1 opsyon.',
      a11yOptionsCount_other: 'Gen {{count}} opsyon.',
      listpickerSelectAll: 'Chwazi tout',
      listpickerSelectOption: 'Chwazi yon opsyon',
      listpickerSearchAriaLabel: 'Chèche opsyon filtè',
      listpickerSearchPlaceholder: 'Chèche…',
      listpickerNoResults: 'Pa gen opsyon ki koresponn.',
      listpickerResults_one: '1 rezilta',
      listpickerResults_other: '{{count}} rezilta',
      listpickerCondensed_one: '1 chwazi',
      listpickerCondensed_other: '{{count}} chwazi',
      scrollToLatest: 'Woule nan dènye mesaj la',
      scrollToUnread_one: '1 nouvo mesaj, ale nan dènye a',
      scrollToUnread_other: '{{count}} nouvo mesaj, ale nan dènye a',
      showPassword: 'Montre kontni sekirize',
      hidePassword: 'Kache kontni sekirize',
      clear: 'Efase',
      send: 'Voye',
      yesterday: 'Yè',
      chatEndedActions: 'Aksyon apre chat la fini',
      openConversationDialog: 'Louvri dyalòg konvèsasyon an avèk {{title}}',
      agentTyping: 'Ajan an ap tape',
      agentAway: 'Ajan nou yo pa disponib kounye a.',
      agentBusy: 'Ajan nou yo okipe kounye a. Tanpri tann...',
      waitingForAgent: 'N ap konekte ou avèk yon ajan...',
      waitingForAgentWithSkill: 'N ap konekte ou avèk yon ajan {{skill}}...',
      talkingWithAgent: 'Ap pale avèk {{name}}',
      home: 'Akèy',
      back: 'Retounen',
      menu: 'Meni',
      minimize: 'Minimize',
      endConversation: 'Fini konvèsasyon an',
      engageWithUs: 'Kontakte nou',
      noMessagesYet: 'Poko gen mesaj',
      tryAgain: 'Eseye ankò',
      gettingLocation: 'Jwenn kote ou ye kounye a...',
      locationSharedMessage: 'Men kote mwen ye.',
      selectFile: 'Chwazi yon fichye',
      upload: 'Telechaje',
      uploadComplete: 'Telechajman fini',
      uploadFailed: 'Telechajman echwe',
      fileTooLarge:
        'Fichye sa a twò gwo pou telechaje. Tanpri chwazi yon fichye ki pi piti pase {{maxSize}}.',
      dragOrClick: 'Trennen yon fichye oswa klike pou chwazi',
      document: 'Dokiman',
      audioContent: 'Kontni odyo',
      videoContent: 'Kontni videyo',
      videoUnsupported: 'Videyo sa a pa ka jwe nan navigatè ou a.',
      unsupportedContent: 'Kontni ki pa sipòte',
      unavailable: {
        error: {
          title: 'Yon bagay pa mache',
          body: 'Nou pa t kapab chaje chat la. Tanpri eseye ankò.',
          retry: 'Eseye ankò',
        },
        maintenance: {
          title: 'Chat la pa disponib pou kounye a',
          body: 'N ap fè antretyen ki pwograme. Tanpri retounen byento.',
        },
      },
      image: 'Imaj',
      agentSharedImage: '{{name}} pataje yon imaj: ',
      assistantSharedImage: '{{name}} pataje yon imaj: ',
      starRating: 'Evalyasyon etwal',
      starRatingOrder: '{{current}} nan {{total}} etwal',
      submit: 'Voye',
      closeConversationDialog: 'Fèmen konvèsasyon',
      waitingForAgentDescription:
        'Tanpri tann pandan nou konekte w ak yon ajan',
      agentTransferred: 'Yo te transfere bay yon lòt ajan.',
      uploadingFile: 'Ou ap telechaje: {{fileName}}',
      uploadedFile: 'Ou te telechaje {{fileName}}',
      attachedFile: 'Atache: {{fileName}}',
      fileTypeNotPermitted: 'Padon, kalite fichye sa a pa otorize.',
      relaunch: 'Relanse',
      screenReaderHintChrome:
        'Pou pi bon eksperyans lektè ekran nan Google Chrome, nou sijere itilize JAWS.',
      screenReaderHintFirefox:
        'Pou pi bon eksperyans lektè ekran nan Firefox, nou sijere itilize NVDA.',
      agentInitiatedCall: '{{name}} kòmanse yon apèl',
      clickToJoin: 'Klike pou w patisipe',
      callSessionInProgress: 'Sesyon apèl ou a an pwogrè',
      primaryNavigation: 'Navigasyon',
      agentTypingNamed: '{{name}} ap tape',
      agentSaysUnnamed: 'Ajan an di',
      botIsThinkingNamed: '{{name}} ap reflechi',
      talkingWithAgentUnnamed: 'Ap pale ak yon ajan',
      download: 'Telechaje',
      downloading: 'Ap telechaje',
      downloadComplete: 'Telechajman fini',
      downloadFailed: 'Telechajman echwe',
      attachFile: 'Tache yon fichye',
      removeAttachment: 'Retire atachman an',
      uploadFailedConnection: 'Telechajman echwe. Tcheke koneksyon ou.',
      fileTooLargeToUpload:
        'Fichye sa a twò gwo pou telechaje. Tanpri chwazi yon fichye ki pi piti pase {{maxSize}}.',
      problemUploadingFile:
        'Te gen yon pwoblèm pandan w ap telechaje fichye ou a.',
      attachmentRemoved: 'Atachman an retire.',
      tomorrow: 'Demen',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Meni prensipal',
      goBack: 'Retounen',
      expandInSameWindow: 'Agrandi nan menm fenèt la',
      collapseDialog: 'Redwi dyalòg',
      closeDialog: 'Fèmen dyalòg',
    },
  },
  {
    lang: 'hu',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ez a beszélgetés véget ért.',
      agentConnected: 'Sikeresen kapcsolódott egy ügyintézőhöz.',
      downloadTranscript: 'Átirat letöltése',
      startNewConversation: 'Új beszélgetés indítása',
      returnToConversation: 'Vissza a beszélgetéshez',
      connecting: 'Csatlakozás...',
      retry: 'Újra',
      reconnecting: 'Újracsatlakozás...',
      connectionLost: 'Az internetkapcsolat megszakadt',
      reconnectDescription:
        'Az internetkapcsolat megszakadt. Kattintson az Újracsatlakozás gombra az újbóli próbálkozáshoz.',
      typeMessage: 'Írjon üzenetet',
      inputSelect: 'Válasszon egy lehetőséget',
      inputSelectOrType: 'Válasszon egy lehetőséget vagy írjon üzenetet',
      secureInput: 'Írjon biztonságos üzenetet',
      secureValueHidden: 'Rejtett biztonságos érték',
      redactedValue: 'Rejtett személyes adatok',
      startChat: 'Csevegés indítása',
      settings: 'Beállítások',
      cancel: 'Mégse',
      confirm: 'Megerősítés',
      close: 'Bezárás',
      next: 'Tovább',
      brandingTagline: 'Lendítse fel vállalkozását intelligens MI-ügynökökkel',
      poweredBy: 'Üzemelteti',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Az asszisztens gondolkodik',
      youSaid: 'Ön ezt mondta',
      botSays: 'Az asszisztens ezt mondja',
      agentSays: '{{name}} ezt mondja',
      joinMeeting: 'Csatlakozás az értekezlethez',
      meetingInProgress:
        'Az értekezlet folyamatban van — kattintson az újbóli csatlakozáshoz',
      meetingExpired: 'Értekezlet-hivatkozás (lejárt)',
      embeddedContent: 'Beágyazott tartalom',
      openInNewTab: 'Megnyitás új lapon',
      skipToMain: 'Ugrás a fő tartalomra',
      customerLogoAlt: '{{customerName}} logó',
      selectDate: 'Válasszon dátumot',
      selectTime: 'Válasszon időpontot',
      browseOptions: 'Lehetőségek böngészése',
      carouselRoleDescription: 'Körhinta',
      carouselSlideLabel: '{{current}}. dia a(z) {{total}}-ból',
      carouselPrevious: 'Előző elem',
      carouselNext: 'Következő elem',
      carouselGoToItem: 'Ugrás a(z) {{index}}. elemre',
      collapse: 'Összecsukás',
      expand: 'Kibontás',
      messageHistory: 'Üzenetelőzmények',
      reduce: 'Kicsinyítés',
      today: 'Ma',
      at: '–',
      a11yOptionsCount_one: '1 lehetőség van.',
      a11yOptionsCount_other: '{{count}} lehetőség van.',
      listpickerSelectAll: 'Összes kijelölése',
      listpickerSelectOption: 'Válasszon egy lehetőséget',
      listpickerSearchAriaLabel: 'Szűrési lehetőségek keresése',
      listpickerSearchPlaceholder: 'Keresés…',
      listpickerNoResults: 'Nincs megfelelő lehetőség.',
      listpickerResults_one: '1 találat',
      listpickerResults_other: '{{count}} találat',
      listpickerCondensed_one: '1 kijelölve',
      listpickerCondensed_other: '{{count}} kijelölve',
      scrollToLatest: 'Ugrás a legújabb üzenetre',
      scrollToUnread_one: '1 új üzenet, ugrás a legújabbra',
      scrollToUnread_other: '{{count}} új üzenet, ugrás a legújabbra',
      showPassword: 'Biztonságos tartalom megjelenítése',
      hidePassword: 'Biztonságos tartalom elrejtése',
      clear: 'Törlés',
      send: 'Küldés',
      yesterday: 'Tegnap',
      chatEndedActions: 'Műveletek a csevegés befejezése után',
      openConversationDialog: 'Beszélgetési ablak megnyitása: {{title}}',
      agentTyping: 'Az ügyintéző gépel',
      agentAway: 'Ügyintézőink jelenleg nem érhetők el.',
      agentBusy: 'Ügyintézőink jelenleg elfoglaltak. Kérjük, várjon...',
      waitingForAgent: 'Összekapcsoljuk egy ügyintézővel...',
      waitingForAgentWithSkill: 'Összekapcsoljuk egy {{skill}} ügyintézővel...',
      talkingWithAgent: 'Beszélgetés vele: {{name}}',
      home: 'Kezdőlap',
      back: 'Vissza',
      menu: 'Menü',
      minimize: 'Kis méret',
      endConversation: 'Beszélgetés befejezése',
      engageWithUs: 'Lépjen kapcsolatba velünk',
      noMessagesYet: 'Még nincsenek üzenetek',
      tryAgain: 'Próbálja újra',
      gettingLocation: 'Jelenlegi földrajzi hely lekérése...',
      locationSharedMessage: 'Íme a földrajzi helyem.',
      selectFile: 'Válasszon fájlt',
      upload: 'Feltöltés',
      uploadComplete: 'Feltöltés kész',
      uploadFailed: 'A feltöltés sikertelen',
      fileTooLarge:
        'Ez a fájl túl nagy a feltöltéshez. Kérjük, válasszon {{maxSize}}-nál kisebb fájlt.',
      dragOrClick: 'Húzzon ide egy fájlt, vagy kattintson a kiválasztáshoz',
      document: 'Dokumentum',
      audioContent: 'Hangtartalom',
      videoContent: 'Videotartalom',
      videoUnsupported: 'Ez a videó nem játszható le a böngészőjében.',
      unsupportedContent: 'Nem támogatott tartalom',
      unavailable: {
        error: {
          title: 'Valami hiba történt',
          body: 'Nem sikerült betölteni a csevegést. Próbálja újra.',
          retry: 'Próbálja újra',
        },
        maintenance: {
          title: 'A csevegés átmenetileg nem érhető el',
          body: 'Ütemezett karbantartást végzünk. Térjen vissza hamarosan.',
        },
      },
      image: 'Kép',
      agentSharedImage: '{{name}} Megosztott egy képet: ',
      assistantSharedImage: '{{name}} Megosztott egy képet: ',
      starRating: 'Csillagos értékelés',
      starRatingOrder: '{{current}} / {{total}} csillag',
      submit: 'Küldés',
      closeConversationDialog: 'Beszélgetés bezárása',
      waitingForAgentDescription:
        'Kérjük, várjon, amíg összekapcsoljuk Önt egy ügynökkel',
      agentTransferred: 'Egy másik ügynökhöz irányítottuk át.',
      uploadingFile: 'Feltöltés folyamatban: {{fileName}}',
      uploadedFile: 'Feltöltötte: {{fileName}}',
      attachedFile: 'Csatolva: {{fileName}}',
      fileTypeNotPermitted: 'Sajnáljuk, ez a fájltípus nem engedélyezett.',
      relaunch: 'Újraindítás',
      screenReaderHintChrome:
        'A legjobb képernyőolvasó élmény érdekében a Google Chrome böngészőben javasoljuk a JAWS használatát.',
      screenReaderHintFirefox:
        'A legjobb képernyőolvasó élmény érdekében a Firefox böngészőben javasoljuk az NVDA használatát.',
      agentInitiatedCall: '{{name}} hívást kezdeményezett',
      clickToJoin: 'Kattintson a csatlakozáshoz',
      callSessionInProgress: 'A hívás folyamatban van',
      primaryNavigation: 'Navigáció',
      agentTypingNamed: '{{name}} ír',
      agentSaysUnnamed: 'Az ügyintéző azt mondja',
      botIsThinkingNamed: '{{name}} gondolkodik',
      talkingWithAgentUnnamed: 'Beszélgetés ügyintézővel',
      download: 'Letöltés',
      downloading: 'Letöltés folyamatban',
      downloadComplete: 'A letöltés befejeződött',
      downloadFailed: 'A letöltés sikertelen',
      attachFile: 'Fájl csatolása',
      removeAttachment: 'Melléklet eltávolítása',
      uploadFailedConnection:
        'A feltöltés sikertelen. Ellenőrizze a kapcsolatot.',
      fileTooLargeToUpload:
        'Ez a fájl túl nagy a feltöltéshez. Kérjük, válasszon {{maxSize}}-nál kisebb fájlt.',
      problemUploadingFile: 'Probléma merült fel a fájl feltöltése során.',
      attachmentRemoved: 'Melléklet eltávolítva.',
      tomorrow: 'Holnap',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Főmenü',
      goBack: 'Vissza',
      expandInSameWindow: 'Kibontás ugyanabban az ablakban',
      collapseDialog: 'Párbeszédablak összecsukása',
      closeDialog: 'Párbeszédablak bezárása',
    },
  },
  {
    lang: 'id',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Percakapan ini telah berakhir.',
      agentConnected: 'Anda telah berhasil terhubung dengan agen.',
      downloadTranscript: 'Unduh transkrip',
      startNewConversation: 'Mulai percakapan baru',
      returnToConversation: 'Kembali ke percakapan',
      connecting: 'Menghubungkan...',
      retry: 'Coba lagi',
      reconnecting: 'Menyambungkan ulang...',
      connectionLost: 'Koneksi internet terputus',
      reconnectDescription:
        'Koneksi internet terputus. Klik Sambungkan ulang untuk mencoba lagi.',
      typeMessage: 'Ketik pesan',
      inputSelect: 'Pilih opsi',
      inputSelectOrType: 'Pilih opsi atau ketik pesan',
      secureInput: 'Ketik pesan aman',
      secureValueHidden: 'Nilai aman tersembunyi',
      redactedValue: 'Informasi pribadi tersembunyi',
      startChat: 'Mulai obrolan',
      settings: 'Pengaturan',
      cancel: 'Batal',
      confirm: 'Konfirmasi',
      close: 'Tutup',
      next: 'Berikutnya',
      brandingTagline: 'Tingkatkan bisnis Anda dengan agen AI cerdas',
      poweredBy: 'Didukung oleh',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asisten sedang berpikir',
      youSaid: 'Anda berkata',
      botSays: 'Asisten berkata',
      agentSays: '{{name}} berkata',
      joinMeeting: 'Gabung rapat',
      meetingInProgress:
        'Rapat sedang berlangsung — klik untuk bergabung kembali',
      meetingExpired: 'Tautan rapat (kedaluwarsa)',
      embeddedContent: 'Konten tersemat',
      openInNewTab: 'Buka di tab baru',
      skipToMain: 'Lewati ke konten utama',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Pilih tanggal',
      selectTime: 'Pilih waktu',
      browseOptions: 'Jelajahi opsi',
      carouselRoleDescription: 'Korsel',
      carouselSlideLabel: 'Slide {{current}} dari {{total}}',
      carouselPrevious: 'Item sebelumnya',
      carouselNext: 'Item berikutnya',
      carouselGoToItem: 'Buka item {{index}}',
      collapse: 'Ciutkan',
      expand: 'Perluas',
      messageHistory: 'Riwayat pesan',
      reduce: 'Perkecil',
      today: 'Hari ini',
      at: 'pukul',
      a11yOptionsCount_other: 'Ada {{count}} opsi.',
      listpickerSelectAll: 'Pilih semua',
      listpickerSelectOption: 'Pilih opsi',
      listpickerSearchAriaLabel: 'Cari opsi filter',
      listpickerSearchPlaceholder: 'Cari…',
      listpickerNoResults: 'Tidak ada opsi yang cocok.',
      listpickerResults_other: '{{count}} hasil',
      listpickerCondensed_other: '{{count}} dipilih',
      scrollToLatest: 'Gulir ke pesan terbaru',
      scrollToUnread_other: '{{count}} pesan baru, gulir ke terbaru',
      showPassword: 'Tampilkan konten aman',
      hidePassword: 'Sembunyikan konten aman',
      clear: 'Hapus',
      send: 'Kirim',
      yesterday: 'Kemarin',
      chatEndedActions: 'Tindakan setelah obrolan berakhir',
      openConversationDialog: 'Buka dialog percakapan dengan {{title}}',
      agentTyping: 'Agen sedang mengetik',
      agentAway: 'Agen kami saat ini tidak tersedia.',
      agentBusy: 'Agen kami saat ini sibuk. Harap tunggu...',
      waitingForAgent: 'Menghubungkan Anda dengan agen...',
      waitingForAgentWithSkill: 'Menghubungkan Anda dengan agen {{skill}}...',
      talkingWithAgent: 'Berbicara dengan {{name}}',
      home: 'Beranda',
      back: 'Kembali',
      menu: 'Menu',
      minimize: 'Perkecil',
      endConversation: 'Akhiri percakapan',
      engageWithUs: 'Hubungi kami',
      noMessagesYet: 'Belum ada pesan',
      tryAgain: 'Coba lagi',
      gettingLocation: 'Mendapatkan lokasi saat ini...',
      locationSharedMessage: 'Ini lokasi saya.',
      selectFile: 'Pilih file',
      upload: 'Unggah',
      uploadComplete: 'Unggahan selesai',
      uploadFailed: 'Unggahan gagal',
      fileTooLarge:
        'File ini terlalu besar untuk diunggah. Silakan pilih file yang kurang dari {{maxSize}}.',
      dragOrClick: 'Seret file atau klik untuk memilih',
      document: 'Dokumen',
      audioContent: 'Konten audio',
      videoContent: 'Konten video',
      videoUnsupported: 'Video ini tidak dapat diputar di browser Anda.',
      unsupportedContent: 'Konten tidak didukung',
      unavailable: {
        error: {
          title: 'Terjadi kesalahan',
          body: 'Kami tidak dapat memuat obrolan. Silakan coba lagi.',
          retry: 'Coba lagi',
        },
        maintenance: {
          title: 'Obrolan sementara tidak tersedia',
          body: 'Kami sedang melakukan pemeliharaan terjadwal. Silakan kembali lagi nanti.',
        },
      },
      image: 'Gambar',
      agentSharedImage: '{{name}} membagikan gambar: ',
      assistantSharedImage: '{{name}} membagikan gambar: ',
      starRating: 'Penilaian bintang',
      starRatingOrder: 'Bintang {{current}} dari {{total}}',
      submit: 'Kirim',
      closeConversationDialog: 'Tutup percakapan',
      waitingForAgentDescription:
        'Harap tunggu sementara kami menghubungkan Anda dengan agen',
      agentTransferred: 'Anda telah dialihkan ke agen lain.',
      uploadingFile: 'Anda sedang mengunggah: {{fileName}}',
      uploadedFile: 'Anda telah mengunggah {{fileName}}',
      attachedFile: 'Terlampir: {{fileName}}',
      fileTypeNotPermitted: 'Maaf, jenis file ini tidak diizinkan.',
      relaunch: 'Mulai ulang',
      screenReaderHintChrome:
        'Untuk pengalaman pembaca layar terbaik di Google Chrome, kami menyarankan menggunakan JAWS.',
      screenReaderHintFirefox:
        'Untuk pengalaman pembaca layar terbaik di Firefox, kami menyarankan menggunakan NVDA.',
      agentInitiatedCall: '{{name}} telah memulai panggilan',
      clickToJoin: 'Klik untuk bergabung',
      callSessionInProgress: 'Sesi panggilan Anda sedang berlangsung',
      primaryNavigation: 'Navigasi',
      agentTypingNamed: '{{name}} sedang mengetik',
      agentSaysUnnamed: 'Agen berkata',
      botIsThinkingNamed: '{{name}} sedang berpikir',
      talkingWithAgentUnnamed: 'Berbicara dengan agen',
      download: 'Unduh',
      downloading: 'Mengunduh',
      downloadComplete: 'Unduhan selesai',
      downloadFailed: 'Unduhan gagal',
      attachFile: 'Lampirkan file',
      removeAttachment: 'Hapus lampiran',
      uploadFailedConnection: 'Unggahan gagal. Periksa koneksi Anda.',
      fileTooLargeToUpload:
        'File ini terlalu besar untuk diunggah. Silakan pilih file yang kurang dari {{maxSize}}.',
      problemUploadingFile: 'Terjadi masalah saat mengunggah file Anda.',
      attachmentRemoved: 'Lampiran dihapus.',
      tomorrow: 'Besok',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menu utama',
      goBack: 'Kembali',
      expandInSameWindow: 'Perluas di jendela yang sama',
      collapseDialog: 'Ciutkan Dialog',
      closeDialog: 'Tutup Dialog',
    },
  },
  {
    lang: 'is',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Þessu samtali er lokið.',
      agentConnected: 'Þú tengdist fulltrúa.',
      downloadTranscript: 'Sækja umritun',
      startNewConversation: 'Hefja nýtt samtal',
      returnToConversation: 'Til baka í samtalið',
      connecting: 'Tengist...',
      retry: 'Reyna aftur',
      reconnecting: 'Tengist aftur...',
      connectionLost: 'Internettengingin rofnaði',
      reconnectDescription:
        'Internettengingin rofnaði. Smelltu á Tengjast aftur til að reyna aftur.',
      typeMessage: 'Skrifaðu skilaboð',
      inputSelect: 'Veldu valkost',
      inputSelectOrType: 'Veldu valkost eða skrifaðu skilaboð',
      secureInput: 'Skrifaðu örugg skilaboð',
      secureValueHidden: 'Falið öruggt gildi',
      redactedValue: 'Faldar persónuupplýsingar',
      startChat: 'Hefja spjall',
      settings: 'Stillingar',
      cancel: 'Hætta við',
      confirm: 'Staðfesta',
      close: 'Loka',
      next: 'Áfram',
      brandingTagline:
        'Efldu fyrirtækið þitt með snjöllum gervigreindarfulltrúum',
      poweredBy: 'Keyrt af',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Aðstoðarmaðurinn hugsar',
      youSaid: 'Þú sagðir',
      botSays: 'Aðstoðarmaðurinn segir',
      agentSays: '{{name}} segir',
      joinMeeting: 'Taka þátt í fundi',
      meetingInProgress: 'Fundur í gangi — smelltu til að tengjast aftur',
      meetingExpired: 'Fundartengill (útrunninn)',
      embeddedContent: 'Innfellt efni',
      openInNewTab: 'Opna í nýjum flipa',
      skipToMain: 'Fara í meginefni',
      customerLogoAlt: '{{customerName}} merki',
      selectDate: 'Veldu dagsetningu',
      selectTime: 'Veldu tíma',
      browseOptions: 'Skoða valkosti',
      carouselRoleDescription: 'Skjámynd',
      carouselSlideLabel: 'Skyggna {{current}} af {{total}}',
      carouselPrevious: 'Fyrra atriði',
      carouselNext: 'Næsta atriði',
      carouselGoToItem: 'Fara í atriði {{index}}',
      collapse: 'Fella saman',
      expand: 'Fletta út',
      messageHistory: 'Skilaboðasaga',
      reduce: 'Minnka',
      today: 'Í dag',
      at: 'kl.',
      a11yOptionsCount_one: 'Það er 1 valkostur.',
      a11yOptionsCount_other: 'Það eru {{count}} valkostir.',
      listpickerSelectAll: 'Velja allt',
      listpickerSelectOption: 'Veldu valkost',
      listpickerSearchAriaLabel: 'Leita að síunarkostum',
      listpickerSearchPlaceholder: 'Leita…',
      listpickerNoResults: 'Engir samsvarandi valkostir.',
      listpickerResults_one: '1 niðurstaða',
      listpickerResults_other: '{{count}} niðurstöður',
      listpickerCondensed_one: '1 valið',
      listpickerCondensed_other: '{{count}} valin',
      scrollToLatest: 'Skruna á nýjustu skilaboðin',
      scrollToUnread_one: '1 ný skilaboð, á nýjustu',
      scrollToUnread_other: '{{count}} ný skilaboð, á nýjustu',
      showPassword: 'Sýna öruggt efni',
      hidePassword: 'Fela öruggt efni',
      clear: 'Hreinsa',
      send: 'Senda',
      yesterday: 'Í gær',
      chatEndedActions: 'Aðgerðir eftir að spjalli lýkur',
      openConversationDialog: 'Opna samtalsglugga með {{title}}',
      agentTyping: 'Fulltrúinn skrifar',
      agentAway: 'Fulltrúar okkar eru ekki tiltækir sem stendur.',
      agentBusy:
        'Fulltrúar okkar eru uppteknir sem stendur. Vinsamlegast bíddu...',
      waitingForAgent: 'Við tengjum þig við fulltrúa...',
      waitingForAgentWithSkill: 'Við tengjum þig við {{skill}} fulltrúa...',
      talkingWithAgent: 'Talar við {{name}}',
      home: 'Heim',
      back: 'Til baka',
      menu: 'Valmynd',
      minimize: 'Minnka',
      endConversation: 'Ljúka samtali',
      engageWithUs: 'Hafðu samband við okkur',
      noMessagesYet: 'Engin skilaboð enn',
      tryAgain: 'Reyna aftur',
      gettingLocation: 'Sækir núverandi staðsetningu...',
      locationSharedMessage: 'Hér er staðsetningin mín.',
      selectFile: 'Veldu skrá',
      upload: 'Hlaða upp',
      uploadComplete: 'Upphleðslu lokið',
      uploadFailed: 'Upphleðsla mistókst',
      fileTooLarge:
        'Þessi skrá er of stór til að hlaða upp. Vinsamlegast veldu skrá sem er minni en {{maxSize}}.',
      dragOrClick: 'Dragðu skrá eða smelltu til að velja',
      document: 'Skjal',
      audioContent: 'Hljóðefni',
      videoContent: 'Myndefni',
      videoUnsupported:
        'Þetta myndband er ekki unnt að spila í vafranum þínum.',
      unsupportedContent: 'Óstutt efni',
      unavailable: {
        error: {
          title: 'Eitthvað fór úrskeiðis',
          body: 'Okkur tókst ekki að hlaða spjallinu. Vinsamlegast reyndu aftur.',
          retry: 'Reyna aftur',
        },
        maintenance: {
          title: 'Spjall er tímabundið ótiltækt',
          body: 'Við erum að framkvæma áætlað viðhald. Vinsamlegast komdu aftur fljótlega.',
        },
      },
      image: 'Mynd',
      agentSharedImage: '{{name}} deildi mynd: ',
      assistantSharedImage: '{{name}} deildi mynd: ',
      starRating: 'Stjörnueinkunn',
      starRatingOrder: '{{current}} af {{total}} stjörnum',
      submit: 'Senda',
      closeConversationDialog: 'Loka samtal',
      waitingForAgentDescription:
        'Vinsamlegast bíðið á meðan við tengum ykkur við umboðsmann',
      agentTransferred: 'Þú hefur verið fluttur til annars umboðsmanns.',
      uploadingFile: 'Þú ert að hlaða upp: {{fileName}}',
      uploadedFile: 'Þú hlóðst upp {{fileName}}',
      attachedFile: 'Viðhengi: {{fileName}}',
      fileTypeNotPermitted: 'Því miður er þessi skráargerð ekki leyfð.',
      relaunch: 'Endurræsa',
      screenReaderHintChrome:
        'Fyrir bestu skjálesaraupplifun í Google Chrome mælum við með að nota JAWS.',
      screenReaderHintFirefox:
        'Fyrir bestu skjálesaraupplifun í Firefox mælum við með að nota NVDA.',
      agentInitiatedCall: '{{name}} hefur hringt',
      clickToJoin: 'Smelltu til að taka þátt',
      callSessionInProgress: 'Símtalið þitt er í gangi',
      primaryNavigation: 'Leiðsögn',
      agentTypingNamed: '{{name}} er að slá inn',
      agentSaysUnnamed: 'Fulltrúinn segir',
      botIsThinkingNamed: '{{name}} er að hugsa',
      talkingWithAgentUnnamed: 'Í samtali við fulltrúa',
      download: 'Sækja',
      downloading: 'Sæki',
      downloadComplete: 'Niðurhali lokið',
      downloadFailed: 'Niðurhal mistókst',
      attachFile: 'Hengja við skrá',
      removeAttachment: 'Fjarlægja viðhengi',
      uploadFailedConnection: 'Upphleðsla mistókst. Athugaðu tenginguna.',
      fileTooLargeToUpload:
        'Þessi skrá er of stór til að hlaða upp. Vinsamlegast veldu skrá sem er minni en {{maxSize}}.',
      problemUploadingFile: 'Vandamál kom upp við að hlaða upp skránni þinni.',
      attachmentRemoved: 'Viðhengi fjarlægt.',
      tomorrow: 'Á morgun',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Heimavalmynd',
      goBack: 'Fara til baka',
      expandInSameWindow: 'Stækka í sama glugga',
      collapseDialog: 'Fella glugga',
      closeDialog: 'Loka glugga',
    },
  },
  {
    lang: 'it',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Questa conversazione è terminata.',
      agentConnected: 'Sei stato collegato correttamente a un operatore.',
      downloadTranscript: 'Scarica la trascrizione',
      startNewConversation: 'Avvia una nuova conversazione',
      returnToConversation: 'Torna alla conversazione',
      connecting: 'Connessione in corso...',
      retry: 'Riprova',
      reconnecting: 'Riconnessione in corso...',
      connectionLost: 'La connessione a internet è stata persa',
      reconnectDescription:
        'La connessione a internet è stata persa. Clicca su Riconnetti per riprovare.',
      typeMessage: 'Scrivi un messaggio',
      inputSelect: "Seleziona un'opzione",
      inputSelectOrType: "Seleziona un'opzione o scrivi un messaggio",
      secureInput: 'Scrivi un messaggio sicuro',
      secureValueHidden: 'Valore sicuro nascosto',
      redactedValue: 'Informazioni personali nascoste',
      startChat: 'Avvia chat',
      settings: 'Impostazioni',
      cancel: 'Annulla',
      confirm: 'Conferma',
      close: 'Chiudi',
      next: 'Avanti',
      brandingTagline: 'Potenzia la tua azienda con agenti IA intelligenti',
      poweredBy: 'Con tecnologia',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: "L'assistente sta pensando",
      youSaid: 'Hai detto',
      botSays: "L'assistente dice",
      agentSays: '{{name}} dice',
      joinMeeting: 'Partecipa alla riunione',
      meetingInProgress: 'Riunione in corso — clicca per rientrare',
      meetingExpired: 'Link della riunione (scaduto)',
      embeddedContent: 'Contenuto incorporato',
      openInNewTab: 'Apri in una nuova scheda',
      skipToMain: 'Vai al contenuto principale',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Seleziona la data',
      selectTime: "Seleziona l'ora",
      browseOptions: 'Sfoglia le opzioni',
      carouselRoleDescription: 'Carosello',
      carouselSlideLabel: 'Diapositiva {{current}} di {{total}}',
      carouselPrevious: 'Elemento precedente',
      carouselNext: 'Elemento successivo',
      carouselGoToItem: "Vai all'elemento {{index}}",
      collapse: 'Comprimi',
      expand: 'Espandi',
      messageHistory: 'Cronologia dei messaggi',
      reduce: 'Riduci',
      today: 'Oggi',
      at: 'alle',
      a11yOptionsCount_one: "C'è 1 opzione.",
      a11yOptionsCount_many: 'Ci sono {{count}} opzioni.',
      a11yOptionsCount_other: 'Ci sono {{count}} opzioni.',
      listpickerSelectAll: 'Seleziona tutto',
      listpickerSelectOption: "Seleziona un'opzione",
      listpickerSearchAriaLabel: 'Cerca opzioni di filtro',
      listpickerSearchPlaceholder: 'Cerca…',
      listpickerNoResults: 'Nessuna opzione corrispondente.',
      listpickerResults_one: '1 risultato',
      listpickerResults_many: '{{count}} risultati',
      listpickerResults_other: '{{count}} risultati',
      listpickerCondensed_one: '1 selezionato',
      listpickerCondensed_many: '{{count}} selezionati',
      listpickerCondensed_other: '{{count}} selezionati',
      scrollToLatest: "Vai all'ultimo messaggio",
      scrollToUnread_one: "1 nuovo messaggio, vai all'ultimo",
      scrollToUnread_many: "{{count}} nuovi messaggi, vai all'ultimo",
      scrollToUnread_other: "{{count}} nuovi messaggi, vai all'ultimo",
      showPassword: 'Mostra contenuto sicuro',
      hidePassword: 'Nascondi contenuto sicuro',
      clear: 'Cancella',
      send: 'Invia',
      yesterday: 'Ieri',
      chatEndedActions: 'Azioni a fine chat',
      openConversationDialog: 'Apri la finestra di conversazione con {{title}}',
      agentTyping: "L'operatore sta scrivendo",
      agentAway: 'I nostri operatori non sono al momento disponibili.',
      agentBusy: 'I nostri operatori sono al momento occupati. Attendi...',
      waitingForAgent: 'Ti stiamo mettendo in contatto con un operatore...',
      waitingForAgentWithSkill:
        'Ti stiamo mettendo in contatto con un operatore {{skill}}...',
      talkingWithAgent: 'Conversazione con {{name}}',
      home: 'Home',
      back: 'Indietro',
      menu: 'Menu',
      minimize: 'Riduci a icona',
      endConversation: 'Termina conversazione',
      engageWithUs: 'Contattaci',
      noMessagesYet: 'Ancora nessun messaggio',
      tryAgain: 'Riprova',
      gettingLocation: 'Rilevamento della posizione attuale ...',
      locationSharedMessage: 'Ecco la mia posizione.',
      selectFile: 'Seleziona un file',
      upload: 'Carica',
      uploadComplete: 'Caricamento completato',
      uploadFailed: 'Caricamento fallito',
      fileTooLarge:
        'Questo file è troppo grande per essere caricato. Seleziona un file inferiore a {{maxSize}}.',
      dragOrClick: 'Trascina un file o clicca per sceglierlo',
      document: 'Documento',
      audioContent: 'Contenuto audio',
      videoContent: 'Contenuto video',
      videoUnsupported:
        'Questo video non può essere riprodotto nel tuo browser.',
      unsupportedContent: 'Contenuto non supportato',
      unavailable: {
        error: {
          title: 'Qualcosa è andato storto',
          body: 'Non è stato possibile caricare la chat. Riprova.',
          retry: 'Riprova',
        },
        maintenance: {
          title: 'La chat non è temporaneamente disponibile',
          body: 'Stiamo eseguendo una manutenzione programmata. Torna presto.',
        },
      },
      image: 'Immagine',
      agentSharedImage: "{{name}} ha condiviso un'immagine: ",
      assistantSharedImage: "{{name}} ha condiviso un'immagine: ",
      starRating: 'Valutazione a stelle',
      starRatingOrder: '{{current}} su {{total}} stelle',
      submit: 'Invia',
      closeConversationDialog: 'Chiudi conversazione',
      waitingForAgentDescription: 'Attendere mentre vi connettiamo a un agente',
      agentTransferred: 'Sei stato trasferito a un altro agente.',
      uploadingFile: 'Stai caricando: {{fileName}}',
      uploadedFile: 'Hai caricato {{fileName}}',
      attachedFile: 'Allegato: {{fileName}}',
      fileTypeNotPermitted: 'Spiacenti, questo tipo di file non è consentito.',
      relaunch: 'Riavvia',
      screenReaderHintChrome:
        'Per la migliore esperienza con il lettore di schermo in Google Chrome, suggeriamo di utilizzare JAWS.',
      screenReaderHintFirefox:
        'Per la migliore esperienza con il lettore di schermo in Firefox, suggeriamo di utilizzare NVDA.',
      agentInitiatedCall: '{{name}} ha avviato una chiamata',
      clickToJoin: 'Clicca per partecipare',
      callSessionInProgress: 'La tua sessione di chiamata è in corso',
      primaryNavigation: 'Navigazione',
      agentTypingNamed: '{{name}} sta scrivendo',
      agentSaysUnnamed: "L'operatore dice",
      botIsThinkingNamed: '{{name}} sta pensando',
      talkingWithAgentUnnamed: 'Conversazione con un operatore',
      download: 'Scarica',
      downloading: 'Download in corso',
      downloadComplete: 'Download completato',
      downloadFailed: 'Download non riuscito',
      attachFile: 'Allega file',
      removeAttachment: 'Rimuovi allegato',
      uploadFailedConnection:
        'Caricamento non riuscito. Controlla la connessione.',
      fileTooLargeToUpload:
        'Questo file è troppo grande per essere caricato. Seleziona un file inferiore a {{maxSize}}.',
      problemUploadingFile:
        'Si è verificato un problema durante il caricamento del file.',
      attachmentRemoved: 'Allegato rimosso.',
      tomorrow: 'Domani',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menu principale',
      goBack: 'Torna indietro',
      expandInSameWindow: 'Espandi nella stessa finestra',
      collapseDialog: 'Comprimi finestra di dialogo',
      closeDialog: 'Chiudi finestra di dialogo',
    },
  },
  {
    lang: 'ja',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'この会話は終了しました。',
      agentConnected: '担当者に接続されました。',
      downloadTranscript: 'トランスクリプトをダウンロード',
      startNewConversation: '新しい会話を開始',
      returnToConversation: '会話に戻る',
      connecting: '接続中...',
      retry: '再試行',
      reconnecting: '再接続中...',
      connectionLost: 'インターネット接続が切断されました',
      reconnectDescription:
        'インターネット接続が切断されました。「再接続」をクリックして再試行してください。',
      typeMessage: 'メッセージを入力',
      inputSelect: 'オプションを選択',
      inputSelectOrType: 'オプションを選択するかメッセージを入力',
      secureInput: 'セキュアなメッセージを入力',
      secureValueHidden: '非表示のセキュアな値',
      redactedValue: '非表示の個人情報',
      startChat: 'チャットを開始',
      settings: '設定',
      cancel: 'キャンセル',
      confirm: '確認',
      close: '閉じる',
      next: '次へ',
      brandingTagline: 'インテリジェントなAIエージェントでビジネスを加速',
      poweredBy: '提供',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'アシスタントが考えています',
      youSaid: 'あなたの発言',
      botSays: 'アシスタントの発言',
      agentSays: '{{name}}の発言',
      joinMeeting: '会議に参加',
      meetingInProgress: '会議が進行中です — クリックして再参加',
      meetingExpired: '会議リンク（期限切れ）',
      embeddedContent: '埋め込みコンテンツ',
      openInNewTab: '新しいタブで開く',
      skipToMain: 'メインコンテンツにスキップ',
      customerLogoAlt: '{{customerName}}のロゴ',
      selectDate: '日付を選択',
      selectTime: '時刻を選択',
      browseOptions: 'オプションを見る',
      carouselRoleDescription: 'カルーセル',
      carouselSlideLabel: 'スライド {{current}} / {{total}}',
      carouselPrevious: '前の項目',
      carouselNext: '次の項目',
      carouselGoToItem: '項目 {{index}} に移動',
      collapse: '折りたたむ',
      expand: '展開',
      messageHistory: 'メッセージ履歴',
      reduce: '縮小',
      today: '今日',
      at: '',
      a11yOptionsCount_other: '{{count}}件のオプションがあります。',
      listpickerSelectAll: 'すべて選択',
      listpickerSelectOption: 'オプションを選択',
      listpickerSearchAriaLabel: 'フィルターオプションを検索',
      listpickerSearchPlaceholder: '検索…',
      listpickerNoResults: '一致するオプションはありません。',
      listpickerResults_other: '{{count}}件の結果',
      listpickerCondensed_other: '{{count}}件選択',
      scrollToLatest: '最新のメッセージにスクロール',
      scrollToUnread_other: '新着メッセージ{{count}}件、最新へスクロール',
      showPassword: 'セキュアなコンテンツを表示',
      hidePassword: 'セキュアなコンテンツを非表示',
      clear: 'クリア',
      send: '送信',
      yesterday: '昨日',
      chatEndedActions: 'チャット終了後の操作',
      openConversationDialog: '{{title}}の会話ダイアログを開く',
      agentTyping: '担当者が入力中',
      agentAway: '現在、担当者は対応できません。',
      agentBusy: '現在、担当者は取り込み中です。少々お待ちください...',
      waitingForAgent: '担当者におつなぎしています...',
      waitingForAgentWithSkill: '{{skill}}の担当者におつなぎしています...',
      talkingWithAgent: '{{name}}と会話中',
      home: 'ホーム',
      back: '戻る',
      menu: 'メニュー',
      minimize: '最小化',
      endConversation: '会話を終了',
      engageWithUs: 'お問い合わせ',
      noMessagesYet: 'まだメッセージはありません',
      tryAgain: 'もう一度お試しください',
      gettingLocation: '現在地を取得中...',
      locationSharedMessage: 'ここが私の位置です.',
      selectFile: 'ファイルを選択',
      upload: 'アップロード',
      uploadComplete: 'アップロード完了',
      uploadFailed: 'アップロード失敗',
      fileTooLarge:
        'このファイルは大きすぎてアップロードできません。{{maxSize}}未満のファイルを選択してください。',
      dragOrClick: 'ファイルをドラッグするかクリックして選択',
      document: 'ドキュメント',
      audioContent: 'オーディオコンテンツ',
      videoContent: 'ビデオコンテンツ',
      videoUnsupported: 'この動画はお使いのブラウザでは再生できません。',
      unsupportedContent: 'サポートされていないコンテンツ',
      unavailable: {
        error: {
          title: '問題が発生しました',
          body: 'チャットを読み込めませんでした。もう一度お試しください。',
          retry: 'もう一度お試しください',
        },
        maintenance: {
          title: 'チャットは一時的に利用できません',
          body: '予定されたメンテナンスを実施しています。しばらくしてからもう一度ご確認ください。',
        },
      },
      image: '画像',
      agentSharedImage: '{{name}} が画像を共有しました： ',
      assistantSharedImage: '{{name}} が画像を共有しました：',
      starRating: '星評価',
      starRatingOrder: '{{total}}段階中{{current}}',
      submit: '送信',
      closeConversationDialog: '会話を終了',
      waitingForAgentDescription: 'エージェントに接続するまでお待ちください',
      agentTransferred: '別のエージェントに転送されました。',
      uploadingFile: 'アップロード中: {{fileName}}',
      uploadedFile: '{{fileName}} をアップロードしました',
      attachedFile: '添付: {{fileName}}',
      fileTypeNotPermitted:
        '申し訳ありませんが、このファイルタイプは許可されていません。',
      relaunch: '再起動',
      screenReaderHintChrome:
        '「Google Chrome」で最適なスクリーンリーダー体験を得るには、「JAWS」の使用をお勧めします。',
      screenReaderHintFirefox:
        'Firefox で最適なスクリーンリーダー体験を得るには、NVDA の使用をお勧めします。',
      agentInitiatedCall: '{{name}} が通話を開始しました',
      clickToJoin: 'クリックして参加',
      callSessionInProgress: '通話セッションが進行中です',
      primaryNavigation: 'ナビゲーション',
      agentTypingNamed: '{{name}} が入力中',
      agentSaysUnnamed: 'エージェントの発言',
      botIsThinkingNamed: '{{name}} が考えています',
      talkingWithAgentUnnamed: 'エージェントと会話中',
      download: 'ダウンロード',
      downloading: 'ダウンロード中',
      downloadComplete: 'ダウンロードが完了しました',
      downloadFailed: 'ダウンロードに失敗しました',
      attachFile: 'ファイルを添付',
      removeAttachment: '添付ファイルを削除',
      uploadFailedConnection:
        'アップロードに失敗しました。接続を確認してください。',
      fileTooLargeToUpload:
        'このファイルは大きすぎてアップロードできません。{{maxSize}}未満のファイルを選択してください。',
      problemUploadingFile: 'ファイルのアップロード中に問題が発生しました。',
      attachmentRemoved: '添付ファイルを削除しました。',
      tomorrow: '明日',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'ホームメニュー',
      goBack: '戻る',
      expandInSameWindow: '同じウィンドウで展開',
      collapseDialog: 'ダイアログを折りたたむ',
      closeDialog: 'ダイアログを閉じる',
    },
  },
  {
    lang: 'ko',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '이 대화가 종료되었습니다.',
      agentConnected: '상담원에게 연결되었습니다.',
      downloadTranscript: '대화 내용 다운로드',
      startNewConversation: '새 대화 시작',
      returnToConversation: '대화로 돌아가기',
      connecting: '연결 중...',
      retry: '다시 시도',
      reconnecting: '다시 연결 중...',
      connectionLost: '인터넷 연결이 끊겼습니다',
      reconnectDescription:
        '인터넷 연결이 끊겼습니다. 다시 연결을 클릭하여 다시 시도하세요.',
      typeMessage: '메시지 입력',
      inputSelect: '옵션 선택',
      inputSelectOrType: '옵션을 선택하거나 메시지를 입력하세요',
      secureInput: '보안 메시지 입력',
      secureValueHidden: '숨겨진 보안 값',
      redactedValue: '숨겨진 개인 정보',
      startChat: '채팅 시작',
      settings: '설정',
      cancel: '취소',
      confirm: '확인',
      close: '닫기',
      next: '다음',
      brandingTagline: '지능형 AI 에이전트로 비즈니스를 강화하세요',
      poweredBy: '제공',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: '어시스턴트가 생각 중입니다',
      youSaid: '내가 한 말',
      botSays: '어시스턴트가 하는 말',
      agentSays: '{{name}}님이 하는 말',
      joinMeeting: '회의 참여',
      meetingInProgress: '회의가 진행 중입니다 — 다시 참여하려면 클릭하세요',
      meetingExpired: '회의 링크(만료됨)',
      embeddedContent: '삽입된 콘텐츠',
      openInNewTab: '새 탭에서 열기',
      skipToMain: '본문으로 건너뛰기',
      customerLogoAlt: '{{customerName}} 로고',
      selectDate: '날짜 선택',
      selectTime: '시간 선택',
      browseOptions: '옵션 둘러보기',
      carouselRoleDescription: '캐러셀',
      carouselSlideLabel: '슬라이드 {{total}}개 중 {{current}}번째',
      carouselPrevious: '이전 항목',
      carouselNext: '다음 항목',
      carouselGoToItem: '{{index}}번 항목으로 이동',
      collapse: '접기',
      expand: '펼치기',
      messageHistory: '메시지 기록',
      reduce: '축소',
      today: '오늘',
      at: '',
      a11yOptionsCount_other: '옵션이 {{count}}개 있습니다.',
      listpickerSelectAll: '모두 선택',
      listpickerSelectOption: '옵션 선택',
      listpickerSearchAriaLabel: '필터 옵션 검색',
      listpickerSearchPlaceholder: '검색…',
      listpickerNoResults: '일치하는 옵션이 없습니다.',
      listpickerResults_other: '결과 {{count}}개',
      listpickerCondensed_other: '{{count}}개 선택됨',
      scrollToLatest: '최신 메시지로 스크롤',
      scrollToUnread_other: '새 메시지 {{count}}개, 최신으로 스크롤',
      showPassword: '보안 콘텐츠 표시',
      hidePassword: '보안 콘텐츠 숨기기',
      clear: '지우기',
      send: '보내기',
      yesterday: '어제',
      chatEndedActions: '채팅 종료 후 작업',
      openConversationDialog: '{{title}} 대화 창 열기',
      agentTyping: '상담원이 입력 중',
      agentAway: '현재 상담원이 대응할 수 없습니다.',
      agentBusy: '현재 상담원이 응대 중입니다. 잠시만 기다려 주세요...',
      waitingForAgent: '상담원에게 연결하고 있습니다...',
      waitingForAgentWithSkill: '{{skill}} 상담원에게 연결하고 있습니다...',
      talkingWithAgent: '{{name}}님과 대화 중',
      home: '홈',
      back: '뒤로',
      menu: '메뉴',
      minimize: '최소화',
      endConversation: '대화 종료',
      engageWithUs: '문의하기',
      noMessagesYet: '아직 메시지가 없습니다',
      tryAgain: '다시 시도',
      gettingLocation: '현재 위치 가져오는 중...',
      locationSharedMessage: '여기가 내 위치입니다',
      selectFile: '파일 선택',
      upload: '업로드',
      uploadComplete: '업로드 완료',
      uploadFailed: '업로드 실패',
      fileTooLarge:
        '이 파일은 업로드하기에 너무 큽니다. {{maxSize}} 미만의 파일을 선택해 주세요.',
      dragOrClick: '파일을 끌어다 놓거나 클릭하여 선택하세요',
      document: '문서',
      audioContent: '오디오 콘텐츠',
      videoContent: '동영상 콘텐츠',
      videoUnsupported:
        '이 동영상은 사용 중인 브라우저에서 재생할 수 없습니다.',
      unsupportedContent: '지원되지 않는 콘텐츠',
      unavailable: {
        error: {
          title: '문제가 발생했습니다',
          body: '채팅을 로드할 수 없습니다. 다시 시도하세요.',
          retry: '다시 시도',
        },
        maintenance: {
          title: '채팅을 일시적으로 사용할 수 없습니다',
          body: '예정된 유지관리를 진행하고 있습니다. 잠시 후 다시 확인해 주세요.',
        },
      },
      image: '이미지',
      agentSharedImage: '{{name}}님이 이미지를 공유했습니다: ',
      assistantSharedImage: '{{name}}님이 이미지를 공유했습니다: ',
      starRating: '별점',
      starRatingOrder: '{{total}}개 중 {{current}}번째 별',
      submit: '제출',
      closeConversationDialog: '대화 종료',
      waitingForAgentDescription: '상담원에게 연결하는 동안 잠시 기다려 주세요',
      agentTransferred: '다른 상담원에게 전달되었습니다.',
      uploadingFile: '업로드 중: {{fileName}}',
      uploadedFile: '{{fileName}}을(를) 업로드했습니다',
      attachedFile: '첨부됨: {{fileName}}',
      fileTypeNotPermitted: '죄송합니다. 이 파일 유형은 허용되지 않습니다.',
      relaunch: '다시 시작',
      screenReaderHintChrome:
        'Google Chrome에서 최상의 스크린 리더 경험을 위해 JAWS 사용을 권장합니다.',
      screenReaderHintFirefox:
        'Firefox에서 최상의 스크린 리더 경험을 위해 NVDA 사용을 권장합니다.',
      agentInitiatedCall: '{{name}}님이 통화를 시작했습니다',
      clickToJoin: '클릭하여 참여',
      callSessionInProgress: '통화 세션이 진행 중입니다',
      primaryNavigation: '내비게이션',
      agentTypingNamed: '{{name}} 이(가) 입력 중입니다',
      agentSaysUnnamed: '상담원의 말',
      botIsThinkingNamed: '{{name}}이(가) 생각 중입니다',
      talkingWithAgentUnnamed: '상담원과 대화 중',
      download: '다운로드',
      downloading: '다운로드 중',
      downloadComplete: '다운로드 완료',
      downloadFailed: '다운로드 실패',
      attachFile: '파일 첨부',
      removeAttachment: '첨부 파일 제거',
      uploadFailedConnection: '업로드에 실패했습니다. 연결을 확인하세요.',
      fileTooLargeToUpload:
        '이 파일은 업로드하기에 너무 큽니다. {{maxSize}} 미만의 파일을 선택해 주세요.',
      problemUploadingFile: '파일 업로드 중 문제가 발생했습니다.',
      attachmentRemoved: '첨부 파일이 제거되었습니다.',
      tomorrow: '내일',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: '홈 메뉴',
      goBack: '뒤로 가기',
      expandInSameWindow: '같은 창에서 확장',
      collapseDialog: '대화 상자 축소',
      closeDialog: '대화 상자 닫기',
    },
  },
  {
    lang: 'lt',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Šis pokalbis baigtas.',
      agentConnected: 'Sėkmingai prisijungėte prie operatoriaus.',
      downloadTranscript: 'Atsisiųsti nuorašą',
      startNewConversation: 'Pradėti naują pokalbį',
      returnToConversation: 'Grįžti į pokalbį',
      connecting: 'Jungiamasi...',
      retry: 'Bandyti dar kartą',
      reconnecting: 'Jungiamasi iš naujo...',
      connectionLost: 'Interneto ryšys nutrūko',
      reconnectDescription:
        'Interneto ryšys nutrūko. Spustelėkite „Prisijungti iš naujo“, kad bandytumėte dar kartą.',
      typeMessage: 'Įveskite žinutę',
      inputSelect: 'Pasirinkite parinktį',
      inputSelectOrType: 'Pasirinkite parinktį arba įveskite žinutę',
      secureInput: 'Įveskite saugią žinutę',
      secureValueHidden: 'Paslėpta saugi reikšmė',
      redactedValue: 'Paslėpti asmens duomenys',
      startChat: 'Pradėti pokalbį',
      settings: 'Nustatymai',
      cancel: 'Atšaukti',
      confirm: 'Patvirtinti',
      close: 'Uždaryti',
      next: 'Toliau',
      brandingTagline: 'Sustiprinkite savo verslą su išmaniaisiais DI agentais',
      poweredBy: 'Sukurta su',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistentas mąsto',
      youSaid: 'Jūs pasakėte',
      botSays: 'Asistentas sako',
      agentSays: '{{name}} sako',
      joinMeeting: 'Prisijungti prie susitikimo',
      meetingInProgress:
        'Susitikimas vyksta — spustelėkite, kad prisijungtumėte iš naujo',
      meetingExpired: 'Susitikimo nuoroda (nebegalioja)',
      embeddedContent: 'Įterptas turinys',
      openInNewTab: 'Atidaryti naujame skirtuke',
      skipToMain: 'Pereiti prie pagrindinio turinio',
      customerLogoAlt: '{{customerName}} logotipas',
      selectDate: 'Pasirinkite datą',
      selectTime: 'Pasirinkite laiką',
      browseOptions: 'Naršyti parinktis',
      carouselRoleDescription: 'Karuselė',
      carouselSlideLabel: '{{current}} skaidrė iš {{total}}',
      carouselPrevious: 'Ankstesnis elementas',
      carouselNext: 'Kitas elementas',
      carouselGoToItem: 'Eiti į elementą {{index}}',
      collapse: 'Sutraukti',
      expand: 'Išskleisti',
      messageHistory: 'Žinučių istorija',
      reduce: 'Sumažinti',
      today: 'Šiandien',
      at: '',
      a11yOptionsCount_one: 'Yra 1 parinktis.',
      a11yOptionsCount_few: 'Yra {{count}} parinktys.',
      a11yOptionsCount_many: 'Yra {{count}} parinkties.',
      a11yOptionsCount_other: 'Yra {{count}} parinkčių.',
      listpickerSelectAll: 'Pasirinkti viską',
      listpickerSelectOption: 'Pasirinkite parinktį',
      listpickerSearchAriaLabel: 'Ieškoti filtravimo parinkčių',
      listpickerSearchPlaceholder: 'Ieškoti…',
      listpickerNoResults: 'Nėra atitinkančių parinkčių.',
      listpickerResults_one: '1 rezultatas',
      listpickerResults_few: '{{count}} rezultatai',
      listpickerResults_many: '{{count}} rezultato',
      listpickerResults_other: '{{count}} rezultatų',
      listpickerCondensed_one: 'Pasirinkta 1',
      listpickerCondensed_few: 'Pasirinkta {{count}}',
      listpickerCondensed_many: 'Pasirinkta {{count}}',
      listpickerCondensed_other: 'Pasirinkta {{count}}',
      scrollToLatest: 'Slinkti į naujausią žinutę',
      scrollToUnread_one: '1 nauja žinutė, eiti į naujausią',
      scrollToUnread_few: '{{count}} naujos žinutės, eiti į naujausią',
      scrollToUnread_many: '{{count}} naujos žinutės, eiti į naujausią',
      scrollToUnread_other: '{{count}} naujų žinučių, eiti į naujausią',
      showPassword: 'Rodyti saugų turinį',
      hidePassword: 'Slėpti saugų turinį',
      clear: 'Išvalyti',
      send: 'Siųsti',
      yesterday: 'Vakar',
      chatEndedActions: 'Veiksmai pasibaigus pokalbiui',
      openConversationDialog: 'Atidaryti pokalbio langą su {{title}}',
      agentTyping: 'Operatorius rašo',
      agentAway: 'Mūsų operatoriai šiuo metu nepasiekiami.',
      agentBusy: 'Mūsų operatoriai šiuo metu užimti. Palaukite...',
      waitingForAgent: 'Jungiame jus su operatoriumi...',
      waitingForAgentWithSkill: 'Jungiame jus su {{skill}} operatoriumi...',
      talkingWithAgent: 'Kalbatės su {{name}}',
      home: 'Pradžia',
      back: 'Atgal',
      menu: 'Meniu',
      minimize: 'Sumažinti',
      endConversation: 'Baigti pokalbį',
      engageWithUs: 'Susisiekite su mumis',
      noMessagesYet: 'Kol kas žinučių nėra',
      tryAgain: 'Bandyti dar kartą',
      gettingLocation: 'Gaunama dabartinė vieta...',
      locationSharedMessage: 'Čia yra mano vieta.',
      selectFile: 'Pasirinkite failą',
      upload: 'Įkelti',
      uploadComplete: 'Įkėlimas baigtas',
      uploadFailed: 'Įkėlimas nepavyko',
      fileTooLarge:
        'Šis failas per didelis įkelti. Prašome pasirinkti failą, mažesnį nei {{maxSize}}.',
      dragOrClick: 'Vilkite failą arba spustelėkite norėdami pasirinkti',
      document: 'Dokumentas',
      audioContent: 'Garso turinys',
      videoContent: 'Vaizdo turinys',
      videoUnsupported: 'Šio vaizdo įrašo negalima atkurti jūsų naršyklėje.',
      unsupportedContent: 'Nepalaikomas turinys',
      unavailable: {
        error: {
          title: 'Kažkas nepavyko',
          body: 'Nepavyko įkelti pokalbio. Bandykite dar kartą.',
          retry: 'Bandyti dar kartą',
        },
        maintenance: {
          title: 'Pokalbis laikinai nepasiekiamas',
          body: 'Atliekame suplanuotą priežiūrą. Grįžkite netrukus.',
        },
      },
      image: 'Vaizdas',
      agentSharedImage: '{{name}} pasidalijo vaizdu: ',
      assistantSharedImage: '{{name}} pasidalijo vaizdu: ',
      starRating: 'Žvaigždučių įvertinimas',
      starRatingOrder: '{{current}} iš {{total}} žvaigždžių',
      submit: 'Pateikti',
      closeConversationDialog: 'Uždaryti pokalbį',
      waitingForAgentDescription: 'Palaukite, kol sujungsime jus su agentu',
      agentTransferred: 'Jūs buvote perkeltas į kitą agentą.',
      uploadingFile: 'Įkeliate: {{fileName}}',
      uploadedFile: 'Įkėlėte {{fileName}}',
      attachedFile: 'Pridėta: {{fileName}}',
      fileTypeNotPermitted: 'Atsiprašome, šio tipo failai neleidžiami.',
      relaunch: 'Paleisti iš naujo',
      screenReaderHintChrome:
        'Geriausiai ekrano skaitytuvo patirčiai Google Chrome naršyklėje rekomenduojame naudoti JAWS.',
      screenReaderHintFirefox:
        'Geriausiai ekrano skaitytuvo patirčiai Firefox naršyklėje rekomenduojame naudoti NVDA.',
      agentInitiatedCall: '{{name}} inicijavo skambutį',
      clickToJoin: 'Spustelėkite kad prisijungtumėte',
      callSessionInProgress: 'Jūsų skambučio sesija vyksta',
      primaryNavigation: 'Naršymas',
      agentTypingNamed: '{{name}} rašo',
      agentSaysUnnamed: 'Agentas sako',
      botIsThinkingNamed: '{{name}} mąsto',
      talkingWithAgentUnnamed: 'Kalbatės su agentu',
      download: 'Atsisiųsti',
      downloading: 'Atsisiunčiama',
      downloadComplete: 'Atsisiuntimas baigtas',
      downloadFailed: 'Nepavyko atsisiųsti',
      attachFile: 'Pridėti failą',
      removeAttachment: 'Pašalinti priedą',
      uploadFailedConnection: 'Nepavyko įkelti. Patikrinkite ryšį.',
      fileTooLargeToUpload:
        'Šis failas per didelis įkelti. Prašome pasirinkti failą, mažesnį nei {{maxSize}}.',
      problemUploadingFile: 'Įkeliant jūsų failą įvyko klaida.',
      attachmentRemoved: 'Priedas pašalintas.',
      tomorrow: 'Rytoj',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Pagrindinis meniu',
      goBack: 'Grįžti',
      expandInSameWindow: 'Išplėsti tame pačiame lange',
      collapseDialog: 'Sutraukti dialogą',
      closeDialog: 'Uždaryti dialogą',
    },
  },
  {
    lang: 'lv',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Šī saruna ir beigusies.',
      agentConnected: 'Jūs esat veiksmīgi savienots ar aģentu.',
      downloadTranscript: 'Lejupielādēt sarakstu',
      startNewConversation: 'Sākt jaunu sarunu',
      returnToConversation: 'Atgriezties pie sarunas',
      connecting: 'Notiek savienošana...',
      retry: 'Mēģināt vēlreiz',
      reconnecting: 'Notiek atkārtota savienošana...',
      connectionLost: 'Interneta savienojums ir zaudēts',
      reconnectDescription:
        'Interneta savienojums ir zaudēts. Noklikšķiniet uz “Savienoties atkārtoti”, lai mēģinātu vēlreiz.',
      typeMessage: 'Ierakstiet ziņojumu',
      inputSelect: 'Atlasiet opciju',
      inputSelectOrType: 'Atlasiet opciju vai ierakstiet ziņojumu',
      secureInput: 'Ierakstiet drošu ziņojumu',
      secureValueHidden: 'Slēpta droša vērtība',
      redactedValue: 'Slēpta personas informācija',
      startChat: 'Sākt tērzēšanu',
      settings: 'Iestatījumi',
      cancel: 'Atcelt',
      confirm: 'Apstiprināt',
      close: 'Aizvērt',
      next: 'Tālāk',
      brandingTagline: 'Stipriniet savu uzņēmumu ar viediem MI aģentiem',
      poweredBy: 'Nodrošina',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistents domā',
      youSaid: 'Jūs teicāt',
      botSays: 'Asistents saka',
      agentSays: '{{name}} saka',
      joinMeeting: 'Pievienoties sapulcei',
      meetingInProgress:
        'Sapulce norit — noklikšķiniet, lai pievienotos atkārtoti',
      meetingExpired: 'Sapulces saite (beigusies)',
      embeddedContent: 'Iegults saturs',
      openInNewTab: 'Atvērt jaunā cilnē',
      skipToMain: 'Pāriet uz galveno saturu',
      customerLogoAlt: '{{customerName}} logotips',
      selectDate: 'Atlasiet datumu',
      selectTime: 'Atlasiet laiku',
      browseOptions: 'Pārlūkot opcijas',
      carouselRoleDescription: 'Karuselis',
      carouselSlideLabel: 'Slaids {{current}} no {{total}}',
      carouselPrevious: 'Iepriekšējais vienums',
      carouselNext: 'Nākamais vienums',
      carouselGoToItem: 'Pāriet uz vienumu {{index}}',
      collapse: 'Sakļaut',
      expand: 'Izvērst',
      messageHistory: 'Ziņojumu vēsture',
      reduce: 'Samazināt',
      today: 'Šodien',
      at: 'plkst.',
      a11yOptionsCount_zero: 'Nav opciju.',
      a11yOptionsCount_one: 'Ir {{count}} opcija.',
      a11yOptionsCount_other: 'Ir {{count}} opcijas.',
      listpickerSelectAll: 'Atlasīt visu',
      listpickerSelectOption: 'Atlasiet opciju',
      listpickerSearchAriaLabel: 'Meklēt filtra opcijas',
      listpickerSearchPlaceholder: 'Meklēt…',
      listpickerNoResults: 'Nav atbilstošu opciju.',
      listpickerResults_zero: '{{count}} rezultātu',
      listpickerResults_one: '{{count}} rezultāts',
      listpickerResults_other: '{{count}} rezultāti',
      listpickerCondensed_zero: 'Atlasīti {{count}}',
      listpickerCondensed_one: 'Atlasīts {{count}}',
      listpickerCondensed_other: 'Atlasīti {{count}}',
      scrollToLatest: 'Ritināt uz jaunāko ziņojumu',
      scrollToUnread_zero: '{{count}} jaunu ziņojumu, uz jaunāko',
      scrollToUnread_one: '{{count}} jauns ziņojums, uz jaunāko',
      scrollToUnread_other: '{{count}} jauni ziņojumi, uz jaunāko',
      showPassword: 'Rādīt drošu saturu',
      hidePassword: 'Slēpt drošu saturu',
      clear: 'Notīrīt',
      send: 'Sūtīt',
      yesterday: 'Vakar',
      chatEndedActions: 'Darbības pēc tērzēšanas beigām',
      openConversationDialog: 'Atvērt sarunas logu ar {{title}}',
      agentTyping: 'Aģents raksta',
      agentAway: 'Mūsu aģenti pašlaik nav pieejami.',
      agentBusy: 'Mūsu aģenti pašlaik ir aizņemti. Lūdzu, uzgaidiet...',
      waitingForAgent: 'Savienojam jūs ar aģentu...',
      waitingForAgentWithSkill: 'Savienojam jūs ar {{skill}} aģentu...',
      talkingWithAgent: 'Saruna ar {{name}}',
      home: 'Sākums',
      back: 'Atpakaļ',
      menu: 'Izvēlne',
      minimize: 'Minimizēt',
      endConversation: 'Beigt sarunu',
      engageWithUs: 'Sazinieties ar mums',
      noMessagesYet: 'Vēl nav ziņojumu',
      tryAgain: 'Mēģināt vēlreiz',
      gettingLocation: 'Notiek pašreizējās atrašanās vietas iegūšana...',
      locationSharedMessage: 'Šeit ir mana atrašanās vieta.',
      selectFile: 'Atlasiet failu',
      upload: 'Augšupielādēt',
      uploadComplete: 'Augšupielāde pabeigta',
      uploadFailed: 'Augšupielāde neizdevās',
      fileTooLarge:
        'Šis fails ir pārāk liels, lai to augšupielādētu. Lūdzu, izvēlieties failu, kas ir mazāks par {{maxSize}}.',
      dragOrClick: 'Velciet failu vai noklikšķiniet, lai izvēlētos',
      document: 'Dokuments',
      audioContent: 'Audio saturs',
      videoContent: 'Video saturs',
      videoUnsupported: 'Šo video nevar atskaņot jūsu pārlūkprogrammā.',
      unsupportedContent: 'Neatbalstīts saturs',
      unavailable: {
        error: {
          title: 'Radās kļūda',
          body: 'Neizdevās ielādēt tērzēšanu. Lūdzu, mēģiniet vēlreiz.',
          retry: 'Mēģināt vēlreiz',
        },
        maintenance: {
          title: 'Tērzēšana īslaicīgi nav pieejama',
          body: 'Mēs veicam plānotu apkopi. Lūdzu, atgriezieties drīz.',
        },
      },
      image: 'Attēls',
      agentSharedImage: '{{name}} kopīgoja attēlu: ',
      assistantSharedImage: '{{name}} kopīgoja attēlu: ',
      starRating: 'Zvaigžņu vērtējums',
      starRatingOrder: '{{current}}. no {{total}} zvaigznēm',
      submit: 'Iesniegt',
      closeConversationDialog: 'Aizvērt sarunu',
      waitingForAgentDescription:
        'Lūdzu, uzgaidiet, kamēr mēs jūs savienosim ar aģentu',
      agentTransferred: 'Jūs esat pārcelts uz citu aģentu.',
      uploadingFile: 'Jūs augšupielādējat: {{fileName}}',
      uploadedFile: 'Jūs augšupielādējāt {{fileName}}',
      attachedFile: 'Pievienots: {{fileName}}',
      fileTypeNotPermitted: 'Atvainojiet, šis faila veids nav atļauts.',
      relaunch: 'Atkārtoti palaist',
      screenReaderHintChrome:
        'Lai iegūtu labāko ekrānlasītāja pieredzi Google Chrome, iesakām izmantot JAWS.',
      screenReaderHintFirefox:
        'Lai iegūtu labāko ekrānlasītāja pieredzi Firefox, iesakām izmantot NVDA.',
      agentInitiatedCall: '{{name}} ir uzsācis zvanu',
      clickToJoin: 'Noklikšķiniet lai pievienotos',
      callSessionInProgress: 'Jūsu zvana sesija ir procesā',
      primaryNavigation: 'Navigācija',
      agentTypingNamed: '{{name}} raksta',
      agentSaysUnnamed: 'Aģents saka',
      botIsThinkingNamed: '{{name}} domā',
      talkingWithAgentUnnamed: 'Saruna ar aģentu',
      download: 'Lejupielādēt',
      downloading: 'Notiek lejupielāde',
      downloadComplete: 'Lejupielāde pabeigta',
      downloadFailed: 'Lejupielāde neizdevās',
      attachFile: 'Pievienot failu',
      removeAttachment: 'Noņemt pielikumu',
      uploadFailedConnection: 'Augšupielāde neizdevās. Pārbaudiet savienojumu.',
      fileTooLargeToUpload:
        'Šis fails ir pārāk liels, lai to augšupielādētu. Lūdzu, izvēlieties failu, kas ir mazāks par {{maxSize}}.',
      problemUploadingFile: 'Radās problēma augšupielādējot jūsu failu.',
      attachmentRemoved: 'Pielikums noņemts.',
      tomorrow: 'Rīt',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Sākuma izvēlne',
      goBack: 'Atpakaļ',
      expandInSameWindow: 'Izvērst tajā pašā logā',
      collapseDialog: 'Sakļaut dialoglodziņu',
      closeDialog: 'Aizvērt dialoglodziņu',
    },
  },
  {
    lang: 'mk',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Овој разговор заврши.',
      agentConnected: 'Успешно сте поврзани со агент.',
      downloadTranscript: 'Преземи транскрипт',
      startNewConversation: 'Започни нов разговор',
      returnToConversation: 'Назад кон разговорот',
      connecting: 'Поврзување...',
      retry: 'Обиди се повторно',
      reconnecting: 'Повторно поврзување...',
      connectionLost: 'Врската со интернет е изгубена',
      reconnectDescription:
        'Врската со интернет е изгубена. Кликнете на „Поврзи се повторно“ за да се обидете повторно.',
      typeMessage: 'Напишете порака',
      inputSelect: 'Изберете опција',
      inputSelectOrType: 'Изберете опција или напишете порака',
      secureInput: 'Напишете безбедна порака',
      secureValueHidden: 'Скриена безбедна вредност',
      redactedValue: 'Скриени лични податоци',
      startChat: 'Започни разговор',
      settings: 'Поставки',
      cancel: 'Откажи',
      confirm: 'Потврди',
      close: 'Затвори',
      next: 'Следно',
      brandingTagline:
        'Зајакнете го вашиот бизнис со интелигентни агенти со ВИ',
      poweredBy: 'Овозможено од',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Асистентот размислува',
      youSaid: 'Рековте',
      botSays: 'Асистентот вели',
      agentSays: '{{name}} вели',
      joinMeeting: 'Приклучи се на состанокот',
      meetingInProgress:
        'Состанокот е во тек — кликнете за повторно приклучување',
      meetingExpired: 'Врска до состанок (истечена)',
      embeddedContent: 'Вградена содржина',
      openInNewTab: 'Отвори во ново јазиче',
      skipToMain: 'Прескокни до главната содржина',
      customerLogoAlt: 'Лого на {{customerName}}',
      selectDate: 'Изберете датум',
      selectTime: 'Изберете време',
      browseOptions: 'Прегледај опции',
      carouselRoleDescription: 'Ротатор',
      carouselSlideLabel: 'Слајд {{current}} од {{total}}',
      carouselPrevious: 'Претходна ставка',
      carouselNext: 'Следна ставка',
      carouselGoToItem: 'Оди на ставка {{index}}',
      collapse: 'Собери',
      expand: 'Прошири',
      messageHistory: 'Историја на пораки',
      reduce: 'Намали',
      today: 'Денес',
      at: 'во',
      a11yOptionsCount_one: 'Има 1 опција.',
      a11yOptionsCount_other: 'Има {{count}} опции.',
      listpickerSelectAll: 'Избери сè',
      listpickerSelectOption: 'Изберете опција',
      listpickerSearchAriaLabel: 'Пребарај опции за филтрирање',
      listpickerSearchPlaceholder: 'Пребарај…',
      listpickerNoResults: 'Нема совпаѓачки опции.',
      listpickerResults_one: '1 резултат',
      listpickerResults_other: '{{count}} резултати',
      listpickerCondensed_one: '1 избрана',
      listpickerCondensed_other: '{{count}} избрани',
      scrollToLatest: 'Кон најновата порака',
      scrollToUnread_one: '1 нова порака, кон најновата',
      scrollToUnread_other: '{{count}} нови пораки, кон најновата',
      showPassword: 'Прикажи безбедна содржина',
      hidePassword: 'Скриј безбедна содржина',
      clear: 'Исчисти',
      send: 'Испрати',
      yesterday: 'Вчера',
      chatEndedActions: 'Дејства по завршување на разговорот',
      openConversationDialog: 'Отвори прозорец за разговор со {{title}}',
      agentTyping: 'Агентот пишува',
      agentAway: 'Нашите агенти во моментов не се достапни.',
      agentBusy:
        'Нашите агенти во моментов се зафатени. Ве молиме почекајте...',
      waitingForAgent: 'Ве поврзуваме со агент...',
      waitingForAgentWithSkill: 'Ве поврзуваме со агент за {{skill}}...',
      talkingWithAgent: 'Разговор со {{name}}',
      home: 'Почетна',
      back: 'Назад',
      menu: 'Мени',
      minimize: 'Минимизирај',
      endConversation: 'Заврши разговор',
      engageWithUs: 'Контактирајте нè',
      noMessagesYet: 'Сè уште нема пораки',
      tryAgain: 'Обиди се повторно',
      gettingLocation: 'Се добива моменталната локација...',
      locationSharedMessage: 'Еве ја мојата локација.',
      selectFile: 'Изберете датотека',
      upload: 'Прикачи',
      uploadComplete: 'Прикачувањето заврши',
      uploadFailed: 'Качувањето не успеа',
      fileTooLarge:
        'Оваа датотека е премногу голема за качување. Ве молиме изберете датотека помала од {{maxSize}}.',
      dragOrClick: 'Влечете датотека или кликнете за избор',
      document: 'Документ',
      audioContent: 'Аудио содржина',
      videoContent: 'Видео содржина',
      videoUnsupported:
        'Ова видео не може да се репродуцира во вашиот прелистувач.',
      unsupportedContent: 'Неподдржана содржина',
      unavailable: {
        error: {
          title: 'Нешто тргна наопаку',
          body: 'Не можевме да го вчитаме разговорот. Обидете се повторно.',
          retry: 'Обиди се повторно',
        },
        maintenance: {
          title: 'Разговорот е привремено недостапен',
          body: 'Спроведуваме планирано одржување. Вратете се наскоро.',
        },
      },
      image: 'Слика',
      agentSharedImage: '{{name}} сподели слика: ',
      assistantSharedImage: '{{name}} сподели слика: ',
      starRating: 'Оценување со ѕвезди',
      starRatingOrder: '{{current}} од {{total}} ѕвезди',
      submit: 'Испрати',
      closeConversationDialog: 'Затвори разговор',
      waitingForAgentDescription:
        'Ве молиме почекајте додека ве поврзуваме со агент',
      agentTransferred: 'Вие сте префрлени на друг агент.',
      uploadingFile: 'Качувате: {{fileName}}',
      uploadedFile: 'Качивте {{fileName}}',
      attachedFile: 'Прикачено: {{fileName}}',
      fileTypeNotPermitted: 'Жал ни е, овој тип на датотека не е дозволен.',
      relaunch: 'Рестартирајте',
      screenReaderHintChrome:
        'За најдобро искуство со читач на екран во Google Chrome, предлагаме да користите JAWS.',
      screenReaderHintFirefox:
        'За најдобро искуство со читач на екран во Firefox, предлагаме да користите NVDA.',
      agentInitiatedCall: '{{name}} започна повик',
      clickToJoin: 'Кликнете за да се приклучите',
      callSessionInProgress: 'Вашата сесија на повик е во тек',
      primaryNavigation: 'Навигација',
      agentTypingNamed: '{{name}} пишува',
      agentSaysUnnamed: 'Агентот вели',
      botIsThinkingNamed: '{{name}} размислува',
      talkingWithAgentUnnamed: 'Разговор со агент',
      download: 'Преземи',
      downloading: 'Се презема',
      downloadComplete: 'Преземањето заврши',
      downloadFailed: 'Преземањето не успеа',
      attachFile: 'Прикачи датотека',
      removeAttachment: 'Отстрани го прилогот',
      uploadFailedConnection: 'Прикачувањето не успеа. Проверете ја врската.',
      fileTooLargeToUpload:
        'Оваа датотека е премногу голема за качување. Ве молиме изберете датотека помала од {{maxSize}}.',
      problemUploadingFile:
        'Се појави проблем при качувањето на вашата датотека.',
      attachmentRemoved: 'Прилогот е отстранет.',
      tomorrow: 'Утре',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Почетно мени',
      goBack: 'Назад',
      expandInSameWindow: 'Прошири во истиот прозорец',
      collapseDialog: 'Собери дијалог',
      closeDialog: 'Затвори дијалог',
    },
  },
  {
    lang: 'ms',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Perbualan ini telah tamat.',
      agentConnected: 'Anda telah berjaya disambungkan kepada ejen.',
      downloadTranscript: 'Muat turun transkrip',
      startNewConversation: 'Mulakan perbualan baharu',
      returnToConversation: 'Kembali ke perbualan',
      connecting: 'Menyambung...',
      retry: 'Cuba lagi',
      reconnecting: 'Menyambung semula...',
      connectionLost: 'Sambungan internet terputus',
      reconnectDescription:
        'Sambungan internet terputus. Klik Sambung semula untuk mencuba lagi.',
      typeMessage: 'Taip mesej',
      inputSelect: 'Pilih pilihan',
      inputSelectOrType: 'Pilih pilihan atau taip mesej',
      secureInput: 'Taip mesej selamat',
      secureValueHidden: 'Nilai selamat tersembunyi',
      redactedValue: 'Maklumat peribadi tersembunyi',
      startChat: 'Mulakan sembang',
      settings: 'Tetapan',
      cancel: 'Batal',
      confirm: 'Sahkan',
      close: 'Tutup',
      next: 'Seterusnya',
      brandingTagline: 'Perkasakan perniagaan anda dengan ejen AI pintar',
      poweredBy: 'Dikuasakan oleh',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Pembantu sedang berfikir',
      youSaid: 'Anda berkata',
      botSays: 'Pembantu berkata',
      agentSays: '{{name}} berkata',
      joinMeeting: 'Sertai mesyuarat',
      meetingInProgress:
        'Mesyuarat sedang berlangsung — klik untuk menyertai semula',
      meetingExpired: 'Pautan mesyuarat (tamat tempoh)',
      embeddedContent: 'Kandungan terbenam',
      openInNewTab: 'Buka dalam tab baharu',
      skipToMain: 'Langkau ke kandungan utama',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Pilih tarikh',
      selectTime: 'Pilih masa',
      browseOptions: 'Semak imbas pilihan',
      carouselRoleDescription: 'Karusel',
      carouselSlideLabel: 'Slaid {{current}} daripada {{total}}',
      carouselPrevious: 'Item sebelumnya',
      carouselNext: 'Item seterusnya',
      carouselGoToItem: 'Pergi ke item {{index}}',
      collapse: 'Runtuhkan',
      expand: 'Kembangkan',
      messageHistory: 'Sejarah mesej',
      reduce: 'Kecilkan',
      today: 'Hari ini',
      at: 'pada',
      a11yOptionsCount_other: 'Terdapat {{count}} pilihan.',
      listpickerSelectAll: 'Pilih semua',
      listpickerSelectOption: 'Pilih pilihan',
      listpickerSearchAriaLabel: 'Cari pilihan penapis',
      listpickerSearchPlaceholder: 'Cari…',
      listpickerNoResults: 'Tiada pilihan yang sepadan.',
      listpickerResults_other: '{{count}} hasil',
      listpickerCondensed_other: '{{count}} dipilih',
      scrollToLatest: 'Tatal ke mesej terkini',
      scrollToUnread_other: '{{count}} mesej baharu, tatal ke terkini',
      showPassword: 'Tunjukkan kandungan selamat',
      hidePassword: 'Sembunyikan kandungan selamat',
      clear: 'Kosongkan',
      send: 'Hantar',
      yesterday: 'Semalam',
      chatEndedActions: 'Tindakan selepas sembang tamat',
      openConversationDialog: 'Buka dialog perbualan dengan {{title}}',
      agentTyping: 'Ejen sedang menaip',
      agentAway: 'Ejen kami tidak tersedia buat masa ini.',
      agentBusy: 'Ejen kami sibuk buat masa ini. Sila tunggu...',
      waitingForAgent: 'Menyambungkan anda kepada ejen...',
      waitingForAgentWithSkill: 'Menyambungkan anda kepada ejen {{skill}}...',
      talkingWithAgent: 'Bercakap dengan {{name}}',
      home: 'Laman utama',
      back: 'Kembali',
      menu: 'Menu',
      minimize: 'Minimumkan',
      endConversation: 'Tamatkan perbualan',
      engageWithUs: 'Hubungi kami',
      noMessagesYet: 'Belum ada mesej',
      tryAgain: 'Cuba lagi',
      gettingLocation: 'Mendapatkan lokasi semasa...',
      locationSharedMessage: 'Ini lokasi saya',
      selectFile: 'Pilih fail',
      upload: 'Muat naik',
      uploadComplete: 'Muat naik selesai',
      uploadFailed: 'Muat naik gagal',
      fileTooLarge:
        'Fail ini terlalu besar untuk dimuat naik. Sila pilih fail yang kurang daripada {{maxSize}}.',
      dragOrClick: 'Seret fail atau klik untuk memilih',
      document: 'Dokumen',
      audioContent: 'Kandungan audio',
      videoContent: 'Kandungan video',
      videoUnsupported: 'Video ini tidak dapat dimainkan dalam pelayar anda.',
      unsupportedContent: 'Kandungan tidak disokong',
      unavailable: {
        error: {
          title: 'Sesuatu tidak kena',
          body: 'Kami tidak dapat memuatkan sembang. Sila cuba lagi.',
          retry: 'Cuba lagi',
        },
        maintenance: {
          title: 'Sembang tidak tersedia buat sementara waktu',
          body: 'Kami sedang menjalankan penyelenggaraan berjadual. Sila kembali sebentar lagi.',
        },
      },
      image: 'Imej',
      agentSharedImage: '{{name}} berkongsi imej: ',
      assistantSharedImage: '{{name}} berkongsi imej: ',
      starRating: 'Penilaian bintang',
      starRatingOrder: 'Bintang {{current}} daripada {{total}}',
      submit: 'Hantar',
      closeConversationDialog: 'Tutup perbualan',
      waitingForAgentDescription:
        'Sila tunggu sementara kami menghubungkan anda dengan ejen',
      agentTransferred: 'Anda telah dipindahkan kepada ejen lain.',
      uploadingFile: 'Anda sedang memuat naik: {{fileName}}',
      uploadedFile: 'Anda telah memuat naik {{fileName}}',
      attachedFile: 'Dilampirkan: {{fileName}}',
      fileTypeNotPermitted: 'Maaf, jenis fail ini tidak dibenarkan.',
      relaunch: 'Lancarkan semula',
      screenReaderHintChrome:
        'Untuk pengalaman pembaca skrin terbaik dalam Google Chrome, kami mencadangkan penggunaan JAWS.',
      screenReaderHintFirefox:
        'Untuk pengalaman pembaca skrin terbaik dalam Firefox, kami mencadangkan penggunaan NVDA.',
      agentInitiatedCall: '{{name}} telah memulakan panggilan',
      clickToJoin: 'Klik untuk menyertai',
      callSessionInProgress: 'Sesi panggilan anda sedang berlangsung',
      primaryNavigation: 'Navigasi',
      agentTypingNamed: '{{name}} sedang menaip',
      agentSaysUnnamed: 'Ejen berkata',
      botIsThinkingNamed: '{{name}} sedang berfikir',
      talkingWithAgentUnnamed: 'Bercakap dengan ejen',
      download: 'Muat turun',
      downloading: 'Sedang memuat turun',
      downloadComplete: 'Muat turun selesai',
      downloadFailed: 'Muat turun gagal',
      attachFile: 'Lampirkan fail',
      removeAttachment: 'Alih keluar lampiran',
      uploadFailedConnection: 'Muat naik gagal. Semak sambungan anda.',
      fileTooLargeToUpload:
        'Fail ini terlalu besar untuk dimuat naik. Sila pilih fail yang kurang daripada {{maxSize}}.',
      problemUploadingFile: 'Terdapat masalah semasa memuat naik fail anda.',
      attachmentRemoved: 'Lampiran dialih keluar.',
      tomorrow: 'Esok',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menu utama',
      goBack: 'Kembali',
      expandInSameWindow: 'Kembangkan dalam tetingkap yang sama',
      collapseDialog: 'Runtuhkan Dialog',
      closeDialog: 'Tutup Dialog',
    },
  },
  {
    lang: 'nl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Dit gesprek is beëindigd.',
      agentConnected: 'Je bent verbonden met een medewerker.',
      downloadTranscript: 'Transcript downloaden',
      startNewConversation: 'Nieuw gesprek starten',
      returnToConversation: 'Terug naar het gesprek',
      connecting: 'Verbinden...',
      retry: 'Opnieuw proberen',
      reconnecting: 'Opnieuw verbinden...',
      connectionLost: 'De internetverbinding is verbroken',
      reconnectDescription:
        'De internetverbinding is verbroken. Klik op Opnieuw verbinden om het opnieuw te proberen.',
      typeMessage: 'Typ een bericht',
      inputSelect: 'Selecteer een optie',
      inputSelectOrType: 'Selecteer een optie of typ een bericht',
      secureInput: 'Typ een beveiligd bericht',
      secureValueHidden: 'Verborgen beveiligde waarde',
      redactedValue: 'Verborgen persoonsgegevens',
      startChat: 'Chat starten',
      settings: 'Instellingen',
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
      close: 'Sluiten',
      next: 'Volgende',
      brandingTagline: 'Geef je bedrijf een boost met intelligente AI-agents',
      poweredBy: 'Mogelijk gemaakt door',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'De assistent denkt na',
      youSaid: 'Je zei',
      botSays: 'De assistent zegt',
      agentSays: '{{name}} zegt',
      joinMeeting: 'Deelnemen aan vergadering',
      meetingInProgress: 'Vergadering bezig — klik om opnieuw deel te nemen',
      meetingExpired: 'Vergaderlink (verlopen)',
      embeddedContent: 'Ingesloten inhoud',
      openInNewTab: 'Openen in nieuw tabblad',
      skipToMain: 'Ga naar hoofdinhoud',
      customerLogoAlt: 'Logo van {{customerName}}',
      selectDate: 'Datum selecteren',
      selectTime: 'Tijd selecteren',
      browseOptions: 'Opties bekijken',
      carouselRoleDescription: 'Carrousel',
      carouselSlideLabel: 'Dia {{current}} van {{total}}',
      carouselPrevious: 'Vorig item',
      carouselNext: 'Volgend item',
      carouselGoToItem: 'Ga naar item {{index}}',
      collapse: 'Samenvouwen',
      expand: 'Uitvouwen',
      messageHistory: 'Berichtgeschiedenis',
      reduce: 'Verkleinen',
      today: 'Vandaag',
      at: 'om',
      a11yOptionsCount_one: 'Er is 1 optie.',
      a11yOptionsCount_other: 'Er zijn {{count}} opties.',
      listpickerSelectAll: 'Alles selecteren',
      listpickerSelectOption: 'Selecteer een optie',
      listpickerSearchAriaLabel: 'Zoeken naar filteropties',
      listpickerSearchPlaceholder: 'Zoeken…',
      listpickerNoResults: 'Geen overeenkomende opties.',
      listpickerResults_one: '1 resultaat',
      listpickerResults_other: '{{count}} resultaten',
      listpickerCondensed_one: '1 geselecteerd',
      listpickerCondensed_other: '{{count}} geselecteerd',
      scrollToLatest: 'Naar het nieuwste bericht scrollen',
      scrollToUnread_one: '1 nieuw bericht, naar het nieuwste',
      scrollToUnread_other: '{{count}} nieuwe berichten, naar het nieuwste',
      showPassword: 'Beveiligde inhoud tonen',
      hidePassword: 'Beveiligde inhoud verbergen',
      clear: 'Wissen',
      send: 'Verzenden',
      yesterday: 'Gisteren',
      chatEndedActions: 'Acties na afloop van de chat',
      openConversationDialog: 'Gespreksvenster openen met {{title}}',
      agentTyping: 'De medewerker typt',
      agentAway: 'Onze medewerkers zijn momenteel niet beschikbaar.',
      agentBusy: 'Onze medewerkers zijn momenteel bezet. Even geduld...',
      waitingForAgent: 'Je wordt verbonden met een medewerker...',
      waitingForAgentWithSkill:
        'Je wordt verbonden met een medewerker voor {{skill}}...',
      talkingWithAgent: 'In gesprek met {{name}}',
      home: 'Home',
      back: 'Terug',
      menu: 'Menu',
      minimize: 'Minimaliseren',
      endConversation: 'Gesprek beëindigen',
      engageWithUs: 'Neem contact met ons op',
      noMessagesYet: 'Nog geen berichten',
      tryAgain: 'Opnieuw proberen',
      gettingLocation: 'Huidige locatie ophalen...',
      locationSharedMessage: 'Hier is mijn locatie.',
      selectFile: 'Selecteer een bestand',
      upload: 'Uploaden',
      uploadComplete: 'Upload voltooid',
      uploadFailed: 'Upload mislukt',
      fileTooLarge:
        'Dit bestand is te groot om te uploaden. Selecteer een bestand kleiner dan {{maxSize}}.',
      dragOrClick: 'Sleep een bestand of klik om te kiezen',
      document: 'Document',
      audioContent: 'Audio-inhoud',
      videoContent: 'Video-inhoud',
      videoUnsupported: 'Deze video kan niet in uw browser worden weergegeven.',
      unsupportedContent: 'Niet-ondersteunde inhoud',
      unavailable: {
        error: {
          title: 'Er is iets misgegaan',
          body: 'We konden de chat niet laden. Probeer het opnieuw.',
          retry: 'Opnieuw proberen',
        },
        maintenance: {
          title: 'Chat is tijdelijk niet beschikbaar',
          body: 'We voeren gepland onderhoud uit. Kom binnenkort terug.',
        },
      },
      image: 'Afbeelding',
      agentSharedImage: '{{name}} heeft een afbeelding gedeeld: ',
      assistantSharedImage: '{{name}} heeft een afbeelding gedeeld: ',
      starRating: 'Sterrenbeoordeling',
      starRatingOrder: '{{current}} van {{total}} sterren',
      submit: 'Verzenden',
      closeConversationDialog: 'Gesprek beëindigen',
      waitingForAgentDescription:
        'Even geduld terwijl we u verbinden met een agent',
      agentTransferred: 'U bent overgeplaatst naar een andere agent.',
      uploadingFile: 'U uploadt: {{fileName}}',
      uploadedFile: 'U heeft {{fileName}} geüpload',
      attachedFile: 'Bijgevoegd: {{fileName}}',
      fileTypeNotPermitted: 'Sorry, dit bestandstype is niet toegestaan.',
      relaunch: 'Opnieuw starten',
      screenReaderHintChrome:
        'Voor de beste schermlezerervaring in Google Chrome raden we aan om JAWS te gebruiken.',
      screenReaderHintFirefox:
        'Voor de beste schermlezerervaring in Firefox raden we aan om NVDA te gebruiken.',
      agentInitiatedCall: '{{name}} heeft een gesprek gestart',
      clickToJoin: 'Klik om deel te nemen',
      callSessionInProgress: 'Uw gespreksessie is bezig',
      primaryNavigation: 'Navigatie',
      agentTypingNamed: '{{name}} typt',
      agentSaysUnnamed: 'De medewerker zegt',
      botIsThinkingNamed: '{{name}} denkt na',
      talkingWithAgentUnnamed: 'In gesprek met een medewerker',
      download: 'Downloaden',
      downloading: 'Bezig met downloaden',
      downloadComplete: 'Download voltooid',
      downloadFailed: 'Download mislukt',
      attachFile: 'Bestand bijvoegen',
      removeAttachment: 'Bijlage verwijderen',
      uploadFailedConnection: 'Uploaden mislukt. Controleer uw verbinding.',
      fileTooLargeToUpload:
        'Dit bestand is te groot om te uploaden. Selecteer een bestand kleiner dan {{maxSize}}.',
      problemUploadingFile:
        'Er is een probleem opgetreden bij het uploaden van uw bestand.',
      attachmentRemoved: 'Bijlage verwijderd.',
      tomorrow: 'Morgen',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Startmenu',
      goBack: 'Terug',
      expandInSameWindow: 'Uitvouwen in hetzelfde venster',
      collapseDialog: 'Dialoogvenster samenvouwen',
      closeDialog: 'Dialoogvenster sluiten',
    },
  },
  {
    lang: 'no',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Denne samtalen er avsluttet.',
      agentConnected: 'Du er koblet til en kundebehandler.',
      downloadTranscript: 'Last ned utskrift',
      startNewConversation: 'Start ny samtale',
      returnToConversation: 'Tilbake til samtalen',
      connecting: 'Kobler til...',
      retry: 'Prøv igjen',
      reconnecting: 'Kobler til på nytt...',
      connectionLost: 'Internettforbindelsen er brutt',
      reconnectDescription:
        'Internettforbindelsen er brutt. Klikk på Koble til på nytt for å prøve igjen.',
      typeMessage: 'Skriv en melding',
      inputSelect: 'Velg et alternativ',
      inputSelectOrType: 'Velg et alternativ eller skriv en melding',
      secureInput: 'Skriv en sikker melding',
      secureValueHidden: 'Skjult sikker verdi',
      redactedValue: 'Skjulte personopplysninger',
      startChat: 'Start chat',
      settings: 'Innstillinger',
      cancel: 'Avbryt',
      confirm: 'Bekreft',
      close: 'Lukk',
      next: 'Neste',
      brandingTagline:
        'Gi virksomheten din et løft med intelligente AI-agenter',
      poweredBy: 'Drevet av',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Assistenten tenker',
      youSaid: 'Du sa',
      botSays: 'Assistenten sier',
      agentSays: '{{name}} sier',
      joinMeeting: 'Bli med i møte',
      meetingInProgress: 'Møte pågår — klikk for å bli med igjen',
      meetingExpired: 'Møtelenke (utløpt)',
      embeddedContent: 'Innebygd innhold',
      openInNewTab: 'Åpne i ny fane',
      skipToMain: 'Hopp til hovedinnhold',
      customerLogoAlt: '{{customerName}}-logo',
      selectDate: 'Velg dato',
      selectTime: 'Velg tidspunkt',
      browseOptions: 'Bla gjennom alternativer',
      carouselRoleDescription: 'Karusell',
      carouselSlideLabel: 'Lysbilde {{current}} av {{total}}',
      carouselPrevious: 'Forrige element',
      carouselNext: 'Neste element',
      carouselGoToItem: 'Gå til element {{index}}',
      collapse: 'Skjul',
      expand: 'Utvid',
      messageHistory: 'Meldingshistorikk',
      reduce: 'Forminsk',
      today: 'I dag',
      at: 'kl.',
      a11yOptionsCount_one: 'Det er 1 alternativ.',
      a11yOptionsCount_other: 'Det er {{count}} alternativer.',
      listpickerSelectAll: 'Velg alle',
      listpickerSelectOption: 'Velg et alternativ',
      listpickerSearchAriaLabel: 'Søk etter filteralternativer',
      listpickerSearchPlaceholder: 'Søk…',
      listpickerNoResults: 'Ingen samsvarende alternativer.',
      listpickerResults_one: '1 resultat',
      listpickerResults_other: '{{count}} resultater',
      listpickerCondensed_one: '1 valgt',
      listpickerCondensed_other: '{{count}} valgt',
      scrollToLatest: 'Bla til den nyeste meldingen',
      scrollToUnread_one: '1 ny melding, gå til nyeste',
      scrollToUnread_other: '{{count}} nye meldinger, gå til nyeste',
      showPassword: 'Vis sikkert innhold',
      hidePassword: 'Skjul sikkert innhold',
      clear: 'Tøm',
      send: 'Send',
      yesterday: 'I går',
      chatEndedActions: 'Handlinger etter avsluttet chat',
      openConversationDialog: 'Åpne samtalevindu med {{title}}',
      agentTyping: 'Kundebehandleren skriver',
      agentAway: 'Kundebehandlerne våre er utilgjengelige for øyeblikket.',
      agentBusy:
        'Kundebehandlerne våre er opptatt for øyeblikket. Vennligst vent...',
      waitingForAgent: 'Du kobles til en kundebehandler...',
      waitingForAgentWithSkill:
        'Du kobles til en kundebehandler for {{skill}}...',
      talkingWithAgent: 'Snakker med {{name}}',
      home: 'Hjem',
      back: 'Tilbake',
      menu: 'Meny',
      minimize: 'Minimer',
      endConversation: 'Avslutt samtalen',
      engageWithUs: 'Kontakt oss',
      noMessagesYet: 'Ingen meldinger ennå',
      tryAgain: 'Prøv igjen',
      gettingLocation: 'Henter nåværende posisjon ...',
      locationSharedMessage: 'Her er min plassering',
      selectFile: 'Velg en fil',
      upload: 'Last opp',
      uploadComplete: 'Opplasting fullført',
      uploadFailed: 'Opplasting mislyktes',
      fileTooLarge:
        'Denne filen er for stor til å laste opp. Vennligst velg en fil mindre enn {{maxSize}}.',
      dragOrClick: 'Dra en fil eller klikk for å velge',
      document: 'Dokument',
      audioContent: 'Lydinnhold',
      videoContent: 'Videoinnhold',
      videoUnsupported: 'Denne videoen kan ikke spilles av i nettleseren din.',
      unsupportedContent: 'Innhold som ikke støttes',
      unavailable: {
        error: {
          title: 'Noe gikk galt',
          body: 'Vi kunne ikke laste inn chatten. Prøv igjen.',
          retry: 'Prøv igjen',
        },
        maintenance: {
          title: 'Chatten er midlertidig utilgjengelig',
          body: 'Vi utfører planlagt vedlikehold. Kom tilbake snart.',
        },
      },
      image: 'Bilde',
      agentSharedImage: '{{name}} delte et bilde:',
      assistantSharedImage: '{{name}} delte et bilde:',
      starRating: 'Stjernevurdering',
      starRatingOrder: '{{current}} av {{total}} stjerner',
      submit: 'Send inn',
      closeConversationDialog: 'Avslutt samtale',
      waitingForAgentDescription:
        'Vennligst vent mens vi kobler deg til en agent',
      agentTransferred: 'Du har blitt overført til en annen agent.',
      uploadingFile: 'Du laster opp: {{fileName}}',
      uploadedFile: 'Du lastet opp {{fileName}}',
      attachedFile: 'Vedlagt: {{fileName}}',
      fileTypeNotPermitted: 'Beklager, denne filtypen er ikke tillatt.',
      relaunch: 'Start på nytt',
      screenReaderHintChrome:
        'For den beste skjermleseropplevelsen i Google Chrome anbefaler vi å bruke JAWS.',
      screenReaderHintFirefox:
        'For den beste skjermleseropplevelsen i Firefox anbefaler vi å bruke NVDA.',
      agentInitiatedCall: '{{name}} har initiert et anrop',
      clickToJoin: 'Klikk for å delta',
      callSessionInProgress: 'Anropsøkten din pågår',
      primaryNavigation: 'Navigasjon',
      agentTypingNamed: '{{name}} skriver',
      agentSaysUnnamed: 'Agenten sier',
      botIsThinkingNamed: '{{name}} tenker',
      talkingWithAgentUnnamed: 'Snakker med en agent',
      download: 'Last ned',
      downloading: 'Laster ned',
      downloadComplete: 'Nedlasting fullført',
      downloadFailed: 'Nedlastingen mislyktes',
      attachFile: 'Legg ved fil',
      removeAttachment: 'Fjern vedlegg',
      uploadFailedConnection: 'Opplastingen mislyktes. Sjekk tilkoblingen.',
      fileTooLargeToUpload:
        'Denne filen er for stor til å laste opp. Vennligst velg en fil mindre enn {{maxSize}}.',
      problemUploadingFile:
        'Det oppstod et problem med opplastingen av filen din.',
      attachmentRemoved: 'Vedlegg fjernet.',
      tomorrow: 'I morgen',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Hjemmemeny',
      goBack: 'Gå tilbake',
      expandInSameWindow: 'Utvid i samme vindu',
      collapseDialog: 'Skjul dialog',
      closeDialog: 'Lukk dialog',
    },
  },
  {
    lang: 'pl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ta rozmowa została zakończona.',
      agentConnected: 'Zostałeś połączony z konsultantem.',
      downloadTranscript: 'Pobierz transkrypcję',
      startNewConversation: 'Rozpocznij nową rozmowę',
      returnToConversation: 'Wróć do rozmowy',
      connecting: 'Łączenie...',
      retry: 'Ponów',
      reconnecting: 'Ponowne łączenie...',
      connectionLost: 'Utracono połączenie z internetem',
      reconnectDescription:
        'Utracono połączenie z internetem. Kliknij „Połącz ponownie”, aby spróbować jeszcze raz.',
      typeMessage: 'Wpisz wiadomość',
      inputSelect: 'Wybierz opcję',
      inputSelectOrType: 'Wybierz opcję lub wpisz wiadomość',
      secureInput: 'Wpisz bezpieczną wiadomość',
      secureValueHidden: 'Ukryta bezpieczna wartość',
      redactedValue: 'Ukryte dane osobowe',
      startChat: 'Rozpocznij czat',
      settings: 'Ustawienia',
      cancel: 'Anuluj',
      confirm: 'Potwierdź',
      close: 'Zamknij',
      next: 'Dalej',
      brandingTagline: 'Wzmocnij swoją firmę dzięki inteligentnym agentom AI',
      poweredBy: 'Obsługiwane przez',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asystent myśli',
      youSaid: 'Powiedziałeś',
      botSays: 'Asystent mówi',
      agentSays: '{{name}} mówi',
      joinMeeting: 'Dołącz do spotkania',
      meetingInProgress: 'Spotkanie w toku — kliknij, aby dołączyć ponownie',
      meetingExpired: 'Link do spotkania (wygasł)',
      embeddedContent: 'Osadzona treść',
      openInNewTab: 'Otwórz w nowej karcie',
      skipToMain: 'Przejdź do treści głównej',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Wybierz datę',
      selectTime: 'Wybierz godzinę',
      browseOptions: 'Przeglądaj opcje',
      carouselRoleDescription: 'Karuzela',
      carouselSlideLabel: 'Slajd {{current}} z {{total}}',
      carouselPrevious: 'Poprzedni element',
      carouselNext: 'Następny element',
      carouselGoToItem: 'Przejdź do elementu {{index}}',
      collapse: 'Zwiń',
      expand: 'Rozwiń',
      messageHistory: 'Historia wiadomości',
      reduce: 'Zmniejsz',
      today: 'Dzisiaj',
      at: 'o',
      a11yOptionsCount_one: 'Jest 1 opcja.',
      a11yOptionsCount_few: 'Są {{count}} opcje.',
      a11yOptionsCount_many: 'Jest {{count}} opcji.',
      a11yOptionsCount_other: 'Jest {{count}} opcji.',
      listpickerSelectAll: 'Zaznacz wszystko',
      listpickerSelectOption: 'Wybierz opcję',
      listpickerSearchAriaLabel: 'Szukaj opcji filtrowania',
      listpickerSearchPlaceholder: 'Szukaj…',
      listpickerNoResults: 'Brak pasujących opcji.',
      listpickerResults_one: '1 wynik',
      listpickerResults_few: '{{count}} wyniki',
      listpickerResults_many: '{{count}} wyników',
      listpickerResults_other: '{{count}} wyniku',
      listpickerCondensed_one: 'Wybrano 1',
      listpickerCondensed_few: 'Wybrano {{count}}',
      listpickerCondensed_many: 'Wybrano {{count}}',
      listpickerCondensed_other: 'Wybrano {{count}}',
      scrollToLatest: 'Przewiń do najnowszej wiadomości',
      scrollToUnread_one: '1 nowa wiadomość, przejdź do najnowszej',
      scrollToUnread_few: '{{count}} nowe wiadomości, przejdź do najnowszej',
      scrollToUnread_many: '{{count}} nowych wiadomości, przejdź do najnowszej',
      scrollToUnread_other:
        '{{count}} nowych wiadomości, przejdź do najnowszej',
      showPassword: 'Pokaż bezpieczną treść',
      hidePassword: 'Ukryj bezpieczną treść',
      clear: 'Wyczyść',
      send: 'Wyślij',
      yesterday: 'Wczoraj',
      chatEndedActions: 'Działania po zakończeniu czatu',
      openConversationDialog: 'Otwórz okno rozmowy z {{title}}',
      agentTyping: 'Konsultant pisze',
      agentAway: 'Nasi konsultanci są obecnie niedostępni.',
      agentBusy: 'Nasi konsultanci są obecnie zajęci. Prosimy o cierpliwość...',
      waitingForAgent: 'Łączymy Cię z konsultantem...',
      waitingForAgentWithSkill: 'Łączymy Cię z konsultantem ds. {{skill}}...',
      talkingWithAgent: 'Rozmowa z {{name}}',
      home: 'Strona główna',
      back: 'Wstecz',
      menu: 'Menu',
      minimize: 'Minimalizuj',
      endConversation: 'Zakończ rozmowę',
      engageWithUs: 'Skontaktuj się z nami',
      noMessagesYet: 'Brak wiadomości',
      tryAgain: 'Spróbuj ponownie',
      gettingLocation: 'Pobieranie bieżącej lokalizacji...',
      locationSharedMessage: 'Oto moja lokalizacja.',
      selectFile: 'Wybierz plik',
      upload: 'Prześlij',
      uploadComplete: 'Przesyłanie zakończone',
      uploadFailed: 'Przesyłanie nie powiodło się',
      fileTooLarge:
        'Ten plik jest za duży, aby go przesłać. Wybierz plik mniejszy niż {{maxSize}}.',
      dragOrClick: 'Przeciągnij plik lub kliknij, aby wybrać',
      document: 'Dokument',
      audioContent: 'Treść audio',
      videoContent: 'Treść wideo',
      videoUnsupported: 'Tego filmu nie można odtworzyć w Twojej przeglądarce.',
      unsupportedContent: 'Nieobsługiwana treść',
      unavailable: {
        error: {
          title: 'Coś poszło nie tak',
          body: 'Nie udało się wczytać czatu. Spróbuj ponownie.',
          retry: 'Spróbuj ponownie',
        },
        maintenance: {
          title: 'Czat jest tymczasowo niedostępny',
          body: 'Przeprowadzamy zaplanowaną konserwację. Wróć wkrótce.',
        },
      },
      image: 'Obraz',
      agentSharedImage: '{{name}} udostępnił obraz: ',
      assistantSharedImage: '{{name}} udostępnił obraz: ',
      starRating: 'Ocena gwiazdkowa',
      starRatingOrder: '{{current}} z {{total}} gwiazdek',
      submit: 'Wyślij',
      closeConversationDialog: 'Zamknij rozmowę',
      waitingForAgentDescription: 'Proszę czekać, łączymy Cię z agentem',
      agentTransferred: 'Zostałeś przeniesiony do innego agenta.',
      uploadingFile: 'Przesyłasz: {{fileName}}',
      uploadedFile: 'Przesłałeś {{fileName}}',
      attachedFile: 'Przyłączony: {{fileName}}',
      fileTypeNotPermitted: 'Przepraszamy, ten typ pliku jest niedozwolony.',
      relaunch: 'ponowne uruchomienie',
      screenReaderHintChrome:
        'Aby uzyskać najlepsze doświadczenie czytnika ekranu w przeglądarce Google Chrome, sugerujemy korzystanie z JAWS.',
      screenReaderHintFirefox:
        'Aby uzyskać najlepsze doświadczenie czytnika ekranu w przeglądarce Firefox, sugerujemy korzystanie z NVDA.',
      agentInitiatedCall: '{{name}} zainicjował(-a) połączenie',
      clickToJoin: 'Kliknij aby dołączyć',
      callSessionInProgress: 'Twoja sesja połączenia jest w toku',
      primaryNavigation: 'Nawigacja',
      agentTypingNamed: '{{name}} pisze',
      agentSaysUnnamed: 'Agent mówi',
      botIsThinkingNamed: '{{name}} myśli',
      talkingWithAgentUnnamed: 'Rozmowa z agentem',
      download: 'Pobierz',
      downloading: 'Pobieranie',
      downloadComplete: 'Pobieranie zakończone',
      downloadFailed: 'Pobieranie nie powiodło się',
      attachFile: 'Załącz plik',
      removeAttachment: 'Usuń załącznik',
      uploadFailedConnection:
        'Przesyłanie nie powiodło się. Sprawdź połączenie.',
      fileTooLargeToUpload:
        'Ten plik jest za duży, aby go przesłać. Wybierz plik mniejszy niż {{maxSize}}.',
      problemUploadingFile: 'Wystąpił problem podczas przesyłania pliku.',
      attachmentRemoved: 'Załącznik usunięty.',
      tomorrow: 'Jutro',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menu główne',
      goBack: 'Wracać',
      expandInSameWindow: 'Rozwiń w tym samym oknie',
      collapseDialog: 'Zwiń okno dialogowe',
      closeDialog: 'Zamknij okno dialogowe ',
    },
  },
  {
    lang: 'pt',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Esta conversa foi encerrada.',
      agentConnected: 'Você foi conectado com sucesso a um atendente.',
      downloadTranscript: 'Baixar transcrição',
      startNewConversation: 'Iniciar nova conversa',
      returnToConversation: 'Voltar à conversa',
      connecting: 'Conectando...',
      retry: 'Tentar novamente',
      reconnecting: 'Reconectando...',
      connectionLost: 'A conexão com a internet foi perdida',
      reconnectDescription:
        'A conexão com a internet foi perdida. Clique em Reconectar para tentar novamente.',
      typeMessage: 'Digite uma mensagem',
      inputSelect: 'Selecione uma opção',
      inputSelectOrType: 'Selecione uma opção ou digite uma mensagem',
      secureInput: 'Digite uma mensagem segura',
      secureValueHidden: 'Valor seguro oculto',
      redactedValue: 'Informações pessoais ocultas',
      startChat: 'Iniciar chat',
      settings: 'Configurações',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      close: 'Fechar',
      next: 'Avançar',
      brandingTagline:
        'Impulsione o seu negócio com agentes de IA inteligentes',
      poweredBy: 'Desenvolvido por',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'O assistente está pensando',
      youSaid: 'Você disse',
      botSays: 'O assistente diz',
      agentSays: '{{name}} diz',
      joinMeeting: 'Entrar na reunião',
      meetingInProgress: 'Reunião em andamento — clique para voltar a entrar',
      meetingExpired: 'Link da reunião (expirado)',
      embeddedContent: 'Conteúdo incorporado',
      openInNewTab: 'Abrir em uma nova aba',
      skipToMain: 'Ir para o conteúdo principal',
      customerLogoAlt: 'Logotipo de {{customerName}}',
      selectDate: 'Selecionar data',
      selectTime: 'Selecionar horário',
      browseOptions: 'Explorar opções',
      carouselRoleDescription: 'Carrossel',
      carouselSlideLabel: 'Slide {{current}} de {{total}}',
      carouselPrevious: 'Item anterior',
      carouselNext: 'Próximo item',
      carouselGoToItem: 'Ir para o item {{index}}',
      collapse: 'Recolher',
      expand: 'Expandir',
      messageHistory: 'Histórico de mensagens',
      reduce: 'Reduzir',
      today: 'Hoje',
      at: 'às',
      a11yOptionsCount_one: 'Há 1 opção.',
      a11yOptionsCount_many: 'Há {{count}} opções.',
      a11yOptionsCount_other: 'Há {{count}} opções.',
      listpickerSelectAll: 'Selecionar tudo',
      listpickerSelectOption: 'Selecione uma opção',
      listpickerSearchAriaLabel: 'Pesquisar opções de filtro',
      listpickerSearchPlaceholder: 'Pesquisar…',
      listpickerNoResults: 'Nenhuma opção corresponde.',
      listpickerResults_one: '1 resultado',
      listpickerResults_many: '{{count}} resultados',
      listpickerResults_other: '{{count}} resultados',
      listpickerCondensed_one: '1 selecionado',
      listpickerCondensed_many: '{{count}} selecionados',
      listpickerCondensed_other: '{{count}} selecionados',
      scrollToLatest: 'Rolar até a mensagem mais recente',
      scrollToUnread_one: '1 nova mensagem, ir para a mais recente',
      scrollToUnread_many: '{{count}} novas mensagens, ir para a mais recente',
      scrollToUnread_other: '{{count}} novas mensagens, ir para a mais recente',
      showPassword: 'Mostrar conteúdo seguro',
      hidePassword: 'Ocultar conteúdo seguro',
      clear: 'Limpar',
      send: 'Enviar',
      yesterday: 'Ontem',
      chatEndedActions: 'Ações de fim de chat',
      openConversationDialog:
        'Abrir a caixa de diálogo da conversa com {{title}}',
      agentTyping: 'O atendente está digitando',
      agentAway: 'Nossos atendentes não estão disponíveis no momento.',
      agentBusy:
        'Nossos atendentes estão ocupados no momento. Por favor, aguarde...',
      waitingForAgent: 'Conectando você a um atendente...',
      waitingForAgentWithSkill:
        'Conectando você a um atendente de {{skill}}...',
      talkingWithAgent: 'Conversando com {{name}}',
      home: 'Início',
      back: 'Voltar',
      menu: 'Menu',
      minimize: 'Minimizar',
      endConversation: 'Encerrar conversa',
      engageWithUs: 'Fale conosco',
      noMessagesYet: 'Ainda não há mensagens',
      tryAgain: 'Tentar novamente',
      gettingLocation: 'Obtendo localização atual...',
      locationSharedMessage: 'Aqui está minha localização',
      selectFile: 'Selecionar um arquivo',
      upload: 'Enviar',
      uploadComplete: 'Envio concluído',
      uploadFailed: 'Falha no carregamento',
      fileTooLarge:
        'Este arquivo é muito grande para fazer upload. Por favor, selecione um arquivo menor que {{maxSize}}.',
      dragOrClick: 'Arraste um arquivo ou clique para escolher',
      document: 'Documento',
      audioContent: 'Conteúdo de áudio',
      videoContent: 'Conteúdo de vídeo',
      videoUnsupported:
        'Não é possível reproduzir este vídeo no seu navegador.',
      unsupportedContent: 'Conteúdo não suportado',
      unavailable: {
        error: {
          title: 'Algo deu errado',
          body: 'Não foi possível carregar o chat. Por favor, tente novamente.',
          retry: 'Tentar novamente',
        },
        maintenance: {
          title: 'O chat está temporariamente indisponível',
          body: 'Estamos realizando uma manutenção programada. Volte em breve.',
        },
      },
      image: 'Imagem',
      agentSharedImage: '{{name}} partilhou uma imagem: ',
      assistantSharedImage: '{{name}} partilhou uma imagem: ',
      starRating: 'Avaliação por estrelas',
      starRatingOrder: '{{current}} de {{total}} estrelas',
      submit: 'Enviar',
      closeConversationDialog: 'Encerrar conversa',
      waitingForAgentDescription:
        'Por favor, aguarde enquanto conectamos você a um agente',
      agentTransferred: 'Você foi transferido para outro agente.',
      uploadingFile: 'Está a carregar: {{fileName}}',
      uploadedFile: 'Carregou {{fileName}}',
      attachedFile: 'Anexado: {{fileName}}',
      fileTypeNotPermitted: 'Desculpe, este tipo de ficheiro não é permitido.',
      relaunch: 'Reiniciar',
      screenReaderHintChrome:
        'Para a melhor experiência de leitor de tela no Google Chrome, sugerimos usar o JAWS.',
      screenReaderHintFirefox:
        'Para a melhor experiência de leitor de tela no Firefox, sugerimos usar o NVDA.',
      agentInitiatedCall: '{{name}} iniciou uma chamada',
      clickToJoin: 'Clique para participar',
      callSessionInProgress: 'A sua sessão de chamada está em curso',
      primaryNavigation: 'Navegação',
      agentTypingNamed: '{{name}} está digitando',
      agentSaysUnnamed: 'O agente diz',
      botIsThinkingNamed: '{{name}} está pensando',
      talkingWithAgentUnnamed: 'Conversando com um agente',
      download: 'Baixar',
      downloading: 'Baixando',
      downloadComplete: 'Download concluído',
      downloadFailed: 'Falha no download',
      attachFile: 'Anexar arquivo',
      removeAttachment: 'Remover anexo',
      uploadFailedConnection: 'Falha no envio. Verifique sua conexão.',
      fileTooLargeToUpload:
        'Este arquivo é muito grande para fazer upload. Por favor, selecione um arquivo menor que {{maxSize}}.',
      problemUploadingFile: 'Ocorreu um problema ao carregar o seu ficheiro.',
      attachmentRemoved: 'Anexo removido.',
      tomorrow: 'Amanhã',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menu inicial',
      goBack: 'Voltar',
      expandInSameWindow: 'Expandir na mesma janela',
      collapseDialog: 'Recolher diálogo',
      closeDialog: 'Fechar diálogo',
    },
  },
  {
    lang: 'ro',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Această conversație s-a încheiat.',
      agentConnected: 'Ați fost conectat cu succes la un agent.',
      downloadTranscript: 'Descarcă transcrierea',
      startNewConversation: 'Începe o conversație nouă',
      returnToConversation: 'Înapoi la conversație',
      connecting: 'Se conectează...',
      retry: 'Reîncearcă',
      reconnecting: 'Se reconectează...',
      connectionLost: 'Conexiunea la internet a fost pierdută',
      reconnectDescription:
        'Conexiunea la internet a fost pierdută. Faceți clic pe Reconectează-te pentru a reîncerca.',
      typeMessage: 'Scrieți un mesaj',
      inputSelect: 'Selectați o opțiune',
      inputSelectOrType: 'Selectați o opțiune sau scrieți un mesaj',
      secureInput: 'Scrieți un mesaj securizat',
      secureValueHidden: 'Valoare securizată ascunsă',
      redactedValue: 'Informații personale ascunse',
      startChat: 'Începe chatul',
      settings: 'Setări',
      cancel: 'Anulează',
      confirm: 'Confirmă',
      close: 'Închide',
      next: 'Înainte',
      brandingTagline: 'Impulsionați-vă afacerea cu agenți AI inteligenți',
      poweredBy: 'Susținut de',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistentul se gândește',
      youSaid: 'Ați spus',
      botSays: 'Asistentul spune',
      agentSays: '{{name}} spune',
      joinMeeting: 'Alătură-te întâlnirii',
      meetingInProgress:
        'Întâlnire în curs — faceți clic pentru a vă reconecta',
      meetingExpired: 'Link întâlnire (expirat)',
      embeddedContent: 'Conținut încorporat',
      openInNewTab: 'Deschide într-o filă nouă',
      skipToMain: 'Salt la conținutul principal',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Selectați data',
      selectTime: 'Selectați ora',
      browseOptions: 'Răsfoiește opțiunile',
      carouselRoleDescription: 'Carusel',
      carouselSlideLabel: 'Diapozitivul {{current}} din {{total}}',
      carouselPrevious: 'Elementul anterior',
      carouselNext: 'Elementul următor',
      carouselGoToItem: 'Mergi la elementul {{index}}',
      collapse: 'Restrânge',
      expand: 'Extinde',
      messageHistory: 'Istoricul mesajelor',
      reduce: 'Micșorează',
      today: 'Astăzi',
      at: 'la',
      a11yOptionsCount_one: 'Există 1 opțiune.',
      a11yOptionsCount_few: 'Există {{count}} opțiuni.',
      a11yOptionsCount_other: 'Există {{count}} de opțiuni.',
      listpickerSelectAll: 'Selectează tot',
      listpickerSelectOption: 'Selectați o opțiune',
      listpickerSearchAriaLabel: 'Căutați opțiuni de filtrare',
      listpickerSearchPlaceholder: 'Căutare…',
      listpickerNoResults: 'Nicio opțiune care se potrivește.',
      listpickerResults_one: '1 rezultat',
      listpickerResults_few: '{{count}} rezultate',
      listpickerResults_other: '{{count}} de rezultate',
      listpickerCondensed_one: '1 selectat',
      listpickerCondensed_few: '{{count}} selectate',
      listpickerCondensed_other: '{{count}} de selectate',
      scrollToLatest: 'Derulează la cel mai recent mesaj',
      scrollToUnread_one: '1 mesaj nou, mergi la cel mai recent',
      scrollToUnread_few: '{{count}} mesaje noi, mergi la cel mai recent',
      scrollToUnread_other: '{{count}} de mesaje noi, mergi la cel mai recent',
      showPassword: 'Afișează conținutul securizat',
      hidePassword: 'Ascunde conținutul securizat',
      clear: 'Golește',
      send: 'Trimite',
      yesterday: 'Ieri',
      chatEndedActions: 'Acțiuni după încheierea chatului',
      openConversationDialog: 'Deschide fereastra de conversație cu {{title}}',
      agentTyping: 'Agentul scrie',
      agentAway: 'Agenții noștri nu sunt disponibili momentan.',
      agentBusy:
        'Agenții noștri sunt momentan ocupați. Vă rugăm să așteptați...',
      waitingForAgent: 'Vă conectăm cu un agent...',
      waitingForAgentWithSkill: 'Vă conectăm cu un agent pentru {{skill}}...',
      talkingWithAgent: 'În conversație cu {{name}}',
      home: 'Acasă',
      back: 'Înapoi',
      menu: 'Meniu',
      minimize: 'Minimizează',
      endConversation: 'Încheie conversația',
      engageWithUs: 'Contactați-ne',
      noMessagesYet: 'Încă niciun mesaj',
      tryAgain: 'Încearcă din nou',
      gettingLocation: 'Se obține locația actuală...',
      locationSharedMessage: 'Aici este locația mea.',
      selectFile: 'Selectați un fișier',
      upload: 'Încarcă',
      uploadComplete: 'Încărcare finalizată',
      uploadFailed: 'Încărcarea fisierului nu a reușit',
      fileTooLarge:
        'Acest fișier este prea mare pentru a fi încărcat. Vă rugăm să selectați un fișier mai mic de {{maxSize}}.',
      dragOrClick: 'Trageți un fișier sau faceți clic pentru a alege',
      document: 'Document',
      audioContent: 'Conținut audio',
      videoContent: 'Conținut video',
      videoUnsupported:
        'Acest videoclip nu poate fi redat în browserul dumneavoastră.',
      unsupportedContent: 'Conținut neacceptat',
      unavailable: {
        error: {
          title: 'Ceva nu a mers bine',
          body: 'Nu am putut încărca chatul. Încercați din nou.',
          retry: 'Încearcă din nou',
        },
        maintenance: {
          title: 'Chatul este temporar indisponibil',
          body: 'Efectuăm o întreținere programată. Reveniți în curând.',
        },
      },
      image: 'Imagine',
      agentSharedImage: '{{name}} a distribuit o imagine: ',
      assistantSharedImage: '{{name}} a distribuit o imagine: ',
      starRating: 'Evaluare cu stele',
      starRatingOrder: '{{current}} din {{total}} stele',
      submit: 'Trimite',
      closeConversationDialog: 'Închideți conversația',
      waitingForAgentDescription:
        'Vă rugăm să așteptați în timp ce vă conectăm la un agent',
      agentTransferred: 'Ati fost transferat la un alt agent.',
      uploadingFile: 'Incărcati fișierul: {{fileName}}',
      uploadedFile: 'Ați încărcat fișierul {{fileName}}',
      attachedFile: 'Fișierul ataşat: {{fileName}}',
      fileTypeNotPermitted: 'Ne pare rău, acest tip de fișier nu este permis.',
      relaunch: 'Relansați',
      screenReaderHintChrome:
        'Pentru cea mai bună experiență cu cititorul de ecran în Google Chrome, vă sugerăm să utilizați JAWS.',
      screenReaderHintFirefox:
        'Pentru cea mai bună experiență cu cititorul de ecran în Firefox, vă sugerăm să utilizați NVDA.',
      agentInitiatedCall: '{{name}} a inițiat un apel',
      clickToJoin: 'Faceți clic pentru a vă alătura',
      callSessionInProgress: 'Sesiunea dvs. de apel este în desfășurare',
      primaryNavigation: 'Navigare',
      agentTypingNamed: '{{name}} tastează',
      agentSaysUnnamed: 'Agentul spune',
      botIsThinkingNamed: '{{name}} se gândește',
      talkingWithAgentUnnamed: 'Discuție cu un agent',
      download: 'Descarcă',
      downloading: 'Se descarcă',
      downloadComplete: 'Descărcare finalizată',
      downloadFailed: 'Descărcarea a eșuat',
      attachFile: 'Atașați un fișier',
      removeAttachment: 'Eliminați atașamentul',
      uploadFailedConnection: 'Încărcarea a eșuat. Verificați conexiunea.',
      fileTooLargeToUpload:
        'Acest fișier este prea mare pentru a fi încărcat. Vă rugăm să selectați un fișier mai mic de {{maxSize}}.',
      problemUploadingFile:
        'A apărut o problemă la încărcarea fișierului dumneavoastră.',
      attachmentRemoved: 'Atașament eliminat.',
      tomorrow: 'Mâine',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Meniu principal',
      goBack: 'Întoarce-te',
      expandInSameWindow: 'Extindeți în aceeași fereastră',
      collapseDialog: 'Restrange fereastra de dialog',
      closeDialog: 'Închide fereastra de dialog',
    },
  },
  {
    lang: 'ru',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Этот разговор завершён.',
      agentConnected: 'Вы успешно подключены к оператору.',
      downloadTranscript: 'Скачать расшифровку',
      startNewConversation: 'Начать новый разговор',
      returnToConversation: 'Вернуться к разговору',
      connecting: 'Подключение...',
      retry: 'Повторить',
      reconnecting: 'Переподключение...',
      connectionLost: 'Интернет-соединение потеряно',
      reconnectDescription:
        'Интернет-соединение потеряно. Нажмите «Переподключиться», чтобы повторить.',
      typeMessage: 'Введите сообщение',
      inputSelect: 'Выберите вариант',
      inputSelectOrType: 'Выберите вариант или введите сообщение',
      secureInput: 'Введите защищённое сообщение',
      secureValueHidden: 'Скрытое защищённое значение',
      redactedValue: 'Скрытые персональные данные',
      startChat: 'Начать чат',
      settings: 'Настройки',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      close: 'Закрыть',
      next: 'Далее',
      brandingTagline:
        'Ускорьте развитие бизнеса с помощью интеллектуальных ИИ-агентов',
      poweredBy: 'Работает на',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Ассистент думает',
      youSaid: 'Вы сказали',
      botSays: 'Ассистент говорит',
      agentSays: '{{name}} говорит',
      joinMeeting: 'Присоединиться к встрече',
      meetingInProgress: 'Встреча идёт — нажмите, чтобы вернуться',
      meetingExpired: 'Ссылка на встречу (истекла)',
      embeddedContent: 'Встроенный контент',
      openInNewTab: 'Открыть в новой вкладке',
      skipToMain: 'Перейти к основному содержимому',
      customerLogoAlt: 'Логотип {{customerName}}',
      selectDate: 'Выберите дату',
      selectTime: 'Выберите время',
      browseOptions: 'Просмотр вариантов',
      carouselRoleDescription: 'Карусель',
      carouselSlideLabel: 'Слайд {{current}} из {{total}}',
      carouselPrevious: 'Предыдущий элемент',
      carouselNext: 'Следующий элемент',
      carouselGoToItem: 'Перейти к элементу {{index}}',
      collapse: 'Свернуть',
      expand: 'Развернуть',
      messageHistory: 'История сообщений',
      reduce: 'Уменьшить',
      today: 'Сегодня',
      at: 'в',
      a11yOptionsCount_one: '{{count}} вариант.',
      a11yOptionsCount_few: '{{count}} варианта.',
      a11yOptionsCount_many: '{{count}} вариантов.',
      a11yOptionsCount_other: '{{count}} вариантов.',
      listpickerSelectAll: 'Выбрать все',
      listpickerSelectOption: 'Выберите вариант',
      listpickerSearchAriaLabel: 'Поиск вариантов фильтра',
      listpickerSearchPlaceholder: 'Поиск…',
      listpickerNoResults: 'Нет подходящих вариантов.',
      listpickerResults_one: '{{count}} результат',
      listpickerResults_few: '{{count}} результата',
      listpickerResults_many: '{{count}} результатов',
      listpickerResults_other: '{{count}} результатов',
      listpickerCondensed_one: 'Выбран {{count}}',
      listpickerCondensed_few: 'Выбрано {{count}}',
      listpickerCondensed_many: 'Выбрано {{count}}',
      listpickerCondensed_other: 'Выбрано {{count}}',
      scrollToLatest: 'Перейти к последнему сообщению',
      scrollToUnread_one: '{{count}} новое сообщение, перейти к последнему',
      scrollToUnread_few: '{{count}} новых сообщения, перейти к последнему',
      scrollToUnread_many: '{{count}} новых сообщений, перейти к последнему',
      scrollToUnread_other: '{{count}} новых сообщений, перейти к последнему',
      showPassword: 'Показать защищённое содержимое',
      hidePassword: 'Скрыть защищённое содержимое',
      clear: 'Очистить',
      send: 'Отправить',
      yesterday: 'Вчера',
      chatEndedActions: 'Действия после завершения чата',
      openConversationDialog: 'Открыть диалог беседы с {{title}}',
      agentTyping: 'Оператор печатает',
      agentAway: 'Наши операторы сейчас недоступны.',
      agentBusy: 'Наши операторы сейчас заняты. Пожалуйста, подождите...',
      waitingForAgent: 'Подключаем вас к оператору...',
      waitingForAgentWithSkill:
        'Подключаем вас к оператору по теме «{{skill}}»...',
      talkingWithAgent: 'Разговор с {{name}}',
      home: 'Главная',
      back: 'Назад',
      menu: 'Меню',
      minimize: 'Свернуть',
      endConversation: 'Завершить разговор',
      engageWithUs: 'Свяжитесь с нами',
      noMessagesYet: 'Сообщений пока нет',
      tryAgain: 'Повторить попытку',
      gettingLocation: 'Получение текущего местоположения ...',
      locationSharedMessage: 'Вот мое местоположение.',
      selectFile: 'Выберите файл',
      upload: 'Загрузить',
      uploadComplete: 'Загрузка завершена',
      uploadFailed: 'Загрузка не удалась',
      fileTooLarge:
        'Этот файл слишком велик для загрузки. Пожалуйста, выберите файл размером менее {{maxSize}}.',
      dragOrClick: 'Перетащите файл или нажмите, чтобы выбрать',
      document: 'Документ',
      audioContent: 'Аудиоконтент',
      videoContent: 'Видеоконтент',
      videoUnsupported:
        'Это видео не может быть воспроизведено в вашем браузере.',
      unsupportedContent: 'Неподдерживаемый контент',
      unavailable: {
        error: {
          title: 'Что-то пошло не так',
          body: 'Не удалось загрузить чат. Пожалуйста, попробуйте снова.',
          retry: 'Повторить попытку',
        },
        maintenance: {
          title: 'Чат временно недоступен',
          body: 'Проводится плановое обслуживание. Пожалуйста, зайдите позже.',
        },
      },
      image: 'Изображение',
      agentSharedImage: 'Пользователь {{name}} поделился изображением: ',
      assistantSharedImage: 'Пользователь {{name}} поделился изображением:',
      starRating: 'Оценка звёздами',
      starRatingOrder: '{{current}} из {{total}} звёзд',
      submit: 'Отправить',
      closeConversationDialog: 'Закрытый разговор',
      waitingForAgentDescription:
        'Пожалуйста, подождите, пока мы подключим вас к агенту',
      agentTransferred: 'Вы были переведены к другому агенту.',
      uploadingFile: 'Вы загружаете: {{fileName}}',
      uploadedFile: 'Вы загрузили {{fileName}}',
      attachedFile: 'Прикреплён: {{fileName}}',
      fileTypeNotPermitted: 'К сожалению, этот тип файла не разрешен.',
      relaunch: 'Перезапуск',
      screenReaderHintChrome:
        'Для наилучшего опыта работы с программой чтения с экрана в Google Chrome мы рекомендуем использовать JAWS.',
      screenReaderHintFirefox:
        'Для наилучшего опыта работы с программой чтения с экрана в Firefox мы рекомендуем использовать NVDA.',
      agentInitiatedCall: '{{name}} начал(-а) звонок',
      clickToJoin: 'Нажмите чтобы присоединиться',
      callSessionInProgress: 'Ваш сеанс звонка в процессе',
      primaryNavigation: 'Навигация',
      agentTypingNamed: '{{name}} печатает',
      agentSaysUnnamed: 'Агент говорит',
      botIsThinkingNamed: '{{name}} думает',
      talkingWithAgentUnnamed: 'Разговор с агентом',
      download: 'Скачать',
      downloading: 'Скачивание',
      downloadComplete: 'Скачивание завершено',
      downloadFailed: 'Не удалось скачать',
      attachFile: 'Прикрепить файл',
      removeAttachment: 'Удалить вложение',
      uploadFailedConnection: 'Не удалось загрузить. Проверьте подключение.',
      fileTooLargeToUpload:
        'Этот файл слишком велик для загрузки. Пожалуйста, выберите файл размером менее {{maxSize}}.',
      problemUploadingFile: 'Возникла проблема с загрузкой вашего файла.',
      attachmentRemoved: 'Вложение удалено.',
      tomorrow: 'Завтра',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Главное меню',
      goBack: 'Возвращаться',
      expandInSameWindow: 'Развернуть в том же окне',
      collapseDialog: 'Свернуть диалоговое окно',
      closeDialog: 'Закрыть диалог',
    },
  },
  {
    lang: 'sk',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Táto konverzácia sa skončila.',
      agentConnected: 'Boli ste úspešne spojení s operátorom.',
      downloadTranscript: 'Stiahnuť prepis',
      startNewConversation: 'Začať novú konverzáciu',
      returnToConversation: 'Späť ku konverzácii',
      connecting: 'Pripájanie...',
      retry: 'Skúsiť znova',
      reconnecting: 'Opätovné pripájanie...',
      connectionLost: 'Pripojenie na internet sa stratilo',
      reconnectDescription:
        'Pripojenie na internet sa stratilo. Kliknutím na Znova pripojiť to skúste znova.',
      typeMessage: 'Napíšte správu',
      inputSelect: 'Vyberte možnosť',
      inputSelectOrType: 'Vyberte možnosť alebo napíšte správu',
      secureInput: 'Napíšte zabezpečenú správu',
      secureValueHidden: 'Skrytá zabezpečená hodnota',
      redactedValue: 'Skryté osobné údaje',
      startChat: 'Začať chat',
      settings: 'Nastavenia',
      cancel: 'Zrušiť',
      confirm: 'Potvrdiť',
      close: 'Zavrieť',
      next: 'Ďalej',
      brandingTagline: 'Posilnite svoje podnikanie s inteligentnými agentmi AI',
      poweredBy: 'Poháňané technológiou',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistent premýšľa',
      youSaid: 'Povedali ste',
      botSays: 'Asistent hovorí',
      agentSays: '{{name}} hovorí',
      joinMeeting: 'Pripojiť sa k schôdzke',
      meetingInProgress: 'Schôdzka prebieha — kliknutím sa znova pripojíte',
      meetingExpired: 'Odkaz na schôdzku (vypršal)',
      embeddedContent: 'Vložený obsah',
      openInNewTab: 'Otvoriť na novej karte',
      skipToMain: 'Preskočiť na hlavný obsah',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Vyberte dátum',
      selectTime: 'Vyberte čas',
      browseOptions: 'Prehľadávať možnosti',
      carouselRoleDescription: 'Karusel',
      carouselSlideLabel: 'Snímka {{current}} z {{total}}',
      carouselPrevious: 'Predchádzajúca položka',
      carouselNext: 'Ďalšia položka',
      carouselGoToItem: 'Prejsť na položku {{index}}',
      collapse: 'Zbaliť',
      expand: 'Rozbaliť',
      messageHistory: 'História správ',
      reduce: 'Zmenšiť',
      today: 'Dnes',
      at: 'o',
      a11yOptionsCount_one: 'Je 1 možnosť.',
      a11yOptionsCount_few: 'Sú {{count}} možnosti.',
      a11yOptionsCount_many: 'Je {{count}} možnosti.',
      a11yOptionsCount_other: 'Je {{count}} možností.',
      listpickerSelectAll: 'Vybrať všetko',
      listpickerSelectOption: 'Vyberte možnosť',
      listpickerSearchAriaLabel: 'Hľadať možnosti filtra',
      listpickerSearchPlaceholder: 'Hľadať…',
      listpickerNoResults: 'Žiadne zodpovedajúce možnosti.',
      listpickerResults_one: '1 výsledok',
      listpickerResults_few: '{{count}} výsledky',
      listpickerResults_many: '{{count}} výsledku',
      listpickerResults_other: '{{count}} výsledkov',
      listpickerCondensed_one: 'Vybraté 1',
      listpickerCondensed_few: 'Vybraté {{count}}',
      listpickerCondensed_many: 'Vybraté {{count}}',
      listpickerCondensed_other: 'Vybraté {{count}}',
      scrollToLatest: 'Prejsť na najnovšiu správu',
      scrollToUnread_one: '1 nová správa, prejsť na najnovšiu',
      scrollToUnread_few: '{{count}} nové správy, prejsť na najnovšiu',
      scrollToUnread_many: '{{count}} novej správy, prejsť na najnovšiu',
      scrollToUnread_other: '{{count}} nových správ, prejsť na najnovšiu',
      showPassword: 'Zobraziť zabezpečený obsah',
      hidePassword: 'Skryť zabezpečený obsah',
      clear: 'Vymazať',
      send: 'Odoslať',
      yesterday: 'Včera',
      chatEndedActions: 'Akcie po ukončení chatu',
      openConversationDialog: 'Otvoriť okno konverzácie s {{title}}',
      agentTyping: 'Operátor píše',
      agentAway: 'Naši operátori sú momentálne nedostupní.',
      agentBusy:
        'Naši operátori sú momentálne zaneprázdnení. Počkajte prosím...',
      waitingForAgent: 'Spájame vás s operátorom...',
      waitingForAgentWithSkill: 'Spájame vás s operátorom pre {{skill}}...',
      talkingWithAgent: 'Hovoríte s {{name}}',
      home: 'Domov',
      back: 'Späť',
      menu: 'Ponuka',
      minimize: 'Minimalizovať',
      endConversation: 'Ukončiť konverzáciu',
      engageWithUs: 'Kontaktujte nás',
      noMessagesYet: 'Zatiaľ žiadne správy',
      tryAgain: 'Skúsiť znova',
      gettingLocation: 'Načítava sa aktuálna poloha...',
      locationSharedMessage: 'Tu je moja poloha.',
      selectFile: 'Vyberte súbor',
      upload: 'Nahrať',
      uploadComplete: 'Nahrávanie dokončené',
      uploadFailed: 'Nahrávanie zlyhalo',
      fileTooLarge:
        'Tento súbor je príliš veľký na nahratie. Prosím, vyberte súbor menší ako {{maxSize}}.',
      dragOrClick: 'Presuňte súbor alebo kliknite na výber',
      document: 'Dokument',
      audioContent: 'Zvukový obsah',
      videoContent: 'Videoobsah',
      videoUnsupported: 'Toto video sa nedá prehrať vo vašom prehliadači.',
      unsupportedContent: 'Nepodporovaný obsah',
      unavailable: {
        error: {
          title: 'Niečo sa pokazilo',
          body: 'Chat sa nepodarilo načítať. Skúste to znova.',
          retry: 'Skúsiť znova',
        },
        maintenance: {
          title: 'Chat je dočasne nedostupný',
          body: 'Vykonávame plánovanú údržbu. Vráťte sa prosím čoskoro.',
        },
      },
      image: 'Obrázok',
      agentSharedImage: '{{name}} zdieľal(a) obrázok:',
      assistantSharedImage: '{{name}} zdieľal(a) obrázok:',
      starRating: 'Hodnotenie hviezdičkami',
      starRatingOrder: '{{current}} z {{total}} hviezd',
      submit: 'Odoslať',
      closeConversationDialog: 'Ukončiť konverzáciu',
      waitingForAgentDescription:
        'Počkajte prosím, kým vás prepojíme na agenta',
      agentTransferred: 'Boli ste prevelení k inému agentovi.',
      uploadingFile: 'Nahráte: {{fileName}}',
      uploadedFile: 'Nahrali ste {{fileName}}',
      attachedFile: 'Pripojené: {{fileName}}',
      fileTypeNotPermitted: 'Prepáčte, tento typ súboru nie je povolený.',
      relaunch: 'Reštartovať',
      screenReaderHintChrome:
        'Pre najlepšie využitie čítača obrazovky v Google Chrome odporúčame používať JAWS.',
      screenReaderHintFirefox:
        'Pre najlepšie využitie čítača obrazovky vo Firefoxe odporúčame používať NVDA.',
      agentInitiatedCall: '{{name}} inicioval(-a) hovor',
      clickToJoin: 'Kliknite pre pripojenie',
      callSessionInProgress: 'Vaša relácia hovoru prebieha',
      primaryNavigation: 'Navigácia',
      agentTypingNamed: '{{name}} píše',
      agentSaysUnnamed: 'Agent hovorí',
      botIsThinkingNamed: '{{name}} premýšľa',
      talkingWithAgentUnnamed: 'Rozhovor s agentom',
      download: 'Stiahnuť',
      downloading: 'Sťahovanie',
      downloadComplete: 'Sťahovanie dokončené',
      downloadFailed: 'Sťahovanie zlyhalo',
      attachFile: 'Priložiť súbor',
      removeAttachment: 'Odstrániť prílohu',
      uploadFailedConnection: 'Nahrávanie zlyhalo. Skontrolujte pripojenie.',
      fileTooLargeToUpload:
        'Tento súbor je príliš veľký na nahratie. Prosím, vyberte súbor menší ako {{maxSize}}.',
      problemUploadingFile: 'Pri nahrávaní vášho súboru sa vyskytol problém.',
      attachmentRemoved: 'Príloha odstránená.',
      tomorrow: 'Zajtra',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Domovské menu',
      goBack: 'Späť',
      expandInSameWindow: 'Rozšíriť v rovnakom okne',
      collapseDialog: 'Zbaliť dialógové okno',
      closeDialog: 'Zavrieť dialógové okno',
    },
  },
  {
    lang: 'sl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ta pogovor je končan.',
      agentConnected: 'Uspešno ste povezani z agentom.',
      downloadTranscript: 'Prenesi prepis',
      startNewConversation: 'Začni nov pogovor',
      returnToConversation: 'Nazaj na pogovor',
      connecting: 'Povezovanje...',
      retry: 'Poskusi znova',
      reconnecting: 'Ponovno povezovanje...',
      connectionLost: 'Internetna povezava je bila prekinjena',
      reconnectDescription:
        'Internetna povezava je bila prekinjena. Kliknite Znova poveži za ponovni poskus.',
      typeMessage: 'Vnesite sporočilo',
      inputSelect: 'Izberite možnost',
      inputSelectOrType: 'Izberite možnost ali vnesite sporočilo',
      secureInput: 'Vnesite varno sporočilo',
      secureValueHidden: 'Skrita varna vrednost',
      redactedValue: 'Skriti osebni podatki',
      startChat: 'Začni klepet',
      settings: 'Nastavitve',
      cancel: 'Prekliči',
      confirm: 'Potrdi',
      close: 'Zapri',
      next: 'Naprej',
      brandingTagline: 'Okrepite svoje podjetje z inteligentnimi agenti UI',
      poweredBy: 'Poganja',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Pomočnik razmišlja',
      youSaid: 'Rekli ste',
      botSays: 'Pomočnik pravi',
      agentSays: '{{name}} pravi',
      joinMeeting: 'Pridruži se sestanku',
      meetingInProgress: 'Sestanek poteka — kliknite za ponovno pridružitev',
      meetingExpired: 'Povezava do sestanka (potekla)',
      embeddedContent: 'Vgrajena vsebina',
      openInNewTab: 'Odpri v novem zavihku',
      skipToMain: 'Preskoči na glavno vsebino',
      customerLogoAlt: 'Logotip {{customerName}}',
      selectDate: 'Izberite datum',
      selectTime: 'Izberite čas',
      browseOptions: 'Prebrskaj možnosti',
      carouselRoleDescription: 'Vrtiljak',
      carouselSlideLabel: 'Prosojnica {{current}} od {{total}}',
      carouselPrevious: 'Prejšnji element',
      carouselNext: 'Naslednji element',
      carouselGoToItem: 'Pojdi na element {{index}}',
      collapse: 'Strni',
      expand: 'Razširi',
      messageHistory: 'Zgodovina sporočil',
      reduce: 'Pomanjšaj',
      today: 'Danes',
      at: 'ob',
      a11yOptionsCount_one: 'Na voljo je 1 možnost.',
      a11yOptionsCount_two: 'Na voljo sta {{count}} možnosti.',
      a11yOptionsCount_few: 'Na voljo so {{count}} možnosti.',
      a11yOptionsCount_other: 'Na voljo je {{count}} možnosti.',
      listpickerSelectAll: 'Izberi vse',
      listpickerSelectOption: 'Izberite možnost',
      listpickerSearchAriaLabel: 'Iskanje možnosti filtra',
      listpickerSearchPlaceholder: 'Iskanje…',
      listpickerNoResults: 'Ni ujemajočih se možnosti.',
      listpickerResults_one: '1 rezultat',
      listpickerResults_two: '{{count}} rezultata',
      listpickerResults_few: '{{count}} rezultati',
      listpickerResults_other: '{{count}} rezultatov',
      listpickerCondensed_one: '1 izbran',
      listpickerCondensed_two: '{{count}} izbrana',
      listpickerCondensed_few: '{{count}} izbrani',
      listpickerCondensed_other: '{{count}} izbranih',
      scrollToLatest: 'Pomakni se na najnovejše sporočilo',
      scrollToUnread_one: '1 novo sporočilo, na najnovejše',
      scrollToUnread_two: '{{count}} novi sporočili, na najnovejše',
      scrollToUnread_few: '{{count}} nova sporočila, na najnovejše',
      scrollToUnread_other: '{{count}} novih sporočil, na najnovejše',
      showPassword: 'Pokaži varno vsebino',
      hidePassword: 'Skrij varno vsebino',
      clear: 'Počisti',
      send: 'Pošlji',
      yesterday: 'Včeraj',
      chatEndedActions: 'Dejanja po koncu klepeta',
      openConversationDialog: 'Odpri pogovorno okno z {{title}}',
      agentTyping: 'Agent tipka',
      agentAway: 'Naši agenti trenutno niso na voljo.',
      agentBusy: 'Naši agenti so trenutno zasedeni. Počakajte...',
      waitingForAgent: 'Povezujemo vas z agentom...',
      waitingForAgentWithSkill: 'Povezujemo vas z agentom za {{skill}}...',
      talkingWithAgent: 'Pogovor z {{name}}',
      home: 'Domov',
      back: 'Nazaj',
      menu: 'Meni',
      minimize: 'Pomanjšaj',
      endConversation: 'Končaj pogovor',
      engageWithUs: 'Stopite v stik z nami',
      noMessagesYet: 'Še ni sporočil',
      tryAgain: 'Poskusi znova',
      gettingLocation: 'Pridobivanje trenutne lokacije...',
      locationSharedMessage: 'Tukaj je moja lokacija.',
      selectFile: 'Izberite datoteko',
      upload: 'Naloži',
      uploadComplete: 'Nalaganje končano',
      uploadFailed: 'Nalaganje ni uspelo',
      fileTooLarge:
        'Ta datoteka je prevelika za nalaganje. Prosimo, izberite datoteko, manjšo od {{maxSize}}.',
      dragOrClick: 'Povlecite datoteko ali kliknite za izbiro',
      document: 'Dokument',
      audioContent: 'Zvočna vsebina',
      videoContent: 'Videovsebina',
      videoUnsupported:
        'Tega videoposnetka ni mogoče predvajati v vašem brskalniku.',
      unsupportedContent: 'Nepodprta vsebina',
      unavailable: {
        error: {
          title: 'Nekaj je šlo narobe',
          body: 'Klepeta ni bilo mogoče naložiti. Poskusite znova.',
          retry: 'Poskusi znova',
        },
        maintenance: {
          title: 'Klepet je začasno nedosegljiv',
          body: 'Izvajamo načrtovano vzdrževanje. Vrnite se kmalu.',
        },
      },
      image: 'Slika',
      agentSharedImage: '{{name}} je delil(-a) sliko: ',
      assistantSharedImage: '{{name}} je delil(-a) sliko: ',
      starRating: 'Ocena z zvezdicami',
      starRatingOrder: '{{current}} od {{total}} zvezdic',
      submit: 'Pošlji',
      closeConversationDialog: 'Zapri pogovor',
      waitingForAgentDescription:
        'Prosimo, počakajte, medtem ko vas povezujemo z agentom',
      agentTransferred: 'Premeščeni ste k drugemu agentu.',
      uploadingFile: 'Nalaganje: {{fileName}}',
      uploadedFile: 'Naložili ste {{fileName}}',
      attachedFile: 'Priloženo: {{fileName}}',
      fileTypeNotPermitted: 'Oprostite, ta vrsta datoteke ni dovoljena.',
      relaunch: 'Ponovno zaženite',
      screenReaderHintChrome:
        'Za najboljšo izkušnjo z bralnikom zaslona v Google Chrome priporočamo uporabo JAWS.',
      screenReaderHintFirefox:
        'Za najboljšo izkušnjo z bralnikom zaslona v Firefoxu priporočamo uporabo NVDA.',
      agentInitiatedCall: '{{name}} je začel(-a) klic',
      clickToJoin: 'Kliknite za pridružitev',
      callSessionInProgress: 'Vaša klicna seja je v teku',
      primaryNavigation: 'Navigacija',
      agentTypingNamed: '{{name}} tipka',
      agentSaysUnnamed: 'Agent pravi',
      botIsThinkingNamed: '{{name}} razmišlja',
      talkingWithAgentUnnamed: 'Pogovor z agentom',
      download: 'Prenesi',
      downloading: 'Prenašanje',
      downloadComplete: 'Prenos končan',
      downloadFailed: 'Prenos ni uspel',
      attachFile: 'Pripni datoteko',
      removeAttachment: 'Odstrani prilogo',
      uploadFailedConnection: 'Nalaganje ni uspelo. Preverite povezavo.',
      fileTooLargeToUpload:
        'Ta datoteka je prevelika za nalaganje. Prosimo, izberite datoteko, manjšo od {{maxSize}}.',
      problemUploadingFile: 'Pri nalaganju vaše datoteke je prišlo do težave.',
      attachmentRemoved: 'Priloga odstranjena.',
      tomorrow: 'Jutri',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Domači meni',
      goBack: 'Nazaj',
      expandInSameWindow: 'Razširi v istem oknu',
      collapseDialog: 'Strni pogovorno okno',
      closeDialog: 'Zapri pogovorno okno',
    },
  },
  {
    lang: 'sr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ovaj razgovor je završen.',
      agentConnected: 'Uspešno ste povezani sa agentom.',
      downloadTranscript: 'Preuzmi transkript',
      startNewConversation: 'Započni novi razgovor',
      returnToConversation: 'Nazad na razgovor',
      connecting: 'Povezivanje...',
      retry: 'Pokušaj ponovo',
      reconnecting: 'Ponovno povezivanje...',
      connectionLost: 'Internet veza je izgubljena',
      reconnectDescription:
        'Internet veza je izgubljena. Kliknite Ponovo poveži da pokušate ponovo.',
      typeMessage: 'Upišite poruku',
      inputSelect: 'Izaberite opciju',
      inputSelectOrType: 'Izaberite opciju ili upišite poruku',
      secureInput: 'Upišite bezbednu poruku',
      secureValueHidden: 'Skrivena bezbedna vrednost',
      redactedValue: 'Skriveni lični podaci',
      startChat: 'Započni ćaskanje',
      settings: 'Podešavanja',
      cancel: 'Otkaži',
      confirm: 'Potvrdi',
      close: 'Zatvori',
      next: 'Dalje',
      brandingTagline: 'Osnažite svoje poslovanje inteligentnim AI agentima',
      poweredBy: 'Pokreće',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistent razmišlja',
      youSaid: 'Rekli ste',
      botSays: 'Asistent kaže',
      agentSays: '{{name}} kaže',
      joinMeeting: 'Pridruži se sastanku',
      meetingInProgress:
        'Sastanak je u toku — kliknite da se ponovo pridružite',
      meetingExpired: 'Link ka sastanku (istekao)',
      embeddedContent: 'Ugrađeni sadržaj',
      openInNewTab: 'Otvori u novoj kartici',
      skipToMain: 'Pređi na glavni sadržaj',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Izaberite datum',
      selectTime: 'Izaberite vreme',
      browseOptions: 'Pregledaj opcije',
      carouselRoleDescription: 'Vrteška',
      carouselSlideLabel: 'Slajd {{current}} od {{total}}',
      carouselPrevious: 'Prethodna stavka',
      carouselNext: 'Sledeća stavka',
      carouselGoToItem: 'Idi na stavku {{index}}',
      collapse: 'Skupi',
      expand: 'Proširi',
      messageHistory: 'Istorija poruka',
      reduce: 'Smanji',
      today: 'Danas',
      at: 'u',
      a11yOptionsCount_one: 'Postoji 1 opcija.',
      a11yOptionsCount_few: 'Postoje {{count}} opcije.',
      a11yOptionsCount_other: 'Postoji {{count}} opcija.',
      listpickerSelectAll: 'Izaberi sve',
      listpickerSelectOption: 'Izaberite opciju',
      listpickerSearchAriaLabel: 'Pretraži opcije filtera',
      listpickerSearchPlaceholder: 'Pretraži…',
      listpickerNoResults: 'Nema podudarnih opcija.',
      listpickerResults_one: '1 rezultat',
      listpickerResults_few: '{{count}} rezultata',
      listpickerResults_other: '{{count}} rezultata',
      listpickerCondensed_one: '1 izabrano',
      listpickerCondensed_few: '{{count}} izabrano',
      listpickerCondensed_other: '{{count}} izabrano',
      scrollToLatest: 'Pomeri na najnoviju poruku',
      scrollToUnread_one: '1 nova poruka, na najnoviju',
      scrollToUnread_few: '{{count}} nove poruke, na najnoviju',
      scrollToUnread_other: '{{count}} novih poruka, na najnoviju',
      showPassword: 'Prikaži bezbedan sadržaj',
      hidePassword: 'Sakrij bezbedan sadržaj',
      clear: 'Obriši',
      send: 'Pošalji',
      yesterday: 'Juče',
      chatEndedActions: 'Radnje nakon završetka ćaskanja',
      openConversationDialog: 'Otvori prozor razgovora sa {{title}}',
      agentTyping: 'Agent kuca',
      agentAway: 'Naši agenti trenutno nisu dostupni.',
      agentBusy: 'Naši agenti su trenutno zauzeti. Sačekajte...',
      waitingForAgent: 'Povezujemo vas sa agentom...',
      waitingForAgentWithSkill: 'Povezujemo vas sa agentom za {{skill}}...',
      talkingWithAgent: 'Razgovor sa {{name}}',
      home: 'Početna',
      back: 'Nazad',
      menu: 'Meni',
      minimize: 'Umanji',
      endConversation: 'Završite razgovor',
      engageWithUs: 'Kontaktirajte nas',
      noMessagesYet: 'Još nema poruka',
      tryAgain: 'Pokušaj ponovo',
      gettingLocation: 'Preuzimanje trenutne lokacije...',
      locationSharedMessage: 'Evo moje lokacije.',
      selectFile: 'Izaberite datoteku',
      upload: 'Otpremi',
      uploadComplete: 'Otpremanje završeno',
      uploadFailed: 'Otpremanje neuspešno',
      fileTooLarge:
        'Ova datoteka je prevelika za otpremanje. Molimo vas da izaberete datoteku manju od {{maxSize}}.',
      dragOrClick: 'Prevucite datoteku ili kliknite da izaberete',
      document: 'Dokument',
      audioContent: 'Audio sadržaj',
      videoContent: 'Video sadržaj',
      videoUnsupported:
        'Ovaj video se ne može reprodukovati u vašem pregledaču.',
      unsupportedContent: 'Nepodržani sadržaj',
      unavailable: {
        error: {
          title: 'Nešto je pošlo naopako',
          body: 'Nismo mogli da učitamo ćaskanje. Pokušajte ponovo.',
          retry: 'Pokušaj ponovo',
        },
        maintenance: {
          title: 'Ćaskanje je privremeno nedostupno',
          body: 'Sprovodimo planirano održavanje. Vratite se uskoro.',
        },
      },
      image: 'Slika',
      agentSharedImage: '{{name}} je podelio sliku: ',
      assistantSharedImage: '{{name}} je podelio sliku: ',
      starRating: 'Ocena zvezdicama',
      starRatingOrder: '{{current}} od {{total}} zvezdica',
      submit: 'Pošalji',
      closeConversationDialog: 'Zatvori razgovor',
      waitingForAgentDescription:
        'Molimo sačekajte dok vas povezujemo sa agentom',
      agentTransferred: 'Prebačeni ste na drugog agenta.',
      uploadingFile: 'Otpremate: {{fileName}}',
      uploadedFile: 'Otpremili ste {{fileName}}',
      attachedFile: 'Prikačeno: {{fileName}}',
      fileTypeNotPermitted: 'Žao nam je, ova vrsta datoteke nije dozvoljena.',
      relaunch: 'Ponovo pokrenite',
      screenReaderHintChrome:
        'Za najbolje iskustvo sa čitačem ekrana u Google Chrome-u, predlažemo korišćenje JAWS-a.',
      screenReaderHintFirefox:
        'Za najbolje iskustvo sa čitačem ekrana u Firefox-u, predlažemo korišćenje NVDA.',
      agentInitiatedCall: '{{name}} je započeo poziv',
      clickToJoin: 'Kliknite da se pridružite',
      callSessionInProgress: 'Vaša sesija poziva je u toku',
      primaryNavigation: 'Navigacija',
      agentTypingNamed: '{{name}} kuca',
      agentSaysUnnamed: 'Agent kaže',
      botIsThinkingNamed: '{{name}} razmišlja',
      talkingWithAgentUnnamed: 'Razgovor sa agentom',
      download: 'Preuzmi',
      downloading: 'Preuzimanje',
      downloadComplete: 'Preuzimanje završeno',
      downloadFailed: 'Preuzimanje nije uspelo',
      attachFile: 'Priloži datoteku',
      removeAttachment: 'Ukloni prilog',
      uploadFailedConnection: 'Otpremanje nije uspelo. Proverite vezu.',
      fileTooLargeToUpload:
        'Ova datoteka je prevelika za otpremanje. Molimo vas da izaberete datoteku manju od {{maxSize}}.',
      problemUploadingFile:
        'Došlo je do problema prilikom otpremanja vaše datoteke.',
      attachmentRemoved: 'Prilog uklonjen.',
      tomorrow: 'Sutra',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Početni meni',
      goBack: 'Vrati se',
      expandInSameWindow: 'Proširi u istom prozoru',
      collapseDialog: 'Skupi dijalog',
      closeDialog: 'Zatvori dijalog',
    },
  },
  {
    lang: 'sr-CYRL',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Овај разговор је завршен.',
      agentConnected: 'Успешно сте повезани са агентом.',
      downloadTranscript: 'Преузми транскрипт',
      startNewConversation: 'Започни нови разговор',
      returnToConversation: 'Назад на разговор',
      connecting: 'Повезивање...',
      retry: 'Покушај поново',
      reconnecting: 'Поновно повезивање...',
      connectionLost: 'Интернет веза је изгубљена',
      reconnectDescription:
        'Интернет веза је изгубљена. Кликните Поново повежи да покушате поново.',
      typeMessage: 'Упишите поруку',
      inputSelect: 'Изаберите опцију',
      inputSelectOrType: 'Изаберите опцију или упишите поруку',
      secureInput: 'Упишите безбедну поруку',
      secureValueHidden: 'Скривена безбедна вредност',
      redactedValue: 'Скривени лични подаци',
      startChat: 'Започни ћаскање',
      settings: 'Подешавања',
      cancel: 'Откажи',
      confirm: 'Потврди',
      close: 'Затвори',
      next: 'Даље',
      brandingTagline: 'Оснажите своје пословање интелигентним АИ агентима',
      poweredBy: 'Покреће',
      pypestreamCom: 'Пyпестреам.цом',
      botIsThinking: 'Асистент размишља',
      youSaid: 'Рекли сте',
      botSays: 'Асистент каже',
      agentSays: '{{name}} каже',
      joinMeeting: 'Придружи се састанку',
      meetingInProgress:
        'Састанак је у току — кликните да се поново придружите',
      meetingExpired: 'Линк ка састанку (истекао)',
      embeddedContent: 'Уграђени садржај',
      openInNewTab: 'Отвори у новој картици',
      skipToMain: 'Пређи на главни садржај',
      customerLogoAlt: 'Лого {{customerName}}',
      selectDate: 'Изаберите датум',
      selectTime: 'Изаберите време',
      browseOptions: 'Прегледај опције',
      carouselRoleDescription: 'Вртешка',
      carouselSlideLabel: 'Слајд {{current}} од {{total}}',
      carouselPrevious: 'Претходна ставка',
      carouselNext: 'Следећа ставка',
      carouselGoToItem: 'Иди на ставку {{index}}',
      collapse: 'Скупи',
      expand: 'Прошири',
      messageHistory: 'Историја порука',
      reduce: 'Смањи',
      today: 'Данас',
      at: 'у',
      a11yOptionsCount_one: 'Постоји 1 опција.',
      a11yOptionsCount_few: 'Постоје {{count}} опције.',
      a11yOptionsCount_other: 'Постоји {{count}} опција.',
      listpickerSelectAll: 'Изабери све',
      listpickerSelectOption: 'Изаберите опцију',
      listpickerSearchAriaLabel: 'Претражи опције филтера',
      listpickerSearchPlaceholder: 'Претражи…',
      listpickerNoResults: 'Нема подударних опција.',
      listpickerResults_one: '1 резултат',
      listpickerResults_few: '{{count}} резултата',
      listpickerResults_other: '{{count}} резултата',
      listpickerCondensed_one: '1 изабрано',
      listpickerCondensed_few: '{{count}} изабрано',
      listpickerCondensed_other: '{{count}} изабрано',
      scrollToLatest: 'Помери на најновију поруку',
      scrollToUnread_one: '1 нова порука, на најновију',
      scrollToUnread_few: '{{count}} нове поруке, на најновију',
      scrollToUnread_other: '{{count}} нових порука, на најновију',
      showPassword: 'Прикажи безбедан садржај',
      hidePassword: 'Сакриј безбедан садржај',
      clear: 'Обриши',
      send: 'Пошаљи',
      yesterday: 'Јуче',
      chatEndedActions: 'Радње након завршетка ћаскања',
      openConversationDialog: 'Отвори прозор разговора са {{title}}',
      agentTyping: 'Агент куца',
      agentAway: 'Наши агенти тренутно нису доступни.',
      agentBusy: 'Наши агенти су тренутно заузети. Сачекајте...',
      waitingForAgent: 'Повезујемо вас са агентом...',
      waitingForAgentWithSkill: 'Повезујемо вас са агентом за {{skill}}...',
      talkingWithAgent: 'Разговор са {{name}}',
      home: 'Почетна',
      back: 'Назад',
      menu: 'Мени',
      minimize: 'Умањи',
      endConversation: 'Завршите разговор',
      engageWithUs: 'Контактирајте нас',
      noMessagesYet: 'Још нема порука',
      tryAgain: 'Покушај поново',
      gettingLocation: 'Преузимање тренутне локације...',
      locationSharedMessage: 'Ево моје локације.',
      selectFile: 'Изаберите датотеку',
      upload: 'Отпреми',
      uploadComplete: 'Отпремање завршено',
      uploadFailed: 'Отпремање неуспешно',
      fileTooLarge:
        'Ова датотека је превелика за отпремање. Молимо вас да изаберете датотеку мању од {{maxSize}}.',
      dragOrClick: 'Превуците датотеку или кликните да изаберете',
      document: 'Документ',
      audioContent: 'Аудио садржај',
      videoContent: 'Видео садржај',
      videoUnsupported:
        'Овај видео се не може репродуковати у вашем прегледачу.',
      unsupportedContent: 'Неподржани садржај',
      unavailable: {
        error: {
          title: 'Нешто је пошло наопако',
          body: 'Нисмо могли да учитамо ћаскање. Покушајте поново.',
          retry: 'Покушај поново',
        },
        maintenance: {
          title: 'Ћаскање је привремено недоступно',
          body: 'Спроводимо планирано одржавање. Вратите се ускоро.',
        },
      },
      image: 'Слика',
      agentSharedImage: '{{name}} је поделио слику: ',
      assistantSharedImage: '{{name}} је поделио слику: ',
      starRating: 'Оцена звездицама',
      starRatingOrder: '{{current}} од {{total}} звездица',
      submit: 'Пошаљи',
      closeConversationDialog: 'Затвори разговор',
      waitingForAgentDescription:
        'Молимо сачекајте док вас повезујемо са агентом',
      agentTransferred: 'Пребачени сте на другог агента.',
      uploadingFile: 'Отпремате: {{fileName}}',
      uploadedFile: 'Отпремили сте {{fileName}}',
      attachedFile: 'Прикачено: {{fileName}}',
      fileTypeNotPermitted: 'Жао нам је, ова врста датотеке није дозвољена.',
      relaunch: 'Поново покрените',
      screenReaderHintChrome:
        'За најбоље искуство са читачем екрана у Google Chrome-у, предлажемо коришћење JAWS-а.',
      screenReaderHintFirefox:
        'За најбоље искуство са читачем екрана у Firefox-у, предлажемо коришћење NVDA.',
      agentInitiatedCall: '{{name}} је започео позив',
      clickToJoin: 'Кликните да се придружите',
      callSessionInProgress: 'Ваша сесија позива је у току',
      primaryNavigation: 'Навигација',
      agentTypingNamed: '{{name}} куца',
      agentSaysUnnamed: 'Агент каже',
      botIsThinkingNamed: '{{name}} размишља',
      talkingWithAgentUnnamed: 'Разговор са агентом',
      download: 'Преузми',
      downloading: 'Преузимање',
      downloadComplete: 'Преузимање завршено',
      downloadFailed: 'Преузимање није успело',
      attachFile: 'Приложи датотеку',
      removeAttachment: 'Уклони прилог',
      uploadFailedConnection: 'Отпремање није успело. Проверите везу.',
      fileTooLargeToUpload:
        'Ова датотека је превелика за отпремање. Молимо вас да изаберете датотеку мању од {{maxSize}}.',
      problemUploadingFile:
        'Дошло је до проблема приликом отпремања ваше датотеке.',
      attachmentRemoved: 'Прилог уклоњен.',
      tomorrow: 'Сутра',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Почетни мени',
      goBack: 'Врати се',
      expandInSameWindow: 'Прошири у истом прозору',
      collapseDialog: 'Скупи дијалог',
      closeDialog: 'Затвори дијалог',
    },
  },
  {
    lang: 'sv',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Den här konversationen har avslutats.',
      agentConnected: 'Du har anslutits till en handläggare.',
      downloadTranscript: 'Ladda ner transkript',
      startNewConversation: 'Starta ny konversation',
      returnToConversation: 'Tillbaka till konversationen',
      connecting: 'Ansluter...',
      retry: 'Försök igen',
      reconnecting: 'Återansluter...',
      connectionLost: 'Internetanslutningen har brutits',
      reconnectDescription:
        'Internetanslutningen har brutits. Klicka på Återanslut för att försöka igen.',
      typeMessage: 'Skriv ett meddelande',
      inputSelect: 'Välj ett alternativ',
      inputSelectOrType: 'Välj ett alternativ eller skriv ett meddelande',
      secureInput: 'Skriv ett säkert meddelande',
      secureValueHidden: 'Dolt säkert värde',
      redactedValue: 'Dolda personuppgifter',
      startChat: 'Starta chatt',
      settings: 'Inställningar',
      cancel: 'Avbryt',
      confirm: 'Bekräfta',
      close: 'Stäng',
      next: 'Nästa',
      brandingTagline: 'Ge ditt företag ett lyft med intelligenta AI-agenter',
      poweredBy: 'Drivs av',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Assistenten tänker',
      youSaid: 'Du sa',
      botSays: 'Assistenten säger',
      agentSays: '{{name}} säger',
      joinMeeting: 'Anslut till möte',
      meetingInProgress: 'Möte pågår — klicka för att återansluta',
      meetingExpired: 'Möteslänk (utgången)',
      embeddedContent: 'Inbäddat innehåll',
      openInNewTab: 'Öppna i ny flik',
      skipToMain: 'Hoppa till huvudinnehållet',
      customerLogoAlt: '{{customerName}}-logotyp',
      selectDate: 'Välj datum',
      selectTime: 'Välj tid',
      browseOptions: 'Bläddra bland alternativ',
      carouselRoleDescription: 'Karusell',
      carouselSlideLabel: 'Bild {{current}} av {{total}}',
      carouselPrevious: 'Föregående objekt',
      carouselNext: 'Nästa objekt',
      carouselGoToItem: 'Gå till objekt {{index}}',
      collapse: 'Fäll ihop',
      expand: 'Expandera',
      messageHistory: 'Meddelandehistorik',
      reduce: 'Förminska',
      today: 'Idag',
      at: 'kl.',
      a11yOptionsCount_one: 'Det finns 1 alternativ.',
      a11yOptionsCount_other: 'Det finns {{count}} alternativ.',
      listpickerSelectAll: 'Välj alla',
      listpickerSelectOption: 'Välj ett alternativ',
      listpickerSearchAriaLabel: 'Sök efter filteralternativ',
      listpickerSearchPlaceholder: 'Sök…',
      listpickerNoResults: 'Inga matchande alternativ.',
      listpickerResults_one: '1 resultat',
      listpickerResults_other: '{{count}} resultat',
      listpickerCondensed_one: '1 vald',
      listpickerCondensed_other: '{{count}} valda',
      scrollToLatest: 'Bläddra till senaste meddelandet',
      scrollToUnread_one: '1 nytt meddelande, gå till senaste',
      scrollToUnread_other: '{{count}} nya meddelanden, gå till senaste',
      showPassword: 'Visa säkert innehåll',
      hidePassword: 'Dölj säkert innehåll',
      clear: 'Rensa',
      send: 'Skicka',
      yesterday: 'Igår',
      chatEndedActions: 'Åtgärder efter avslutad chatt',
      openConversationDialog: 'Öppna konversationsfönster med {{title}}',
      agentTyping: 'Handläggaren skriver',
      agentAway: 'Våra handläggare är för närvarande inte tillgängliga.',
      agentBusy: 'Våra handläggare är upptagna just nu. Vänta...',
      waitingForAgent: 'Du kopplas till en handläggare...',
      waitingForAgentWithSkill:
        'Du kopplas till en handläggare för {{skill}}...',
      talkingWithAgent: 'Pratar med {{name}}',
      home: 'Start',
      back: 'Tillbaka',
      menu: 'Meny',
      minimize: 'Minimera',
      endConversation: 'Avsluta konversation',
      engageWithUs: 'Kontakta oss',
      noMessagesYet: 'Inga meddelanden ännu',
      tryAgain: 'Försök igen',
      gettingLocation: 'Hämtar aktuell plats...',
      locationSharedMessage: 'Här är min plats',
      selectFile: 'Välj en fil',
      upload: 'Ladda upp',
      uploadComplete: 'Uppladdning klar',
      uploadFailed: 'Uppladdning misslyckades',
      fileTooLarge:
        'Denna fil är för stor för att laddas upp. Vänligen välj en fil mindre än {{maxSize}}.',
      dragOrClick: 'Dra en fil eller klicka för att välja',
      document: 'Dokument',
      audioContent: 'Ljudinnehåll',
      videoContent: 'Videoinnehåll',
      videoUnsupported: 'Den här videon kan inte spelas upp i din webbläsare.',
      unsupportedContent: 'Innehåll som inte stöds',
      unavailable: {
        error: {
          title: 'Något gick fel',
          body: 'Vi kunde inte läsa in chatten. Försök igen.',
          retry: 'Försök igen',
        },
        maintenance: {
          title: 'Chatten är tillfälligt otillgänglig',
          body: 'Vi utför planerat underhåll. Kom tillbaka snart.',
        },
      },
      image: 'Bild',
      agentSharedImage: '{{name}} Delade en bild: ',
      assistantSharedImage: '{{name}} Delade en bild: ',
      starRating: 'Stjärnbetyg',
      starRatingOrder: '{{current}} av {{total}} stjärnor',
      submit: 'Skicka',
      closeConversationDialog: 'Avsluta konversation',
      waitingForAgentDescription:
        'Vänligen vänta medan vi kopplar dig till en agent',
      agentTransferred: 'Du har överförts till en annan agent.',
      uploadingFile: 'Du laddar upp: {{fileName}}',
      uploadedFile: 'Du laddade upp {{fileName}}',
      attachedFile: 'Bifogad: {{fileName}}',
      fileTypeNotPermitted: 'Tyvärr, denna filtyp är inte tillåten.',
      relaunch: 'Starta om',
      screenReaderHintChrome:
        'För bästa skärmläsarupplevelse i Google Chrome rekommenderar vi att använda JAWS.',
      screenReaderHintFirefox:
        'För bästa skärmläsarupplevelse i Firefox rekommenderar vi att använda NVDA.',
      agentInitiatedCall: '{{name}} har initierat ett samtal',
      clickToJoin: 'Klicka för att ansluta',
      callSessionInProgress: 'Din samtalsession pågår',
      primaryNavigation: 'Navigering',
      agentTypingNamed: '{{name}} skriver',
      agentSaysUnnamed: 'Agenten säger',
      botIsThinkingNamed: '{{name}} tänker',
      talkingWithAgentUnnamed: 'Samtal med en agent',
      download: 'Ladda ned',
      downloading: 'Laddar ned',
      downloadComplete: 'Nedladdningen är klar',
      downloadFailed: 'Nedladdningen misslyckades',
      attachFile: 'Bifoga fil',
      removeAttachment: 'Ta bort bifogad fil',
      uploadFailedConnection:
        'Uppladdningen misslyckades. Kontrollera anslutningen.',
      fileTooLargeToUpload:
        'Denna fil är för stor för att laddas upp. Vänligen välj en fil mindre än {{maxSize}}.',
      problemUploadingFile:
        'Det uppstod ett problem vid uppladdningen av din fil.',
      attachmentRemoved: 'Bifogad fil borttagen.',
      tomorrow: 'I morgon',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Startmeny',
      goBack: 'Gå tillbaka',
      expandInSameWindow: 'Expandera i samma fönster',
      collapseDialog: 'Dölj dialog',
      closeDialog: 'Stäng dialog',
    },
  },
  {
    lang: 'th',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'การสนทนานี้สิ้นสุดแล้ว',
      agentConnected: 'คุณเชื่อมต่อกับเจ้าหน้าที่เรียบร้อยแล้ว',
      downloadTranscript: 'ดาวน์โหลดบันทึกการสนทนา',
      startNewConversation: 'เริ่มการสนทนาใหม่',
      returnToConversation: 'กลับไปที่การสนทนา',
      connecting: 'กำลังเชื่อมต่อ...',
      retry: 'ลองใหม่',
      reconnecting: 'กำลังเชื่อมต่อใหม่...',
      connectionLost: 'การเชื่อมต่ออินเทอร์เน็ตหลุด',
      reconnectDescription:
        'การเชื่อมต่ออินเทอร์เน็ตหลุด คลิกเชื่อมต่อใหม่เพื่อลองอีกครั้ง',
      typeMessage: 'พิมพ์ข้อความ',
      inputSelect: 'เลือกตัวเลือก',
      inputSelectOrType: 'เลือกตัวเลือกหรือพิมพ์ข้อความ',
      secureInput: 'พิมพ์ข้อความที่ปลอดภัย',
      secureValueHidden: 'ค่าที่ปลอดภัยที่ซ่อนอยู่',
      redactedValue: 'ข้อมูลส่วนบุคคลที่ซ่อนอยู่',
      startChat: 'เริ่มแชท',
      settings: 'การตั้งค่า',
      cancel: 'ยกเลิก',
      confirm: 'ยืนยัน',
      close: 'ปิด',
      next: 'ถัดไป',
      brandingTagline: 'เพิ่มศักยภาพธุรกิจของคุณด้วยเอเจนต์ AI อัจฉริยะ',
      poweredBy: 'ขับเคลื่อนโดย',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'ผู้ช่วยกำลังคิด',
      youSaid: 'คุณพูดว่า',
      botSays: 'ผู้ช่วยพูดว่า',
      agentSays: '{{name}} พูดว่า',
      joinMeeting: 'เข้าร่วมการประชุม',
      meetingInProgress: 'การประชุมกำลังดำเนินอยู่ — คลิกเพื่อเข้าร่วมอีกครั้ง',
      meetingExpired: 'ลิงก์การประชุม (หมดอายุ)',
      embeddedContent: 'เนื้อหาที่ฝัง',
      openInNewTab: 'เปิดในแท็บใหม่',
      skipToMain: 'ข้ามไปยังเนื้อหาหลัก',
      customerLogoAlt: 'โลโก้ {{customerName}}',
      selectDate: 'เลือกวันที่',
      selectTime: 'เลือกเวลา',
      browseOptions: 'เรียกดูตัวเลือก',
      carouselRoleDescription: 'ภาพหมุน',
      carouselSlideLabel: 'สไลด์ {{current}} จาก {{total}}',
      carouselPrevious: 'รายการก่อนหน้า',
      carouselNext: 'รายการถัดไป',
      carouselGoToItem: 'ไปที่รายการ {{index}}',
      collapse: 'ยุบ',
      expand: 'ขยาย',
      messageHistory: 'ประวัติข้อความ',
      reduce: 'ย่อ',
      today: 'วันนี้',
      at: 'เวลา',
      a11yOptionsCount_other: 'มี {{count}} ตัวเลือก',
      listpickerSelectAll: 'เลือกทั้งหมด',
      listpickerSelectOption: 'เลือกตัวเลือก',
      listpickerSearchAriaLabel: 'ค้นหาตัวเลือกตัวกรอง',
      listpickerSearchPlaceholder: 'ค้นหา…',
      listpickerNoResults: 'ไม่มีตัวเลือกที่ตรงกัน',
      listpickerResults_other: '{{count}} ผลลัพธ์',
      listpickerCondensed_other: 'เลือกแล้ว {{count}}',
      scrollToLatest: 'เลื่อนไปที่ข้อความล่าสุด',
      scrollToUnread_other: 'ข้อความใหม่ {{count}} รายการ เลื่อนไปล่าสุด',
      showPassword: 'แสดงเนื้อหาที่ปลอดภัย',
      hidePassword: 'ซ่อนเนื้อหาที่ปลอดภัย',
      clear: 'ล้าง',
      send: 'ส่ง',
      yesterday: 'เมื่อวาน',
      chatEndedActions: 'การดำเนินการหลังจบแชท',
      openConversationDialog: 'เปิดหน้าต่างการสนทนากับ {{title}}',
      agentTyping: 'เจ้าหน้าที่กำลังพิมพ์',
      agentAway: 'ขณะนี้เจ้าหน้าที่ของเราไม่พร้อมให้บริการ',
      agentBusy: 'ขณะนี้เจ้าหน้าที่ของเราไม่ว่าง โปรดรอสักครู่...',
      waitingForAgent: 'กำลังเชื่อมต่อคุณกับเจ้าหน้าที่...',
      waitingForAgentWithSkill: 'กำลังเชื่อมต่อคุณกับเจ้าหน้าที่ {{skill}}...',
      talkingWithAgent: 'กำลังสนทนากับ {{name}}',
      home: 'หน้าแรก',
      back: 'ย้อนกลับ',
      menu: 'เมนู',
      minimize: 'ย่อเล็กสุด',
      endConversation: 'จบการสนทนา',
      engageWithUs: 'ติดต่อเรา',
      noMessagesYet: 'ยังไม่มีข้อความ',
      tryAgain: 'ลองอีกครั้ง',
      gettingLocation: 'กำลังรับตำแหน่งปัจจุบัน...',
      locationSharedMessage: 'นี่คือตำแหน่งของฉัน.',
      selectFile: 'เลือกไฟล์',
      upload: 'อัปโหลด',
      uploadComplete: 'อัปโหลดเสร็จสมบูรณ์',
      uploadFailed: 'อัปโหลดล้มเหลว',
      fileTooLarge:
        'ไฟล์นี้ใหญ่เกินไปที่จะอัปโหลด โปรดเลือกไฟล์ที่มีขนาดน้อยกว่า {{maxSize}}',
      dragOrClick: 'ลากไฟล์หรือคลิกเพื่อเลือก',
      document: 'เอกสาร',
      audioContent: 'เนื้อหาเสียง',
      videoContent: 'เนื้อหาวิดีโอ',
      videoUnsupported: 'ไม่สามารถเล่นวิดีโอนี้ในเบราว์เซอร์ของคุณได้',
      unsupportedContent: 'เนื้อหาที่ไม่รองรับ',
      unavailable: {
        error: {
          title: 'มีบางอย่างผิดพลาด',
          body: 'เราไม่สามารถโหลดแชทได้ โปรดลองอีกครั้ง',
          retry: 'ลองอีกครั้ง',
        },
        maintenance: {
          title: 'แชทไม่พร้อมใช้งานชั่วคราว',
          body: 'เรากำลังดำเนินการบำรุงรักษาตามกำหนด โปรดกลับมาใหม่อีกครั้งเร็วๆ นี้',
        },
      },
      image: 'รูปภาพ',
      agentSharedImage: '{{name}} แชร์รูปภาพ: ',
      assistantSharedImage: '{{name}} แชร์รูปภาพ: ',
      starRating: 'การให้คะแนนดาว',
      starRatingOrder: '{{current}} จาก {{total}} ดาว',
      submit: 'ส่ง',
      closeConversationDialog: 'ปิดการสนทนา',
      waitingForAgentDescription:
        'กรุณารอสักครู่ขณะที่เรากำลังเชื่อมต่อคุณกับเจ้าหน้าที่',
      agentTransferred: 'คุณได้รับการโอนไปยังเจ้าหน้าที่คนอื่น.',
      uploadingFile: 'คุณกำลังอัปโหลด: {{fileName}}',
      uploadedFile: 'คุณได้อัปโหลด {{fileName}}',
      attachedFile: 'แนบ: {{fileName}}',
      fileTypeNotPermitted: 'ขออภัย ไม่อนุญาตให้ใช้ไฟล์ประเภทนี้.',
      relaunch: 'เริ่มใหม่',
      screenReaderHintChrome:
        'สำหรับประสบการณ์การใช้โปรแกรมอ่านหน้าจอที่ดีที่สุดใน Google Chrome เราแนะนำให้ใช้ JAWS',
      screenReaderHintFirefox:
        'สำหรับประสบการณ์การใช้โปรแกรมอ่านหน้าจอที่ดีที่สุดใน Firefox เราแนะนำให้ใช้ NVDA',
      agentInitiatedCall: '{{name}} ได้เริ่มการโทร',
      clickToJoin: 'คลิกเพื่อเข้าร่วม',
      callSessionInProgress: 'เซสชันการโทรของคุณกำลังดำเนินอยู่',
      primaryNavigation: 'การนำทาง',
      agentTypingNamed: '{{name}} กำลังพิมพ์',
      agentSaysUnnamed: 'เจ้าหน้าที่พูดว่า',
      botIsThinkingNamed: '{{name}} กำลังคิด',
      talkingWithAgentUnnamed: 'กำลังสนทนากับเจ้าหน้าที่',
      download: 'ดาวน์โหลด',
      downloading: 'กำลังดาวน์โหลด',
      downloadComplete: 'ดาวน์โหลดเสร็จสิ้น',
      downloadFailed: 'ดาวน์โหลดไม่สำเร็จ',
      attachFile: 'แนบไฟล์',
      removeAttachment: 'นำไฟล์แนบออก',
      uploadFailedConnection: 'อัปโหลดไม่สำเร็จ ตรวจสอบการเชื่อมต่อของคุณ',
      fileTooLargeToUpload:
        'ไฟล์นี้ใหญ่เกินไปที่จะอัปโหลด โปรดเลือกไฟล์ที่มีขนาดน้อยกว่า {{maxSize}}',
      problemUploadingFile: 'เกิดปัญหาในการอัปโหลดไฟล์ของคุณ.',
      attachmentRemoved: 'นำไฟล์แนบออกแล้ว',
      tomorrow: 'พรุ่งนี้',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'เมนูหลัก',
      goBack: 'กลับ',
      expandInSameWindow: 'ขยายในหน้าต่างเดียวกัน',
      collapseDialog: 'ย่อกล่องโต้ตอบ',
      closeDialog: 'ปิดกล่องโต้ตอบ',
    },
  },
  {
    lang: 'tl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Natapos na ang pag-uusap na ito.',
      agentConnected: 'Matagumpay kang naikonekta sa isang ahente.',
      downloadTranscript: 'I-download ang transcript',
      startNewConversation: 'Magsimula ng bagong pag-uusap',
      returnToConversation: 'Bumalik sa pag-uusap',
      connecting: 'Kumokonekta...',
      retry: 'Subukan ulit',
      reconnecting: 'Kumokonekta muli...',
      connectionLost: 'Nawala ang koneksyon sa internet',
      reconnectDescription:
        'Nawala ang koneksyon sa internet. I-click ang Kumonekta muli para subukang muli.',
      typeMessage: 'Mag-type ng mensahe',
      inputSelect: 'Pumili ng opsyon',
      inputSelectOrType: 'Pumili ng opsyon o mag-type ng mensahe',
      secureInput: 'Mag-type ng secure na mensahe',
      secureValueHidden: 'Nakatagong secure na halaga',
      redactedValue: 'Nakatagong personal na impormasyon',
      startChat: 'Magsimula ng chat',
      settings: 'Mga setting',
      cancel: 'Kanselahin',
      confirm: 'Kumpirmahin',
      close: 'Isara',
      next: 'Susunod',
      brandingTagline:
        'Palakasin ang iyong negosyo gamit ang matatalinong AI agent',
      poweredBy: 'Pinapagana ng',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Nag-iisip ang assistant',
      youSaid: 'Sinabi mo',
      botSays: 'Sinabi ng assistant',
      agentSays: 'Sinabi ni {{name}}',
      joinMeeting: 'Sumali sa meeting',
      meetingInProgress: 'Isinasagawa ang meeting — i-click para sumali muli',
      meetingExpired: 'Link ng meeting (nag-expire na)',
      embeddedContent: 'Naka-embed na nilalaman',
      openInNewTab: 'Buksan sa bagong tab',
      skipToMain: 'Lumaktaw sa pangunahing nilalaman',
      customerLogoAlt: 'Logo ng {{customerName}}',
      selectDate: 'Pumili ng petsa',
      selectTime: 'Pumili ng oras',
      browseOptions: 'Mag-browse ng mga opsyon',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} ng {{total}}',
      carouselPrevious: 'Nakaraang item',
      carouselNext: 'Susunod na item',
      carouselGoToItem: 'Pumunta sa item {{index}}',
      collapse: 'I-collapse',
      expand: 'I-expand',
      messageHistory: 'Kasaysayan ng mensahe',
      reduce: 'Paliitin',
      today: 'Ngayon',
      at: 'nang',
      a11yOptionsCount_one: 'May 1 opsyon.',
      a11yOptionsCount_other: 'May {{count}} na opsyon.',
      listpickerSelectAll: 'Piliin lahat',
      listpickerSelectOption: 'Pumili ng opsyon',
      listpickerSearchAriaLabel: 'Maghanap ng mga opsyon sa filter',
      listpickerSearchPlaceholder: 'Maghanap…',
      listpickerNoResults: 'Walang tumutugmang opsyon.',
      listpickerResults_one: '1 resulta',
      listpickerResults_other: '{{count}} na resulta',
      listpickerCondensed_one: '1 napili',
      listpickerCondensed_other: '{{count}} napili',
      scrollToLatest: 'Mag-scroll sa pinakabagong mensahe',
      scrollToUnread_one: '1 bagong mensahe, pumunta sa pinakabago',
      scrollToUnread_other: '{{count}} bagong mensahe, pumunta sa pinakabago',
      showPassword: 'Ipakita ang secure na nilalaman',
      hidePassword: 'Itago ang secure na nilalaman',
      clear: 'I-clear',
      send: 'Ipadala',
      yesterday: 'Kahapon',
      chatEndedActions: 'Mga aksyon pagkatapos ng chat',
      openConversationDialog:
        'Buksan ang dialog ng pag-uusap kasama si {{title}}',
      agentTyping: 'Nagta-type ang ahente',
      agentAway: 'Kasalukuyang hindi available ang aming mga ahente.',
      agentBusy:
        'Kasalukuyang abala ang aming mga ahente. Mangyaring maghintay...',
      waitingForAgent: 'Ikinokonekta ka sa isang ahente...',
      waitingForAgentWithSkill:
        'Ikinokonekta ka sa isang ahente para sa {{skill}}...',
      talkingWithAgent: 'Nakikipag-usap kay {{name}}',
      home: 'Home',
      back: 'Bumalik',
      menu: 'Menu',
      minimize: 'I-minimize',
      endConversation: 'Tapusin ang pag-uusap',
      engageWithUs: 'Makipag-ugnayan sa amin',
      noMessagesYet: 'Wala pang mensahe',
      tryAgain: 'Subukan ulit',
      gettingLocation: 'Kinukuha ang kasalukuyang lokasyon...',
      locationSharedMessage: 'Ito ang aking lokasyon.',
      selectFile: 'Pumili ng file',
      upload: 'Mag-upload',
      uploadComplete: 'Kumpleto na ang pag-upload',
      uploadFailed: 'Nabigo ang pag-upload',
      fileTooLarge:
        'Ang file na ito ay masyadong malaki para i-upload. Mangyaring pumili ng file na mas mababa sa {{maxSize}}.',
      dragOrClick: 'Mag-drag ng file o mag-click para pumili',
      document: 'Dokumento',
      audioContent: 'Nilalamang audio',
      videoContent: 'Nilalamang video',
      videoUnsupported: 'Hindi mapatugtog ang video na ito sa iyong browser.',
      unsupportedContent: 'Hindi suportadong nilalaman',
      unavailable: {
        error: {
          title: 'May nangyaring mali',
          body: 'Hindi namin ma-load ang chat. Pakisubukan muli.',
          retry: 'Subukan ulit',
        },
        maintenance: {
          title: 'Pansamantalang hindi available ang chat',
          body: 'Nagsasagawa kami ng nakaiskedyul na maintenance. Bumalik ka mamaya.',
        },
      },
      image: 'Larawan',
      agentSharedImage: '{{name}} ay nagbahagi ng larawan: ',
      assistantSharedImage: '{{name}} ay nagbahagi ng larawan: ',
      starRating: 'Rating ng bituin',
      starRatingOrder: 'Bituin {{current}} sa {{total}}',
      submit: 'Isumite',
      closeConversationDialog: 'Isara ang pag-uusap',
      waitingForAgentDescription:
        'Mangyaring maghintay habang ikinokonekta ka namin sa isang ahente',
      agentTransferred: 'Inilipat ka sa ibang ahente.',
      uploadingFile: 'Nag-a-upload ka ng: {{fileName}}',
      uploadedFile: 'Nag-upload ka ng {{fileName}}',
      attachedFile: 'Nakalakip: {{fileName}}',
      fileTypeNotPermitted:
        'Paumanhin, hindi pinapayagan ang ganitong uri ng file.',
      relaunch: 'I-launch muli',
      screenReaderHintChrome:
        'Para sa pinakamahusay na karanasan sa screen reader sa Google Chrome, iminumungkahi naming gumamit ng JAWS.',
      screenReaderHintFirefox:
        'Para sa pinakamahusay na karanasan sa screen reader sa Firefox, iminumungkahi naming gumamit ng NVDA.',
      agentInitiatedCall: 'Nagsimula ng tawag si {{name}}',
      clickToJoin: 'I-click upang sumali',
      callSessionInProgress:
        'Ang iyong sesyon ng tawag ay kasalukuyang nagaganap',
      primaryNavigation: 'Nabigasyon',
      agentTypingNamed: '{{name}} ay nagta-type',
      agentSaysUnnamed: 'Sabi ng ahente',
      botIsThinkingNamed: 'Nag-iisip si {{name}}',
      talkingWithAgentUnnamed: 'Kausap ang isang ahente',
      download: 'I-download',
      downloading: 'Nagda-download',
      downloadComplete: 'Kumpleto na ang pag-download',
      downloadFailed: 'Nabigo ang pag-download',
      attachFile: 'Maglakip ng file',
      removeAttachment: 'Alisin ang lakip',
      uploadFailedConnection:
        'Nabigo ang pag-upload. Suriin ang iyong koneksyon.',
      fileTooLargeToUpload:
        'Ang file na ito ay masyadong malaki para i-upload. Mangyaring pumili ng file na mas mababa sa {{maxSize}}.',
      problemUploadingFile:
        'Nagkaroon ng problema sa pag-upload ng iyong file.',
      attachmentRemoved: 'Inalis ang lakip.',
      tomorrow: 'Bukas',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Pangunahing menu',
      goBack: 'Bumalik',
      expandInSameWindow: 'Palawakin sa parehong window',
      collapseDialog: 'I-collapse ang Dialog',
      closeDialog: 'Isara ang Dialog',
    },
  },
  {
    lang: 'tr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Bu görüşme sona erdi.',
      agentConnected: 'Bir temsilciye başarıyla bağlandınız.',
      downloadTranscript: 'Dökümü indir',
      startNewConversation: 'Yeni görüşme başlat',
      returnToConversation: 'Görüşmeye dön',
      connecting: 'Bağlanıyor...',
      retry: 'Tekrar dene',
      reconnecting: 'Yeniden bağlanıyor...',
      connectionLost: 'İnternet bağlantısı kesildi',
      reconnectDescription:
        "İnternet bağlantısı kesildi. Yeniden denemek için Yeniden bağlan'a tıklayın.",
      typeMessage: 'Mesaj yazın',
      inputSelect: 'Bir seçenek belirleyin',
      inputSelectOrType: 'Bir seçenek belirleyin veya mesaj yazın',
      secureInput: 'Güvenli mesaj yazın',
      secureValueHidden: 'Gizli güvenli değer',
      redactedValue: 'Gizlenen kişisel bilgiler',
      startChat: 'Sohbeti başlat',
      settings: 'Ayarlar',
      cancel: 'İptal',
      confirm: 'Onayla',
      close: 'Kapat',
      next: 'İleri',
      brandingTagline: 'İşinizi akıllı yapay zeka aracılarıyla güçlendirin',
      poweredBy: 'Destekleyen',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Asistan düşünüyor',
      youSaid: 'Şöyle dediniz',
      botSays: 'Asistan diyor ki',
      agentSays: '{{name}} diyor ki',
      joinMeeting: 'Toplantıya katıl',
      meetingInProgress:
        'Toplantı devam ediyor — yeniden katılmak için tıklayın',
      meetingExpired: 'Toplantı bağlantısı (süresi doldu)',
      embeddedContent: 'Gömülü içerik',
      openInNewTab: 'Yeni sekmede aç',
      skipToMain: 'Ana içeriğe geç',
      customerLogoAlt: '{{customerName}} logosu',
      selectDate: 'Tarih seçin',
      selectTime: 'Saat seçin',
      browseOptions: 'Seçeneklere göz atın',
      carouselRoleDescription: 'Atlıkarınca',
      carouselSlideLabel: 'Slayt {{current}} / {{total}}',
      carouselPrevious: 'Önceki öğe',
      carouselNext: 'Sonraki öğe',
      carouselGoToItem: '{{index}}. öğeye git',
      collapse: 'Daralt',
      expand: 'Genişlet',
      messageHistory: 'Mesaj geçmişi',
      reduce: 'Küçült',
      today: 'Bugün',
      at: 'saat',
      a11yOptionsCount_one: '1 seçenek var.',
      a11yOptionsCount_other: '{{count}} seçenek var.',
      listpickerSelectAll: 'Tümünü seç',
      listpickerSelectOption: 'Bir seçenek belirleyin',
      listpickerSearchAriaLabel: 'Filtre seçeneklerinde ara',
      listpickerSearchPlaceholder: 'Ara…',
      listpickerNoResults: 'Eşleşen seçenek yok.',
      listpickerResults_one: '1 sonuç',
      listpickerResults_other: '{{count}} sonuç',
      listpickerCondensed_one: '1 seçildi',
      listpickerCondensed_other: '{{count}} seçildi',
      scrollToLatest: 'En son mesaja kaydır',
      scrollToUnread_one: '1 yeni mesaj, en sona kaydır',
      scrollToUnread_other: '{{count}} yeni mesaj, en sona kaydır',
      showPassword: 'Güvenli içeriği göster',
      hidePassword: 'Güvenli içeriği gizle',
      clear: 'Temizle',
      send: 'Gönder',
      yesterday: 'Dün',
      chatEndedActions: 'Sohbet sonu işlemleri',
      openConversationDialog: '{{title}} ile görüşme penceresini aç',
      agentTyping: 'Temsilci yazıyor',
      agentAway: 'Temsilcilerimiz şu anda uygun değil.',
      agentBusy: 'Temsilcilerimiz şu anda meşgul. Lütfen bekleyin...',
      waitingForAgent: 'Sizi bir temsilciye bağlıyoruz...',
      waitingForAgentWithSkill: 'Sizi bir {{skill}} temsilcisine bağlıyoruz...',
      talkingWithAgent: '{{name}} ile görüşülüyor',
      home: 'Ana sayfa',
      back: 'Geri',
      menu: 'Menü',
      minimize: 'Simge durumuna küçült',
      endConversation: 'Konuşmayı Sonlandır',
      engageWithUs: 'Bizimle iletişime geçin',
      noMessagesYet: 'Henüz mesaj yok',
      tryAgain: 'Tekrar dene',
      gettingLocation: 'Mevcut konum alınıyor...',
      locationSharedMessage: 'İşte konumum.',
      selectFile: 'Bir dosya seçin',
      upload: 'Yükle',
      uploadComplete: 'Yükleme tamamlandı',
      uploadFailed: 'Yükleme başarısız',
      fileTooLarge:
        'Bu dosya yüklemek için çok büyük. Lütfen {{maxSize}}’tan küçük bir dosya seçin.',
      dragOrClick: 'Bir dosya sürükleyin veya seçmek için tıklayın',
      document: 'Belge',
      audioContent: 'Ses içeriği',
      videoContent: 'Video içeriği',
      videoUnsupported: 'Bu video tarayıcınızda oynatılamıyor.',
      unsupportedContent: 'Desteklenmeyen içerik',
      unavailable: {
        error: {
          title: 'Bir şeyler ters gitti',
          body: 'Sohbet yüklenemedi. Lütfen tekrar deneyin.',
          retry: 'Tekrar dene',
        },
        maintenance: {
          title: 'Sohbet geçici olarak kullanılamıyor',
          body: 'Planlı bakım gerçekleştiriyoruz. Lütfen kısa süre sonra tekrar gelin.',
        },
      },
      image: 'Görsel',
      agentSharedImage: '{{name}} bir resim paylaştı: ',
      assistantSharedImage: '{{name}} bir resim paylaştı: ',
      starRating: 'Yıldız değerlendirmesi',
      starRatingOrder: '{{current}}/{{total}} yıldız',
      submit: 'Gönder',
      closeConversationDialog: 'Konuşmayı kapat',
      waitingForAgentDescription:
        'Sizi bir temsilciye bağlarken lütfen bekleyin',
      agentTransferred: 'Başka bir temsilciye aktarıldınız.',
      uploadingFile: 'Yükleniyor: {{fileName}}',
      uploadedFile: '{{fileName}} dosyasını yüklediniz',
      attachedFile: 'Eklendi: {{fileName}}',
      fileTypeNotPermitted: 'Üzgünüz, bu dosya türüne izin verilmiyor.',
      relaunch: 'Tekrar Başlat',
      screenReaderHintChrome:
        'Google Chrome’da en iyi ekran okuyucu deneyimi için JAWS kullanmanızı öneririz.',
      screenReaderHintFirefox:
        'Firefox’ta en iyi ekran okuyucu deneyimi için NVDA kullanmanızı öneririz.',
      agentInitiatedCall: '{{name}} bir çağrı başlattı',
      clickToJoin: 'Katılmak için tıklayın',
      callSessionInProgress: 'Çağrı oturumunuz devam ediyor',
      primaryNavigation: 'Gezinme',
      agentTypingNamed: '{{name}} yazıyor',
      agentSaysUnnamed: 'Temsilci diyor',
      botIsThinkingNamed: '{{name}} düşünüyor',
      talkingWithAgentUnnamed: 'Bir temsilciyle görüşülüyor',
      download: 'İndir',
      downloading: 'İndiriliyor',
      downloadComplete: 'İndirme tamamlandı',
      downloadFailed: 'İndirme başarısız',
      attachFile: 'Dosya ekle',
      removeAttachment: 'Eki kaldır',
      uploadFailedConnection: 'Yükleme başarısız. Bağlantınızı kontrol edin.',
      fileTooLargeToUpload:
        'Bu dosya yüklemek için çok büyük. Lütfen {{maxSize}}’tan küçük bir dosya seçin.',
      problemUploadingFile: 'Dosyanız yüklenirken bir sorun oluştu.',
      attachmentRemoved: 'Ek kaldırıldı.',
      tomorrow: 'Yarın',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Ana Menü',
      goBack: 'Geri git',
      expandInSameWindow: 'Aynı pencerede genişlet',
      collapseDialog: 'Diyaloğu Daralt',
      closeDialog: 'Diyaloğu Kapat',
    },
  },
  {
    lang: 'uk',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Цю розмову завершено.',
      agentConnected: "Вас успішно з'єднано з оператором.",
      downloadTranscript: 'Завантажити стенограму',
      startNewConversation: 'Розпочати нову розмову',
      returnToConversation: 'Повернутися до розмови',
      connecting: "З'єднання...",
      retry: 'Повторити',
      reconnecting: "Повторне з'єднання...",
      connectionLost: "З'єднання з інтернетом втрачено",
      reconnectDescription:
        "З'єднання з інтернетом втрачено. Натисніть «Перепідключитися», щоб повторити.",
      typeMessage: 'Введіть повідомлення',
      inputSelect: 'Виберіть варіант',
      inputSelectOrType: 'Виберіть варіант або введіть повідомлення',
      secureInput: 'Введіть захищене повідомлення',
      secureValueHidden: 'Приховане захищене значення',
      redactedValue: 'Приховані персональні дані',
      startChat: 'Почати чат',
      settings: 'Налаштування',
      cancel: 'Скасувати',
      confirm: 'Підтвердити',
      close: 'Закрити',
      next: 'Далі',
      brandingTagline:
        'Прискорте свій бізнес за допомогою інтелектуальних ШІ-агентів',
      poweredBy: 'Працює на',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Асистент думає',
      youSaid: 'Ви сказали',
      botSays: 'Асистент каже',
      agentSays: '{{name}} каже',
      joinMeeting: 'Приєднатися до зустрічі',
      meetingInProgress: 'Зустріч триває — натисніть, щоб приєднатися знову',
      meetingExpired: 'Посилання на зустріч (застаріле)',
      embeddedContent: 'Вбудований вміст',
      openInNewTab: 'Відкрити в новій вкладці',
      skipToMain: 'Перейти до основного вмісту',
      customerLogoAlt: 'Логотип {{customerName}}',
      selectDate: 'Виберіть дату',
      selectTime: 'Виберіть час',
      browseOptions: 'Переглянути варіанти',
      carouselRoleDescription: 'Карусель',
      carouselSlideLabel: 'Слайд {{current}} з {{total}}',
      carouselPrevious: 'Попередній елемент',
      carouselNext: 'Наступний елемент',
      carouselGoToItem: 'Перейти до елемента {{index}}',
      collapse: 'Згорнути',
      expand: 'Розгорнути',
      messageHistory: 'Історія повідомлень',
      reduce: 'Зменшити',
      today: 'Сьогодні',
      at: 'о',
      a11yOptionsCount_one: 'Є 1 варіант.',
      a11yOptionsCount_few: 'Є {{count}} варіанти.',
      a11yOptionsCount_many: 'Є {{count}} варіантів.',
      a11yOptionsCount_other: 'Є {{count}} варіанта.',
      listpickerSelectAll: 'Вибрати все',
      listpickerSelectOption: 'Виберіть варіант',
      listpickerSearchAriaLabel: 'Пошук параметрів фільтра',
      listpickerSearchPlaceholder: 'Пошук…',
      listpickerNoResults: 'Немає відповідних варіантів.',
      listpickerResults_one: '1 результат',
      listpickerResults_few: '{{count}} результати',
      listpickerResults_many: '{{count}} результатів',
      listpickerResults_other: '{{count}} результату',
      listpickerCondensed_one: 'Вибрано 1',
      listpickerCondensed_few: 'Вибрано {{count}}',
      listpickerCondensed_many: 'Вибрано {{count}}',
      listpickerCondensed_other: 'Вибрано {{count}}',
      scrollToLatest: 'Перейти до останнього повідомлення',
      scrollToUnread_one: '1 нове повідомлення, до останнього',
      scrollToUnread_few: '{{count}} нові повідомлення, до останнього',
      scrollToUnread_many: '{{count}} нових повідомлень, до останнього',
      scrollToUnread_other: '{{count}} нового повідомлення, до останнього',
      showPassword: 'Показати захищений вміст',
      hidePassword: 'Приховати захищений вміст',
      clear: 'Очистити',
      send: 'Надіслати',
      yesterday: 'Учора',
      chatEndedActions: 'Дії після завершення чату',
      openConversationDialog: 'Відкрити вікно розмови з {{title}}',
      agentTyping: 'Оператор друкує',
      agentAway: 'Наші оператори наразі недоступні.',
      agentBusy: 'Наші оператори наразі зайняті. Зачекайте, будь ласка...',
      waitingForAgent: "З'єднуємо вас з оператором...",
      waitingForAgentWithSkill:
        "З'єднуємо вас з оператором із питання «{{skill}}»...",
      talkingWithAgent: 'Розмова з {{name}}',
      home: 'Головна',
      back: 'Назад',
      menu: 'Меню',
      minimize: 'Згорнути',
      endConversation: 'Завершити розмову',
      engageWithUs: "Зв'яжіться з нами",
      noMessagesYet: 'Повідомлень поки немає',
      tryAgain: 'Спробувати ще раз',
      gettingLocation: 'Отримання поточного місцезнаходження...',
      locationSharedMessage: 'Ось моє місцезнаходження.',
      selectFile: 'Виберіть файл',
      upload: 'Завантажити',
      uploadComplete: 'Завантаження завершено',
      uploadFailed: 'Завантаження не вдалося',
      fileTooLarge:
        'Цей файл занадто великий для завантаження. Будь ласка, оберіть файл менше {{maxSize}}.',
      dragOrClick: 'Перетягніть файл або натисніть, щоб вибрати',
      document: 'Документ',
      audioContent: 'Аудіовміст',
      videoContent: 'Відеовміст',
      videoUnsupported: 'Це відео не може бути відтворене у вашому браузері.',
      unsupportedContent: 'Непідтримуваний вміст',
      unavailable: {
        error: {
          title: 'Щось пішло не так',
          body: 'Не вдалося завантажити чат. Спробуйте ще раз.',
          retry: 'Спробувати ще раз',
        },
        maintenance: {
          title: 'Чат тимчасово недоступний',
          body: 'Ми проводимо планове обслуговування. Завітайте пізніше.',
        },
      },
      image: 'Зображення',
      agentSharedImage: '{{name}} поділився зображенням: ',
      assistantSharedImage: '{{name}} поділився зображенням: ',
      starRating: 'Оцінка зірками',
      starRatingOrder: '{{current}} з {{total}} зірок',
      submit: 'Надіслати',
      closeConversationDialog: 'Закрити розмову',
      waitingForAgentDescription:
        "Будь ласка, зачекайте, поки ми з'єднаємо вас з агентом",
      agentTransferred: 'Вас переведено до іншого оператора.',
      uploadingFile: 'Ви завантажуєте: {{fileName}}',
      uploadedFile: 'Ви завантажили {{fileName}}',
      attachedFile: 'Прикріплено: {{fileName}}',
      fileTypeNotPermitted: 'Вибачте, цей тип файлу не дозволено.',
      relaunch: 'Перезапустити',
      screenReaderHintChrome:
        'Для найкращого досвіду використання програми зчитування з екрана у Google Chrome рекомендуємо використовувати JAWS.',
      screenReaderHintFirefox:
        'Для найкращого досвіду використання програми зчитування з екрана у Firefox рекомендуємо використовувати NVDA.',
      agentInitiatedCall: '{{name}} розпочав дзвінок',
      clickToJoin: 'Натисніть, щоб приєднатися',
      callSessionInProgress: 'Ваш дзвінок триває',
      primaryNavigation: 'Навігація',
      agentTypingNamed: '{{name}} друкує',
      agentSaysUnnamed: 'Агент каже',
      botIsThinkingNamed: '{{name}} думає',
      talkingWithAgentUnnamed: 'Розмова з агентом',
      download: 'Завантажити',
      downloading: 'Завантаження',
      downloadComplete: 'Завантаження завершено',
      downloadFailed: 'Не вдалося завантажити',
      attachFile: 'Прикріпити файл',
      removeAttachment: 'Видалити вкладення',
      uploadFailedConnection: 'Не вдалося завантажити. Перевірте з’єднання.',
      fileTooLargeToUpload:
        'Цей файл занадто великий для завантаження. Будь ласка, оберіть файл менше {{maxSize}}.',
      problemUploadingFile: 'Виникла проблема при завантаженні вашого файлу.',
      attachmentRemoved: 'Вкладення видалено.',
      tomorrow: 'Завтра',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Головне меню',
      goBack: 'Назад',
      expandInSameWindow: 'Розгорнути в тому ж вікні',
      collapseDialog: 'Згорнути діалог',
      closeDialog: 'Закрити діалог',
    },
  },
  {
    lang: 'ur',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'یہ گفتگو ختم ہو گئی ہے۔',
      agentConnected: 'آپ کامیابی سے ایک ایجنٹ سے منسلک ہو گئے ہیں۔',
      downloadTranscript: 'ٹرانسکرپٹ ڈاؤن لوڈ کریں',
      startNewConversation: 'نئی گفتگو شروع کریں',
      returnToConversation: 'گفتگو پر واپس جائیں',
      connecting: 'منسلک ہو رہا ہے...',
      retry: 'دوبارہ کوشش کریں',
      reconnecting: 'دوبارہ منسلک ہو رہا ہے...',
      connectionLost: 'انٹرنیٹ کنکشن ختم ہو گیا',
      reconnectDescription:
        "انٹرنیٹ کنکشن ختم ہو گیا۔ دوبارہ کوشش کے لیے 'دوبارہ منسلک کریں' پر کلک کریں۔",
      typeMessage: 'پیغام ٹائپ کریں',
      inputSelect: 'ایک آپشن منتخب کریں',
      inputSelectOrType: 'ایک آپشن منتخب کریں یا پیغام ٹائپ کریں',
      secureInput: 'محفوظ پیغام ٹائپ کریں',
      secureValueHidden: 'چھپی ہوئی محفوظ قدر',
      redactedValue: 'چھپی ہوئی ذاتی معلومات',
      startChat: 'چیٹ شروع کریں',
      settings: 'ترتیبات',
      cancel: 'منسوخ کریں',
      confirm: 'تصدیق کریں',
      close: 'بند کریں',
      next: 'اگلا',
      brandingTagline: 'ذہین AI ایجنٹس کے ساتھ اپنے کاروبار کو تقویت دیں',
      poweredBy: 'کے ذریعے',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'اسسٹنٹ سوچ رہا ہے',
      youSaid: 'آپ نے کہا',
      botSays: 'اسسٹنٹ کہتا ہے',
      agentSays: '{{name}} کہتے ہیں',
      joinMeeting: 'میٹنگ میں شامل ہوں',
      meetingInProgress: 'میٹنگ جاری ہے — دوبارہ شامل ہونے کے لیے کلک کریں',
      meetingExpired: 'میٹنگ لنک (میعاد ختم)',
      embeddedContent: 'سرایت شدہ مواد',
      openInNewTab: 'نئے ٹیب میں کھولیں',
      skipToMain: 'مرکزی مواد پر جائیں',
      customerLogoAlt: '{{customerName}} کا لوگو',
      selectDate: 'تاریخ منتخب کریں',
      selectTime: 'وقت منتخب کریں',
      browseOptions: 'اختیارات دیکھیں',
      carouselRoleDescription: 'کیروسل',
      carouselSlideLabel: 'سلائیڈ {{current}} از {{total}}',
      carouselPrevious: 'پچھلا آئٹم',
      carouselNext: 'اگلا آئٹم',
      carouselGoToItem: 'آئٹم {{index}} پر جائیں',
      collapse: 'سکیڑیں',
      expand: 'پھیلائیں',
      messageHistory: 'پیغام کی تاریخ',
      reduce: 'چھوٹا کریں',
      today: 'آج',
      at: 'بوقت',
      a11yOptionsCount_one: '1 آپشن ہے۔',
      a11yOptionsCount_other: '{{count}} آپشنز ہیں۔',
      listpickerSelectAll: 'سب منتخب کریں',
      listpickerSelectOption: 'ایک آپشن منتخب کریں',
      listpickerSearchAriaLabel: 'فلٹر اختیارات تلاش کریں',
      listpickerSearchPlaceholder: 'تلاش کریں…',
      listpickerNoResults: 'کوئی مماثل اختیار نہیں۔',
      listpickerResults_one: '1 نتیجہ',
      listpickerResults_other: '{{count}} نتائج',
      listpickerCondensed_one: '1 منتخب',
      listpickerCondensed_other: '{{count}} منتخب',
      scrollToLatest: 'تازہ ترین پیغام پر سکرول کریں',
      scrollToUnread_one: '1 نیا پیغام، تازہ ترین پر جائیں',
      scrollToUnread_other: '{{count}} نئے پیغامات، تازہ ترین پر جائیں',
      showPassword: 'محفوظ مواد دکھائیں',
      hidePassword: 'محفوظ مواد چھپائیں',
      clear: 'صاف کریں',
      send: 'بھیجیں',
      yesterday: 'کل',
      chatEndedActions: 'چیٹ ختم ہونے کے بعد کے اعمال',
      openConversationDialog: '{{title}} کے ساتھ گفتگو کا ڈائیلاگ کھولیں',
      agentTyping: 'ایجنٹ ٹائپ کر رہا ہے',
      agentAway: 'ہمارے ایجنٹس اس وقت دستیاب نہیں ہیں۔',
      agentBusy: 'ہمارے ایجنٹس اس وقت مصروف ہیں۔ براہ کرم انتظار کریں...',
      waitingForAgent: 'آپ کو ایک ایجنٹ سے منسلک کیا جا رہا ہے...',
      waitingForAgentWithSkill:
        'آپ کو {{skill}} کے ایجنٹ سے منسلک کیا جا رہا ہے...',
      talkingWithAgent: '{{name}} سے گفتگو',
      home: 'ہوم',
      back: 'واپس',
      menu: 'مینو',
      minimize: 'چھوٹا کریں',
      endConversation: 'گفتگو ختم کریں',
      engageWithUs: 'ہم سے رابطہ کریں',
      noMessagesYet: 'ابھی تک کوئی پیغام نہیں',
      tryAgain: 'دوبارہ کوشش کریں',
      gettingLocation: 'موجودہ مقام حاصل کر رہا ہے...',
      locationSharedMessage: 'یہ میرا مقام ہے۔',
      selectFile: 'ایک فائل منتخب کریں',
      upload: 'اپ لوڈ کریں',
      uploadComplete: 'اپ لوڈ مکمل',
      uploadFailed: 'اپ لوڈ ناکام ہو گیا۔',
      fileTooLarge:
        'یہ فائل اپ لوڈ کرنے کے لیے بہت بڑی ہے۔ براہ کرم {{maxSize}} سے کم فائل منتخب کریں۔',
      dragOrClick: 'فائل گھسیٹیں یا منتخب کرنے کے لیے کلک کریں',
      document: 'دستاویز',
      audioContent: 'آڈیو مواد',
      videoContent: 'ویڈیو مواد',
      videoUnsupported: 'یہ ویڈیو آپ کے براؤزر میں نہیں چلائی جا سکتی۔',
      unsupportedContent: 'غیر معاون مواد',
      unavailable: {
        error: {
          title: 'کچھ غلط ہو گیا',
          body: 'ہم چیٹ لوڈ نہیں کر سکے۔ براہ کرم دوبارہ کوشش کریں۔',
          retry: 'دوبارہ کوشش کریں',
        },
        maintenance: {
          title: 'چیٹ عارضی طور پر دستیاب نہیں',
          body: 'ہم طے شدہ دیکھ بھال کر رہے ہیں۔ براہ کرم جلد واپس آئیں۔',
        },
      },
      image: 'تصویر',
      agentSharedImage: '{{name}} نے ایک تصویر شیئر کی۔',
      assistantSharedImage: '{{name}} نے ایک تصویر شیئر کی۔',
      starRating: 'ستارے کی درجہ بندی',
      starRatingOrder: '{{total}} ستاروں میں سے {{current}}',
      submit: 'جمع کرائیں',
      closeConversationDialog: 'گفتگو بند کریں۔',
      waitingForAgentDescription:
        'براہ کرم انتظار کریں جب تک ہم آپ کو ایجنٹ سے جوڑتے ہیں',
      agentTransferred: 'آپ کو دوسرے ایجنٹ کے پاس منتقل کر دیا گیا ہے۔',
      uploadingFile: 'آپ اپ لوڈ کر رہے ہیں : {{fileName}}',
      uploadedFile: 'آپ نے اپ لوڈ کیا۔ {{fileName}}',
      attachedFile: 'منسلک : {{fileName}}',
      fileTypeNotPermitted: 'معذرت، اس فائل کی قسم کی اجازت نہیں ہے۔',
      relaunch: 'دوبارہ شروع کریں',
      screenReaderHintChrome:
        'Google Chrome میں سکرین ریڈر کے بہترین تجربے کے لیے، ہم JAWS استعمال کرنے کا مشورہ دیتے ہیں۔',
      screenReaderHintFirefox:
        'Firefox میں سکرین ریڈر کے بہترین تجربے کے لیے، ہم NVDA استعمال کرنے کا مشورہ دیتے ہیں۔',
      agentInitiatedCall: '{{name}} نے کال شروع کی ہے',
      clickToJoin: 'شامل ہونے کے لیے کلک کریں',
      callSessionInProgress: 'آپ کا کال سیشن جاری ہے',
      primaryNavigation: 'نیویگیشن',
      agentTypingNamed: 'ٹائپ کر رہا ہے۔ {{name}}',
      agentSaysUnnamed: 'ایجنٹ کہتا ہے',
      botIsThinkingNamed: '{{name}} سوچ رہا ہے',
      talkingWithAgentUnnamed: 'ایک ایجنٹ سے بات ہو رہی ہے',
      download: 'ڈاؤن لوڈ کریں',
      downloading: 'ڈاؤن لوڈ ہو رہا ہے',
      downloadComplete: 'ڈاؤن لوڈ مکمل',
      downloadFailed: 'ڈاؤن لوڈ ناکام',
      attachFile: 'فائل منسلک کریں',
      removeAttachment: 'منسلکہ ہٹائیں',
      uploadFailedConnection: 'اپ لوڈ ناکام۔ اپنا کنکشن چیک کریں۔',
      fileTooLargeToUpload:
        'یہ فائل اپ لوڈ کرنے کے لیے بہت بڑی ہے۔ براہ کرم {{maxSize}} سے کم فائل منتخب کریں۔',
      problemUploadingFile: 'آپ کی فائل اپ لوڈ کرنے میں ایک مسئلہ تھا۔',
      attachmentRemoved: 'منسلکہ ہٹا دیا گیا۔',
      tomorrow: 'کل',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'ہوم مینو',
      goBack: 'واپس جاؤ',
      expandInSameWindow: 'اسی ونڈو میں پھیلائیں۔',
      collapseDialog: 'ڈائیلاگ کو سکیڑیں۔',
      closeDialog: 'ڈائیلاگ بند کریں۔',
    },
  },
  {
    lang: 'vi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Cuộc trò chuyện này đã kết thúc.',
      agentConnected: 'Bạn đã được kết nối thành công với nhân viên hỗ trợ.',
      downloadTranscript: 'Tải xuống bản ghi',
      startNewConversation: 'Bắt đầu cuộc trò chuyện mới',
      returnToConversation: 'Quay lại cuộc trò chuyện',
      connecting: 'Đang kết nối...',
      retry: 'Thử lại',
      reconnecting: 'Đang kết nối lại...',
      connectionLost: 'Đã mất kết nối internet',
      reconnectDescription:
        'Đã mất kết nối internet. Nhấp vào Kết nối lại để thử lại.',
      typeMessage: 'Nhập tin nhắn',
      inputSelect: 'Chọn một tùy chọn',
      inputSelectOrType: 'Chọn một tùy chọn hoặc nhập tin nhắn',
      secureInput: 'Nhập tin nhắn bảo mật',
      secureValueHidden: 'Giá trị bảo mật ẩn',
      redactedValue: 'Thông tin cá nhân đã ẩn',
      startChat: 'Bắt đầu trò chuyện',
      settings: 'Cài đặt',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      close: 'Đóng',
      next: 'Tiếp theo',
      brandingTagline:
        'Tăng cường doanh nghiệp của bạn với các tác nhân AI thông minh',
      poweredBy: 'Được cung cấp bởi',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'Trợ lý đang suy nghĩ',
      youSaid: 'Bạn đã nói',
      botSays: 'Trợ lý nói',
      agentSays: '{{name}} nói',
      joinMeeting: 'Tham gia cuộc họp',
      meetingInProgress: 'Cuộc họp đang diễn ra — nhấp để tham gia lại',
      meetingExpired: 'Liên kết cuộc họp (đã hết hạn)',
      embeddedContent: 'Nội dung nhúng',
      openInNewTab: 'Mở trong tab mới',
      skipToMain: 'Chuyển đến nội dung chính',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Chọn ngày',
      selectTime: 'Chọn giờ',
      browseOptions: 'Duyệt các tùy chọn',
      carouselRoleDescription: 'Băng chuyền',
      carouselSlideLabel: 'Trang chiếu {{current}} trên {{total}}',
      carouselPrevious: 'Mục trước',
      carouselNext: 'Mục tiếp theo',
      carouselGoToItem: 'Đến mục {{index}}',
      collapse: 'Thu gọn',
      expand: 'Mở rộng',
      messageHistory: 'Lịch sử tin nhắn',
      reduce: 'Thu nhỏ',
      today: 'Hôm nay',
      at: 'lúc',
      a11yOptionsCount_other: 'Có {{count}} tùy chọn.',
      listpickerSelectAll: 'Chọn tất cả',
      listpickerSelectOption: 'Chọn một tùy chọn',
      listpickerSearchAriaLabel: 'Tìm kiếm tùy chọn bộ lọc',
      listpickerSearchPlaceholder: 'Tìm kiếm…',
      listpickerNoResults: 'Không có tùy chọn nào phù hợp.',
      listpickerResults_other: '{{count}} kết quả',
      listpickerCondensed_other: 'Đã chọn {{count}}',
      scrollToLatest: 'Cuộn đến tin nhắn mới nhất',
      scrollToUnread_other: '{{count}} tin nhắn mới, cuộn đến mới nhất',
      showPassword: 'Hiện nội dung bảo mật',
      hidePassword: 'Ẩn nội dung bảo mật',
      clear: 'Xóa',
      send: 'Gửi',
      yesterday: 'Hôm qua',
      chatEndedActions: 'Hành động sau khi trò chuyện kết thúc',
      openConversationDialog: 'Mở hộp thoại trò chuyện với {{title}}',
      agentTyping: 'Nhân viên đang nhập',
      agentAway: 'Nhân viên của chúng tôi hiện không có mặt.',
      agentBusy: 'Nhân viên của chúng tôi hiện đang bận. Vui lòng chờ...',
      waitingForAgent: 'Đang kết nối bạn với nhân viên hỗ trợ...',
      waitingForAgentWithSkill: 'Đang kết nối bạn với nhân viên {{skill}}...',
      talkingWithAgent: 'Đang trò chuyện với {{name}}',
      home: 'Trang chủ',
      back: 'Quay lại',
      menu: 'Menu',
      minimize: 'Thu nhỏ',
      endConversation: 'Kết thúc cuộc trò chuyện',
      engageWithUs: 'Liên hệ với chúng tôi',
      noMessagesYet: 'Chưa có tin nhắn',
      tryAgain: 'Thử lại',
      gettingLocation: 'Đang lấy vị trí hiện tại...',
      locationSharedMessage: 'Đây là vị trí của tôi.',
      selectFile: 'Chọn tệp',
      upload: 'Tải lên',
      uploadComplete: 'Tải lên hoàn tất',
      uploadFailed: 'Tải lên thất bại',
      fileTooLarge:
        'Tệp này quá lớn để tải lên. Vui lòng chọn tệp nhỏ hơn {{maxSize}}.',
      dragOrClick: 'Kéo tệp hoặc nhấp để chọn',
      document: 'Tài liệu',
      audioContent: 'Nội dung âm thanh',
      videoContent: 'Nội dung video',
      videoUnsupported: 'Không thể phát video này trên trình duyệt của bạn.',
      unsupportedContent: 'Nội dung không được hỗ trợ',
      unavailable: {
        error: {
          title: 'Đã xảy ra lỗi',
          body: 'Chúng tôi không thể tải cuộc trò chuyện. Vui lòng thử lại.',
          retry: 'Thử lại',
        },
        maintenance: {
          title: 'Trò chuyện tạm thời không khả dụng',
          body: 'Chúng tôi đang bảo trì theo lịch. Vui lòng quay lại sau.',
        },
      },
      image: 'Hình ảnh',
      agentSharedImage: '{{name}} đã chia sẻ một hình ảnh: ',
      assistantSharedImage: '{{name}} đã chia sẻ một hình ảnh: ',
      starRating: 'Đánh giá sao',
      starRatingOrder: 'Sao thứ {{current}} trên {{total}} sao',
      submit: 'Gửi',
      closeConversationDialog: 'Đóng cuộc trò chuyện',
      waitingForAgentDescription:
        'Vui lòng đợi trong khi chúng tôi kết nối bạn với một nhân viên hỗ trợ',
      agentTransferred: 'Bạn đã được chuyển sang một nhân viên khác.',
      uploadingFile: 'Bạn đang tải lên: {{fileName}}',
      uploadedFile: 'Bạn đã tải lên {{fileName}}',
      attachedFile: 'Đã đính kèm: {{fileName}}',
      fileTypeNotPermitted: 'Xin lỗi, loại tệp này không được phép.',
      relaunch: 'Khởi chạy lại',
      screenReaderHintChrome:
        'Để có trải nghiệm tốt nhất với trình đọc màn hình trên Google Chrome, chúng tôi đề xuất dùng JAWS.',
      screenReaderHintFirefox:
        'Để có trải nghiệm tốt nhất với trình đọc màn hình trên Firefox, chúng tôi đề xuất dùng NVDA.',
      agentInitiatedCall: '{{name}} đã bắt đầu một cuộc gọi',
      clickToJoin: 'Nhấn để tham gia',
      callSessionInProgress: 'Phiên cuộc gọi của bạn đang diễn ra',
      primaryNavigation: 'Điều hướng',
      agentTypingNamed: '{{name}} đang nhập',
      agentSaysUnnamed: 'Nhân viên nói',
      botIsThinkingNamed: '{{name}} đang suy nghĩ',
      talkingWithAgentUnnamed: 'Đang nói chuyện với nhân viên',
      download: 'Tải xuống',
      downloading: 'Đang tải xuống',
      downloadComplete: 'Tải xuống hoàn tất',
      downloadFailed: 'Tải xuống thất bại',
      attachFile: 'Đính kèm tệp',
      removeAttachment: 'Xóa tệp đính kèm',
      uploadFailedConnection: 'Tải lên thất bại. Kiểm tra kết nối của bạn.',
      fileTooLargeToUpload:
        'Tệp này quá lớn để tải lên. Vui lòng chọn tệp nhỏ hơn {{maxSize}}.',
      problemUploadingFile: 'Đã xảy ra sự cố khi tải tệp của bạn lên.',
      attachmentRemoved: 'Đã xóa tệp đính kèm.',
      tomorrow: 'Ngày mai',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'Menu trang chủ',
      goBack: 'Quay lại',
      expandInSameWindow: 'Mở rộng trong cùng cửa sổ',
      collapseDialog: 'Thu gọn hộp thoại',
      closeDialog: 'Đóng hộp thoại',
    },
  },
  {
    lang: 'yi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'די דאָזיקע שמועס האָט זיך געענדיקט.',
      agentConnected:
        'איר זײַט מיט דערפאָלג פֿאַרבונדן געוואָרן מיט אַן אַגענט.',
      downloadTranscript: 'אַראָפּלאָדן טראַנסקריפּט',
      startNewConversation: 'אָנהייבן אַ נײַע שמועס',
      returnToConversation: 'צוריק צו דער שמועס',
      connecting: 'פֿאַרבינדן...',
      retry: 'פּרוּווט נאָך אַ מאָל',
      reconnecting: 'פֿאַרבינדן זיך נאָך אַ מאָל...',
      connectionLost: 'די אינטערנעץ־פֿאַרבינדונג איז פֿאַרלוירן געוואָרן',
      reconnectDescription:
        'די אינטערנעץ־פֿאַרבינדונג איז פֿאַרלוירן געוואָרן. קליקט „פֿאַרבינדט זיך נאָך אַ מאָל“ צו פּרוּוון נאָך אַ מאָל.',
      typeMessage: 'שרײַבט אַ מעלדונג',
      inputSelect: 'קלײַבט אַן אָפּציע',
      inputSelectOrType: 'קלײַבט אַן אָפּציע אָדער שרײַבט אַ מעלדונג',
      secureInput: 'שרײַבט אַ זיכערע מעלדונג',
      secureValueHidden: 'באַהאַלטענער זיכערער ווערט',
      redactedValue: 'באַהאַלטענע פּערזענלעכע אינפֿאָרמאַציע',
      startChat: 'אָנהייבן שמועס',
      settings: 'אײַנשטעלונגען',
      cancel: 'אָפּזאָגן',
      confirm: 'באַשטעטיקן',
      close: 'פֿאַרמאַכן',
      next: 'ווײַטער',
      brandingTagline: 'שטאַרקט אײַער געשעפֿט מיט קלוגע KI־אַגענטן',
      poweredBy: 'אָנגעטריבן דורך',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: 'דער אַסיסטענט טראַכט',
      youSaid: 'איר האָט געזאָגט',
      botSays: 'דער אַסיסטענט זאָגט',
      agentSays: '{{name}} זאָגט',
      joinMeeting: 'בײַטרעטן צו דער זיצונג',
      meetingInProgress: 'די זיצונג גייט אָן — קליקט צו בײַטרעטן נאָך אַ מאָל',
      meetingExpired: 'זיצונג־לינק (אויסגעגאַנגען)',
      embeddedContent: 'אײַנגעבעטער אינהאַלט',
      openInNewTab: 'עפֿן אין אַ נײַעם טאַב',
      skipToMain: 'שפּרינגט צום הויפּט־אינהאַלט',
      customerLogoAlt: '{{customerName}} לאָגאָ',
      selectDate: 'קלײַבט אַ דאַטע',
      selectTime: 'קלײַבט אַ צײַט',
      browseOptions: 'בלעטערט אָפּציעס',
      carouselRoleDescription: 'קאַרוסעל',
      carouselSlideLabel: 'בילד {{current}} פֿון {{total}}',
      carouselPrevious: 'פֿריִערדיקער אײַנטראָג',
      carouselNext: 'ווײַטערדיקער אײַנטראָג',
      carouselGoToItem: 'גייט צו אײַנטראָג {{index}}',
      collapse: 'צונויפֿקלאַפּן',
      expand: 'פֿאַרברייטערן',
      messageHistory: 'מעלדונג־געשיכטע',
      reduce: 'פֿאַרקלענערן',
      today: 'הײַנט',
      at: '',
      a11yOptionsCount_one: 'עס איז דאָ 1 אָפּציע.',
      a11yOptionsCount_other: 'עס זײַנען דאָ {{count}} אָפּציעס.',
      listpickerSelectAll: 'קלײַבט אַלץ',
      listpickerSelectOption: 'קלײַבט אַן אָפּציע',
      listpickerSearchAriaLabel: 'זוכט פֿילטער־אָפּציעס',
      listpickerSearchPlaceholder: 'זוכן…',
      listpickerNoResults: 'קיין פּאַסיקע אָפּציעס.',
      listpickerResults_one: '1 רעזולטאַט',
      listpickerResults_other: '{{count}} רעזולטאַטן',
      listpickerCondensed_one: '1 געקליבן',
      listpickerCondensed_other: '{{count}} געקליבן',
      scrollToLatest: 'בלעטערט צו דער לעצטער מעלדונג',
      scrollToUnread_one: '1 נײַע מעלדונג, צו דער לעצטער',
      scrollToUnread_other: '{{count}} נײַע מעלדונגען, צו דער לעצטער',
      showPassword: 'ווײַזן זיכערן אינהאַלט',
      hidePassword: 'באַהאַלטן זיכערן אינהאַלט',
      clear: 'רייניקן',
      send: 'שיקן',
      yesterday: 'נעכטן',
      chatEndedActions: 'אַקציעס נאָך דעם ענד פֿון שמועס',
      openConversationDialog: 'עפֿן שמועס־דיאַלאָג מיט {{title}}',
      agentTyping: 'דער אַגענט שרײַבט',
      agentAway: 'אונדזערע אַגענטן זײַנען דערווײַל נישט צוטריטלעך.',
      agentBusy: 'אונדזערע אַגענטן זײַנען דערווײַל פֿאַרנומען. וואַרט ביטע...',
      waitingForAgent: 'מיר פֿאַרבינדן אײַך מיט אַן אַגענט...',
      waitingForAgentWithSkill:
        'מיר פֿאַרבינדן אײַך מיט אַ {{skill}}־אַגענט...',
      talkingWithAgent: 'רעדן מיט {{name}}',
      home: 'היים',
      back: 'צוריק',
      menu: 'מעניו',
      minimize: 'פֿאַרקלענערן',
      endConversation: 'ענדיקן שמועס',
      engageWithUs: 'פֿאַרבינדט זיך מיט אונדז',
      noMessagesYet: 'נאָך קיין מעלדונגען',
      tryAgain: 'פּרוּווט נאָך אַ מאָל',
      gettingLocation: 'באַקומען קראַנט אָרט...',
      locationSharedMessage: 'דאָ איז מיין אָרט',
      selectFile: 'קלײַבט אַ טעקע',
      upload: 'אַרויפֿלאָדן',
      uploadComplete: 'אַרויפֿלאָדן פֿאַרטיק',
      uploadFailed: 'אַרויפלאָדן דורכגעפֿאַלן',
      fileTooLarge:
        ' די טעקע איז צו גרויס צו אַרויפלאָדן. ביטע קלייַבן אַ טעקע ווייניקער ווי {{maxSize}}.',
      dragOrClick: 'שלעפּט אַ טעקע אָדער קליקט צו קלײַבן',
      document: 'דאָקומענט',
      audioContent: 'אַודיאָ־אינהאַלט',
      videoContent: 'ווידעאָ־אינהאַלט',
      videoUnsupported:
        'דער ווידעאָ קען נישט געשפילט ווערן אין אײַער בלעטערער.',
      unsupportedContent: 'נישט־געשטיצטער אינהאַלט',
      unavailable: {
        error: {
          title: 'עפּעס איז געגאַנגען נישט ריכטיק',
          body: 'מיר האָבן נישט געקענט לאָדן די שמועס. פּרוּווט ביטע נאָך אַ מאָל.',
          retry: 'פּרוּווט נאָך אַ מאָל',
        },
        maintenance: {
          title: 'שמועס איז דערווײַל נישט צוטריטלעך',
          body: 'מיר פֿירן אויס אַ פּלאַנירטע וואַרטונג. קומט ביטע צוריק אין גיכן.',
        },
      },
      image: 'בילד',
      agentSharedImage: '{{name}} האט געטיילט אַ בילד:',
      assistantSharedImage: '{{name}} האט געטיילט אַ בילד:',
      starRating: 'שטערן־באַווערטונג',
      starRatingOrder: '{{current}} פון {{total}} שטערן',
      submit: 'אײַנשיקן',
      closeConversationDialog: 'פֿאַרמאַכן שמועס',
      waitingForAgentDescription:
        'ביטע וואַרט בשעת מיר פאַרבינדן אייך מיט אַן אַגענט',
      agentTransferred: 'איר זענט איבערגעפירט צו אַן אַנדער אַגענט.',
      uploadingFile: 'איר לאָדנט אַרויף: {{fileName}}',
      uploadedFile: 'איר האָט אַרויפגעלאָדן {{fileName}}',
      attachedFile: 'צוגעלייגט: {{fileName}}',
      fileTypeNotPermitted: 'אַנטשולדיקט, דער טיפ טעקע איז נישט דערלויבט.',
      relaunch: 'ווידער אָנהייבן',
      screenReaderHintChrome:
        'פאר די בעסטע סקרין רידער דערפארונג אין Google Chrome, רעקאמענדירן מיר צו נוצן JAWS.',
      screenReaderHintFirefox:
        'פאר די בעסטע סקרין רידער דערפארונג אין Firefox, רעקאמענדירן מיר צו נוצן NVDA.',
      agentInitiatedCall: '{{name}} האט אָנגעהויבן אַ רוף',
      clickToJoin: 'קליקט צו באַטייליקן',
      callSessionInProgress: 'אייער רוף סעסיע איז אין פּראָגרעס',
      primaryNavigation: 'נאַוויגאַציע',
      agentTypingNamed: '{{name}} טיפּט',
      agentSaysUnnamed: 'דער אַגענט זאָגט',
      botIsThinkingNamed: '{{name}} טראַכט',
      talkingWithAgentUnnamed: 'רעדן מיט אַן אַגענט',
      download: 'אַראָפּלאָדן',
      downloading: 'לאָדט אַראָפּ',
      downloadComplete: 'אַראָפּלאָדן פֿאַרטיק',
      downloadFailed: 'אַראָפּלאָדן דורכגעפֿאַלן',
      attachFile: 'צוהעפֿטן א טעקע',
      removeAttachment: 'אַוועקנעמען די בײַלאַגע',
      uploadFailedConnection:
        'אַרויפֿלאָדן דורכגעפֿאַלן. קאָנטראָלירט אײַער פֿאַרבינדונג.',
      fileTooLargeToUpload:
        ' די טעקע איז צו גרויס צו אַרויפלאָדן. ביטע קלייַבן אַ טעקע ווייניקער ווי {{maxSize}}.',
      problemUploadingFile:
        'עס איז געווען אַ פּראָבלעם מיט אַרויפלאָדן אייער טעקע.',
      attachmentRemoved: 'די בײַלאַגע איז אַוועקגענומען געוואָרן.',
      tomorrow: 'מאָרגן',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: 'היים מעניו',
      goBack: 'גיין צוריק',
      expandInSameWindow: 'אויסברייטערן אין זעלבן פֿענצטער',
      collapseDialog: 'צונויפֿפֿאַלן דיאַלאָג',
      closeDialog: 'פֿאַרמאַכן דיאַלאָג',
    },
  },
  {
    lang: 'zh',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '此对话已结束。',
      agentConnected: '您已成功接入人工客服。',
      downloadTranscript: '下载记录',
      startNewConversation: '开始新对话',
      returnToConversation: '返回对话',
      connecting: '正在连接…',
      retry: '重试',
      reconnecting: '正在重新连接…',
      connectionLost: '网络连接已断开',
      reconnectDescription: '网络连接已断开。点击“重新连接”重试。',
      typeMessage: '输入消息',
      inputSelect: '选择选项',
      inputSelectOrType: '选择选项或输入消息',
      secureInput: '输入安全消息',
      secureValueHidden: '隐藏的安全值',
      redactedValue: '已隐藏的个人信息',
      startChat: '开始聊天',
      settings: '设置',
      cancel: '取消',
      confirm: '确认',
      close: '关闭',
      next: '下一步',
      brandingTagline: '借助智能 AI 代理为您的业务赋能',
      poweredBy: '技术支持',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: '助手正在思考',
      youSaid: '您说',
      botSays: '助手说',
      agentSays: '{{name}} 说',
      joinMeeting: '加入会议',
      meetingInProgress: '会议进行中 — 点击重新加入',
      meetingExpired: '会议链接（已过期）',
      embeddedContent: '嵌入内容',
      openInNewTab: '在新标签页中打开',
      skipToMain: '跳到主要内容',
      customerLogoAlt: '{{customerName}} 徽标',
      selectDate: '选择日期',
      selectTime: '选择时间',
      browseOptions: '浏览选项',
      carouselRoleDescription: '轮播',
      carouselSlideLabel: '第 {{current}} 张，共 {{total}} 张',
      carouselPrevious: '上一项',
      carouselNext: '下一项',
      carouselGoToItem: '转到第 {{index}} 项',
      collapse: '收起',
      expand: '展开',
      messageHistory: '消息历史',
      reduce: '缩小',
      today: '今天',
      at: '于',
      a11yOptionsCount_other: '共 {{count}} 个选项。',
      listpickerSelectAll: '全选',
      listpickerSelectOption: '选择一个选项',
      listpickerSearchAriaLabel: '搜索筛选选项',
      listpickerSearchPlaceholder: '搜索…',
      listpickerNoResults: '没有匹配的选项。',
      listpickerResults_other: '{{count}} 个结果',
      listpickerCondensed_other: '已选择 {{count}} 项',
      scrollToLatest: '滚动到最新消息',
      scrollToUnread_other: '{{count}} 条新消息，滚动到最新',
      showPassword: '显示安全内容',
      hidePassword: '隐藏安全内容',
      clear: '清除',
      send: '发送',
      yesterday: '昨天',
      chatEndedActions: '聊天结束操作',
      openConversationDialog: '打开与 {{title}} 的对话窗口',
      agentTyping: '客服正在输入',
      agentAway: '我们的客服当前不可用。',
      agentBusy: '我们的客服当前繁忙，请稍候…',
      waitingForAgent: '正在为您接入客服…',
      waitingForAgentWithSkill: '正在为您接入 {{skill}} 客服…',
      talkingWithAgent: '正在与 {{name}} 对话',
      home: '主页',
      back: '返回',
      menu: '菜单',
      minimize: '最小化',
      endConversation: '结束对话',
      engageWithUs: '与我们互动',
      noMessagesYet: '暂无消息',
      tryAgain: '重试',
      gettingLocation: '获取当前位置...',
      locationSharedMessage: '这是我的位置',
      selectFile: '选择文件',
      upload: '上传',
      uploadComplete: '上传完成',
      uploadFailed: '上传失败',
      fileTooLarge: '此文件太大，无法上传。请选择小于{{maxSize}}的文件。',
      dragOrClick: '拖动文件或点击选择',
      document: '文档',
      audioContent: '音频内容',
      videoContent: '视频内容',
      videoUnsupported: '此视频无法在您的浏览器中播放。',
      unsupportedContent: '不支持的内容',
      unavailable: {
        error: {
          title: '出了点问题',
          body: '无法加载聊天，请重试。',
          retry: '重试',
        },
        maintenance: {
          title: '聊天暂时不可用',
          body: '我们正在进行计划维护，请稍后再来。',
        },
      },
      image: '图片',
      agentSharedImage: '{{name}} 分享了一张图片： ',
      assistantSharedImage: '{{name}} 分享了一张图片： ',
      starRating: '星级评分',
      starRatingOrder: '共 {{total}} 颗星，第 {{current}} 颗',
      submit: '提交',
      closeConversationDialog: '结束对话',
      waitingForAgentDescription: '请稍候，我们正在为您连接客服',
      agentTransferred: '您已被转接至另一位客服人员。',
      uploadingFile: '您正在上传：{{fileName}}',
      uploadedFile: '您已上传 {{fileName}}',
      attachedFile: '已附加：{{fileName}}',
      fileTypeNotPermitted: '抱歉，不允许使用此文件类型。',
      relaunch: '重新启动',
      screenReaderHintChrome:
        '为获得Google Chrome中最佳的屏幕阅读器体验, 我们建议使用JAWS。',
      screenReaderHintFirefox:
        '为获得Firefox中最佳的屏幕阅读器体验，我们建议使用NVDA。',
      agentInitiatedCall: '{{name}}已发起通话',
      clickToJoin: '点击加入',
      callSessionInProgress: '您的通话会话正在进行中',
      primaryNavigation: '导航',
      agentTypingNamed: '{{name}} 正在输入',
      agentSaysUnnamed: '客服人员说',
      botIsThinkingNamed: '{{name}} 正在思考',
      talkingWithAgentUnnamed: '正在与客服人员对话',
      download: '下载',
      downloading: '正在下载',
      downloadComplete: '下载完成',
      downloadFailed: '下载失败',
      attachFile: '添加附件',
      removeAttachment: '移除附件',
      uploadFailedConnection: '上传失败。请检查网络连接。',
      fileTooLargeToUpload:
        '此文件太大，无法上传。请选择小于{{maxSize}}的文件。',
      problemUploadingFile: '上传文件时出现问题。',
      attachmentRemoved: '附件已移除。',
      tomorrow: '明天',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: '主菜单',
      goBack: '返回',
      expandInSameWindow: '在同一窗口中展开',
      collapseDialog: '折叠对话框',
      closeDialog: '关闭对话框',
    },
  },
  {
    lang: 'zh-HK',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '此對話已結束。',
      agentConnected: '您已成功接入客服專員。',
      downloadTranscript: '下載記錄',
      startNewConversation: '開始新對話',
      returnToConversation: '返回對話',
      connecting: '連線中...',
      retry: '重試',
      reconnecting: '重新連線中...',
      connectionLost: '網路連線已中斷',
      reconnectDescription: '網路連線已中斷。請按一下「重新連線」以重試。',
      typeMessage: '輸入訊息',
      inputSelect: '選擇選項',
      inputSelectOrType: '選擇選項或輸入訊息',
      secureInput: '輸入安全訊息',
      secureValueHidden: '隱藏的安全值',
      redactedValue: '已隱藏的個人資料',
      startChat: '開始對話',
      settings: '設定',
      cancel: '取消',
      confirm: '確認',
      close: '關閉',
      next: '下一步',
      brandingTagline: '以智慧型 AI 代理為您的業務賦能',
      poweredBy: '技術支援',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: '助理正在思考',
      youSaid: '您說',
      botSays: '助理說',
      agentSays: '{{name}} 說',
      joinMeeting: '加入會議',
      meetingInProgress: '會議進行中 — 按一下以重新加入',
      meetingExpired: '會議連結（已過期）',
      embeddedContent: '嵌入內容',
      openInNewTab: '在新分頁中開啟',
      skipToMain: '跳至主要內容',
      customerLogoAlt: '{{customerName}} 標誌',
      selectDate: '選擇日期',
      selectTime: '選擇時間',
      browseOptions: '瀏覽選項',
      carouselRoleDescription: '輪播',
      carouselSlideLabel: '第 {{current}} 張，共 {{total}} 張',
      carouselPrevious: '上一項',
      carouselNext: '下一項',
      carouselGoToItem: '前往第 {{index}} 項',
      collapse: '收合',
      expand: '展開',
      messageHistory: '訊息記錄',
      reduce: '縮小',
      today: '今天',
      at: '於',
      a11yOptionsCount_other: '共有 {{count}} 個選項。',
      listpickerSelectAll: '全選',
      listpickerSelectOption: '選擇一個選項',
      listpickerSearchAriaLabel: '搜尋篩選選項',
      listpickerSearchPlaceholder: '搜尋…',
      listpickerNoResults: '沒有相符的選項。',
      listpickerResults_other: '{{count}} 個結果',
      listpickerCondensed_other: '已選擇 {{count}} 個',
      scrollToLatest: '捲動至最新訊息',
      scrollToUnread_other: '{{count}} 則新訊息，捲動至最新',
      showPassword: '顯示安全內容',
      hidePassword: '隱藏安全內容',
      clear: '清除',
      send: '傳送',
      yesterday: '昨天',
      chatEndedActions: '對話結束操作',
      openConversationDialog: '開啟與 {{title}} 的對話視窗',
      agentTyping: '客服專員正在輸入',
      agentAway: '我們的客服專員目前無法提供服務。',
      agentBusy: '我們的客服專員目前忙碌中，請稍候...',
      waitingForAgent: '正在為您接入客服專員...',
      waitingForAgentWithSkill: '正在為您接入 {{skill}} 客服專員...',
      talkingWithAgent: '正在與 {{name}} 對話',
      home: '首頁',
      back: '返回',
      menu: '選單',
      minimize: '最小化',
      endConversation: '結束對話',
      engageWithUs: '與我們聯絡',
      noMessagesYet: '尚無訊息',
      tryAgain: '再試一次',
      gettingLocation: '正在取得目前位置...',
      locationSharedMessage: '這是我的位置',
      selectFile: '選擇檔案',
      upload: '上傳',
      uploadComplete: '上傳完成',
      uploadFailed: '上載失敗',
      fileTooLarge: '此檔案太大，無法上載。請選擇小於{{maxSize}}的檔案。',
      dragOrClick: '拖曳檔案或按一下以選擇',
      document: '文件',
      audioContent: '音訊內容',
      videoContent: '影片內容',
      videoUnsupported: '此影片無法在您的瀏覽器中播放。',
      unsupportedContent: '不支援的內容',
      unavailable: {
        error: {
          title: '發生錯誤',
          body: '我們無法載入對話，請再試一次。',
          retry: '再試一次',
        },
        maintenance: {
          title: '對話暫時無法使用',
          body: '我們正在進行預定維護，請稍後再回來。',
        },
      },
      image: '圖片',
      agentSharedImage: '{{name}} 分享了一張圖片： ',
      assistantSharedImage: '{{name}} 分享了一張圖片： ',
      starRating: '星級評分',
      starRatingOrder: '共 {{total}} 顆星，第 {{current}} 顆',
      submit: '提交',
      closeConversationDialog: '結束對話',
      waitingForAgentDescription: '請稍候，我們正在為您連接客服',
      agentTransferred: '您已被轉接至另一位客服人員。',
      uploadingFile: '你正在上載：{{fileName}}',
      uploadedFile: '您已上載 {{fileName}}',
      attachedFile: '已附加：{{fileName}}',
      fileTypeNotPermitted: '對不起，不允許使用此檔案類型。',
      relaunch: '重新啟動',
      screenReaderHintChrome:
        '為獲得「Google Chrome」中最佳的螢幕閱讀器體驗，我們建議使用「JAWS」。',
      screenReaderHintFirefox:
        '為獲得Firefox中最佳的螢幕閱讀器體驗，我們建議使用NVDA。',
      agentInitiatedCall: '{{name}}已發起通話',
      clickToJoin: '點擊加入',
      callSessionInProgress: '您的通話會話正在進行中',
      primaryNavigation: '導航',
      agentTypingNamed: '{{name}} 正在輸入',
      agentSaysUnnamed: '客服人員說',
      botIsThinkingNamed: '{{name}} 正在思考',
      talkingWithAgentUnnamed: '正在與客服人員對話',
      download: '下載',
      downloading: '正在下載',
      downloadComplete: '下載完成',
      downloadFailed: '下載失敗',
      attachFile: '新增附件',
      removeAttachment: '移除附件',
      uploadFailedConnection: '上載失敗。請檢查網絡連線。',
      fileTooLargeToUpload:
        '此檔案太大，無法上載。請選擇小於{{maxSize}}的檔案。',
      problemUploadingFile: '上載檔案時出現問題。',
      attachmentRemoved: '附件已移除。',
      tomorrow: '明天',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: '主選單',
      goBack: '返回',
      expandInSameWindow: '在同一視窗中展開',
      collapseDialog: '摺疊對話方塊',
      closeDialog: '關閉對話方塊',
    },
  },
  {
    lang: 'zh-TW',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '此對話已結束。',
      agentConnected: '您已成功接入客服專員。',
      downloadTranscript: '下載記錄',
      startNewConversation: '開始新對話',
      returnToConversation: '返回對話',
      connecting: '連線中...',
      retry: '重試',
      reconnecting: '重新連線中...',
      connectionLost: '網路連線已中斷',
      reconnectDescription: '網路連線已中斷。請按一下「重新連線」以重試。',
      typeMessage: '輸入訊息',
      inputSelect: '選擇選項',
      inputSelectOrType: '選擇選項或輸入訊息',
      secureInput: '輸入安全訊息',
      secureValueHidden: '隱藏的安全值',
      redactedValue: '已隱藏的個人資料',
      startChat: '開始對話',
      settings: '設定',
      cancel: '取消',
      confirm: '確認',
      close: '關閉',
      next: '下一步',
      brandingTagline: '以智慧型 AI 代理為您的業務賦能',
      poweredBy: '技術支援',
      pypestreamCom: 'Pypestream.com',
      botIsThinking: '助理正在思考',
      youSaid: '您說',
      botSays: '助理說',
      agentSays: '{{name}} 說',
      joinMeeting: '加入會議',
      meetingInProgress: '會議進行中 — 按一下以重新加入',
      meetingExpired: '會議連結（已過期）',
      embeddedContent: '嵌入內容',
      openInNewTab: '在新分頁中開啟',
      skipToMain: '跳至主要內容',
      customerLogoAlt: '{{customerName}} 標誌',
      selectDate: '選擇日期',
      selectTime: '選擇時間',
      browseOptions: '瀏覽選項',
      carouselRoleDescription: '輪播',
      carouselSlideLabel: '第 {{current}} 張，共 {{total}} 張',
      carouselPrevious: '上一項',
      carouselNext: '下一項',
      carouselGoToItem: '前往第 {{index}} 項',
      collapse: '收合',
      expand: '展開',
      messageHistory: '訊息記錄',
      reduce: '縮小',
      today: '今天',
      at: '於',
      a11yOptionsCount_other: '共有 {{count}} 個選項。',
      listpickerSelectAll: '全選',
      listpickerSelectOption: '選擇一個選項',
      listpickerSearchAriaLabel: '搜尋篩選選項',
      listpickerSearchPlaceholder: '搜尋…',
      listpickerNoResults: '沒有相符的選項。',
      listpickerResults_other: '{{count}} 個結果',
      listpickerCondensed_other: '已選擇 {{count}} 個',
      scrollToLatest: '捲動至最新訊息',
      scrollToUnread_other: '{{count}} 則新訊息，捲動至最新',
      showPassword: '顯示安全內容',
      hidePassword: '隱藏安全內容',
      clear: '清除',
      send: '傳送',
      yesterday: '昨天',
      chatEndedActions: '對話結束操作',
      openConversationDialog: '開啟與 {{title}} 的對話視窗',
      agentTyping: '客服專員正在輸入',
      agentAway: '我們的客服專員目前無法提供服務。',
      agentBusy: '我們的客服專員目前忙碌中，請稍候...',
      waitingForAgent: '正在為您接入客服專員...',
      waitingForAgentWithSkill: '正在為您接入 {{skill}} 客服專員...',
      talkingWithAgent: '正在與 {{name}} 對話',
      home: '首頁',
      back: '返回',
      menu: '選單',
      minimize: '最小化',
      endConversation: '結束對話',
      engageWithUs: '與我們聯絡',
      noMessagesYet: '尚無訊息',
      tryAgain: '再試一次',
      gettingLocation: '正在取得目前位置...',
      locationSharedMessage: '這是我的位置',
      selectFile: '選擇檔案',
      upload: '上傳',
      uploadComplete: '上傳完成',
      uploadFailed: '上傳失敗',
      fileTooLarge: '此檔案太大，無法上傳。請選擇小於{{maxSize}}的檔案。',
      dragOrClick: '拖曳檔案或按一下以選擇',
      document: '文件',
      audioContent: '音訊內容',
      videoContent: '影片內容',
      videoUnsupported: '此影片無法在您的瀏覽器中播放。',
      unsupportedContent: '不支援的內容',
      unavailable: {
        error: {
          title: '發生錯誤',
          body: '我們無法載入對話，請再試一次。',
          retry: '再試一次',
        },
        maintenance: {
          title: '對話暫時無法使用',
          body: '我們正在進行預定維護，請稍後再回來。',
        },
      },
      image: '圖片',
      agentSharedImage: '{{name}} 分享了一張圖片： ',
      assistantSharedImage: '{{name}} 分享了一張圖片： ',
      starRating: '星級評分',
      starRatingOrder: '共 {{total}} 顆星，第 {{current}} 顆',
      submit: '提交',
      closeConversationDialog: '結束對話',
      waitingForAgentDescription: '請稍候，我們正在為您連接客服',
      agentTransferred: '您已被轉接至另一位客服人員。',
      uploadingFile: '您正在上傳：{{fileName}}',
      uploadedFile: '您已上傳 {{fileName}}',
      attachedFile: '已附加：{{fileName}}',
      fileTypeNotPermitted: '抱歉，不允許使用此檔案類型。',
      relaunch: '重新啟動',
      screenReaderHintChrome:
        '為獲得「Google Chrome」中最佳的螢幕閱讀器體驗，我們建議使用「JAWS」。',
      screenReaderHintFirefox:
        '為獲得Firefox中最佳的螢幕閱讀器體驗，我們建議使用NVDA。',
      agentInitiatedCall: '{{name}}已發起通話',
      clickToJoin: '點擊加入',
      callSessionInProgress: '您的通話會話正在進行中',
      primaryNavigation: '導航',
      agentTypingNamed: '{{name}} 正在輸入',
      agentSaysUnnamed: '客服人員說',
      botIsThinkingNamed: '{{name}} 正在思考',
      talkingWithAgentUnnamed: '正在與客服人員對話',
      download: '下載',
      downloading: '正在下載',
      downloadComplete: '下載完成',
      downloadFailed: '下載失敗',
      attachFile: '新增附件',
      removeAttachment: '移除附件',
      uploadFailedConnection: '上傳失敗。請檢查網路連線。',
      fileTooLargeToUpload:
        '此檔案太大，無法上傳。請選擇小於{{maxSize}}的檔案。',
      problemUploadingFile: '上傳檔案時出現問題。',
      attachmentRemoved: '附件已移除。',
      tomorrow: '明天',
      datepickerUnitMonth: 'Month',
      datepickerUnitDay: 'Day',
      datepickerUnitYear: 'Year',
      datepickerPrevious: 'Previous {{unit}}',
      datepickerNext: 'Next {{unit}}',
      datepickerSubmitHint: 'Press Send to submit the selected date.',
      homeMenu: '主選單',
      goBack: '返回',
      expandInSameWindow: '在同一視窗中展開',
      collapseDialog: '摺疊對話方塊',
      closeDialog: '關閉對話方塊',
    },
  },
];
